/* eslint-disable */
// This code was auto-generated by running
// npm run generate-types-validators schemas/UnifiedJSON src/generated/types src/generated/validators
// Please do not modify this code by hand.


'use strict';
exports.validateHelloRequest = validate10;
const schema11 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'HelloRequest.json',
  title: 'HelloRequest',
  type: 'object',
  oneOf: [
    {
      $ref: 'PrepAndSendRequest.json',
      $comment: 'This item must be first in the list or it breaks PHP tests',
    },
    {
      $ref: 'SignerAppRequest.json',
      $comment: 'This item must be second in the list or it breaks PHP tests',
    },
    { $ref: 'HSUser.json' },
    { $ref: 'AccountFeatureSettings.json' },
    { $ref: 'AccountIntegrationSettings.json' },
    { $ref: 'AccountProfileSettings.json' },
  ],
};
const schema111 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'HSUser.json',
  type: 'object',
  title: 'HSUserSchema',
  properties: {
    id: { type: 'number' },
    guid: { type: 'string' },
    emailAddress: { type: 'string' },
    name: { type: 'string' },
    settings: {
      type: 'object',
      properties: {
        firstName: { type: 'string' },
        lastName: { type: 'string' },
      },
      required: ['firstName', 'lastName'],
    },
    isFree: { type: 'boolean' },
    hasTeam: { type: 'boolean' },
    plan: {
      type: 'string',
      enum: [
        '(Grandfathered 2016)',
        'API Basic',
        'Business 10',
        'Business',
        'Enterprise',
        'Enterprise+',
        'Essentials',
        'Free Premium',
        'Free',
        'Grandfathered',
        'Premium',
        'Standard',
        'Test Mode',
        'Web 300k',
      ],
    },
    numApiDocsLeft: { type: 'number' },
    numDocsLeft: { type: 'number' },
    numTemplatesLeft: { type: 'number' },
    numFaxPagesLeft: { type: 'number' },
    canAccessBulkSendUI: { type: 'boolean' },
    canAccessAdminConsole: { type: 'boolean' },
    canAccessTemplateConverter: { type: 'boolean' },
    noTimeout: { type: 'boolean' },
    isFromSelfServeApi: { type: 'boolean' },
    primarySignatureGuid: { type: 'string' },
    showApiCredits: { type: 'boolean' },
    canCreateEditTemplate: { type: 'boolean' },
    hasLegacyApiKeys: { type: 'boolean' },
    referUrl: { type: 'string' },
  },
  required: [
    'id',
    'guid',
    'emailAddress',
    'name',
    'settings',
    'isFree',
    'hasTeam',
    'plan',
    'numApiDocsLeft',
    'numDocsLeft',
    'numTemplatesLeft',
    'numFaxPagesLeft',
    'canAccessBulkSendUI',
    'canAccessAdminConsole',
    'canAccessTemplateConverter',
    'noTimeout',
    'isFromSelfServeApi',
    'showApiCredits',
    'canCreateEditTemplate',
    'hasLegacyApiKeys',
    'referUrl',
  ],
};
const schema12 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'PrepAndSendRequest.json',
  title: 'PrepAndSendRequest',
  type: 'object',
  properties: {
    guid: { type: 'string' },
    settings: { $ref: 'Settings.json' },
    options: { $ref: 'Options.json' },
    flags: { $ref: 'Flags.json' },
    accountSettings: { $ref: 'AccountSettings.json' },
    requestData: { $ref: 'RequestData.json' },
    embeddedData: { $ref: 'EmbeddedData.json' },
    apiApp: { $ref: 'ApiApp.json' },
    user: { $ref: 'User.json' },
  },
  additionalProperties: false,
  required: [
    'guid',
    'settings',
    'flags',
    'accountSettings',
    'user',
    'options',
    'requestData',
  ],
};
const schema13 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'Settings.json',
  type: 'object',
  title: 'Settings',
  additionalProperties: false,
  properties: {
    addCoverPage: { type: 'boolean' },
    recipientOrder: { type: 'boolean' },
    qes: { type: 'boolean' },
    recipientReassignment: { type: 'boolean' },
    requireSignerInfo: { type: 'boolean' },
    sendHighResFax: { type: 'boolean' },
    needsCharge: { type: 'boolean' },
  },
};
const schema105 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'EmbeddedData.json',
  type: 'object',
  title: 'EmbeddedData',
  properties: {
    docGuids: { type: 'array', items: { type: 'string' } },
    isEmbeddedRequest: { type: 'boolean' },
    isEmbeddedTemplate: { type: 'boolean' },
    isGmail: { type: 'boolean' },
    skipMeNow: { type: 'boolean' },
    usingTemplate: { type: 'boolean' },
    isCreatedFromTemplate: { type: 'boolean' },
    parentUrl: { type: 'string' },
    redirectUrl: { type: 'string' },
    editedTemplateGuid: { type: ['string', 'null'] },
    isSelfSign: { type: ['boolean', 'null'] },
    locale: { type: ['string', 'null'] },
    appName: { type: 'string' },
  },
  required: [
    'docGuids',
    'parentUrl',
    'usingTemplate',
    'redirectUrl',
    'isSelfSign',
    'locale',
  ],
};
const schema106 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'ApiApp.json',
  type: 'object',
  title: 'ApiApp',
  properties: { clientId: { type: 'string' }, parentUrl: { type: 'string' } },
  required: ['clientId', 'parentUrl'],
};
const func4 = Object.prototype.hasOwnProperty;
const schema14 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'Options.json',
  type: 'object',
  title: 'Options',
  properties: {
    forceSignerRoles: {
      type: 'boolean',
      description: 'Embedded - force showing signer roles',
    },
    forceSubjectMessage: {
      type: 'boolean',
      description: 'Embedded - force showing subject message',
    },
    hideContinueButton: {
      type: 'boolean',
      description: 'Embedded - force showing subject message',
    },
    isMeOnly: { type: 'boolean' },
    hideProgressStepper: { type: 'boolean', description: 'Hide Stepper icons' },
    hideStepperContainer: {
      type: 'boolean',
      description: 'Hide entire stepper',
    },
    requireSignerInfo: {
      type: 'boolean',
      description: 'Show modal asking for user first & last name',
    },
    blockCC: { type: 'boolean', description: 'Block use of CCs' },
    lockDocumentTitle: { type: 'boolean', description: 'Lock the title' },
    lockDocumentMessage: { type: 'boolean', description: 'Lock the message' },
    dateFormat: { $ref: 'Field.json#/definitions/JSDateFormat' },
    features: {
      type: 'array',
      items: { type: 'string' },
      description:
        'A list of features that are being made available on this request',
    },
    integrationMetadata: {
      type: 'array',
      description: 'Integration super group metadata',
    },
  },
};
const schema33 = {
  type: 'string',
  title: 'JSDateFormat',
  enum: [
    'default',
    'MM / DD / YYYY',
    'MM - DD - YYYY',
    'DD / MM / YYYY',
    'DD - MM - YYYY',
    'YYYY / MM / DD',
    'YYYY - MM - DD',
  ],
  tsEnumNames: [
    'JSDefault',
    'MMDDYYYYSeparatedBySlash',
    'MMDDYYYYSeparatedByHyphen',
    'DDMMYYYYSeparatedBySlash',
    'DDMMYYYYSeparatedByHyphen',
    'YYYYMMDDSeparatedBySlash',
    'YYYYMMDDSeparatedByHyphen',
  ],
  'x-enum-names': [
    'JSDefault',
    'JSMMDDYYYYSeparatedBySlash',
    'JSMMDDYYYYSeparatedByHyphen',
    'JSDDMMYYYYSeparatedBySlash',
    'JSDDMMYYYYSeparatedByHyphen',
    'JSYYYYMMDDSeparatedBySlash',
    'JSYYYYMMDDSeparatedByHyphen',
  ],
};
const func0 = require('ajv/dist/runtime/equal').default;
function validate12(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="Options.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.forceSignerRoles !== undefined) {
        const _errs1 = errors;
        if (typeof data.forceSignerRoles !== 'boolean') {
          validate12.errors = [
            {
              instancePath: instancePath + '/forceSignerRoles',
              schemaPath: '#/properties/forceSignerRoles/type',
              keyword: 'type',
              params: { type: 'boolean' },
              message: 'must be boolean',
            },
          ];
          return false;
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.forceSubjectMessage !== undefined) {
          const _errs3 = errors;
          if (typeof data.forceSubjectMessage !== 'boolean') {
            validate12.errors = [
              {
                instancePath: instancePath + '/forceSubjectMessage',
                schemaPath: '#/properties/forceSubjectMessage/type',
                keyword: 'type',
                params: { type: 'boolean' },
                message: 'must be boolean',
              },
            ];
            return false;
          }
          var valid0 = _errs3 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.hideContinueButton !== undefined) {
            const _errs5 = errors;
            if (typeof data.hideContinueButton !== 'boolean') {
              validate12.errors = [
                {
                  instancePath: instancePath + '/hideContinueButton',
                  schemaPath: '#/properties/hideContinueButton/type',
                  keyword: 'type',
                  params: { type: 'boolean' },
                  message: 'must be boolean',
                },
              ];
              return false;
            }
            var valid0 = _errs5 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.isMeOnly !== undefined) {
              const _errs7 = errors;
              if (typeof data.isMeOnly !== 'boolean') {
                validate12.errors = [
                  {
                    instancePath: instancePath + '/isMeOnly',
                    schemaPath: '#/properties/isMeOnly/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  },
                ];
                return false;
              }
              var valid0 = _errs7 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.hideProgressStepper !== undefined) {
                const _errs9 = errors;
                if (typeof data.hideProgressStepper !== 'boolean') {
                  validate12.errors = [
                    {
                      instancePath: instancePath + '/hideProgressStepper',
                      schemaPath: '#/properties/hideProgressStepper/type',
                      keyword: 'type',
                      params: { type: 'boolean' },
                      message: 'must be boolean',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs9 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.hideStepperContainer !== undefined) {
                  const _errs11 = errors;
                  if (typeof data.hideStepperContainer !== 'boolean') {
                    validate12.errors = [
                      {
                        instancePath: instancePath + '/hideStepperContainer',
                        schemaPath: '#/properties/hideStepperContainer/type',
                        keyword: 'type',
                        params: { type: 'boolean' },
                        message: 'must be boolean',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs11 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.requireSignerInfo !== undefined) {
                    const _errs13 = errors;
                    if (typeof data.requireSignerInfo !== 'boolean') {
                      validate12.errors = [
                        {
                          instancePath: instancePath + '/requireSignerInfo',
                          schemaPath: '#/properties/requireSignerInfo/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs13 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.blockCC !== undefined) {
                      const _errs15 = errors;
                      if (typeof data.blockCC !== 'boolean') {
                        validate12.errors = [
                          {
                            instancePath: instancePath + '/blockCC',
                            schemaPath: '#/properties/blockCC/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs15 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.lockDocumentTitle !== undefined) {
                        const _errs17 = errors;
                        if (typeof data.lockDocumentTitle !== 'boolean') {
                          validate12.errors = [
                            {
                              instancePath: instancePath + '/lockDocumentTitle',
                              schemaPath: '#/properties/lockDocumentTitle/type',
                              keyword: 'type',
                              params: { type: 'boolean' },
                              message: 'must be boolean',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs17 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.lockDocumentMessage !== undefined) {
                          const _errs19 = errors;
                          if (typeof data.lockDocumentMessage !== 'boolean') {
                            validate12.errors = [
                              {
                                instancePath:
                                  instancePath + '/lockDocumentMessage',
                                schemaPath:
                                  '#/properties/lockDocumentMessage/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs19 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.dateFormat !== undefined) {
                            let data10 = data.dateFormat;
                            const _errs21 = errors;
                            if (typeof data10 !== 'string') {
                              validate12.errors = [
                                {
                                  instancePath: instancePath + '/dateFormat',
                                  schemaPath:
                                    'Field.json#/definitions/JSDateFormat/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            if (
                              !(
                                data10 === 'default' ||
                                data10 === 'MM / DD / YYYY' ||
                                data10 === 'MM - DD - YYYY' ||
                                data10 === 'DD / MM / YYYY' ||
                                data10 === 'DD - MM - YYYY' ||
                                data10 === 'YYYY / MM / DD' ||
                                data10 === 'YYYY - MM - DD'
                              )
                            ) {
                              validate12.errors = [
                                {
                                  instancePath: instancePath + '/dateFormat',
                                  schemaPath:
                                    'Field.json#/definitions/JSDateFormat/enum',
                                  keyword: 'enum',
                                  params: { allowedValues: schema33.enum },
                                  message:
                                    'must be equal to one of the allowed values',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs21 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.features !== undefined) {
                              let data11 = data.features;
                              const _errs24 = errors;
                              if (errors === _errs24) {
                                if (Array.isArray(data11)) {
                                  var valid2 = true;
                                  const len0 = data11.length;
                                  for (let i0 = 0; i0 < len0; i0++) {
                                    const _errs26 = errors;
                                    if (typeof data11[i0] !== 'string') {
                                      validate12.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/features/' + i0,
                                          schemaPath:
                                            '#/properties/features/items/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid2 = _errs26 === errors;
                                    if (!valid2) {
                                      break;
                                    }
                                  }
                                } else {
                                  validate12.errors = [
                                    {
                                      instancePath: instancePath + '/features',
                                      schemaPath: '#/properties/features/type',
                                      keyword: 'type',
                                      params: { type: 'array' },
                                      message: 'must be array',
                                    },
                                  ];
                                  return false;
                                }
                              }
                              var valid0 = _errs24 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.integrationMetadata !== undefined) {
                                const _errs28 = errors;
                                if (!Array.isArray(data.integrationMetadata)) {
                                  validate12.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/integrationMetadata',
                                      schemaPath:
                                        '#/properties/integrationMetadata/type',
                                      keyword: 'type',
                                      params: { type: 'array' },
                                      message: 'must be array',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs28 === errors;
                              } else {
                                var valid0 = true;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate12.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate12.errors = vErrors;
  return errors === 0;
}
const schema44 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'Flags.json',
  type: 'object',
  title: 'Flags',
  properties: {
    requestType: { $ref: '#/definitions/RequestType' },
    isHelloFax: {
      type: 'boolean',
      description: 'Is this HelloFax (vs HelloSign)?',
    },
    isResend: {
      type: 'boolean',
      description: 'True if this is coming from a resend or draft flow',
    },
    isMobileAppRequest: {
      type: 'boolean',
      description: 'True if this request is coming from the Mobile app',
    },
    integration: { $ref: '#/definitions/Integration' },
    hasTemplateReuseWarning: {
      type: 'boolean',
      description:
        'True if the underlying template for edit-and-resend has been modified',
    },
    shouldRouteToPrepAndSend: {
      type: 'boolean',
      description: 'True if this is coming from a third party signup flow',
    },
    displayDocToTemplateBanner: {
      type: 'boolean',
      description: 'True if subscription is eligible for creating template',
    },
    docToTemplateCurrentVariation: {
      type: 'boolean',
      description: 'DocToTemplateV2ABTest variation either V1|V2|control',
    },
    shouldConvertDocToTemplate: {
      type: 'boolean',
      description: 'True if Doc to template banner checkbox is checked',
    },
    templateConversionCandidateId: {
      type: 'string',
      description: 'Document to Template conversion ID',
    },
  },
  required: ['requestType'],
  definitions: {
    RequestType: {
      type: 'integer',
      title: 'RequestType',
      enum: [1, 2, 3, 4, 5, 7, 8, 9, 10, 11, 12, 13],
      tsEnumNames: [
        'SendDoc',
        'RequestSig',
        'ResponseSig',
        'Template',
        'SendTemplate',
        'Demo',
        'FinalizeDocGmail',
        'ReusableLink',
        'SelfSave',
        'EmbeddedRequest',
        'EmbeddedTemplate',
        'BulkSend',
      ],
      'x-enum-names': [
        'SendDoc',
        'RequestSig',
        'ResponseSig',
        'Template',
        'SendTemplate',
        'Demo',
        'FinalizeDocGmail',
        'ReusableLink',
        'SelfSave',
        'EmbeddedRequest',
        'EmbeddedTemplate',
        'BulkSend',
      ],
    },
    Integration: {
      type: 'object',
      title: 'Integration',
      description:
        'Is third-party (or Dropbox) integration enabled for this request',
      oneOf: [
        { $ref: '#/definitions/DeepIntegration' },
        { $ref: '#/definitions/SharePointIntegration' },
        { $ref: '#/definitions/HubSpotIntegration' },
      ],
    },
    IntegrationData: {
      type: 'object',
      title: 'IntegrationData',
      description: 'Data relevant to integrations',
      properties: {
        externalCacheKey: { type: 'string' },
        externalAppKey: { type: 'string' },
        externalAccountId: { type: 'string' },
        externalFolderPath: { type: 'string' },
        externalFileName: { type: 'string' },
        externalDefaultSavePath: { type: 'string' },
      },
      required: [
        'externalCacheKey',
        'externalAppKey',
        'externalAccountId',
        'externalFolderPath',
      ],
    },
    DeepIntegration: {
      type: 'object',
      title: 'DeepIntegration',
      properties: {
        name: {
          type: 'string',
          title: 'IntegrationName',
          enum: ['deepintegration', 'officeAddInSelfSign'],
          tsEnumNames: ['DeepIntegration', 'OfficeSelfSign'],
          'x-enum-names': ['DeepIntegration', 'OfficeSelfSign'],
        },
        data: { $ref: '#/definitions/IntegrationData' },
      },
    },
    SharePointIntegration: {
      type: 'object',
      title: 'SharePointIntegration',
      properties: {
        name: {
          type: 'string',
          title: 'IntegrationName',
          enum: ['SharePoint'],
          tsEnumNames: ['SharePoint'],
          'x-enum-names': ['SharePoint'],
        },
        data: { $ref: '#/definitions/IntegrationData' },
      },
    },
    HubSpotIntegration: {
      type: 'object',
      title: 'HubSpotIntegration',
      properties: {
        name: {
          type: 'string',
          title: 'IntegrationName',
          enum: ['hubspot'],
          tsEnumNames: ['HubSpot'],
          'x-enum-names': ['HubSpot'],
        },
        data: { $ref: '#/definitions/IntegrationData' },
      },
    },
  },
};
const schema45 = {
  type: 'integer',
  title: 'RequestType',
  enum: [1, 2, 3, 4, 5, 7, 8, 9, 10, 11, 12, 13],
  tsEnumNames: [
    'SendDoc',
    'RequestSig',
    'ResponseSig',
    'Template',
    'SendTemplate',
    'Demo',
    'FinalizeDocGmail',
    'ReusableLink',
    'SelfSave',
    'EmbeddedRequest',
    'EmbeddedTemplate',
    'BulkSend',
  ],
  'x-enum-names': [
    'SendDoc',
    'RequestSig',
    'ResponseSig',
    'Template',
    'SendTemplate',
    'Demo',
    'FinalizeDocGmail',
    'ReusableLink',
    'SelfSave',
    'EmbeddedRequest',
    'EmbeddedTemplate',
    'BulkSend',
  ],
};
const schema46 = {
  type: 'object',
  title: 'Integration',
  description:
    'Is third-party (or Dropbox) integration enabled for this request',
  oneOf: [
    { $ref: '#/definitions/DeepIntegration' },
    { $ref: '#/definitions/SharePointIntegration' },
    { $ref: '#/definitions/HubSpotIntegration' },
  ],
};
const schema47 = {
  type: 'object',
  title: 'DeepIntegration',
  properties: {
    name: {
      type: 'string',
      title: 'IntegrationName',
      enum: ['deepintegration', 'officeAddInSelfSign'],
      tsEnumNames: ['DeepIntegration', 'OfficeSelfSign'],
      'x-enum-names': ['DeepIntegration', 'OfficeSelfSign'],
    },
    data: { $ref: '#/definitions/IntegrationData' },
  },
};
const schema48 = {
  type: 'object',
  title: 'IntegrationData',
  description: 'Data relevant to integrations',
  properties: {
    externalCacheKey: { type: 'string' },
    externalAppKey: { type: 'string' },
    externalAccountId: { type: 'string' },
    externalFolderPath: { type: 'string' },
    externalFileName: { type: 'string' },
    externalDefaultSavePath: { type: 'string' },
  },
  required: [
    'externalCacheKey',
    'externalAppKey',
    'externalAccountId',
    'externalFolderPath',
  ],
};
function validate32(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.name !== undefined) {
        let data0 = data.name;
        const _errs1 = errors;
        if (typeof data0 !== 'string') {
          validate32.errors = [
            {
              instancePath: instancePath + '/name',
              schemaPath: '#/properties/name/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            },
          ];
          return false;
        }
        if (!(data0 === 'deepintegration' || data0 === 'officeAddInSelfSign')) {
          validate32.errors = [
            {
              instancePath: instancePath + '/name',
              schemaPath: '#/properties/name/enum',
              keyword: 'enum',
              params: { allowedValues: schema47.properties.name.enum },
              message: 'must be equal to one of the allowed values',
            },
          ];
          return false;
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.data !== undefined) {
          let data1 = data.data;
          const _errs3 = errors;
          const _errs4 = errors;
          if (errors === _errs4) {
            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
              let missing0;
              if (
                (data1.externalCacheKey === undefined &&
                  (missing0 = 'externalCacheKey')) ||
                (data1.externalAppKey === undefined &&
                  (missing0 = 'externalAppKey')) ||
                (data1.externalAccountId === undefined &&
                  (missing0 = 'externalAccountId')) ||
                (data1.externalFolderPath === undefined &&
                  (missing0 = 'externalFolderPath'))
              ) {
                validate32.errors = [
                  {
                    instancePath: instancePath + '/data',
                    schemaPath: '#/definitions/IntegrationData/required',
                    keyword: 'required',
                    params: { missingProperty: missing0 },
                    message: "must have required property '" + missing0 + "'",
                  },
                ];
                return false;
              } else {
                if (data1.externalCacheKey !== undefined) {
                  const _errs6 = errors;
                  if (typeof data1.externalCacheKey !== 'string') {
                    validate32.errors = [
                      {
                        instancePath: instancePath + '/data/externalCacheKey',
                        schemaPath:
                          '#/definitions/IntegrationData/properties/externalCacheKey/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid2 = _errs6 === errors;
                } else {
                  var valid2 = true;
                }
                if (valid2) {
                  if (data1.externalAppKey !== undefined) {
                    const _errs8 = errors;
                    if (typeof data1.externalAppKey !== 'string') {
                      validate32.errors = [
                        {
                          instancePath: instancePath + '/data/externalAppKey',
                          schemaPath:
                            '#/definitions/IntegrationData/properties/externalAppKey/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid2 = _errs8 === errors;
                  } else {
                    var valid2 = true;
                  }
                  if (valid2) {
                    if (data1.externalAccountId !== undefined) {
                      const _errs10 = errors;
                      if (typeof data1.externalAccountId !== 'string') {
                        validate32.errors = [
                          {
                            instancePath:
                              instancePath + '/data/externalAccountId',
                            schemaPath:
                              '#/definitions/IntegrationData/properties/externalAccountId/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs10 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data1.externalFolderPath !== undefined) {
                        const _errs12 = errors;
                        if (typeof data1.externalFolderPath !== 'string') {
                          validate32.errors = [
                            {
                              instancePath:
                                instancePath + '/data/externalFolderPath',
                              schemaPath:
                                '#/definitions/IntegrationData/properties/externalFolderPath/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid2 = _errs12 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data1.externalFileName !== undefined) {
                          const _errs14 = errors;
                          if (typeof data1.externalFileName !== 'string') {
                            validate32.errors = [
                              {
                                instancePath:
                                  instancePath + '/data/externalFileName',
                                schemaPath:
                                  '#/definitions/IntegrationData/properties/externalFileName/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid2 = _errs14 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data1.externalDefaultSavePath !== undefined) {
                            const _errs16 = errors;
                            if (
                              typeof data1.externalDefaultSavePath !== 'string'
                            ) {
                              validate32.errors = [
                                {
                                  instancePath:
                                    instancePath +
                                    '/data/externalDefaultSavePath',
                                  schemaPath:
                                    '#/definitions/IntegrationData/properties/externalDefaultSavePath/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid2 = _errs16 === errors;
                          } else {
                            var valid2 = true;
                          }
                        }
                      }
                    }
                  }
                }
              }
            } else {
              validate32.errors = [
                {
                  instancePath: instancePath + '/data',
                  schemaPath: '#/definitions/IntegrationData/type',
                  keyword: 'type',
                  params: { type: 'object' },
                  message: 'must be object',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs3 === errors;
        } else {
          var valid0 = true;
        }
      }
    } else {
      validate32.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate32.errors = vErrors;
  return errors === 0;
}
const schema49 = {
  type: 'object',
  title: 'SharePointIntegration',
  properties: {
    name: {
      type: 'string',
      title: 'IntegrationName',
      enum: ['SharePoint'],
      tsEnumNames: ['SharePoint'],
      'x-enum-names': ['SharePoint'],
    },
    data: { $ref: '#/definitions/IntegrationData' },
  },
};
function validate34(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.name !== undefined) {
        let data0 = data.name;
        const _errs1 = errors;
        if (typeof data0 !== 'string') {
          validate34.errors = [
            {
              instancePath: instancePath + '/name',
              schemaPath: '#/properties/name/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            },
          ];
          return false;
        }
        if (!(data0 === 'SharePoint')) {
          validate34.errors = [
            {
              instancePath: instancePath + '/name',
              schemaPath: '#/properties/name/enum',
              keyword: 'enum',
              params: { allowedValues: schema49.properties.name.enum },
              message: 'must be equal to one of the allowed values',
            },
          ];
          return false;
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.data !== undefined) {
          let data1 = data.data;
          const _errs3 = errors;
          const _errs4 = errors;
          if (errors === _errs4) {
            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
              let missing0;
              if (
                (data1.externalCacheKey === undefined &&
                  (missing0 = 'externalCacheKey')) ||
                (data1.externalAppKey === undefined &&
                  (missing0 = 'externalAppKey')) ||
                (data1.externalAccountId === undefined &&
                  (missing0 = 'externalAccountId')) ||
                (data1.externalFolderPath === undefined &&
                  (missing0 = 'externalFolderPath'))
              ) {
                validate34.errors = [
                  {
                    instancePath: instancePath + '/data',
                    schemaPath: '#/definitions/IntegrationData/required',
                    keyword: 'required',
                    params: { missingProperty: missing0 },
                    message: "must have required property '" + missing0 + "'",
                  },
                ];
                return false;
              } else {
                if (data1.externalCacheKey !== undefined) {
                  const _errs6 = errors;
                  if (typeof data1.externalCacheKey !== 'string') {
                    validate34.errors = [
                      {
                        instancePath: instancePath + '/data/externalCacheKey',
                        schemaPath:
                          '#/definitions/IntegrationData/properties/externalCacheKey/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid2 = _errs6 === errors;
                } else {
                  var valid2 = true;
                }
                if (valid2) {
                  if (data1.externalAppKey !== undefined) {
                    const _errs8 = errors;
                    if (typeof data1.externalAppKey !== 'string') {
                      validate34.errors = [
                        {
                          instancePath: instancePath + '/data/externalAppKey',
                          schemaPath:
                            '#/definitions/IntegrationData/properties/externalAppKey/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid2 = _errs8 === errors;
                  } else {
                    var valid2 = true;
                  }
                  if (valid2) {
                    if (data1.externalAccountId !== undefined) {
                      const _errs10 = errors;
                      if (typeof data1.externalAccountId !== 'string') {
                        validate34.errors = [
                          {
                            instancePath:
                              instancePath + '/data/externalAccountId',
                            schemaPath:
                              '#/definitions/IntegrationData/properties/externalAccountId/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs10 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data1.externalFolderPath !== undefined) {
                        const _errs12 = errors;
                        if (typeof data1.externalFolderPath !== 'string') {
                          validate34.errors = [
                            {
                              instancePath:
                                instancePath + '/data/externalFolderPath',
                              schemaPath:
                                '#/definitions/IntegrationData/properties/externalFolderPath/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid2 = _errs12 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data1.externalFileName !== undefined) {
                          const _errs14 = errors;
                          if (typeof data1.externalFileName !== 'string') {
                            validate34.errors = [
                              {
                                instancePath:
                                  instancePath + '/data/externalFileName',
                                schemaPath:
                                  '#/definitions/IntegrationData/properties/externalFileName/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid2 = _errs14 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data1.externalDefaultSavePath !== undefined) {
                            const _errs16 = errors;
                            if (
                              typeof data1.externalDefaultSavePath !== 'string'
                            ) {
                              validate34.errors = [
                                {
                                  instancePath:
                                    instancePath +
                                    '/data/externalDefaultSavePath',
                                  schemaPath:
                                    '#/definitions/IntegrationData/properties/externalDefaultSavePath/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid2 = _errs16 === errors;
                          } else {
                            var valid2 = true;
                          }
                        }
                      }
                    }
                  }
                }
              }
            } else {
              validate34.errors = [
                {
                  instancePath: instancePath + '/data',
                  schemaPath: '#/definitions/IntegrationData/type',
                  keyword: 'type',
                  params: { type: 'object' },
                  message: 'must be object',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs3 === errors;
        } else {
          var valid0 = true;
        }
      }
    } else {
      validate34.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate34.errors = vErrors;
  return errors === 0;
}
const schema51 = {
  type: 'object',
  title: 'HubSpotIntegration',
  properties: {
    name: {
      type: 'string',
      title: 'IntegrationName',
      enum: ['hubspot'],
      tsEnumNames: ['HubSpot'],
      'x-enum-names': ['HubSpot'],
    },
    data: { $ref: '#/definitions/IntegrationData' },
  },
};
function validate36(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.name !== undefined) {
        let data0 = data.name;
        const _errs1 = errors;
        if (typeof data0 !== 'string') {
          validate36.errors = [
            {
              instancePath: instancePath + '/name',
              schemaPath: '#/properties/name/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            },
          ];
          return false;
        }
        if (!(data0 === 'hubspot')) {
          validate36.errors = [
            {
              instancePath: instancePath + '/name',
              schemaPath: '#/properties/name/enum',
              keyword: 'enum',
              params: { allowedValues: schema51.properties.name.enum },
              message: 'must be equal to one of the allowed values',
            },
          ];
          return false;
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.data !== undefined) {
          let data1 = data.data;
          const _errs3 = errors;
          const _errs4 = errors;
          if (errors === _errs4) {
            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
              let missing0;
              if (
                (data1.externalCacheKey === undefined &&
                  (missing0 = 'externalCacheKey')) ||
                (data1.externalAppKey === undefined &&
                  (missing0 = 'externalAppKey')) ||
                (data1.externalAccountId === undefined &&
                  (missing0 = 'externalAccountId')) ||
                (data1.externalFolderPath === undefined &&
                  (missing0 = 'externalFolderPath'))
              ) {
                validate36.errors = [
                  {
                    instancePath: instancePath + '/data',
                    schemaPath: '#/definitions/IntegrationData/required',
                    keyword: 'required',
                    params: { missingProperty: missing0 },
                    message: "must have required property '" + missing0 + "'",
                  },
                ];
                return false;
              } else {
                if (data1.externalCacheKey !== undefined) {
                  const _errs6 = errors;
                  if (typeof data1.externalCacheKey !== 'string') {
                    validate36.errors = [
                      {
                        instancePath: instancePath + '/data/externalCacheKey',
                        schemaPath:
                          '#/definitions/IntegrationData/properties/externalCacheKey/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid2 = _errs6 === errors;
                } else {
                  var valid2 = true;
                }
                if (valid2) {
                  if (data1.externalAppKey !== undefined) {
                    const _errs8 = errors;
                    if (typeof data1.externalAppKey !== 'string') {
                      validate36.errors = [
                        {
                          instancePath: instancePath + '/data/externalAppKey',
                          schemaPath:
                            '#/definitions/IntegrationData/properties/externalAppKey/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid2 = _errs8 === errors;
                  } else {
                    var valid2 = true;
                  }
                  if (valid2) {
                    if (data1.externalAccountId !== undefined) {
                      const _errs10 = errors;
                      if (typeof data1.externalAccountId !== 'string') {
                        validate36.errors = [
                          {
                            instancePath:
                              instancePath + '/data/externalAccountId',
                            schemaPath:
                              '#/definitions/IntegrationData/properties/externalAccountId/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs10 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data1.externalFolderPath !== undefined) {
                        const _errs12 = errors;
                        if (typeof data1.externalFolderPath !== 'string') {
                          validate36.errors = [
                            {
                              instancePath:
                                instancePath + '/data/externalFolderPath',
                              schemaPath:
                                '#/definitions/IntegrationData/properties/externalFolderPath/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid2 = _errs12 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data1.externalFileName !== undefined) {
                          const _errs14 = errors;
                          if (typeof data1.externalFileName !== 'string') {
                            validate36.errors = [
                              {
                                instancePath:
                                  instancePath + '/data/externalFileName',
                                schemaPath:
                                  '#/definitions/IntegrationData/properties/externalFileName/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid2 = _errs14 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data1.externalDefaultSavePath !== undefined) {
                            const _errs16 = errors;
                            if (
                              typeof data1.externalDefaultSavePath !== 'string'
                            ) {
                              validate36.errors = [
                                {
                                  instancePath:
                                    instancePath +
                                    '/data/externalDefaultSavePath',
                                  schemaPath:
                                    '#/definitions/IntegrationData/properties/externalDefaultSavePath/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid2 = _errs16 === errors;
                          } else {
                            var valid2 = true;
                          }
                        }
                      }
                    }
                  }
                }
              }
            } else {
              validate36.errors = [
                {
                  instancePath: instancePath + '/data',
                  schemaPath: '#/definitions/IntegrationData/type',
                  keyword: 'type',
                  params: { type: 'object' },
                  message: 'must be object',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs3 === errors;
        } else {
          var valid0 = true;
        }
      }
    } else {
      validate36.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate36.errors = vErrors;
  return errors === 0;
}
function validate31(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == 'object' && !Array.isArray(data))) {
    validate31.errors = [
      {
        instancePath,
        schemaPath: '#/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      },
    ];
    return false;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (
    !validate32(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
    })
  ) {
    vErrors =
      vErrors === null ? validate32.errors : vErrors.concat(validate32.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs3 = errors;
  if (
    !validate34(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
    })
  ) {
    vErrors =
      vErrors === null ? validate34.errors : vErrors.concat(validate34.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs3 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs4 = errors;
    if (
      !validate36(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
      })
    ) {
      vErrors =
        vErrors === null
          ? validate36.errors
          : vErrors.concat(validate36.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs4 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
    }
  }
  if (!valid0) {
    const err0 = {
      instancePath,
      schemaPath: '#/oneOf',
      keyword: 'oneOf',
      params: { passingSchemas: passing0 },
      message: 'must match exactly one schema in oneOf',
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
    validate31.errors = vErrors;
    return false;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate31.errors = vErrors;
  return errors === 0;
}
function validate30(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="Flags.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (data.requestType === undefined && (missing0 = 'requestType')) {
        validate30.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.requestType !== undefined) {
          let data0 = data.requestType;
          const _errs1 = errors;
          if (
            !(
              typeof data0 == 'number' &&
              !(data0 % 1) &&
              !isNaN(data0) &&
              isFinite(data0)
            )
          ) {
            validate30.errors = [
              {
                instancePath: instancePath + '/requestType',
                schemaPath: '#/definitions/RequestType/type',
                keyword: 'type',
                params: { type: 'integer' },
                message: 'must be integer',
              },
            ];
            return false;
          }
          if (
            !(
              data0 === 1 ||
              data0 === 2 ||
              data0 === 3 ||
              data0 === 4 ||
              data0 === 5 ||
              data0 === 7 ||
              data0 === 8 ||
              data0 === 9 ||
              data0 === 10 ||
              data0 === 11 ||
              data0 === 12 ||
              data0 === 13
            )
          ) {
            validate30.errors = [
              {
                instancePath: instancePath + '/requestType',
                schemaPath: '#/definitions/RequestType/enum',
                keyword: 'enum',
                params: { allowedValues: schema45.enum },
                message: 'must be equal to one of the allowed values',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.isHelloFax !== undefined) {
            const _errs4 = errors;
            if (typeof data.isHelloFax !== 'boolean') {
              validate30.errors = [
                {
                  instancePath: instancePath + '/isHelloFax',
                  schemaPath: '#/properties/isHelloFax/type',
                  keyword: 'type',
                  params: { type: 'boolean' },
                  message: 'must be boolean',
                },
              ];
              return false;
            }
            var valid0 = _errs4 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.isResend !== undefined) {
              const _errs6 = errors;
              if (typeof data.isResend !== 'boolean') {
                validate30.errors = [
                  {
                    instancePath: instancePath + '/isResend',
                    schemaPath: '#/properties/isResend/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  },
                ];
                return false;
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.isMobileAppRequest !== undefined) {
                const _errs8 = errors;
                if (typeof data.isMobileAppRequest !== 'boolean') {
                  validate30.errors = [
                    {
                      instancePath: instancePath + '/isMobileAppRequest',
                      schemaPath: '#/properties/isMobileAppRequest/type',
                      keyword: 'type',
                      params: { type: 'boolean' },
                      message: 'must be boolean',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.integration !== undefined) {
                  const _errs10 = errors;
                  if (
                    !validate31(data.integration, {
                      instancePath: instancePath + '/integration',
                      parentData: data,
                      parentDataProperty: 'integration',
                      rootData,
                    })
                  ) {
                    vErrors =
                      vErrors === null
                        ? validate31.errors
                        : vErrors.concat(validate31.errors);
                    errors = vErrors.length;
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.hasTemplateReuseWarning !== undefined) {
                    const _errs11 = errors;
                    if (typeof data.hasTemplateReuseWarning !== 'boolean') {
                      validate30.errors = [
                        {
                          instancePath:
                            instancePath + '/hasTemplateReuseWarning',
                          schemaPath:
                            '#/properties/hasTemplateReuseWarning/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.shouldRouteToPrepAndSend !== undefined) {
                      const _errs13 = errors;
                      if (typeof data.shouldRouteToPrepAndSend !== 'boolean') {
                        validate30.errors = [
                          {
                            instancePath:
                              instancePath + '/shouldRouteToPrepAndSend',
                            schemaPath:
                              '#/properties/shouldRouteToPrepAndSend/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.displayDocToTemplateBanner !== undefined) {
                        const _errs15 = errors;
                        if (
                          typeof data.displayDocToTemplateBanner !== 'boolean'
                        ) {
                          validate30.errors = [
                            {
                              instancePath:
                                instancePath + '/displayDocToTemplateBanner',
                              schemaPath:
                                '#/properties/displayDocToTemplateBanner/type',
                              keyword: 'type',
                              params: { type: 'boolean' },
                              message: 'must be boolean',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.docToTemplateCurrentVariation !== undefined) {
                          const _errs17 = errors;
                          if (
                            typeof data.docToTemplateCurrentVariation !==
                            'boolean'
                          ) {
                            validate30.errors = [
                              {
                                instancePath:
                                  instancePath +
                                  '/docToTemplateCurrentVariation',
                                schemaPath:
                                  '#/properties/docToTemplateCurrentVariation/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs17 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.shouldConvertDocToTemplate !== undefined) {
                            const _errs19 = errors;
                            if (
                              typeof data.shouldConvertDocToTemplate !==
                              'boolean'
                            ) {
                              validate30.errors = [
                                {
                                  instancePath:
                                    instancePath +
                                    '/shouldConvertDocToTemplate',
                                  schemaPath:
                                    '#/properties/shouldConvertDocToTemplate/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs19 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (
                              data.templateConversionCandidateId !== undefined
                            ) {
                              const _errs21 = errors;
                              if (
                                typeof data.templateConversionCandidateId !==
                                'string'
                              ) {
                                validate30.errors = [
                                  {
                                    instancePath:
                                      instancePath +
                                      '/templateConversionCandidateId',
                                    schemaPath:
                                      '#/properties/templateConversionCandidateId/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs21 === errors;
                            } else {
                              var valid0 = true;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate30.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate30.errors = vErrors;
  return errors === 0;
}
const schema53 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'AccountSettings.json',
  type: 'object',
  title: 'AccountSettings',
  properties: {
    allowIntegrationsUpload: {
      type: 'boolean',
      description:
        "Allow user to select a file from third-party website on 'Select documents' page",
    },
    allowRecipientAccessCodes: {
      type: 'boolean',
      description:
        'Ability to add signer pin per signer as part of the signature request',
    },
    allowRecipientSmsAuthNumbers: {
      type: 'boolean',
      description:
        'Ability to add signer SMS authentication per signer as part of the signature request',
    },
    allowRecipientAttachments: {
      type: 'boolean',
      description:
        'Ability to require signers to attach (both required or optional) attachments as part of their signing process',
    },
    allowRecipientReassignment: {
      type: 'boolean',
      description:
        "Allow recipient reassignment checkbox on 'Add signers' page",
    },
    allowQualifiedSignature: {
      type: 'boolean',
      description:
        'Should this user be given the ability to send Qualified E-Signatures',
    },
    allowSmsSignatureDelivery: {
      type: 'boolean',
      description:
        'The SMS tools add-on has been purchased and this account has permission to use it',
    },
    allowTemplateDelete: {
      type: 'boolean',
      description: 'Allow template deletion from P&S workflow',
    },
    allowCreateEditTemplate: {
      type: 'boolean',
      description:
        'True if the current account has permission to create/edit templates',
    },
    allowTemplatePreview: {
      type: 'boolean',
      description:
        'True if the current account has the ability to preview templates',
    },
    allowOptionalTemplateSigners: {
      type: 'boolean',
      description:
        'Allow template signature requests to have optional signers if at least one signer is populated.',
    },
    allowSmsAuth: { type: 'boolean', description: 'Allow SMS authentication' },
    allowBulkSend: { type: 'boolean', description: 'Allow bulk send' },
    canAccessRecipientAccessCodes: {
      type: 'boolean',
      description:
        'Has a non-Enterprise+ plan that can use recipient access codes regardless of setting',
    },
    canUpgradeTierSmsSignatureDelivery: {
      type: 'boolean',
      description:
        "User's add-on tier for SMS Signature Delivery can be auto-upgraded",
    },
    noMultiFaxes: {
      type: 'boolean',
      description:
        'Is the account prevented from sending faxes to multiple recipients',
    },
    maxTemplateNumber: {
      type: 'number',
      description: 'User subscription template quota',
    },
    isAtTemplateLimit: {
      type: 'boolean',
      description:
        "Is user at their account-type's limit for creating templates?",
    },
    isAtDocumentLimit: {
      type: 'boolean',
      description:
        "Is user at their account-type's limit for sending signature request?",
    },
    hasHIPAA: {
      type: 'boolean',
      description: "Does the user's subsription have the HIPAA tag?",
    },
    isNewHsPlan: {
      type: 'boolean',
      description: 'Is the plan in context a Blueberry plan?',
    },
    isTransactionalPlan: {
      type: 'boolean',
      description: 'Is the plan in context a transactional plan?',
    },
    alwaysSendMeACopy: {
      type: 'boolean',
      description: 'User wants a copy of PDF/Fax sent to themselves',
    },
    alwaysSendOthersACopy: {
      type: 'boolean',
      description:
        'User wants a copy of complete/faxed PDF sent to recipients and CCs',
    },
    needsCharge: {
      type: 'boolean',
      description: 'True if the fax request needs a one-time charge',
    },
    chargeType: {
      type: 'string',
      description: 'Which charge flow the user needs to see',
    },
    totalPriceInCents: {
      type: 'number',
      description: 'The total price of the charge in cents',
    },
    freeFaxPagesLeft: {
      type: 'number',
      description: 'The amount of free faxes the account has left',
    },
    faxPageCurrentCount: {
      type: 'number',
      description: 'The amount of fax pages in the current request',
    },
    overageFaxMaxLimitInCents: {
      type: 'number',
      description: 'The maximum fax price users can send in a free account',
    },
    pricePerFaxInCents: {
      type: 'number',
      description: "The normal price for a fax on the account's subscription",
    },
    initialPageLimit: {
      type: 'number',
      description: 'How many pages until you are over the initial pricePerFax',
    },
    overagePriceInCentsPerPage: {
      type: 'number',
      description: 'How much each page costs after your initial limit',
    },
    internationalMultiplier: {
      type: 'number',
      description:
        'How much the price of a page multiplies based on the receiving country',
    },
    uploadIntegrations: { $ref: '#/definitions/UploadIntegrations' },
    isSMSToolsOn: {
      type: 'boolean',
      description:
        'The SMS tools add-on has been purchased AND its setting is turned on via Admin Console',
    },
  },
  required: ['allowTemplateDelete', 'uploadIntegrations'],
  definitions: {
    UploadIntegrationType: {
      type: 'string',
      title: 'UploadIntegrationType',
      enum: ['B', 'D', 'E', 'G', 'T'],
      tsEnumNames: ['Box', 'Dropbox', 'Evernote', 'GoogleDrive', 'OneDrive'],
      'x-enum-names': ['Box', 'Dropbox', 'Evernote', 'GoogleDrive', 'OneDrive'],
    },
    DropboxIntegration: {
      type: 'object',
      title: 'DropboxIntegration',
      properties: {
        id: { const: 'D', default: 'D' },
        key: { type: 'string' },
        nonce: { type: 'string' },
        enabled: { type: 'boolean' },
      },
      required: ['id', 'key', 'nonce', 'enabled'],
    },
    OneDriveIntegration: {
      type: 'object',
      title: 'OneDriveIntegration',
      properties: {
        id: { const: 'T', default: 'T' },
        token: { type: 'string' },
        clientId: { type: 'string' },
        nonce: { type: 'string' },
        enabled: { type: 'boolean' },
      },
      required: ['id', 'clientId', 'nonce', 'enabled'],
    },
    GoogleDriveIntegration: {
      type: 'object',
      title: 'GoogleDriveIntegration',
      properties: {
        id: { const: 'G', default: 'G' },
        key: { type: 'string' },
        token: { type: 'string' },
        abbrKey: { type: 'string' },
        enabled: { type: 'boolean' },
      },
      required: ['id', 'key', 'abbrKey', 'enabled'],
    },
    BoxIntegration: {
      type: 'object',
      title: 'BoxIntegration',
      properties: {
        id: { const: 'B', default: 'B' },
        enabled: { type: 'boolean' },
      },
      required: ['id', 'enabled'],
    },
    EvernoteIntegration: {
      type: 'object',
      title: 'EvernoteIntegration',
      properties: {
        id: { const: 'E', default: 'E' },
        enabled: { type: 'boolean' },
      },
      required: ['id', 'enabled'],
    },
    UploadIntegrations: {
      type: 'object',
      title: 'UploadIntegrations',
      properties: {
        D: { $ref: '#/definitions/DropboxIntegration' },
        T: { $ref: '#/definitions/OneDriveIntegration' },
        G: { $ref: '#/definitions/GoogleDriveIntegration' },
        B: { $ref: '#/definitions/BoxIntegration' },
        E: { $ref: '#/definitions/EvernoteIntegration' },
      },
    },
  },
};
const schema54 = {
  type: 'object',
  title: 'UploadIntegrations',
  properties: {
    D: { $ref: '#/definitions/DropboxIntegration' },
    T: { $ref: '#/definitions/OneDriveIntegration' },
    G: { $ref: '#/definitions/GoogleDriveIntegration' },
    B: { $ref: '#/definitions/BoxIntegration' },
    E: { $ref: '#/definitions/EvernoteIntegration' },
  },
};
const schema55 = {
  type: 'object',
  title: 'DropboxIntegration',
  properties: {
    id: { const: 'D', default: 'D' },
    key: { type: 'string' },
    nonce: { type: 'string' },
    enabled: { type: 'boolean' },
  },
  required: ['id', 'key', 'nonce', 'enabled'],
};
const schema56 = {
  type: 'object',
  title: 'OneDriveIntegration',
  properties: {
    id: { const: 'T', default: 'T' },
    token: { type: 'string' },
    clientId: { type: 'string' },
    nonce: { type: 'string' },
    enabled: { type: 'boolean' },
  },
  required: ['id', 'clientId', 'nonce', 'enabled'],
};
const schema57 = {
  type: 'object',
  title: 'GoogleDriveIntegration',
  properties: {
    id: { const: 'G', default: 'G' },
    key: { type: 'string' },
    token: { type: 'string' },
    abbrKey: { type: 'string' },
    enabled: { type: 'boolean' },
  },
  required: ['id', 'key', 'abbrKey', 'enabled'],
};
const schema58 = {
  type: 'object',
  title: 'BoxIntegration',
  properties: {
    id: { const: 'B', default: 'B' },
    enabled: { type: 'boolean' },
  },
  required: ['id', 'enabled'],
};
const schema59 = {
  type: 'object',
  title: 'EvernoteIntegration',
  properties: {
    id: { const: 'E', default: 'E' },
    enabled: { type: 'boolean' },
  },
  required: ['id', 'enabled'],
};
function validate41(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.D !== undefined) {
        let data0 = data.D;
        const _errs1 = errors;
        const _errs2 = errors;
        if (errors === _errs2) {
          if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
            let missing0;
            if (
              (data0.id === undefined && (missing0 = 'id')) ||
              (data0.key === undefined && (missing0 = 'key')) ||
              (data0.nonce === undefined && (missing0 = 'nonce')) ||
              (data0.enabled === undefined && (missing0 = 'enabled'))
            ) {
              validate41.errors = [
                {
                  instancePath: instancePath + '/D',
                  schemaPath: '#/definitions/DropboxIntegration/required',
                  keyword: 'required',
                  params: { missingProperty: missing0 },
                  message: "must have required property '" + missing0 + "'",
                },
              ];
              return false;
            } else {
              if (data0.id !== undefined) {
                const _errs4 = errors;
                if (!func0(data0.id, 'D')) {
                  validate41.errors = [
                    {
                      instancePath: instancePath + '/D/id',
                      schemaPath:
                        '#/definitions/DropboxIntegration/properties/id/const',
                      keyword: 'const',
                      params: { allowedValue: 'D' },
                      message: 'must be equal to constant',
                    },
                  ];
                  return false;
                }
                var valid2 = _errs4 === errors;
              } else {
                var valid2 = true;
              }
              if (valid2) {
                if (data0.key !== undefined) {
                  const _errs5 = errors;
                  if (typeof data0.key !== 'string') {
                    validate41.errors = [
                      {
                        instancePath: instancePath + '/D/key',
                        schemaPath:
                          '#/definitions/DropboxIntegration/properties/key/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid2 = _errs5 === errors;
                } else {
                  var valid2 = true;
                }
                if (valid2) {
                  if (data0.nonce !== undefined) {
                    const _errs7 = errors;
                    if (typeof data0.nonce !== 'string') {
                      validate41.errors = [
                        {
                          instancePath: instancePath + '/D/nonce',
                          schemaPath:
                            '#/definitions/DropboxIntegration/properties/nonce/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid2 = _errs7 === errors;
                  } else {
                    var valid2 = true;
                  }
                  if (valid2) {
                    if (data0.enabled !== undefined) {
                      const _errs9 = errors;
                      if (typeof data0.enabled !== 'boolean') {
                        validate41.errors = [
                          {
                            instancePath: instancePath + '/D/enabled',
                            schemaPath:
                              '#/definitions/DropboxIntegration/properties/enabled/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs9 === errors;
                    } else {
                      var valid2 = true;
                    }
                  }
                }
              }
            }
          } else {
            validate41.errors = [
              {
                instancePath: instancePath + '/D',
                schemaPath: '#/definitions/DropboxIntegration/type',
                keyword: 'type',
                params: { type: 'object' },
                message: 'must be object',
              },
            ];
            return false;
          }
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.T !== undefined) {
          let data5 = data.T;
          const _errs11 = errors;
          const _errs12 = errors;
          if (errors === _errs12) {
            if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
              let missing1;
              if (
                (data5.id === undefined && (missing1 = 'id')) ||
                (data5.clientId === undefined && (missing1 = 'clientId')) ||
                (data5.nonce === undefined && (missing1 = 'nonce')) ||
                (data5.enabled === undefined && (missing1 = 'enabled'))
              ) {
                validate41.errors = [
                  {
                    instancePath: instancePath + '/T',
                    schemaPath: '#/definitions/OneDriveIntegration/required',
                    keyword: 'required',
                    params: { missingProperty: missing1 },
                    message: "must have required property '" + missing1 + "'",
                  },
                ];
                return false;
              } else {
                if (data5.id !== undefined) {
                  const _errs14 = errors;
                  if (!func0(data5.id, 'T')) {
                    validate41.errors = [
                      {
                        instancePath: instancePath + '/T/id',
                        schemaPath:
                          '#/definitions/OneDriveIntegration/properties/id/const',
                        keyword: 'const',
                        params: { allowedValue: 'T' },
                        message: 'must be equal to constant',
                      },
                    ];
                    return false;
                  }
                  var valid4 = _errs14 === errors;
                } else {
                  var valid4 = true;
                }
                if (valid4) {
                  if (data5.token !== undefined) {
                    const _errs15 = errors;
                    if (typeof data5.token !== 'string') {
                      validate41.errors = [
                        {
                          instancePath: instancePath + '/T/token',
                          schemaPath:
                            '#/definitions/OneDriveIntegration/properties/token/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid4 = _errs15 === errors;
                  } else {
                    var valid4 = true;
                  }
                  if (valid4) {
                    if (data5.clientId !== undefined) {
                      const _errs17 = errors;
                      if (typeof data5.clientId !== 'string') {
                        validate41.errors = [
                          {
                            instancePath: instancePath + '/T/clientId',
                            schemaPath:
                              '#/definitions/OneDriveIntegration/properties/clientId/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid4 = _errs17 === errors;
                    } else {
                      var valid4 = true;
                    }
                    if (valid4) {
                      if (data5.nonce !== undefined) {
                        const _errs19 = errors;
                        if (typeof data5.nonce !== 'string') {
                          validate41.errors = [
                            {
                              instancePath: instancePath + '/T/nonce',
                              schemaPath:
                                '#/definitions/OneDriveIntegration/properties/nonce/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid4 = _errs19 === errors;
                      } else {
                        var valid4 = true;
                      }
                      if (valid4) {
                        if (data5.enabled !== undefined) {
                          const _errs21 = errors;
                          if (typeof data5.enabled !== 'boolean') {
                            validate41.errors = [
                              {
                                instancePath: instancePath + '/T/enabled',
                                schemaPath:
                                  '#/definitions/OneDriveIntegration/properties/enabled/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid4 = _errs21 === errors;
                        } else {
                          var valid4 = true;
                        }
                      }
                    }
                  }
                }
              }
            } else {
              validate41.errors = [
                {
                  instancePath: instancePath + '/T',
                  schemaPath: '#/definitions/OneDriveIntegration/type',
                  keyword: 'type',
                  params: { type: 'object' },
                  message: 'must be object',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs11 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.G !== undefined) {
            let data11 = data.G;
            const _errs23 = errors;
            const _errs24 = errors;
            if (errors === _errs24) {
              if (
                data11 &&
                typeof data11 == 'object' &&
                !Array.isArray(data11)
              ) {
                let missing2;
                if (
                  (data11.id === undefined && (missing2 = 'id')) ||
                  (data11.key === undefined && (missing2 = 'key')) ||
                  (data11.abbrKey === undefined && (missing2 = 'abbrKey')) ||
                  (data11.enabled === undefined && (missing2 = 'enabled'))
                ) {
                  validate41.errors = [
                    {
                      instancePath: instancePath + '/G',
                      schemaPath:
                        '#/definitions/GoogleDriveIntegration/required',
                      keyword: 'required',
                      params: { missingProperty: missing2 },
                      message: "must have required property '" + missing2 + "'",
                    },
                  ];
                  return false;
                } else {
                  if (data11.id !== undefined) {
                    const _errs26 = errors;
                    if (!func0(data11.id, 'G')) {
                      validate41.errors = [
                        {
                          instancePath: instancePath + '/G/id',
                          schemaPath:
                            '#/definitions/GoogleDriveIntegration/properties/id/const',
                          keyword: 'const',
                          params: { allowedValue: 'G' },
                          message: 'must be equal to constant',
                        },
                      ];
                      return false;
                    }
                    var valid6 = _errs26 === errors;
                  } else {
                    var valid6 = true;
                  }
                  if (valid6) {
                    if (data11.key !== undefined) {
                      const _errs27 = errors;
                      if (typeof data11.key !== 'string') {
                        validate41.errors = [
                          {
                            instancePath: instancePath + '/G/key',
                            schemaPath:
                              '#/definitions/GoogleDriveIntegration/properties/key/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid6 = _errs27 === errors;
                    } else {
                      var valid6 = true;
                    }
                    if (valid6) {
                      if (data11.token !== undefined) {
                        const _errs29 = errors;
                        if (typeof data11.token !== 'string') {
                          validate41.errors = [
                            {
                              instancePath: instancePath + '/G/token',
                              schemaPath:
                                '#/definitions/GoogleDriveIntegration/properties/token/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid6 = _errs29 === errors;
                      } else {
                        var valid6 = true;
                      }
                      if (valid6) {
                        if (data11.abbrKey !== undefined) {
                          const _errs31 = errors;
                          if (typeof data11.abbrKey !== 'string') {
                            validate41.errors = [
                              {
                                instancePath: instancePath + '/G/abbrKey',
                                schemaPath:
                                  '#/definitions/GoogleDriveIntegration/properties/abbrKey/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid6 = _errs31 === errors;
                        } else {
                          var valid6 = true;
                        }
                        if (valid6) {
                          if (data11.enabled !== undefined) {
                            const _errs33 = errors;
                            if (typeof data11.enabled !== 'boolean') {
                              validate41.errors = [
                                {
                                  instancePath: instancePath + '/G/enabled',
                                  schemaPath:
                                    '#/definitions/GoogleDriveIntegration/properties/enabled/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid6 = _errs33 === errors;
                          } else {
                            var valid6 = true;
                          }
                        }
                      }
                    }
                  }
                }
              } else {
                validate41.errors = [
                  {
                    instancePath: instancePath + '/G',
                    schemaPath: '#/definitions/GoogleDriveIntegration/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                  },
                ];
                return false;
              }
            }
            var valid0 = _errs23 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.B !== undefined) {
              let data17 = data.B;
              const _errs35 = errors;
              const _errs36 = errors;
              if (errors === _errs36) {
                if (
                  data17 &&
                  typeof data17 == 'object' &&
                  !Array.isArray(data17)
                ) {
                  let missing3;
                  if (
                    (data17.id === undefined && (missing3 = 'id')) ||
                    (data17.enabled === undefined && (missing3 = 'enabled'))
                  ) {
                    validate41.errors = [
                      {
                        instancePath: instancePath + '/B',
                        schemaPath: '#/definitions/BoxIntegration/required',
                        keyword: 'required',
                        params: { missingProperty: missing3 },
                        message:
                          "must have required property '" + missing3 + "'",
                      },
                    ];
                    return false;
                  } else {
                    if (data17.id !== undefined) {
                      const _errs38 = errors;
                      if (!func0(data17.id, 'B')) {
                        validate41.errors = [
                          {
                            instancePath: instancePath + '/B/id',
                            schemaPath:
                              '#/definitions/BoxIntegration/properties/id/const',
                            keyword: 'const',
                            params: { allowedValue: 'B' },
                            message: 'must be equal to constant',
                          },
                        ];
                        return false;
                      }
                      var valid8 = _errs38 === errors;
                    } else {
                      var valid8 = true;
                    }
                    if (valid8) {
                      if (data17.enabled !== undefined) {
                        const _errs39 = errors;
                        if (typeof data17.enabled !== 'boolean') {
                          validate41.errors = [
                            {
                              instancePath: instancePath + '/B/enabled',
                              schemaPath:
                                '#/definitions/BoxIntegration/properties/enabled/type',
                              keyword: 'type',
                              params: { type: 'boolean' },
                              message: 'must be boolean',
                            },
                          ];
                          return false;
                        }
                        var valid8 = _errs39 === errors;
                      } else {
                        var valid8 = true;
                      }
                    }
                  }
                } else {
                  validate41.errors = [
                    {
                      instancePath: instancePath + '/B',
                      schemaPath: '#/definitions/BoxIntegration/type',
                      keyword: 'type',
                      params: { type: 'object' },
                      message: 'must be object',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs35 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.E !== undefined) {
                let data20 = data.E;
                const _errs41 = errors;
                const _errs42 = errors;
                if (errors === _errs42) {
                  if (
                    data20 &&
                    typeof data20 == 'object' &&
                    !Array.isArray(data20)
                  ) {
                    let missing4;
                    if (
                      (data20.id === undefined && (missing4 = 'id')) ||
                      (data20.enabled === undefined && (missing4 = 'enabled'))
                    ) {
                      validate41.errors = [
                        {
                          instancePath: instancePath + '/E',
                          schemaPath:
                            '#/definitions/EvernoteIntegration/required',
                          keyword: 'required',
                          params: { missingProperty: missing4 },
                          message:
                            "must have required property '" + missing4 + "'",
                        },
                      ];
                      return false;
                    } else {
                      if (data20.id !== undefined) {
                        const _errs44 = errors;
                        if (!func0(data20.id, 'E')) {
                          validate41.errors = [
                            {
                              instancePath: instancePath + '/E/id',
                              schemaPath:
                                '#/definitions/EvernoteIntegration/properties/id/const',
                              keyword: 'const',
                              params: { allowedValue: 'E' },
                              message: 'must be equal to constant',
                            },
                          ];
                          return false;
                        }
                        var valid10 = _errs44 === errors;
                      } else {
                        var valid10 = true;
                      }
                      if (valid10) {
                        if (data20.enabled !== undefined) {
                          const _errs45 = errors;
                          if (typeof data20.enabled !== 'boolean') {
                            validate41.errors = [
                              {
                                instancePath: instancePath + '/E/enabled',
                                schemaPath:
                                  '#/definitions/EvernoteIntegration/properties/enabled/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid10 = _errs45 === errors;
                        } else {
                          var valid10 = true;
                        }
                      }
                    }
                  } else {
                    validate41.errors = [
                      {
                        instancePath: instancePath + '/E',
                        schemaPath: '#/definitions/EvernoteIntegration/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs41 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate41.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate41.errors = vErrors;
  return errors === 0;
}
function validate40(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="AccountSettings.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.allowTemplateDelete === undefined &&
          (missing0 = 'allowTemplateDelete')) ||
        (data.uploadIntegrations === undefined &&
          (missing0 = 'uploadIntegrations'))
      ) {
        validate40.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.allowIntegrationsUpload !== undefined) {
          const _errs1 = errors;
          if (typeof data.allowIntegrationsUpload !== 'boolean') {
            validate40.errors = [
              {
                instancePath: instancePath + '/allowIntegrationsUpload',
                schemaPath: '#/properties/allowIntegrationsUpload/type',
                keyword: 'type',
                params: { type: 'boolean' },
                message: 'must be boolean',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.allowRecipientAccessCodes !== undefined) {
            const _errs3 = errors;
            if (typeof data.allowRecipientAccessCodes !== 'boolean') {
              validate40.errors = [
                {
                  instancePath: instancePath + '/allowRecipientAccessCodes',
                  schemaPath: '#/properties/allowRecipientAccessCodes/type',
                  keyword: 'type',
                  params: { type: 'boolean' },
                  message: 'must be boolean',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.allowRecipientSmsAuthNumbers !== undefined) {
              const _errs5 = errors;
              if (typeof data.allowRecipientSmsAuthNumbers !== 'boolean') {
                validate40.errors = [
                  {
                    instancePath:
                      instancePath + '/allowRecipientSmsAuthNumbers',
                    schemaPath:
                      '#/properties/allowRecipientSmsAuthNumbers/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.allowRecipientAttachments !== undefined) {
                const _errs7 = errors;
                if (typeof data.allowRecipientAttachments !== 'boolean') {
                  validate40.errors = [
                    {
                      instancePath: instancePath + '/allowRecipientAttachments',
                      schemaPath: '#/properties/allowRecipientAttachments/type',
                      keyword: 'type',
                      params: { type: 'boolean' },
                      message: 'must be boolean',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.allowRecipientReassignment !== undefined) {
                  const _errs9 = errors;
                  if (typeof data.allowRecipientReassignment !== 'boolean') {
                    validate40.errors = [
                      {
                        instancePath:
                          instancePath + '/allowRecipientReassignment',
                        schemaPath:
                          '#/properties/allowRecipientReassignment/type',
                        keyword: 'type',
                        params: { type: 'boolean' },
                        message: 'must be boolean',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.allowQualifiedSignature !== undefined) {
                    const _errs11 = errors;
                    if (typeof data.allowQualifiedSignature !== 'boolean') {
                      validate40.errors = [
                        {
                          instancePath:
                            instancePath + '/allowQualifiedSignature',
                          schemaPath:
                            '#/properties/allowQualifiedSignature/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.allowSmsSignatureDelivery !== undefined) {
                      const _errs13 = errors;
                      if (typeof data.allowSmsSignatureDelivery !== 'boolean') {
                        validate40.errors = [
                          {
                            instancePath:
                              instancePath + '/allowSmsSignatureDelivery',
                            schemaPath:
                              '#/properties/allowSmsSignatureDelivery/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.allowTemplateDelete !== undefined) {
                        const _errs15 = errors;
                        if (typeof data.allowTemplateDelete !== 'boolean') {
                          validate40.errors = [
                            {
                              instancePath:
                                instancePath + '/allowTemplateDelete',
                              schemaPath:
                                '#/properties/allowTemplateDelete/type',
                              keyword: 'type',
                              params: { type: 'boolean' },
                              message: 'must be boolean',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.allowCreateEditTemplate !== undefined) {
                          const _errs17 = errors;
                          if (
                            typeof data.allowCreateEditTemplate !== 'boolean'
                          ) {
                            validate40.errors = [
                              {
                                instancePath:
                                  instancePath + '/allowCreateEditTemplate',
                                schemaPath:
                                  '#/properties/allowCreateEditTemplate/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs17 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.allowTemplatePreview !== undefined) {
                            const _errs19 = errors;
                            if (
                              typeof data.allowTemplatePreview !== 'boolean'
                            ) {
                              validate40.errors = [
                                {
                                  instancePath:
                                    instancePath + '/allowTemplatePreview',
                                  schemaPath:
                                    '#/properties/allowTemplatePreview/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs19 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (
                              data.allowOptionalTemplateSigners !== undefined
                            ) {
                              const _errs21 = errors;
                              if (
                                typeof data.allowOptionalTemplateSigners !==
                                'boolean'
                              ) {
                                validate40.errors = [
                                  {
                                    instancePath:
                                      instancePath +
                                      '/allowOptionalTemplateSigners',
                                    schemaPath:
                                      '#/properties/allowOptionalTemplateSigners/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs21 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.allowSmsAuth !== undefined) {
                                const _errs23 = errors;
                                if (typeof data.allowSmsAuth !== 'boolean') {
                                  validate40.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/allowSmsAuth',
                                      schemaPath:
                                        '#/properties/allowSmsAuth/type',
                                      keyword: 'type',
                                      params: { type: 'boolean' },
                                      message: 'must be boolean',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs23 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.allowBulkSend !== undefined) {
                                  const _errs25 = errors;
                                  if (typeof data.allowBulkSend !== 'boolean') {
                                    validate40.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/allowBulkSend',
                                        schemaPath:
                                          '#/properties/allowBulkSend/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs25 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (
                                    data.canAccessRecipientAccessCodes !==
                                    undefined
                                  ) {
                                    const _errs27 = errors;
                                    if (
                                      typeof data.canAccessRecipientAccessCodes !==
                                      'boolean'
                                    ) {
                                      validate40.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/canAccessRecipientAccessCodes',
                                          schemaPath:
                                            '#/properties/canAccessRecipientAccessCodes/type',
                                          keyword: 'type',
                                          params: { type: 'boolean' },
                                          message: 'must be boolean',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid0 = _errs27 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (
                                      data.canUpgradeTierSmsSignatureDelivery !==
                                      undefined
                                    ) {
                                      const _errs29 = errors;
                                      if (
                                        typeof data.canUpgradeTierSmsSignatureDelivery !==
                                        'boolean'
                                      ) {
                                        validate40.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/canUpgradeTierSmsSignatureDelivery',
                                            schemaPath:
                                              '#/properties/canUpgradeTierSmsSignatureDelivery/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid0 = _errs29 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.noMultiFaxes !== undefined) {
                                        const _errs31 = errors;
                                        if (
                                          typeof data.noMultiFaxes !== 'boolean'
                                        ) {
                                          validate40.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/noMultiFaxes',
                                              schemaPath:
                                                '#/properties/noMultiFaxes/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid0 = _errs31 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (
                                          data.maxTemplateNumber !== undefined
                                        ) {
                                          let data16 = data.maxTemplateNumber;
                                          const _errs33 = errors;
                                          if (
                                            !(
                                              typeof data16 == 'number' &&
                                              isFinite(data16)
                                            )
                                          ) {
                                            validate40.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/maxTemplateNumber',
                                                schemaPath:
                                                  '#/properties/maxTemplateNumber/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid0 = _errs33 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                        if (valid0) {
                                          if (
                                            data.isAtTemplateLimit !== undefined
                                          ) {
                                            const _errs35 = errors;
                                            if (
                                              typeof data.isAtTemplateLimit !==
                                              'boolean'
                                            ) {
                                              validate40.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/isAtTemplateLimit',
                                                  schemaPath:
                                                    '#/properties/isAtTemplateLimit/type',
                                                  keyword: 'type',
                                                  params: { type: 'boolean' },
                                                  message: 'must be boolean',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid0 = _errs35 === errors;
                                          } else {
                                            var valid0 = true;
                                          }
                                          if (valid0) {
                                            if (
                                              data.isAtDocumentLimit !==
                                              undefined
                                            ) {
                                              const _errs37 = errors;
                                              if (
                                                typeof data.isAtDocumentLimit !==
                                                'boolean'
                                              ) {
                                                validate40.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/isAtDocumentLimit',
                                                    schemaPath:
                                                      '#/properties/isAtDocumentLimit/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid0 = _errs37 === errors;
                                            } else {
                                              var valid0 = true;
                                            }
                                            if (valid0) {
                                              if (data.hasHIPAA !== undefined) {
                                                const _errs39 = errors;
                                                if (
                                                  typeof data.hasHIPAA !==
                                                  'boolean'
                                                ) {
                                                  validate40.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/hasHIPAA',
                                                      schemaPath:
                                                        '#/properties/hasHIPAA/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'boolean',
                                                      },
                                                      message:
                                                        'must be boolean',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid0 = _errs39 === errors;
                                              } else {
                                                var valid0 = true;
                                              }
                                              if (valid0) {
                                                if (
                                                  data.isNewHsPlan !== undefined
                                                ) {
                                                  const _errs41 = errors;
                                                  if (
                                                    typeof data.isNewHsPlan !==
                                                    'boolean'
                                                  ) {
                                                    validate40.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath +
                                                          '/isNewHsPlan',
                                                        schemaPath:
                                                          '#/properties/isNewHsPlan/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'boolean',
                                                        },
                                                        message:
                                                          'must be boolean',
                                                      },
                                                    ];
                                                    return false;
                                                  }
                                                  var valid0 =
                                                    _errs41 === errors;
                                                } else {
                                                  var valid0 = true;
                                                }
                                                if (valid0) {
                                                  if (
                                                    data.isTransactionalPlan !==
                                                    undefined
                                                  ) {
                                                    const _errs43 = errors;
                                                    if (
                                                      typeof data.isTransactionalPlan !==
                                                      'boolean'
                                                    ) {
                                                      validate40.errors = [
                                                        {
                                                          instancePath:
                                                            instancePath +
                                                            '/isTransactionalPlan',
                                                          schemaPath:
                                                            '#/properties/isTransactionalPlan/type',
                                                          keyword: 'type',
                                                          params: {
                                                            type: 'boolean',
                                                          },
                                                          message:
                                                            'must be boolean',
                                                        },
                                                      ];
                                                      return false;
                                                    }
                                                    var valid0 =
                                                      _errs43 === errors;
                                                  } else {
                                                    var valid0 = true;
                                                  }
                                                  if (valid0) {
                                                    if (
                                                      data.alwaysSendMeACopy !==
                                                      undefined
                                                    ) {
                                                      const _errs45 = errors;
                                                      if (
                                                        typeof data.alwaysSendMeACopy !==
                                                        'boolean'
                                                      ) {
                                                        validate40.errors = [
                                                          {
                                                            instancePath:
                                                              instancePath +
                                                              '/alwaysSendMeACopy',
                                                            schemaPath:
                                                              '#/properties/alwaysSendMeACopy/type',
                                                            keyword: 'type',
                                                            params: {
                                                              type: 'boolean',
                                                            },
                                                            message:
                                                              'must be boolean',
                                                          },
                                                        ];
                                                        return false;
                                                      }
                                                      var valid0 =
                                                        _errs45 === errors;
                                                    } else {
                                                      var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                      if (
                                                        data.alwaysSendOthersACopy !==
                                                        undefined
                                                      ) {
                                                        const _errs47 = errors;
                                                        if (
                                                          typeof data.alwaysSendOthersACopy !==
                                                          'boolean'
                                                        ) {
                                                          validate40.errors = [
                                                            {
                                                              instancePath:
                                                                instancePath +
                                                                '/alwaysSendOthersACopy',
                                                              schemaPath:
                                                                '#/properties/alwaysSendOthersACopy/type',
                                                              keyword: 'type',
                                                              params: {
                                                                type: 'boolean',
                                                              },
                                                              message:
                                                                'must be boolean',
                                                            },
                                                          ];
                                                          return false;
                                                        }
                                                        var valid0 =
                                                          _errs47 === errors;
                                                      } else {
                                                        var valid0 = true;
                                                      }
                                                      if (valid0) {
                                                        if (
                                                          data.needsCharge !==
                                                          undefined
                                                        ) {
                                                          const _errs49 =
                                                            errors;
                                                          if (
                                                            typeof data.needsCharge !==
                                                            'boolean'
                                                          ) {
                                                            validate40.errors =
                                                              [
                                                                {
                                                                  instancePath:
                                                                    instancePath +
                                                                    '/needsCharge',
                                                                  schemaPath:
                                                                    '#/properties/needsCharge/type',
                                                                  keyword:
                                                                    'type',
                                                                  params: {
                                                                    type: 'boolean',
                                                                  },
                                                                  message:
                                                                    'must be boolean',
                                                                },
                                                              ];
                                                            return false;
                                                          }
                                                          var valid0 =
                                                            _errs49 === errors;
                                                        } else {
                                                          var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                          if (
                                                            data.chargeType !==
                                                            undefined
                                                          ) {
                                                            const _errs51 =
                                                              errors;
                                                            if (
                                                              typeof data.chargeType !==
                                                              'string'
                                                            ) {
                                                              validate40.errors =
                                                                [
                                                                  {
                                                                    instancePath:
                                                                      instancePath +
                                                                      '/chargeType',
                                                                    schemaPath:
                                                                      '#/properties/chargeType/type',
                                                                    keyword:
                                                                      'type',
                                                                    params: {
                                                                      type: 'string',
                                                                    },
                                                                    message:
                                                                      'must be string',
                                                                  },
                                                                ];
                                                              return false;
                                                            }
                                                            var valid0 =
                                                              _errs51 ===
                                                              errors;
                                                          } else {
                                                            var valid0 = true;
                                                          }
                                                          if (valid0) {
                                                            if (
                                                              data.totalPriceInCents !==
                                                              undefined
                                                            ) {
                                                              let data26 =
                                                                data.totalPriceInCents;
                                                              const _errs53 =
                                                                errors;
                                                              if (
                                                                !(
                                                                  typeof data26 ==
                                                                    'number' &&
                                                                  isFinite(
                                                                    data26
                                                                  )
                                                                )
                                                              ) {
                                                                validate40.errors =
                                                                  [
                                                                    {
                                                                      instancePath:
                                                                        instancePath +
                                                                        '/totalPriceInCents',
                                                                      schemaPath:
                                                                        '#/properties/totalPriceInCents/type',
                                                                      keyword:
                                                                        'type',
                                                                      params: {
                                                                        type: 'number',
                                                                      },
                                                                      message:
                                                                        'must be number',
                                                                    },
                                                                  ];
                                                                return false;
                                                              }
                                                              var valid0 =
                                                                _errs53 ===
                                                                errors;
                                                            } else {
                                                              var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                              if (
                                                                data.freeFaxPagesLeft !==
                                                                undefined
                                                              ) {
                                                                let data27 =
                                                                  data.freeFaxPagesLeft;
                                                                const _errs55 =
                                                                  errors;
                                                                if (
                                                                  !(
                                                                    typeof data27 ==
                                                                      'number' &&
                                                                    isFinite(
                                                                      data27
                                                                    )
                                                                  )
                                                                ) {
                                                                  validate40.errors =
                                                                    [
                                                                      {
                                                                        instancePath:
                                                                          instancePath +
                                                                          '/freeFaxPagesLeft',
                                                                        schemaPath:
                                                                          '#/properties/freeFaxPagesLeft/type',
                                                                        keyword:
                                                                          'type',
                                                                        params:
                                                                          {
                                                                            type: 'number',
                                                                          },
                                                                        message:
                                                                          'must be number',
                                                                      },
                                                                    ];
                                                                  return false;
                                                                }
                                                                var valid0 =
                                                                  _errs55 ===
                                                                  errors;
                                                              } else {
                                                                var valid0 = true;
                                                              }
                                                              if (valid0) {
                                                                if (
                                                                  data.faxPageCurrentCount !==
                                                                  undefined
                                                                ) {
                                                                  let data28 =
                                                                    data.faxPageCurrentCount;
                                                                  const _errs57 =
                                                                    errors;
                                                                  if (
                                                                    !(
                                                                      typeof data28 ==
                                                                        'number' &&
                                                                      isFinite(
                                                                        data28
                                                                      )
                                                                    )
                                                                  ) {
                                                                    validate40.errors =
                                                                      [
                                                                        {
                                                                          instancePath:
                                                                            instancePath +
                                                                            '/faxPageCurrentCount',
                                                                          schemaPath:
                                                                            '#/properties/faxPageCurrentCount/type',
                                                                          keyword:
                                                                            'type',
                                                                          params:
                                                                            {
                                                                              type: 'number',
                                                                            },
                                                                          message:
                                                                            'must be number',
                                                                        },
                                                                      ];
                                                                    return false;
                                                                  }
                                                                  var valid0 =
                                                                    _errs57 ===
                                                                    errors;
                                                                } else {
                                                                  var valid0 = true;
                                                                }
                                                                if (valid0) {
                                                                  if (
                                                                    data.overageFaxMaxLimitInCents !==
                                                                    undefined
                                                                  ) {
                                                                    let data29 =
                                                                      data.overageFaxMaxLimitInCents;
                                                                    const _errs59 =
                                                                      errors;
                                                                    if (
                                                                      !(
                                                                        typeof data29 ==
                                                                          'number' &&
                                                                        isFinite(
                                                                          data29
                                                                        )
                                                                      )
                                                                    ) {
                                                                      validate40.errors =
                                                                        [
                                                                          {
                                                                            instancePath:
                                                                              instancePath +
                                                                              '/overageFaxMaxLimitInCents',
                                                                            schemaPath:
                                                                              '#/properties/overageFaxMaxLimitInCents/type',
                                                                            keyword:
                                                                              'type',
                                                                            params:
                                                                              {
                                                                                type: 'number',
                                                                              },
                                                                            message:
                                                                              'must be number',
                                                                          },
                                                                        ];
                                                                      return false;
                                                                    }
                                                                    var valid0 =
                                                                      _errs59 ===
                                                                      errors;
                                                                  } else {
                                                                    var valid0 = true;
                                                                  }
                                                                  if (valid0) {
                                                                    if (
                                                                      data.pricePerFaxInCents !==
                                                                      undefined
                                                                    ) {
                                                                      let data30 =
                                                                        data.pricePerFaxInCents;
                                                                      const _errs61 =
                                                                        errors;
                                                                      if (
                                                                        !(
                                                                          typeof data30 ==
                                                                            'number' &&
                                                                          isFinite(
                                                                            data30
                                                                          )
                                                                        )
                                                                      ) {
                                                                        validate40.errors =
                                                                          [
                                                                            {
                                                                              instancePath:
                                                                                instancePath +
                                                                                '/pricePerFaxInCents',
                                                                              schemaPath:
                                                                                '#/properties/pricePerFaxInCents/type',
                                                                              keyword:
                                                                                'type',
                                                                              params:
                                                                                {
                                                                                  type: 'number',
                                                                                },
                                                                              message:
                                                                                'must be number',
                                                                            },
                                                                          ];
                                                                        return false;
                                                                      }
                                                                      var valid0 =
                                                                        _errs61 ===
                                                                        errors;
                                                                    } else {
                                                                      var valid0 = true;
                                                                    }
                                                                    if (
                                                                      valid0
                                                                    ) {
                                                                      if (
                                                                        data.initialPageLimit !==
                                                                        undefined
                                                                      ) {
                                                                        let data31 =
                                                                          data.initialPageLimit;
                                                                        const _errs63 =
                                                                          errors;
                                                                        if (
                                                                          !(
                                                                            typeof data31 ==
                                                                              'number' &&
                                                                            isFinite(
                                                                              data31
                                                                            )
                                                                          )
                                                                        ) {
                                                                          validate40.errors =
                                                                            [
                                                                              {
                                                                                instancePath:
                                                                                  instancePath +
                                                                                  '/initialPageLimit',
                                                                                schemaPath:
                                                                                  '#/properties/initialPageLimit/type',
                                                                                keyword:
                                                                                  'type',
                                                                                params:
                                                                                  {
                                                                                    type: 'number',
                                                                                  },
                                                                                message:
                                                                                  'must be number',
                                                                              },
                                                                            ];
                                                                          return false;
                                                                        }
                                                                        var valid0 =
                                                                          _errs63 ===
                                                                          errors;
                                                                      } else {
                                                                        var valid0 = true;
                                                                      }
                                                                      if (
                                                                        valid0
                                                                      ) {
                                                                        if (
                                                                          data.overagePriceInCentsPerPage !==
                                                                          undefined
                                                                        ) {
                                                                          let data32 =
                                                                            data.overagePriceInCentsPerPage;
                                                                          const _errs65 =
                                                                            errors;
                                                                          if (
                                                                            !(
                                                                              typeof data32 ==
                                                                                'number' &&
                                                                              isFinite(
                                                                                data32
                                                                              )
                                                                            )
                                                                          ) {
                                                                            validate40.errors =
                                                                              [
                                                                                {
                                                                                  instancePath:
                                                                                    instancePath +
                                                                                    '/overagePriceInCentsPerPage',
                                                                                  schemaPath:
                                                                                    '#/properties/overagePriceInCentsPerPage/type',
                                                                                  keyword:
                                                                                    'type',
                                                                                  params:
                                                                                    {
                                                                                      type: 'number',
                                                                                    },
                                                                                  message:
                                                                                    'must be number',
                                                                                },
                                                                              ];
                                                                            return false;
                                                                          }
                                                                          var valid0 =
                                                                            _errs65 ===
                                                                            errors;
                                                                        } else {
                                                                          var valid0 = true;
                                                                        }
                                                                        if (
                                                                          valid0
                                                                        ) {
                                                                          if (
                                                                            data.internationalMultiplier !==
                                                                            undefined
                                                                          ) {
                                                                            let data33 =
                                                                              data.internationalMultiplier;
                                                                            const _errs67 =
                                                                              errors;
                                                                            if (
                                                                              !(
                                                                                typeof data33 ==
                                                                                  'number' &&
                                                                                isFinite(
                                                                                  data33
                                                                                )
                                                                              )
                                                                            ) {
                                                                              validate40.errors =
                                                                                [
                                                                                  {
                                                                                    instancePath:
                                                                                      instancePath +
                                                                                      '/internationalMultiplier',
                                                                                    schemaPath:
                                                                                      '#/properties/internationalMultiplier/type',
                                                                                    keyword:
                                                                                      'type',
                                                                                    params:
                                                                                      {
                                                                                        type: 'number',
                                                                                      },
                                                                                    message:
                                                                                      'must be number',
                                                                                  },
                                                                                ];
                                                                              return false;
                                                                            }
                                                                            var valid0 =
                                                                              _errs67 ===
                                                                              errors;
                                                                          } else {
                                                                            var valid0 = true;
                                                                          }
                                                                          if (
                                                                            valid0
                                                                          ) {
                                                                            if (
                                                                              data.uploadIntegrations !==
                                                                              undefined
                                                                            ) {
                                                                              const _errs69 =
                                                                                errors;
                                                                              if (
                                                                                !validate41(
                                                                                  data.uploadIntegrations,
                                                                                  {
                                                                                    instancePath:
                                                                                      instancePath +
                                                                                      '/uploadIntegrations',
                                                                                    parentData:
                                                                                      data,
                                                                                    parentDataProperty:
                                                                                      'uploadIntegrations',
                                                                                    rootData,
                                                                                  }
                                                                                )
                                                                              ) {
                                                                                vErrors =
                                                                                  vErrors ===
                                                                                  null
                                                                                    ? validate41.errors
                                                                                    : vErrors.concat(
                                                                                        validate41.errors
                                                                                      );
                                                                                errors =
                                                                                  vErrors.length;
                                                                              }
                                                                              var valid0 =
                                                                                _errs69 ===
                                                                                errors;
                                                                            } else {
                                                                              var valid0 = true;
                                                                            }
                                                                            if (
                                                                              valid0
                                                                            ) {
                                                                              if (
                                                                                data.isSMSToolsOn !==
                                                                                undefined
                                                                              ) {
                                                                                const _errs70 =
                                                                                  errors;
                                                                                if (
                                                                                  typeof data.isSMSToolsOn !==
                                                                                  'boolean'
                                                                                ) {
                                                                                  validate40.errors =
                                                                                    [
                                                                                      {
                                                                                        instancePath:
                                                                                          instancePath +
                                                                                          '/isSMSToolsOn',
                                                                                        schemaPath:
                                                                                          '#/properties/isSMSToolsOn/type',
                                                                                        keyword:
                                                                                          'type',
                                                                                        params:
                                                                                          {
                                                                                            type: 'boolean',
                                                                                          },
                                                                                        message:
                                                                                          'must be boolean',
                                                                                      },
                                                                                    ];
                                                                                  return false;
                                                                                }
                                                                                var valid0 =
                                                                                  _errs70 ===
                                                                                  errors;
                                                                              } else {
                                                                                var valid0 = true;
                                                                              }
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate40.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate40.errors = vErrors;
  return errors === 0;
}
const schema60 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'RequestData.json',
  title: 'RequestData',
  type: 'object',
  properties: {
    files: { type: 'array', items: { $ref: 'File.json' } },
    editorData: { $ref: 'EditorData.json' },
    recipients: { type: 'array', items: { $ref: 'Recipient.json' } },
    ccs: {
      type: 'array',
      items: {
        oneOf: [
          { $ref: 'Recipient.json#/definitions/CCEmail' },
          { $ref: 'Recipient.json#/definitions/CCRole' },
        ],
      },
    },
    title: { type: 'string' },
    message: { type: 'string' },
    templates: { type: 'array', items: { $ref: 'Template.json' } },
    coverPage: { $ref: 'CoverPage.json' },
    bulkSend: { $ref: 'BulkSend.json' },
  },
  required: [
    'files',
    'editorData',
    'recipients',
    'ccs',
    'templates',
    'bulkSend',
    'title',
    'message',
  ],
};
const schema93 = {
  type: 'object',
  title: 'CCRole',
  additionalProperties: false,
  properties: {
    type: { const: 'ccRole', default: 'ccRole' },
    id: { type: 'string' },
    name: { type: 'string' },
  },
  required: ['type', 'id', 'name'],
};
const schema103 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'CoverPage.json',
  type: 'object',
  title: 'CoverPage',
  additionalProperties: false,
  properties: {
    to: { type: 'string' },
    from: { type: 'string' },
    message: { type: 'string' },
  },
  required: ['to', 'from', 'message'],
};
const schema61 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'File.json',
  title: 'File',
  type: 'object',
  additionalProperties: false,
  properties: {
    status: {
      type: 'string',
      enum: [
        'converting',
        'ok',
        'file downloaded',
        'downloading',
        'download queued',
        'deleted',
        'error',
        '404 Error',
        'password required',
        'too many pages',
        'file too large',
        'retrieve error',
        'bad request',
        'bad auth',
      ],
      tsEnumNames: [
        'Converting',
        'Ok',
        'FileDownloaded',
        'Downloading',
        'DownloadQueued',
        'Deleted',
        'Error',
        'Error404',
        'PasswordRequired',
        'TooManyPages',
        'FileTooLarge',
        'RetrieveError',
        'BadRequest',
        'BadAuth',
      ],
    },
    name: { type: 'string' },
    type: {
      type: 'string',
      enum: ['Upload', 'Template', 'External', 'Signer'],
      tsEnumNames: ['Upload', 'Template', 'External', 'Signer'],
    },
    guid: { type: 'string' },
    documentGuid: { type: 'string' },
    draftSnapshotGuid: { type: 'string' },
    tsmGroupGuid: { type: 'string' },
    templateGuid: { type: 'string' },
    rootSnapshotGuid: { type: 'string' },
    order: { type: 'number' },
    fields: { type: 'array', items: { $ref: 'Field.json' } },
    pwRequired: { type: 'boolean' },
    pageCount: { type: 'number' },
    externalFileCacheKey: { type: 'string' },
    externalServiceReference: { type: 'string' },
    externalServiceType: { type: 'string' },
  },
  required: [
    'name',
    'type',
    'guid',
    'fields',
    'pwRequired',
    'rootSnapshotGuid',
  ],
};
const schema15 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'Field.json',
  title: 'Field',
  type: 'object',
  oneOf: [
    { $ref: '#/definitions/TextField' },
    { $ref: '#/definitions/SignatureField' },
    { $ref: '#/definitions/InitialsField' },
    { $ref: '#/definitions/DateField' },
    { $ref: '#/definitions/CheckboxField' },
    { $ref: '#/definitions/RadioField' },
    { $ref: '#/definitions/DropdownField' },
    { $ref: '#/definitions/HyperlinkField' },
  ],
  definitions: {
    FieldType: {
      type: 'string',
      title: 'FieldType',
      enum: [
        'checkbox',
        'date',
        'initials',
        'signature',
        'text',
        'dropdown',
        'radiobutton',
        'hyperlink',
      ],
      tsEnumNames: [
        'Checkbox',
        'Date',
        'Initials',
        'Signature',
        'Text',
        'Dropdown',
        'Radio',
        'Hyperlink',
      ],
      'x-enum-names': [
        'Checkbox',
        'Date',
        'Initials',
        'Signature',
        'Text',
        'Dropdown',
        'Radio',
        'Hyperlink',
      ],
    },
    SignatureType: {
      type: 'string',
      title: 'SignatureType',
      enum: ['S', 'I'],
      tsEnumNames: ['Signature', 'Initials'],
    },
    SignatureCreateType: {
      type: 'string',
      title: 'SignatureCreateType',
      enum: ['C', 'U', 'T', 'E'],
      tsEnumNames: ['Canvas', 'Upload', 'Typed', 'Email'],
    },
    Signature: {
      type: 'object',
      title: 'Signature',
      additionalProperties: false,
      properties: {
        type: { $ref: '#/definitions/SignatureType' },
        createType: { $ref: '#/definitions/SignatureCreateType' },
        createdAt: { type: 'string', format: 'date-time' },
        lastUsedAt: { type: 'string', format: 'date-time' },
        guid: { type: 'string' },
        width: { type: 'number' },
        height: { type: 'number' },
      },
      required: ['guid', 'type'],
    },
    FontFamily: {
      type: 'string',
      enum: [
        'helvetica',
        'arial',
        'calibri',
        'cambria',
        'courier',
        'georgia',
        'times',
        'trebuchet',
        'verdana',
        'notoSerif',
        'notoSans',
        'roboto',
        'robotoMono',
      ],
      tsEnumNames: [
        'Helvetica',
        'Arial',
        'Calibri',
        'Cambria',
        'Courier',
        'Georgia',
        'Times',
        'Trebuchet',
        'Verdana',
        'NotoSerif',
        'NotoSans',
        'Roboto',
        'RobotoMono',
      ],
      title: 'FontFamily',
    },
    JSDateFormat: {
      type: 'string',
      title: 'JSDateFormat',
      enum: [
        'default',
        'MM / DD / YYYY',
        'MM - DD - YYYY',
        'DD / MM / YYYY',
        'DD - MM - YYYY',
        'YYYY / MM / DD',
        'YYYY - MM - DD',
      ],
      tsEnumNames: [
        'JSDefault',
        'MMDDYYYYSeparatedBySlash',
        'MMDDYYYYSeparatedByHyphen',
        'DDMMYYYYSeparatedBySlash',
        'DDMMYYYYSeparatedByHyphen',
        'YYYYMMDDSeparatedBySlash',
        'YYYYMMDDSeparatedByHyphen',
      ],
      'x-enum-names': [
        'JSDefault',
        'JSMMDDYYYYSeparatedBySlash',
        'JSMMDDYYYYSeparatedByHyphen',
        'JSDDMMYYYYSeparatedBySlash',
        'JSDDMMYYYYSeparatedByHyphen',
        'JSYYYYMMDDSeparatedBySlash',
        'JSYYYYMMDDSeparatedByHyphen',
      ],
    },
    PHPDateFormat: {
      type: 'string',
      title: 'PHPDateFormat',
      enum: [
        'Default',
        'm / d / Y',
        'm - d - Y',
        'd / m / Y',
        'd - m - Y',
        'Y / m / d',
        'Y - m - d',
      ],
      tsEnumNames: [
        'Default',
        'MMDDYYYYSeparatedBySlash',
        'MMDDYYYYSeparatedByHyphen',
        'DDMMYYYYSeparatedBySlash',
        'DDMMYYYYSeparatedByHyphen',
        'YYYYMMDDSeparatedBySlash',
        'YYYYMMDDSeparatedByHyphen',
      ],
      'x-enum-names': [
        'Default',
        'MMDDYYYYSeparatedBySlash',
        'MMDDYYYYSeparatedByHyphen',
        'DDMMYYYYSeparatedBySlash',
        'DDMMYYYYSeparatedByHyphen',
        'YYYYMMDDSeparatedBySlash',
        'YYYYMMDDSeparatedByHyphen',
      ],
    },
    FontSize: {
      type: 'number',
      title: 'FontSize',
      enum: [7, 8, 9, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 42, 48],
      tsEnumNames: [
        'Seven',
        'Eight',
        'Nine',
        'Ten',
        'Twelve',
        'Fourteen',
        'Sixteen',
        'Eighteen',
        'Twenty',
        'TwentyTwo',
        'TwentyFour',
        'TwentySix',
        'TwentyEight',
        'ThirtySix',
        'FortyTwo',
        'FortyEight',
      ],
    },
    Color: {
      type: 'string',
      title: 'Color',
      enum: ['black', 'blue', 'red'],
      tsEnumNames: ['Black', 'Blue', 'Red'],
    },
    ValidationType: {
      type: 'string',
      title: 'ValidationType',
      description: 'Validation options available for a text field',
      enum: [
        'numbers_only',
        'letters_only',
        'phone_number',
        'bank_routing_number',
        'bank_account_number',
        'email_address',
        'zip_code',
        'social_security_number',
        'employer_identification_number',
        'custom_regex',
      ],
    },
    AutoFillType: {
      type: 'string',
      title: 'AutoFillType',
      enum: [
        'name',
        'lastName',
        'firstName',
        'company',
        'email',
        'title',
        'none',
      ],
      tsEnumNames: [
        'FullName',
        'LastName',
        'FirstName',
        'Company',
        'Email',
        'Title',
        'None',
      ],
    },
    TextField: {
      title: 'TextField',
      allOf: [
        {
          properties: {
            type: { const: 'text', default: 'text' },
            pageIndex: { type: 'number' },
            id: { type: 'string' },
            apiId: { type: 'string' },
            documentId: { type: 'string' },
            x: { type: 'number' },
            y: { type: 'number' },
            width: { type: 'number' },
            height: { type: 'number' },
            signer: { type: 'string' },
            required: { type: 'boolean' },
            readOnly: { type: 'boolean' },
            name: { type: 'string' },
            autoFillType: { $ref: '#/definitions/AutoFillType' },
            linkId: { type: 'string' },
            isDisabled: { type: 'boolean' },
            fontSize: { $ref: '#/definitions/FontSize' },
            originalFontSize: { $ref: '#/definitions/FontSize' },
            fontFamily: { $ref: '#/definitions/FontFamily' },
            value: { type: 'string' },
            placeholder: { type: 'string' },
            masked: { type: 'boolean' },
            isEditableMergeField: { type: 'boolean' },
            lines: { type: 'string' },
            numLines: { type: 'number' },
            numCharsPerLine: { type: 'number' },
            lineHeight: { type: 'number' },
            validationType: { $ref: '#/definitions/ValidationType' },
            validationCustomRegex: { type: 'string' },
            validationCustomRegexFormatLabel: { type: 'string' },
          },
          required: [
            'pageIndex',
            'signer',
            'documentId',
            'fontSize',
            'fontFamily',
            'type',
            'id',
            'name',
            'required',
            'readOnly',
            'x',
            'y',
            'width',
            'height',
          ],
        },
      ],
    },
    SignatureField: {
      title: 'SignatureField',
      allOf: [
        {
          properties: {
            type: { const: 'signature', default: 'signature' },
            pageIndex: { type: 'number' },
            id: { type: 'string' },
            apiId: { type: 'string' },
            documentId: { type: 'string' },
            x: { type: 'number' },
            y: { type: 'number' },
            width: { type: 'number' },
            height: { type: 'number' },
            signer: { type: 'string' },
            required: { type: 'boolean' },
            readOnly: { type: 'boolean' },
            name: { type: 'string' },
            linkId: { type: 'string' },
            isDisabled: { type: 'boolean' },
            signature: { $ref: '#/definitions/Signature' },
            color: { $ref: '#/definitions/Color' },
          },
          required: [
            'pageIndex',
            'signer',
            'documentId',
            'id',
            'name',
            'required',
            'readOnly',
            'x',
            'y',
            'width',
            'height',
            'type',
          ],
        },
      ],
    },
    InitialsField: {
      title: 'InitialsField',
      allOf: [
        {
          properties: {
            type: { const: 'initials', default: 'initials' },
            pageIndex: { type: 'number' },
            id: { type: 'string' },
            apiId: { type: 'string' },
            documentId: { type: 'string' },
            x: { type: 'number' },
            y: { type: 'number' },
            width: { type: 'number' },
            height: { type: 'number' },
            signer: { type: 'string' },
            required: { type: 'boolean' },
            readOnly: { type: 'boolean' },
            name: { type: 'string' },
            linkId: { type: 'string' },
            isDisabled: { type: 'boolean' },
            signature: { $ref: '#/definitions/Signature' },
            color: { $ref: '#/definitions/Color' },
          },
          required: [
            'pageIndex',
            'signer',
            'documentId',
            'id',
            'name',
            'required',
            'readOnly',
            'x',
            'y',
            'width',
            'height',
            'type',
          ],
        },
      ],
    },
    DateField: {
      title: 'DateField',
      allOf: [
        {
          properties: {
            pageIndex: { type: 'number' },
            id: { type: 'string' },
            apiId: { type: 'string' },
            documentId: { type: 'string' },
            x: { type: 'number' },
            y: { type: 'number' },
            width: { type: 'number' },
            height: { type: 'number' },
            signer: { type: 'string' },
            required: { type: 'boolean' },
            readOnly: { type: 'boolean' },
            name: { type: 'string' },
            linkId: { type: 'string' },
            isDisabled: { type: 'boolean' },
            fontSize: { $ref: '#/definitions/FontSize' },
            originalFontSize: { $ref: '#/definitions/FontSize' },
            fontFamily: { $ref: '#/definitions/FontFamily' },
            lineHeight: { type: 'number' },
            value: { type: ['string', 'null'] },
            placeholder: { type: 'string' },
            type: { const: 'date', default: 'date' },
            dateFormat: { $ref: '#/definitions/JSDateFormat' },
          },
          required: [
            'pageIndex',
            'signer',
            'documentId',
            'value',
            'fontSize',
            'fontFamily',
            'type',
            'id',
            'name',
            'required',
            'readOnly',
            'x',
            'y',
            'width',
            'height',
          ],
        },
      ],
    },
    RadioField: {
      title: 'RadioField',
      allOf: [
        {
          properties: {
            pageIndex: { type: 'number' },
            id: { type: 'string' },
            apiId: { type: 'string' },
            documentId: { type: 'string' },
            x: { type: 'number' },
            y: { type: 'number' },
            width: { type: 'number' },
            height: { type: 'number' },
            signer: { type: 'string' },
            required: { type: 'boolean' },
            readOnly: { type: 'boolean' },
            name: { type: 'string' },
            linkId: { type: 'string' },
            isDisabled: { type: 'boolean' },
            type: { const: 'radiobutton', default: 'radiobutton' },
            checked: { type: 'boolean' },
            requirement: { type: 'string' },
            groupLabel: { type: 'string' },
            group: { type: 'string' },
          },
          required: [
            'checked',
            'requirement',
            'group',
            'pageIndex',
            'signer',
            'documentId',
            'id',
            'name',
            'required',
            'readOnly',
            'x',
            'y',
            'width',
            'height',
            'type',
          ],
        },
      ],
    },
    DropdownField: {
      title: 'DropdownField',
      allOf: [
        {
          properties: {
            pageIndex: { type: 'number' },
            id: { type: 'string' },
            apiId: { type: 'string' },
            documentId: { type: 'string' },
            x: { type: 'number' },
            y: { type: 'number' },
            width: { type: 'number' },
            height: { type: 'number' },
            signer: { type: 'string' },
            required: { type: 'boolean' },
            readOnly: { type: 'boolean' },
            name: { type: 'string' },
            isDisabled: { type: 'boolean' },
            type: { const: 'dropdown', default: 'dropdown' },
            value: { type: ['string', 'null'] },
            options: { type: 'array', items: { type: 'string' } },
            fontSize: { $ref: '#/definitions/FontSize' },
            fontFamily: { $ref: '#/definitions/FontFamily' },
            lineHeight: { type: 'number' },
          },
          required: [
            'pageIndex',
            'signer',
            'documentId',
            'fontSize',
            'fontFamily',
            'type',
            'id',
            'name',
            'required',
            'readOnly',
            'x',
            'y',
            'width',
            'height',
            'options',
          ],
        },
      ],
    },
    CheckboxField: {
      title: 'CheckboxField',
      allOf: [
        {
          properties: {
            pageIndex: { type: 'number' },
            id: { type: 'string' },
            apiId: { type: 'string' },
            documentId: { type: 'string' },
            x: { type: 'number' },
            y: { type: 'number' },
            width: { type: 'number' },
            height: { type: 'number' },
            signer: { type: 'string' },
            required: { type: 'boolean' },
            readOnly: { type: 'boolean' },
            name: { type: 'string' },
            isDisabled: { type: 'boolean' },
            type: { const: 'checkbox', default: 'checkbox' },
            checked: { type: 'boolean' },
            requirement: { type: 'string' },
            groupLabel: { type: 'string' },
            group: { type: 'string' },
          },
          required: [
            'pageIndex',
            'signer',
            'documentId',
            'id',
            'name',
            'required',
            'readOnly',
            'x',
            'y',
            'width',
            'height',
            'type',
          ],
        },
      ],
    },
    HyperlinkField: {
      title: 'HyperlinkField',
      allOf: [
        {
          properties: {
            type: { const: 'hyperlink', default: 'hyperlink' },
            pageIndex: { type: 'number' },
            id: { type: 'string' },
            apiId: { type: 'string' },
            documentId: { type: 'string' },
            x: { type: 'number' },
            y: { type: 'number' },
            width: { type: 'number' },
            height: { type: 'number' },
            signer: { type: 'string' },
            required: { type: 'boolean' },
            readOnly: { type: 'boolean' },
            name: { type: 'string' },
            autoFillType: { $ref: '#/definitions/AutoFillType' },
            linkId: { type: 'string' },
            isDisabled: { type: 'boolean' },
            lineHeight: { type: 'number' },
            fontFamily: { $ref: '#/definitions/FontFamily' },
            fontSize: { $ref: '#/definitions/FontSize' },
            value: { oneOf: [{ type: 'string' }, { type: 'null' }] },
            url: { type: 'string' },
          },
          required: [
            'pageIndex',
            'signer',
            'documentId',
            'fontSize',
            'fontFamily',
            'value',
            'url',
            'type',
            'id',
            'name',
            'required',
            'readOnly',
            'x',
            'y',
            'width',
            'height',
          ],
        },
      ],
    },
  },
};
const schema34 = {
  title: 'CheckboxField',
  allOf: [
    {
      properties: {
        pageIndex: { type: 'number' },
        id: { type: 'string' },
        apiId: { type: 'string' },
        documentId: { type: 'string' },
        x: { type: 'number' },
        y: { type: 'number' },
        width: { type: 'number' },
        height: { type: 'number' },
        signer: { type: 'string' },
        required: { type: 'boolean' },
        readOnly: { type: 'boolean' },
        name: { type: 'string' },
        isDisabled: { type: 'boolean' },
        type: { const: 'checkbox', default: 'checkbox' },
        checked: { type: 'boolean' },
        requirement: { type: 'string' },
        groupLabel: { type: 'string' },
        group: { type: 'string' },
      },
      required: [
        'pageIndex',
        'signer',
        'documentId',
        'id',
        'name',
        'required',
        'readOnly',
        'x',
        'y',
        'width',
        'height',
        'type',
      ],
    },
  ],
};
const schema35 = {
  title: 'RadioField',
  allOf: [
    {
      properties: {
        pageIndex: { type: 'number' },
        id: { type: 'string' },
        apiId: { type: 'string' },
        documentId: { type: 'string' },
        x: { type: 'number' },
        y: { type: 'number' },
        width: { type: 'number' },
        height: { type: 'number' },
        signer: { type: 'string' },
        required: { type: 'boolean' },
        readOnly: { type: 'boolean' },
        name: { type: 'string' },
        linkId: { type: 'string' },
        isDisabled: { type: 'boolean' },
        type: { const: 'radiobutton', default: 'radiobutton' },
        checked: { type: 'boolean' },
        requirement: { type: 'string' },
        groupLabel: { type: 'string' },
        group: { type: 'string' },
      },
      required: [
        'checked',
        'requirement',
        'group',
        'pageIndex',
        'signer',
        'documentId',
        'id',
        'name',
        'required',
        'readOnly',
        'x',
        'y',
        'width',
        'height',
        'type',
      ],
    },
  ],
};
const schema16 = {
  title: 'TextField',
  allOf: [
    {
      properties: {
        type: { const: 'text', default: 'text' },
        pageIndex: { type: 'number' },
        id: { type: 'string' },
        apiId: { type: 'string' },
        documentId: { type: 'string' },
        x: { type: 'number' },
        y: { type: 'number' },
        width: { type: 'number' },
        height: { type: 'number' },
        signer: { type: 'string' },
        required: { type: 'boolean' },
        readOnly: { type: 'boolean' },
        name: { type: 'string' },
        autoFillType: { $ref: '#/definitions/AutoFillType' },
        linkId: { type: 'string' },
        isDisabled: { type: 'boolean' },
        fontSize: { $ref: '#/definitions/FontSize' },
        originalFontSize: { $ref: '#/definitions/FontSize' },
        fontFamily: { $ref: '#/definitions/FontFamily' },
        value: { type: 'string' },
        placeholder: { type: 'string' },
        masked: { type: 'boolean' },
        isEditableMergeField: { type: 'boolean' },
        lines: { type: 'string' },
        numLines: { type: 'number' },
        numCharsPerLine: { type: 'number' },
        lineHeight: { type: 'number' },
        validationType: { $ref: '#/definitions/ValidationType' },
        validationCustomRegex: { type: 'string' },
        validationCustomRegexFormatLabel: { type: 'string' },
      },
      required: [
        'pageIndex',
        'signer',
        'documentId',
        'fontSize',
        'fontFamily',
        'type',
        'id',
        'name',
        'required',
        'readOnly',
        'x',
        'y',
        'width',
        'height',
      ],
    },
  ],
};
const schema17 = {
  type: 'string',
  title: 'AutoFillType',
  enum: ['name', 'lastName', 'firstName', 'company', 'email', 'title', 'none'],
  tsEnumNames: [
    'FullName',
    'LastName',
    'FirstName',
    'Company',
    'Email',
    'Title',
    'None',
  ],
};
const schema18 = {
  type: 'number',
  title: 'FontSize',
  enum: [7, 8, 9, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 42, 48],
  tsEnumNames: [
    'Seven',
    'Eight',
    'Nine',
    'Ten',
    'Twelve',
    'Fourteen',
    'Sixteen',
    'Eighteen',
    'Twenty',
    'TwentyTwo',
    'TwentyFour',
    'TwentySix',
    'TwentyEight',
    'ThirtySix',
    'FortyTwo',
    'FortyEight',
  ],
};
const schema20 = {
  type: 'string',
  enum: [
    'helvetica',
    'arial',
    'calibri',
    'cambria',
    'courier',
    'georgia',
    'times',
    'trebuchet',
    'verdana',
    'notoSerif',
    'notoSans',
    'roboto',
    'robotoMono',
  ],
  tsEnumNames: [
    'Helvetica',
    'Arial',
    'Calibri',
    'Cambria',
    'Courier',
    'Georgia',
    'Times',
    'Trebuchet',
    'Verdana',
    'NotoSerif',
    'NotoSans',
    'Roboto',
    'RobotoMono',
  ],
  title: 'FontFamily',
};
const schema21 = {
  type: 'string',
  title: 'ValidationType',
  description: 'Validation options available for a text field',
  enum: [
    'numbers_only',
    'letters_only',
    'phone_number',
    'bank_routing_number',
    'bank_account_number',
    'email_address',
    'zip_code',
    'social_security_number',
    'employer_identification_number',
    'custom_regex',
  ],
};
function validate14(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    let missing0;
    if (
      (data.pageIndex === undefined && (missing0 = 'pageIndex')) ||
      (data.signer === undefined && (missing0 = 'signer')) ||
      (data.documentId === undefined && (missing0 = 'documentId')) ||
      (data.fontSize === undefined && (missing0 = 'fontSize')) ||
      (data.fontFamily === undefined && (missing0 = 'fontFamily')) ||
      (data.type === undefined && (missing0 = 'type')) ||
      (data.id === undefined && (missing0 = 'id')) ||
      (data.name === undefined && (missing0 = 'name')) ||
      (data.required === undefined && (missing0 = 'required')) ||
      (data.readOnly === undefined && (missing0 = 'readOnly')) ||
      (data.x === undefined && (missing0 = 'x')) ||
      (data.y === undefined && (missing0 = 'y')) ||
      (data.width === undefined && (missing0 = 'width')) ||
      (data.height === undefined && (missing0 = 'height'))
    ) {
      validate14.errors = [
        {
          instancePath,
          schemaPath: '#/allOf/0/required',
          keyword: 'required',
          params: { missingProperty: missing0 },
          message: "must have required property '" + missing0 + "'",
        },
      ];
      return false;
    } else {
      if (data.type !== undefined) {
        const _errs1 = errors;
        if (!func0(data.type, 'text')) {
          validate14.errors = [
            {
              instancePath: instancePath + '/type',
              schemaPath: '#/allOf/0/properties/type/const',
              keyword: 'const',
              params: { allowedValue: 'text' },
              message: 'must be equal to constant',
            },
          ];
          return false;
        }
        var valid1 = _errs1 === errors;
      } else {
        var valid1 = true;
      }
      if (valid1) {
        if (data.pageIndex !== undefined) {
          let data1 = data.pageIndex;
          const _errs2 = errors;
          if (!(typeof data1 == 'number' && isFinite(data1))) {
            validate14.errors = [
              {
                instancePath: instancePath + '/pageIndex',
                schemaPath: '#/allOf/0/properties/pageIndex/type',
                keyword: 'type',
                params: { type: 'number' },
                message: 'must be number',
              },
            ];
            return false;
          }
          var valid1 = _errs2 === errors;
        } else {
          var valid1 = true;
        }
        if (valid1) {
          if (data.id !== undefined) {
            const _errs4 = errors;
            if (typeof data.id !== 'string') {
              validate14.errors = [
                {
                  instancePath: instancePath + '/id',
                  schemaPath: '#/allOf/0/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid1 = _errs4 === errors;
          } else {
            var valid1 = true;
          }
          if (valid1) {
            if (data.apiId !== undefined) {
              const _errs6 = errors;
              if (typeof data.apiId !== 'string') {
                validate14.errors = [
                  {
                    instancePath: instancePath + '/apiId',
                    schemaPath: '#/allOf/0/properties/apiId/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid1 = _errs6 === errors;
            } else {
              var valid1 = true;
            }
            if (valid1) {
              if (data.documentId !== undefined) {
                const _errs8 = errors;
                if (typeof data.documentId !== 'string') {
                  validate14.errors = [
                    {
                      instancePath: instancePath + '/documentId',
                      schemaPath: '#/allOf/0/properties/documentId/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid1 = _errs8 === errors;
              } else {
                var valid1 = true;
              }
              if (valid1) {
                if (data.x !== undefined) {
                  let data5 = data.x;
                  const _errs10 = errors;
                  if (!(typeof data5 == 'number' && isFinite(data5))) {
                    validate14.errors = [
                      {
                        instancePath: instancePath + '/x',
                        schemaPath: '#/allOf/0/properties/x/type',
                        keyword: 'type',
                        params: { type: 'number' },
                        message: 'must be number',
                      },
                    ];
                    return false;
                  }
                  var valid1 = _errs10 === errors;
                } else {
                  var valid1 = true;
                }
                if (valid1) {
                  if (data.y !== undefined) {
                    let data6 = data.y;
                    const _errs12 = errors;
                    if (!(typeof data6 == 'number' && isFinite(data6))) {
                      validate14.errors = [
                        {
                          instancePath: instancePath + '/y',
                          schemaPath: '#/allOf/0/properties/y/type',
                          keyword: 'type',
                          params: { type: 'number' },
                          message: 'must be number',
                        },
                      ];
                      return false;
                    }
                    var valid1 = _errs12 === errors;
                  } else {
                    var valid1 = true;
                  }
                  if (valid1) {
                    if (data.width !== undefined) {
                      let data7 = data.width;
                      const _errs14 = errors;
                      if (!(typeof data7 == 'number' && isFinite(data7))) {
                        validate14.errors = [
                          {
                            instancePath: instancePath + '/width',
                            schemaPath: '#/allOf/0/properties/width/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          },
                        ];
                        return false;
                      }
                      var valid1 = _errs14 === errors;
                    } else {
                      var valid1 = true;
                    }
                    if (valid1) {
                      if (data.height !== undefined) {
                        let data8 = data.height;
                        const _errs16 = errors;
                        if (!(typeof data8 == 'number' && isFinite(data8))) {
                          validate14.errors = [
                            {
                              instancePath: instancePath + '/height',
                              schemaPath: '#/allOf/0/properties/height/type',
                              keyword: 'type',
                              params: { type: 'number' },
                              message: 'must be number',
                            },
                          ];
                          return false;
                        }
                        var valid1 = _errs16 === errors;
                      } else {
                        var valid1 = true;
                      }
                      if (valid1) {
                        if (data.signer !== undefined) {
                          const _errs18 = errors;
                          if (typeof data.signer !== 'string') {
                            validate14.errors = [
                              {
                                instancePath: instancePath + '/signer',
                                schemaPath: '#/allOf/0/properties/signer/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid1 = _errs18 === errors;
                        } else {
                          var valid1 = true;
                        }
                        if (valid1) {
                          if (data.required !== undefined) {
                            const _errs20 = errors;
                            if (typeof data.required !== 'boolean') {
                              validate14.errors = [
                                {
                                  instancePath: instancePath + '/required',
                                  schemaPath:
                                    '#/allOf/0/properties/required/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid1 = _errs20 === errors;
                          } else {
                            var valid1 = true;
                          }
                          if (valid1) {
                            if (data.readOnly !== undefined) {
                              const _errs22 = errors;
                              if (typeof data.readOnly !== 'boolean') {
                                validate14.errors = [
                                  {
                                    instancePath: instancePath + '/readOnly',
                                    schemaPath:
                                      '#/allOf/0/properties/readOnly/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  },
                                ];
                                return false;
                              }
                              var valid1 = _errs22 === errors;
                            } else {
                              var valid1 = true;
                            }
                            if (valid1) {
                              if (data.name !== undefined) {
                                const _errs24 = errors;
                                if (typeof data.name !== 'string') {
                                  validate14.errors = [
                                    {
                                      instancePath: instancePath + '/name',
                                      schemaPath:
                                        '#/allOf/0/properties/name/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid1 = _errs24 === errors;
                              } else {
                                var valid1 = true;
                              }
                              if (valid1) {
                                if (data.autoFillType !== undefined) {
                                  let data13 = data.autoFillType;
                                  const _errs26 = errors;
                                  if (typeof data13 !== 'string') {
                                    validate14.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/autoFillType',
                                        schemaPath:
                                          '#/definitions/AutoFillType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  if (
                                    !(
                                      data13 === 'name' ||
                                      data13 === 'lastName' ||
                                      data13 === 'firstName' ||
                                      data13 === 'company' ||
                                      data13 === 'email' ||
                                      data13 === 'title' ||
                                      data13 === 'none'
                                    )
                                  ) {
                                    validate14.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/autoFillType',
                                        schemaPath:
                                          '#/definitions/AutoFillType/enum',
                                        keyword: 'enum',
                                        params: {
                                          allowedValues: schema17.enum,
                                        },
                                        message:
                                          'must be equal to one of the allowed values',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid1 = _errs26 === errors;
                                } else {
                                  var valid1 = true;
                                }
                                if (valid1) {
                                  if (data.linkId !== undefined) {
                                    const _errs29 = errors;
                                    if (typeof data.linkId !== 'string') {
                                      validate14.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/linkId',
                                          schemaPath:
                                            '#/allOf/0/properties/linkId/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid1 = _errs29 === errors;
                                  } else {
                                    var valid1 = true;
                                  }
                                  if (valid1) {
                                    if (data.isDisabled !== undefined) {
                                      const _errs31 = errors;
                                      if (
                                        typeof data.isDisabled !== 'boolean'
                                      ) {
                                        validate14.errors = [
                                          {
                                            instancePath:
                                              instancePath + '/isDisabled',
                                            schemaPath:
                                              '#/allOf/0/properties/isDisabled/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid1 = _errs31 === errors;
                                    } else {
                                      var valid1 = true;
                                    }
                                    if (valid1) {
                                      if (data.fontSize !== undefined) {
                                        let data16 = data.fontSize;
                                        const _errs33 = errors;
                                        if (
                                          !(
                                            typeof data16 == 'number' &&
                                            isFinite(data16)
                                          )
                                        ) {
                                          validate14.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/fontSize',
                                              schemaPath:
                                                '#/definitions/FontSize/type',
                                              keyword: 'type',
                                              params: { type: 'number' },
                                              message: 'must be number',
                                            },
                                          ];
                                          return false;
                                        }
                                        if (
                                          !(
                                            data16 === 7 ||
                                            data16 === 8 ||
                                            data16 === 9 ||
                                            data16 === 10 ||
                                            data16 === 12 ||
                                            data16 === 14 ||
                                            data16 === 16 ||
                                            data16 === 18 ||
                                            data16 === 20 ||
                                            data16 === 22 ||
                                            data16 === 24 ||
                                            data16 === 26 ||
                                            data16 === 28 ||
                                            data16 === 36 ||
                                            data16 === 42 ||
                                            data16 === 48
                                          )
                                        ) {
                                          validate14.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/fontSize',
                                              schemaPath:
                                                '#/definitions/FontSize/enum',
                                              keyword: 'enum',
                                              params: {
                                                allowedValues: schema18.enum,
                                              },
                                              message:
                                                'must be equal to one of the allowed values',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid1 = _errs33 === errors;
                                      } else {
                                        var valid1 = true;
                                      }
                                      if (valid1) {
                                        if (
                                          data.originalFontSize !== undefined
                                        ) {
                                          let data17 = data.originalFontSize;
                                          const _errs36 = errors;
                                          if (
                                            !(
                                              typeof data17 == 'number' &&
                                              isFinite(data17)
                                            )
                                          ) {
                                            validate14.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/originalFontSize',
                                                schemaPath:
                                                  '#/definitions/FontSize/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number',
                                              },
                                            ];
                                            return false;
                                          }
                                          if (
                                            !(
                                              data17 === 7 ||
                                              data17 === 8 ||
                                              data17 === 9 ||
                                              data17 === 10 ||
                                              data17 === 12 ||
                                              data17 === 14 ||
                                              data17 === 16 ||
                                              data17 === 18 ||
                                              data17 === 20 ||
                                              data17 === 22 ||
                                              data17 === 24 ||
                                              data17 === 26 ||
                                              data17 === 28 ||
                                              data17 === 36 ||
                                              data17 === 42 ||
                                              data17 === 48
                                            )
                                          ) {
                                            validate14.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/originalFontSize',
                                                schemaPath:
                                                  '#/definitions/FontSize/enum',
                                                keyword: 'enum',
                                                params: {
                                                  allowedValues: schema18.enum,
                                                },
                                                message:
                                                  'must be equal to one of the allowed values',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid1 = _errs36 === errors;
                                        } else {
                                          var valid1 = true;
                                        }
                                        if (valid1) {
                                          if (data.fontFamily !== undefined) {
                                            let data18 = data.fontFamily;
                                            const _errs39 = errors;
                                            if (typeof data18 !== 'string') {
                                              validate14.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/fontFamily',
                                                  schemaPath:
                                                    '#/definitions/FontFamily/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                },
                                              ];
                                              return false;
                                            }
                                            if (
                                              !(
                                                data18 === 'helvetica' ||
                                                data18 === 'arial' ||
                                                data18 === 'calibri' ||
                                                data18 === 'cambria' ||
                                                data18 === 'courier' ||
                                                data18 === 'georgia' ||
                                                data18 === 'times' ||
                                                data18 === 'trebuchet' ||
                                                data18 === 'verdana' ||
                                                data18 === 'notoSerif' ||
                                                data18 === 'notoSans' ||
                                                data18 === 'roboto' ||
                                                data18 === 'robotoMono'
                                              )
                                            ) {
                                              validate14.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/fontFamily',
                                                  schemaPath:
                                                    '#/definitions/FontFamily/enum',
                                                  keyword: 'enum',
                                                  params: {
                                                    allowedValues:
                                                      schema20.enum,
                                                  },
                                                  message:
                                                    'must be equal to one of the allowed values',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid1 = _errs39 === errors;
                                          } else {
                                            var valid1 = true;
                                          }
                                          if (valid1) {
                                            if (data.value !== undefined) {
                                              const _errs42 = errors;
                                              if (
                                                typeof data.value !== 'string'
                                              ) {
                                                validate14.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath + '/value',
                                                    schemaPath:
                                                      '#/allOf/0/properties/value/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid1 = _errs42 === errors;
                                            } else {
                                              var valid1 = true;
                                            }
                                            if (valid1) {
                                              if (
                                                data.placeholder !== undefined
                                              ) {
                                                const _errs44 = errors;
                                                if (
                                                  typeof data.placeholder !==
                                                  'string'
                                                ) {
                                                  validate14.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/placeholder',
                                                      schemaPath:
                                                        '#/allOf/0/properties/placeholder/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'string',
                                                      },
                                                      message: 'must be string',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid1 = _errs44 === errors;
                                              } else {
                                                var valid1 = true;
                                              }
                                              if (valid1) {
                                                if (data.masked !== undefined) {
                                                  const _errs46 = errors;
                                                  if (
                                                    typeof data.masked !==
                                                    'boolean'
                                                  ) {
                                                    validate14.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath +
                                                          '/masked',
                                                        schemaPath:
                                                          '#/allOf/0/properties/masked/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'boolean',
                                                        },
                                                        message:
                                                          'must be boolean',
                                                      },
                                                    ];
                                                    return false;
                                                  }
                                                  var valid1 =
                                                    _errs46 === errors;
                                                } else {
                                                  var valid1 = true;
                                                }
                                                if (valid1) {
                                                  if (
                                                    data.isEditableMergeField !==
                                                    undefined
                                                  ) {
                                                    const _errs48 = errors;
                                                    if (
                                                      typeof data.isEditableMergeField !==
                                                      'boolean'
                                                    ) {
                                                      validate14.errors = [
                                                        {
                                                          instancePath:
                                                            instancePath +
                                                            '/isEditableMergeField',
                                                          schemaPath:
                                                            '#/allOf/0/properties/isEditableMergeField/type',
                                                          keyword: 'type',
                                                          params: {
                                                            type: 'boolean',
                                                          },
                                                          message:
                                                            'must be boolean',
                                                        },
                                                      ];
                                                      return false;
                                                    }
                                                    var valid1 =
                                                      _errs48 === errors;
                                                  } else {
                                                    var valid1 = true;
                                                  }
                                                  if (valid1) {
                                                    if (
                                                      data.lines !== undefined
                                                    ) {
                                                      const _errs50 = errors;
                                                      if (
                                                        typeof data.lines !==
                                                        'string'
                                                      ) {
                                                        validate14.errors = [
                                                          {
                                                            instancePath:
                                                              instancePath +
                                                              '/lines',
                                                            schemaPath:
                                                              '#/allOf/0/properties/lines/type',
                                                            keyword: 'type',
                                                            params: {
                                                              type: 'string',
                                                            },
                                                            message:
                                                              'must be string',
                                                          },
                                                        ];
                                                        return false;
                                                      }
                                                      var valid1 =
                                                        _errs50 === errors;
                                                    } else {
                                                      var valid1 = true;
                                                    }
                                                    if (valid1) {
                                                      if (
                                                        data.numLines !==
                                                        undefined
                                                      ) {
                                                        let data24 =
                                                          data.numLines;
                                                        const _errs52 = errors;
                                                        if (
                                                          !(
                                                            typeof data24 ==
                                                              'number' &&
                                                            isFinite(data24)
                                                          )
                                                        ) {
                                                          validate14.errors = [
                                                            {
                                                              instancePath:
                                                                instancePath +
                                                                '/numLines',
                                                              schemaPath:
                                                                '#/allOf/0/properties/numLines/type',
                                                              keyword: 'type',
                                                              params: {
                                                                type: 'number',
                                                              },
                                                              message:
                                                                'must be number',
                                                            },
                                                          ];
                                                          return false;
                                                        }
                                                        var valid1 =
                                                          _errs52 === errors;
                                                      } else {
                                                        var valid1 = true;
                                                      }
                                                      if (valid1) {
                                                        if (
                                                          data.numCharsPerLine !==
                                                          undefined
                                                        ) {
                                                          let data25 =
                                                            data.numCharsPerLine;
                                                          const _errs54 =
                                                            errors;
                                                          if (
                                                            !(
                                                              typeof data25 ==
                                                                'number' &&
                                                              isFinite(data25)
                                                            )
                                                          ) {
                                                            validate14.errors =
                                                              [
                                                                {
                                                                  instancePath:
                                                                    instancePath +
                                                                    '/numCharsPerLine',
                                                                  schemaPath:
                                                                    '#/allOf/0/properties/numCharsPerLine/type',
                                                                  keyword:
                                                                    'type',
                                                                  params: {
                                                                    type: 'number',
                                                                  },
                                                                  message:
                                                                    'must be number',
                                                                },
                                                              ];
                                                            return false;
                                                          }
                                                          var valid1 =
                                                            _errs54 === errors;
                                                        } else {
                                                          var valid1 = true;
                                                        }
                                                        if (valid1) {
                                                          if (
                                                            data.lineHeight !==
                                                            undefined
                                                          ) {
                                                            let data26 =
                                                              data.lineHeight;
                                                            const _errs56 =
                                                              errors;
                                                            if (
                                                              !(
                                                                typeof data26 ==
                                                                  'number' &&
                                                                isFinite(data26)
                                                              )
                                                            ) {
                                                              validate14.errors =
                                                                [
                                                                  {
                                                                    instancePath:
                                                                      instancePath +
                                                                      '/lineHeight',
                                                                    schemaPath:
                                                                      '#/allOf/0/properties/lineHeight/type',
                                                                    keyword:
                                                                      'type',
                                                                    params: {
                                                                      type: 'number',
                                                                    },
                                                                    message:
                                                                      'must be number',
                                                                  },
                                                                ];
                                                              return false;
                                                            }
                                                            var valid1 =
                                                              _errs56 ===
                                                              errors;
                                                          } else {
                                                            var valid1 = true;
                                                          }
                                                          if (valid1) {
                                                            if (
                                                              data.validationType !==
                                                              undefined
                                                            ) {
                                                              let data27 =
                                                                data.validationType;
                                                              const _errs58 =
                                                                errors;
                                                              if (
                                                                typeof data27 !==
                                                                'string'
                                                              ) {
                                                                validate14.errors =
                                                                  [
                                                                    {
                                                                      instancePath:
                                                                        instancePath +
                                                                        '/validationType',
                                                                      schemaPath:
                                                                        '#/definitions/ValidationType/type',
                                                                      keyword:
                                                                        'type',
                                                                      params: {
                                                                        type: 'string',
                                                                      },
                                                                      message:
                                                                        'must be string',
                                                                    },
                                                                  ];
                                                                return false;
                                                              }
                                                              if (
                                                                !(
                                                                  data27 ===
                                                                    'numbers_only' ||
                                                                  data27 ===
                                                                    'letters_only' ||
                                                                  data27 ===
                                                                    'phone_number' ||
                                                                  data27 ===
                                                                    'bank_routing_number' ||
                                                                  data27 ===
                                                                    'bank_account_number' ||
                                                                  data27 ===
                                                                    'email_address' ||
                                                                  data27 ===
                                                                    'zip_code' ||
                                                                  data27 ===
                                                                    'social_security_number' ||
                                                                  data27 ===
                                                                    'employer_identification_number' ||
                                                                  data27 ===
                                                                    'custom_regex'
                                                                )
                                                              ) {
                                                                validate14.errors =
                                                                  [
                                                                    {
                                                                      instancePath:
                                                                        instancePath +
                                                                        '/validationType',
                                                                      schemaPath:
                                                                        '#/definitions/ValidationType/enum',
                                                                      keyword:
                                                                        'enum',
                                                                      params: {
                                                                        allowedValues:
                                                                          schema21.enum,
                                                                      },
                                                                      message:
                                                                        'must be equal to one of the allowed values',
                                                                    },
                                                                  ];
                                                                return false;
                                                              }
                                                              var valid1 =
                                                                _errs58 ===
                                                                errors;
                                                            } else {
                                                              var valid1 = true;
                                                            }
                                                            if (valid1) {
                                                              if (
                                                                data.validationCustomRegex !==
                                                                undefined
                                                              ) {
                                                                const _errs61 =
                                                                  errors;
                                                                if (
                                                                  typeof data.validationCustomRegex !==
                                                                  'string'
                                                                ) {
                                                                  validate14.errors =
                                                                    [
                                                                      {
                                                                        instancePath:
                                                                          instancePath +
                                                                          '/validationCustomRegex',
                                                                        schemaPath:
                                                                          '#/allOf/0/properties/validationCustomRegex/type',
                                                                        keyword:
                                                                          'type',
                                                                        params:
                                                                          {
                                                                            type: 'string',
                                                                          },
                                                                        message:
                                                                          'must be string',
                                                                      },
                                                                    ];
                                                                  return false;
                                                                }
                                                                var valid1 =
                                                                  _errs61 ===
                                                                  errors;
                                                              } else {
                                                                var valid1 = true;
                                                              }
                                                              if (valid1) {
                                                                if (
                                                                  data.validationCustomRegexFormatLabel !==
                                                                  undefined
                                                                ) {
                                                                  const _errs63 =
                                                                    errors;
                                                                  if (
                                                                    typeof data.validationCustomRegexFormatLabel !==
                                                                    'string'
                                                                  ) {
                                                                    validate14.errors =
                                                                      [
                                                                        {
                                                                          instancePath:
                                                                            instancePath +
                                                                            '/validationCustomRegexFormatLabel',
                                                                          schemaPath:
                                                                            '#/allOf/0/properties/validationCustomRegexFormatLabel/type',
                                                                          keyword:
                                                                            'type',
                                                                          params:
                                                                            {
                                                                              type: 'string',
                                                                            },
                                                                          message:
                                                                            'must be string',
                                                                        },
                                                                      ];
                                                                    return false;
                                                                  }
                                                                  var valid1 =
                                                                    _errs63 ===
                                                                    errors;
                                                                } else {
                                                                  var valid1 = true;
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  validate14.errors = vErrors;
  return errors === 0;
}
const schema22 = {
  title: 'SignatureField',
  allOf: [
    {
      properties: {
        type: { const: 'signature', default: 'signature' },
        pageIndex: { type: 'number' },
        id: { type: 'string' },
        apiId: { type: 'string' },
        documentId: { type: 'string' },
        x: { type: 'number' },
        y: { type: 'number' },
        width: { type: 'number' },
        height: { type: 'number' },
        signer: { type: 'string' },
        required: { type: 'boolean' },
        readOnly: { type: 'boolean' },
        name: { type: 'string' },
        linkId: { type: 'string' },
        isDisabled: { type: 'boolean' },
        signature: { $ref: '#/definitions/Signature' },
        color: { $ref: '#/definitions/Color' },
      },
      required: [
        'pageIndex',
        'signer',
        'documentId',
        'id',
        'name',
        'required',
        'readOnly',
        'x',
        'y',
        'width',
        'height',
        'type',
      ],
    },
  ],
};
const schema26 = {
  type: 'string',
  title: 'Color',
  enum: ['black', 'blue', 'red'],
  tsEnumNames: ['Black', 'Blue', 'Red'],
};
const schema23 = {
  type: 'object',
  title: 'Signature',
  additionalProperties: false,
  properties: {
    type: { $ref: '#/definitions/SignatureType' },
    createType: { $ref: '#/definitions/SignatureCreateType' },
    createdAt: { type: 'string', format: 'date-time' },
    lastUsedAt: { type: 'string', format: 'date-time' },
    guid: { type: 'string' },
    width: { type: 'number' },
    height: { type: 'number' },
  },
  required: ['guid', 'type'],
};
const schema24 = {
  type: 'string',
  title: 'SignatureType',
  enum: ['S', 'I'],
  tsEnumNames: ['Signature', 'Initials'],
};
const schema25 = {
  type: 'string',
  title: 'SignatureCreateType',
  enum: ['C', 'U', 'T', 'E'],
  tsEnumNames: ['Canvas', 'Upload', 'Typed', 'Email'],
};
const formats0 = require('ajv-formats/dist/formats').fullFormats['date-time'];
function validate17(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.guid === undefined && (missing0 = 'guid')) ||
        (data.type === undefined && (missing0 = 'type'))
      ) {
        validate17.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (
            !(
              key0 === 'type' ||
              key0 === 'createType' ||
              key0 === 'createdAt' ||
              key0 === 'lastUsedAt' ||
              key0 === 'guid' ||
              key0 === 'width' ||
              key0 === 'height'
            )
          ) {
            validate17.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.type !== undefined) {
            let data0 = data.type;
            const _errs2 = errors;
            if (typeof data0 !== 'string') {
              validate17.errors = [
                {
                  instancePath: instancePath + '/type',
                  schemaPath: '#/definitions/SignatureType/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            if (!(data0 === 'S' || data0 === 'I')) {
              validate17.errors = [
                {
                  instancePath: instancePath + '/type',
                  schemaPath: '#/definitions/SignatureType/enum',
                  keyword: 'enum',
                  params: { allowedValues: schema24.enum },
                  message: 'must be equal to one of the allowed values',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.createType !== undefined) {
              let data1 = data.createType;
              const _errs5 = errors;
              if (typeof data1 !== 'string') {
                validate17.errors = [
                  {
                    instancePath: instancePath + '/createType',
                    schemaPath: '#/definitions/SignatureCreateType/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              if (
                !(
                  data1 === 'C' ||
                  data1 === 'U' ||
                  data1 === 'T' ||
                  data1 === 'E'
                )
              ) {
                validate17.errors = [
                  {
                    instancePath: instancePath + '/createType',
                    schemaPath: '#/definitions/SignatureCreateType/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema25.enum },
                    message: 'must be equal to one of the allowed values',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.createdAt !== undefined) {
                let data2 = data.createdAt;
                const _errs8 = errors;
                if (errors === _errs8) {
                  if (errors === _errs8) {
                    if (typeof data2 === 'string') {
                      if (!formats0.validate(data2)) {
                        validate17.errors = [
                          {
                            instancePath: instancePath + '/createdAt',
                            schemaPath: '#/properties/createdAt/format',
                            keyword: 'format',
                            params: { format: 'date-time' },
                            message: 'must match format "' + 'date-time' + '"',
                          },
                        ];
                        return false;
                      }
                    } else {
                      validate17.errors = [
                        {
                          instancePath: instancePath + '/createdAt',
                          schemaPath: '#/properties/createdAt/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                  }
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.lastUsedAt !== undefined) {
                  let data3 = data.lastUsedAt;
                  const _errs10 = errors;
                  if (errors === _errs10) {
                    if (errors === _errs10) {
                      if (typeof data3 === 'string') {
                        if (!formats0.validate(data3)) {
                          validate17.errors = [
                            {
                              instancePath: instancePath + '/lastUsedAt',
                              schemaPath: '#/properties/lastUsedAt/format',
                              keyword: 'format',
                              params: { format: 'date-time' },
                              message:
                                'must match format "' + 'date-time' + '"',
                            },
                          ];
                          return false;
                        }
                      } else {
                        validate17.errors = [
                          {
                            instancePath: instancePath + '/lastUsedAt',
                            schemaPath: '#/properties/lastUsedAt/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                    }
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.guid !== undefined) {
                    const _errs12 = errors;
                    if (typeof data.guid !== 'string') {
                      validate17.errors = [
                        {
                          instancePath: instancePath + '/guid',
                          schemaPath: '#/properties/guid/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.width !== undefined) {
                      let data5 = data.width;
                      const _errs14 = errors;
                      if (!(typeof data5 == 'number' && isFinite(data5))) {
                        validate17.errors = [
                          {
                            instancePath: instancePath + '/width',
                            schemaPath: '#/properties/width/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs14 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.height !== undefined) {
                        let data6 = data.height;
                        const _errs16 = errors;
                        if (!(typeof data6 == 'number' && isFinite(data6))) {
                          validate17.errors = [
                            {
                              instancePath: instancePath + '/height',
                              schemaPath: '#/properties/height/type',
                              keyword: 'type',
                              params: { type: 'number' },
                              message: 'must be number',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs16 === errors;
                      } else {
                        var valid0 = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate17.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate17.errors = vErrors;
  return errors === 0;
}
function validate16(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    let missing0;
    if (
      (data.pageIndex === undefined && (missing0 = 'pageIndex')) ||
      (data.signer === undefined && (missing0 = 'signer')) ||
      (data.documentId === undefined && (missing0 = 'documentId')) ||
      (data.id === undefined && (missing0 = 'id')) ||
      (data.name === undefined && (missing0 = 'name')) ||
      (data.required === undefined && (missing0 = 'required')) ||
      (data.readOnly === undefined && (missing0 = 'readOnly')) ||
      (data.x === undefined && (missing0 = 'x')) ||
      (data.y === undefined && (missing0 = 'y')) ||
      (data.width === undefined && (missing0 = 'width')) ||
      (data.height === undefined && (missing0 = 'height')) ||
      (data.type === undefined && (missing0 = 'type'))
    ) {
      validate16.errors = [
        {
          instancePath,
          schemaPath: '#/allOf/0/required',
          keyword: 'required',
          params: { missingProperty: missing0 },
          message: "must have required property '" + missing0 + "'",
        },
      ];
      return false;
    } else {
      if (data.type !== undefined) {
        const _errs1 = errors;
        if (!func0(data.type, 'signature')) {
          validate16.errors = [
            {
              instancePath: instancePath + '/type',
              schemaPath: '#/allOf/0/properties/type/const',
              keyword: 'const',
              params: { allowedValue: 'signature' },
              message: 'must be equal to constant',
            },
          ];
          return false;
        }
        var valid1 = _errs1 === errors;
      } else {
        var valid1 = true;
      }
      if (valid1) {
        if (data.pageIndex !== undefined) {
          let data1 = data.pageIndex;
          const _errs2 = errors;
          if (!(typeof data1 == 'number' && isFinite(data1))) {
            validate16.errors = [
              {
                instancePath: instancePath + '/pageIndex',
                schemaPath: '#/allOf/0/properties/pageIndex/type',
                keyword: 'type',
                params: { type: 'number' },
                message: 'must be number',
              },
            ];
            return false;
          }
          var valid1 = _errs2 === errors;
        } else {
          var valid1 = true;
        }
        if (valid1) {
          if (data.id !== undefined) {
            const _errs4 = errors;
            if (typeof data.id !== 'string') {
              validate16.errors = [
                {
                  instancePath: instancePath + '/id',
                  schemaPath: '#/allOf/0/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid1 = _errs4 === errors;
          } else {
            var valid1 = true;
          }
          if (valid1) {
            if (data.apiId !== undefined) {
              const _errs6 = errors;
              if (typeof data.apiId !== 'string') {
                validate16.errors = [
                  {
                    instancePath: instancePath + '/apiId',
                    schemaPath: '#/allOf/0/properties/apiId/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid1 = _errs6 === errors;
            } else {
              var valid1 = true;
            }
            if (valid1) {
              if (data.documentId !== undefined) {
                const _errs8 = errors;
                if (typeof data.documentId !== 'string') {
                  validate16.errors = [
                    {
                      instancePath: instancePath + '/documentId',
                      schemaPath: '#/allOf/0/properties/documentId/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid1 = _errs8 === errors;
              } else {
                var valid1 = true;
              }
              if (valid1) {
                if (data.x !== undefined) {
                  let data5 = data.x;
                  const _errs10 = errors;
                  if (!(typeof data5 == 'number' && isFinite(data5))) {
                    validate16.errors = [
                      {
                        instancePath: instancePath + '/x',
                        schemaPath: '#/allOf/0/properties/x/type',
                        keyword: 'type',
                        params: { type: 'number' },
                        message: 'must be number',
                      },
                    ];
                    return false;
                  }
                  var valid1 = _errs10 === errors;
                } else {
                  var valid1 = true;
                }
                if (valid1) {
                  if (data.y !== undefined) {
                    let data6 = data.y;
                    const _errs12 = errors;
                    if (!(typeof data6 == 'number' && isFinite(data6))) {
                      validate16.errors = [
                        {
                          instancePath: instancePath + '/y',
                          schemaPath: '#/allOf/0/properties/y/type',
                          keyword: 'type',
                          params: { type: 'number' },
                          message: 'must be number',
                        },
                      ];
                      return false;
                    }
                    var valid1 = _errs12 === errors;
                  } else {
                    var valid1 = true;
                  }
                  if (valid1) {
                    if (data.width !== undefined) {
                      let data7 = data.width;
                      const _errs14 = errors;
                      if (!(typeof data7 == 'number' && isFinite(data7))) {
                        validate16.errors = [
                          {
                            instancePath: instancePath + '/width',
                            schemaPath: '#/allOf/0/properties/width/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          },
                        ];
                        return false;
                      }
                      var valid1 = _errs14 === errors;
                    } else {
                      var valid1 = true;
                    }
                    if (valid1) {
                      if (data.height !== undefined) {
                        let data8 = data.height;
                        const _errs16 = errors;
                        if (!(typeof data8 == 'number' && isFinite(data8))) {
                          validate16.errors = [
                            {
                              instancePath: instancePath + '/height',
                              schemaPath: '#/allOf/0/properties/height/type',
                              keyword: 'type',
                              params: { type: 'number' },
                              message: 'must be number',
                            },
                          ];
                          return false;
                        }
                        var valid1 = _errs16 === errors;
                      } else {
                        var valid1 = true;
                      }
                      if (valid1) {
                        if (data.signer !== undefined) {
                          const _errs18 = errors;
                          if (typeof data.signer !== 'string') {
                            validate16.errors = [
                              {
                                instancePath: instancePath + '/signer',
                                schemaPath: '#/allOf/0/properties/signer/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid1 = _errs18 === errors;
                        } else {
                          var valid1 = true;
                        }
                        if (valid1) {
                          if (data.required !== undefined) {
                            const _errs20 = errors;
                            if (typeof data.required !== 'boolean') {
                              validate16.errors = [
                                {
                                  instancePath: instancePath + '/required',
                                  schemaPath:
                                    '#/allOf/0/properties/required/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid1 = _errs20 === errors;
                          } else {
                            var valid1 = true;
                          }
                          if (valid1) {
                            if (data.readOnly !== undefined) {
                              const _errs22 = errors;
                              if (typeof data.readOnly !== 'boolean') {
                                validate16.errors = [
                                  {
                                    instancePath: instancePath + '/readOnly',
                                    schemaPath:
                                      '#/allOf/0/properties/readOnly/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  },
                                ];
                                return false;
                              }
                              var valid1 = _errs22 === errors;
                            } else {
                              var valid1 = true;
                            }
                            if (valid1) {
                              if (data.name !== undefined) {
                                const _errs24 = errors;
                                if (typeof data.name !== 'string') {
                                  validate16.errors = [
                                    {
                                      instancePath: instancePath + '/name',
                                      schemaPath:
                                        '#/allOf/0/properties/name/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid1 = _errs24 === errors;
                              } else {
                                var valid1 = true;
                              }
                              if (valid1) {
                                if (data.linkId !== undefined) {
                                  const _errs26 = errors;
                                  if (typeof data.linkId !== 'string') {
                                    validate16.errors = [
                                      {
                                        instancePath: instancePath + '/linkId',
                                        schemaPath:
                                          '#/allOf/0/properties/linkId/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid1 = _errs26 === errors;
                                } else {
                                  var valid1 = true;
                                }
                                if (valid1) {
                                  if (data.isDisabled !== undefined) {
                                    const _errs28 = errors;
                                    if (typeof data.isDisabled !== 'boolean') {
                                      validate16.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/isDisabled',
                                          schemaPath:
                                            '#/allOf/0/properties/isDisabled/type',
                                          keyword: 'type',
                                          params: { type: 'boolean' },
                                          message: 'must be boolean',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid1 = _errs28 === errors;
                                  } else {
                                    var valid1 = true;
                                  }
                                  if (valid1) {
                                    if (data.signature !== undefined) {
                                      const _errs30 = errors;
                                      if (
                                        !validate17(data.signature, {
                                          instancePath:
                                            instancePath + '/signature',
                                          parentData: data,
                                          parentDataProperty: 'signature',
                                          rootData,
                                        })
                                      ) {
                                        vErrors =
                                          vErrors === null
                                            ? validate17.errors
                                            : vErrors.concat(validate17.errors);
                                        errors = vErrors.length;
                                      }
                                      var valid1 = _errs30 === errors;
                                    } else {
                                      var valid1 = true;
                                    }
                                    if (valid1) {
                                      if (data.color !== undefined) {
                                        let data16 = data.color;
                                        const _errs31 = errors;
                                        if (typeof data16 !== 'string') {
                                          validate16.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/color',
                                              schemaPath:
                                                '#/definitions/Color/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                        if (
                                          !(
                                            data16 === 'black' ||
                                            data16 === 'blue' ||
                                            data16 === 'red'
                                          )
                                        ) {
                                          validate16.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/color',
                                              schemaPath:
                                                '#/definitions/Color/enum',
                                              keyword: 'enum',
                                              params: {
                                                allowedValues: schema26.enum,
                                              },
                                              message:
                                                'must be equal to one of the allowed values',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid1 = _errs31 === errors;
                                      } else {
                                        var valid1 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  validate16.errors = vErrors;
  return errors === 0;
}
const schema27 = {
  title: 'InitialsField',
  allOf: [
    {
      properties: {
        type: { const: 'initials', default: 'initials' },
        pageIndex: { type: 'number' },
        id: { type: 'string' },
        apiId: { type: 'string' },
        documentId: { type: 'string' },
        x: { type: 'number' },
        y: { type: 'number' },
        width: { type: 'number' },
        height: { type: 'number' },
        signer: { type: 'string' },
        required: { type: 'boolean' },
        readOnly: { type: 'boolean' },
        name: { type: 'string' },
        linkId: { type: 'string' },
        isDisabled: { type: 'boolean' },
        signature: { $ref: '#/definitions/Signature' },
        color: { $ref: '#/definitions/Color' },
      },
      required: [
        'pageIndex',
        'signer',
        'documentId',
        'id',
        'name',
        'required',
        'readOnly',
        'x',
        'y',
        'width',
        'height',
        'type',
      ],
    },
  ],
};
function validate20(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    let missing0;
    if (
      (data.pageIndex === undefined && (missing0 = 'pageIndex')) ||
      (data.signer === undefined && (missing0 = 'signer')) ||
      (data.documentId === undefined && (missing0 = 'documentId')) ||
      (data.id === undefined && (missing0 = 'id')) ||
      (data.name === undefined && (missing0 = 'name')) ||
      (data.required === undefined && (missing0 = 'required')) ||
      (data.readOnly === undefined && (missing0 = 'readOnly')) ||
      (data.x === undefined && (missing0 = 'x')) ||
      (data.y === undefined && (missing0 = 'y')) ||
      (data.width === undefined && (missing0 = 'width')) ||
      (data.height === undefined && (missing0 = 'height')) ||
      (data.type === undefined && (missing0 = 'type'))
    ) {
      validate20.errors = [
        {
          instancePath,
          schemaPath: '#/allOf/0/required',
          keyword: 'required',
          params: { missingProperty: missing0 },
          message: "must have required property '" + missing0 + "'",
        },
      ];
      return false;
    } else {
      if (data.type !== undefined) {
        const _errs1 = errors;
        if (!func0(data.type, 'initials')) {
          validate20.errors = [
            {
              instancePath: instancePath + '/type',
              schemaPath: '#/allOf/0/properties/type/const',
              keyword: 'const',
              params: { allowedValue: 'initials' },
              message: 'must be equal to constant',
            },
          ];
          return false;
        }
        var valid1 = _errs1 === errors;
      } else {
        var valid1 = true;
      }
      if (valid1) {
        if (data.pageIndex !== undefined) {
          let data1 = data.pageIndex;
          const _errs2 = errors;
          if (!(typeof data1 == 'number' && isFinite(data1))) {
            validate20.errors = [
              {
                instancePath: instancePath + '/pageIndex',
                schemaPath: '#/allOf/0/properties/pageIndex/type',
                keyword: 'type',
                params: { type: 'number' },
                message: 'must be number',
              },
            ];
            return false;
          }
          var valid1 = _errs2 === errors;
        } else {
          var valid1 = true;
        }
        if (valid1) {
          if (data.id !== undefined) {
            const _errs4 = errors;
            if (typeof data.id !== 'string') {
              validate20.errors = [
                {
                  instancePath: instancePath + '/id',
                  schemaPath: '#/allOf/0/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid1 = _errs4 === errors;
          } else {
            var valid1 = true;
          }
          if (valid1) {
            if (data.apiId !== undefined) {
              const _errs6 = errors;
              if (typeof data.apiId !== 'string') {
                validate20.errors = [
                  {
                    instancePath: instancePath + '/apiId',
                    schemaPath: '#/allOf/0/properties/apiId/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid1 = _errs6 === errors;
            } else {
              var valid1 = true;
            }
            if (valid1) {
              if (data.documentId !== undefined) {
                const _errs8 = errors;
                if (typeof data.documentId !== 'string') {
                  validate20.errors = [
                    {
                      instancePath: instancePath + '/documentId',
                      schemaPath: '#/allOf/0/properties/documentId/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid1 = _errs8 === errors;
              } else {
                var valid1 = true;
              }
              if (valid1) {
                if (data.x !== undefined) {
                  let data5 = data.x;
                  const _errs10 = errors;
                  if (!(typeof data5 == 'number' && isFinite(data5))) {
                    validate20.errors = [
                      {
                        instancePath: instancePath + '/x',
                        schemaPath: '#/allOf/0/properties/x/type',
                        keyword: 'type',
                        params: { type: 'number' },
                        message: 'must be number',
                      },
                    ];
                    return false;
                  }
                  var valid1 = _errs10 === errors;
                } else {
                  var valid1 = true;
                }
                if (valid1) {
                  if (data.y !== undefined) {
                    let data6 = data.y;
                    const _errs12 = errors;
                    if (!(typeof data6 == 'number' && isFinite(data6))) {
                      validate20.errors = [
                        {
                          instancePath: instancePath + '/y',
                          schemaPath: '#/allOf/0/properties/y/type',
                          keyword: 'type',
                          params: { type: 'number' },
                          message: 'must be number',
                        },
                      ];
                      return false;
                    }
                    var valid1 = _errs12 === errors;
                  } else {
                    var valid1 = true;
                  }
                  if (valid1) {
                    if (data.width !== undefined) {
                      let data7 = data.width;
                      const _errs14 = errors;
                      if (!(typeof data7 == 'number' && isFinite(data7))) {
                        validate20.errors = [
                          {
                            instancePath: instancePath + '/width',
                            schemaPath: '#/allOf/0/properties/width/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          },
                        ];
                        return false;
                      }
                      var valid1 = _errs14 === errors;
                    } else {
                      var valid1 = true;
                    }
                    if (valid1) {
                      if (data.height !== undefined) {
                        let data8 = data.height;
                        const _errs16 = errors;
                        if (!(typeof data8 == 'number' && isFinite(data8))) {
                          validate20.errors = [
                            {
                              instancePath: instancePath + '/height',
                              schemaPath: '#/allOf/0/properties/height/type',
                              keyword: 'type',
                              params: { type: 'number' },
                              message: 'must be number',
                            },
                          ];
                          return false;
                        }
                        var valid1 = _errs16 === errors;
                      } else {
                        var valid1 = true;
                      }
                      if (valid1) {
                        if (data.signer !== undefined) {
                          const _errs18 = errors;
                          if (typeof data.signer !== 'string') {
                            validate20.errors = [
                              {
                                instancePath: instancePath + '/signer',
                                schemaPath: '#/allOf/0/properties/signer/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid1 = _errs18 === errors;
                        } else {
                          var valid1 = true;
                        }
                        if (valid1) {
                          if (data.required !== undefined) {
                            const _errs20 = errors;
                            if (typeof data.required !== 'boolean') {
                              validate20.errors = [
                                {
                                  instancePath: instancePath + '/required',
                                  schemaPath:
                                    '#/allOf/0/properties/required/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid1 = _errs20 === errors;
                          } else {
                            var valid1 = true;
                          }
                          if (valid1) {
                            if (data.readOnly !== undefined) {
                              const _errs22 = errors;
                              if (typeof data.readOnly !== 'boolean') {
                                validate20.errors = [
                                  {
                                    instancePath: instancePath + '/readOnly',
                                    schemaPath:
                                      '#/allOf/0/properties/readOnly/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  },
                                ];
                                return false;
                              }
                              var valid1 = _errs22 === errors;
                            } else {
                              var valid1 = true;
                            }
                            if (valid1) {
                              if (data.name !== undefined) {
                                const _errs24 = errors;
                                if (typeof data.name !== 'string') {
                                  validate20.errors = [
                                    {
                                      instancePath: instancePath + '/name',
                                      schemaPath:
                                        '#/allOf/0/properties/name/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid1 = _errs24 === errors;
                              } else {
                                var valid1 = true;
                              }
                              if (valid1) {
                                if (data.linkId !== undefined) {
                                  const _errs26 = errors;
                                  if (typeof data.linkId !== 'string') {
                                    validate20.errors = [
                                      {
                                        instancePath: instancePath + '/linkId',
                                        schemaPath:
                                          '#/allOf/0/properties/linkId/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid1 = _errs26 === errors;
                                } else {
                                  var valid1 = true;
                                }
                                if (valid1) {
                                  if (data.isDisabled !== undefined) {
                                    const _errs28 = errors;
                                    if (typeof data.isDisabled !== 'boolean') {
                                      validate20.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/isDisabled',
                                          schemaPath:
                                            '#/allOf/0/properties/isDisabled/type',
                                          keyword: 'type',
                                          params: { type: 'boolean' },
                                          message: 'must be boolean',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid1 = _errs28 === errors;
                                  } else {
                                    var valid1 = true;
                                  }
                                  if (valid1) {
                                    if (data.signature !== undefined) {
                                      const _errs30 = errors;
                                      if (
                                        !validate17(data.signature, {
                                          instancePath:
                                            instancePath + '/signature',
                                          parentData: data,
                                          parentDataProperty: 'signature',
                                          rootData,
                                        })
                                      ) {
                                        vErrors =
                                          vErrors === null
                                            ? validate17.errors
                                            : vErrors.concat(validate17.errors);
                                        errors = vErrors.length;
                                      }
                                      var valid1 = _errs30 === errors;
                                    } else {
                                      var valid1 = true;
                                    }
                                    if (valid1) {
                                      if (data.color !== undefined) {
                                        let data16 = data.color;
                                        const _errs31 = errors;
                                        if (typeof data16 !== 'string') {
                                          validate20.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/color',
                                              schemaPath:
                                                '#/definitions/Color/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                        if (
                                          !(
                                            data16 === 'black' ||
                                            data16 === 'blue' ||
                                            data16 === 'red'
                                          )
                                        ) {
                                          validate20.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/color',
                                              schemaPath:
                                                '#/definitions/Color/enum',
                                              keyword: 'enum',
                                              params: {
                                                allowedValues: schema26.enum,
                                              },
                                              message:
                                                'must be equal to one of the allowed values',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid1 = _errs31 === errors;
                                      } else {
                                        var valid1 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  validate20.errors = vErrors;
  return errors === 0;
}
const schema29 = {
  title: 'DateField',
  allOf: [
    {
      properties: {
        pageIndex: { type: 'number' },
        id: { type: 'string' },
        apiId: { type: 'string' },
        documentId: { type: 'string' },
        x: { type: 'number' },
        y: { type: 'number' },
        width: { type: 'number' },
        height: { type: 'number' },
        signer: { type: 'string' },
        required: { type: 'boolean' },
        readOnly: { type: 'boolean' },
        name: { type: 'string' },
        linkId: { type: 'string' },
        isDisabled: { type: 'boolean' },
        fontSize: { $ref: '#/definitions/FontSize' },
        originalFontSize: { $ref: '#/definitions/FontSize' },
        fontFamily: { $ref: '#/definitions/FontFamily' },
        lineHeight: { type: 'number' },
        value: { type: ['string', 'null'] },
        placeholder: { type: 'string' },
        type: { const: 'date', default: 'date' },
        dateFormat: { $ref: '#/definitions/JSDateFormat' },
      },
      required: [
        'pageIndex',
        'signer',
        'documentId',
        'value',
        'fontSize',
        'fontFamily',
        'type',
        'id',
        'name',
        'required',
        'readOnly',
        'x',
        'y',
        'width',
        'height',
      ],
    },
  ],
};
function validate23(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    let missing0;
    if (
      (data.pageIndex === undefined && (missing0 = 'pageIndex')) ||
      (data.signer === undefined && (missing0 = 'signer')) ||
      (data.documentId === undefined && (missing0 = 'documentId')) ||
      (data.value === undefined && (missing0 = 'value')) ||
      (data.fontSize === undefined && (missing0 = 'fontSize')) ||
      (data.fontFamily === undefined && (missing0 = 'fontFamily')) ||
      (data.type === undefined && (missing0 = 'type')) ||
      (data.id === undefined && (missing0 = 'id')) ||
      (data.name === undefined && (missing0 = 'name')) ||
      (data.required === undefined && (missing0 = 'required')) ||
      (data.readOnly === undefined && (missing0 = 'readOnly')) ||
      (data.x === undefined && (missing0 = 'x')) ||
      (data.y === undefined && (missing0 = 'y')) ||
      (data.width === undefined && (missing0 = 'width')) ||
      (data.height === undefined && (missing0 = 'height'))
    ) {
      validate23.errors = [
        {
          instancePath,
          schemaPath: '#/allOf/0/required',
          keyword: 'required',
          params: { missingProperty: missing0 },
          message: "must have required property '" + missing0 + "'",
        },
      ];
      return false;
    } else {
      if (data.pageIndex !== undefined) {
        let data0 = data.pageIndex;
        const _errs1 = errors;
        if (!(typeof data0 == 'number' && isFinite(data0))) {
          validate23.errors = [
            {
              instancePath: instancePath + '/pageIndex',
              schemaPath: '#/allOf/0/properties/pageIndex/type',
              keyword: 'type',
              params: { type: 'number' },
              message: 'must be number',
            },
          ];
          return false;
        }
        var valid1 = _errs1 === errors;
      } else {
        var valid1 = true;
      }
      if (valid1) {
        if (data.id !== undefined) {
          const _errs3 = errors;
          if (typeof data.id !== 'string') {
            validate23.errors = [
              {
                instancePath: instancePath + '/id',
                schemaPath: '#/allOf/0/properties/id/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid1 = _errs3 === errors;
        } else {
          var valid1 = true;
        }
        if (valid1) {
          if (data.apiId !== undefined) {
            const _errs5 = errors;
            if (typeof data.apiId !== 'string') {
              validate23.errors = [
                {
                  instancePath: instancePath + '/apiId',
                  schemaPath: '#/allOf/0/properties/apiId/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid1 = _errs5 === errors;
          } else {
            var valid1 = true;
          }
          if (valid1) {
            if (data.documentId !== undefined) {
              const _errs7 = errors;
              if (typeof data.documentId !== 'string') {
                validate23.errors = [
                  {
                    instancePath: instancePath + '/documentId',
                    schemaPath: '#/allOf/0/properties/documentId/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid1 = _errs7 === errors;
            } else {
              var valid1 = true;
            }
            if (valid1) {
              if (data.x !== undefined) {
                let data4 = data.x;
                const _errs9 = errors;
                if (!(typeof data4 == 'number' && isFinite(data4))) {
                  validate23.errors = [
                    {
                      instancePath: instancePath + '/x',
                      schemaPath: '#/allOf/0/properties/x/type',
                      keyword: 'type',
                      params: { type: 'number' },
                      message: 'must be number',
                    },
                  ];
                  return false;
                }
                var valid1 = _errs9 === errors;
              } else {
                var valid1 = true;
              }
              if (valid1) {
                if (data.y !== undefined) {
                  let data5 = data.y;
                  const _errs11 = errors;
                  if (!(typeof data5 == 'number' && isFinite(data5))) {
                    validate23.errors = [
                      {
                        instancePath: instancePath + '/y',
                        schemaPath: '#/allOf/0/properties/y/type',
                        keyword: 'type',
                        params: { type: 'number' },
                        message: 'must be number',
                      },
                    ];
                    return false;
                  }
                  var valid1 = _errs11 === errors;
                } else {
                  var valid1 = true;
                }
                if (valid1) {
                  if (data.width !== undefined) {
                    let data6 = data.width;
                    const _errs13 = errors;
                    if (!(typeof data6 == 'number' && isFinite(data6))) {
                      validate23.errors = [
                        {
                          instancePath: instancePath + '/width',
                          schemaPath: '#/allOf/0/properties/width/type',
                          keyword: 'type',
                          params: { type: 'number' },
                          message: 'must be number',
                        },
                      ];
                      return false;
                    }
                    var valid1 = _errs13 === errors;
                  } else {
                    var valid1 = true;
                  }
                  if (valid1) {
                    if (data.height !== undefined) {
                      let data7 = data.height;
                      const _errs15 = errors;
                      if (!(typeof data7 == 'number' && isFinite(data7))) {
                        validate23.errors = [
                          {
                            instancePath: instancePath + '/height',
                            schemaPath: '#/allOf/0/properties/height/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          },
                        ];
                        return false;
                      }
                      var valid1 = _errs15 === errors;
                    } else {
                      var valid1 = true;
                    }
                    if (valid1) {
                      if (data.signer !== undefined) {
                        const _errs17 = errors;
                        if (typeof data.signer !== 'string') {
                          validate23.errors = [
                            {
                              instancePath: instancePath + '/signer',
                              schemaPath: '#/allOf/0/properties/signer/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid1 = _errs17 === errors;
                      } else {
                        var valid1 = true;
                      }
                      if (valid1) {
                        if (data.required !== undefined) {
                          const _errs19 = errors;
                          if (typeof data.required !== 'boolean') {
                            validate23.errors = [
                              {
                                instancePath: instancePath + '/required',
                                schemaPath:
                                  '#/allOf/0/properties/required/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid1 = _errs19 === errors;
                        } else {
                          var valid1 = true;
                        }
                        if (valid1) {
                          if (data.readOnly !== undefined) {
                            const _errs21 = errors;
                            if (typeof data.readOnly !== 'boolean') {
                              validate23.errors = [
                                {
                                  instancePath: instancePath + '/readOnly',
                                  schemaPath:
                                    '#/allOf/0/properties/readOnly/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid1 = _errs21 === errors;
                          } else {
                            var valid1 = true;
                          }
                          if (valid1) {
                            if (data.name !== undefined) {
                              const _errs23 = errors;
                              if (typeof data.name !== 'string') {
                                validate23.errors = [
                                  {
                                    instancePath: instancePath + '/name',
                                    schemaPath:
                                      '#/allOf/0/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid1 = _errs23 === errors;
                            } else {
                              var valid1 = true;
                            }
                            if (valid1) {
                              if (data.linkId !== undefined) {
                                const _errs25 = errors;
                                if (typeof data.linkId !== 'string') {
                                  validate23.errors = [
                                    {
                                      instancePath: instancePath + '/linkId',
                                      schemaPath:
                                        '#/allOf/0/properties/linkId/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid1 = _errs25 === errors;
                              } else {
                                var valid1 = true;
                              }
                              if (valid1) {
                                if (data.isDisabled !== undefined) {
                                  const _errs27 = errors;
                                  if (typeof data.isDisabled !== 'boolean') {
                                    validate23.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/isDisabled',
                                        schemaPath:
                                          '#/allOf/0/properties/isDisabled/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid1 = _errs27 === errors;
                                } else {
                                  var valid1 = true;
                                }
                                if (valid1) {
                                  if (data.fontSize !== undefined) {
                                    let data14 = data.fontSize;
                                    const _errs29 = errors;
                                    if (
                                      !(
                                        typeof data14 == 'number' &&
                                        isFinite(data14)
                                      )
                                    ) {
                                      validate23.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/fontSize',
                                          schemaPath:
                                            '#/definitions/FontSize/type',
                                          keyword: 'type',
                                          params: { type: 'number' },
                                          message: 'must be number',
                                        },
                                      ];
                                      return false;
                                    }
                                    if (
                                      !(
                                        data14 === 7 ||
                                        data14 === 8 ||
                                        data14 === 9 ||
                                        data14 === 10 ||
                                        data14 === 12 ||
                                        data14 === 14 ||
                                        data14 === 16 ||
                                        data14 === 18 ||
                                        data14 === 20 ||
                                        data14 === 22 ||
                                        data14 === 24 ||
                                        data14 === 26 ||
                                        data14 === 28 ||
                                        data14 === 36 ||
                                        data14 === 42 ||
                                        data14 === 48
                                      )
                                    ) {
                                      validate23.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/fontSize',
                                          schemaPath:
                                            '#/definitions/FontSize/enum',
                                          keyword: 'enum',
                                          params: {
                                            allowedValues: schema18.enum,
                                          },
                                          message:
                                            'must be equal to one of the allowed values',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid1 = _errs29 === errors;
                                  } else {
                                    var valid1 = true;
                                  }
                                  if (valid1) {
                                    if (data.originalFontSize !== undefined) {
                                      let data15 = data.originalFontSize;
                                      const _errs32 = errors;
                                      if (
                                        !(
                                          typeof data15 == 'number' &&
                                          isFinite(data15)
                                        )
                                      ) {
                                        validate23.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/originalFontSize',
                                            schemaPath:
                                              '#/definitions/FontSize/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number',
                                          },
                                        ];
                                        return false;
                                      }
                                      if (
                                        !(
                                          data15 === 7 ||
                                          data15 === 8 ||
                                          data15 === 9 ||
                                          data15 === 10 ||
                                          data15 === 12 ||
                                          data15 === 14 ||
                                          data15 === 16 ||
                                          data15 === 18 ||
                                          data15 === 20 ||
                                          data15 === 22 ||
                                          data15 === 24 ||
                                          data15 === 26 ||
                                          data15 === 28 ||
                                          data15 === 36 ||
                                          data15 === 42 ||
                                          data15 === 48
                                        )
                                      ) {
                                        validate23.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/originalFontSize',
                                            schemaPath:
                                              '#/definitions/FontSize/enum',
                                            keyword: 'enum',
                                            params: {
                                              allowedValues: schema18.enum,
                                            },
                                            message:
                                              'must be equal to one of the allowed values',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid1 = _errs32 === errors;
                                    } else {
                                      var valid1 = true;
                                    }
                                    if (valid1) {
                                      if (data.fontFamily !== undefined) {
                                        let data16 = data.fontFamily;
                                        const _errs35 = errors;
                                        if (typeof data16 !== 'string') {
                                          validate23.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/fontFamily',
                                              schemaPath:
                                                '#/definitions/FontFamily/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                        if (
                                          !(
                                            data16 === 'helvetica' ||
                                            data16 === 'arial' ||
                                            data16 === 'calibri' ||
                                            data16 === 'cambria' ||
                                            data16 === 'courier' ||
                                            data16 === 'georgia' ||
                                            data16 === 'times' ||
                                            data16 === 'trebuchet' ||
                                            data16 === 'verdana' ||
                                            data16 === 'notoSerif' ||
                                            data16 === 'notoSans' ||
                                            data16 === 'roboto' ||
                                            data16 === 'robotoMono'
                                          )
                                        ) {
                                          validate23.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/fontFamily',
                                              schemaPath:
                                                '#/definitions/FontFamily/enum',
                                              keyword: 'enum',
                                              params: {
                                                allowedValues: schema20.enum,
                                              },
                                              message:
                                                'must be equal to one of the allowed values',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid1 = _errs35 === errors;
                                      } else {
                                        var valid1 = true;
                                      }
                                      if (valid1) {
                                        if (data.lineHeight !== undefined) {
                                          let data17 = data.lineHeight;
                                          const _errs38 = errors;
                                          if (
                                            !(
                                              typeof data17 == 'number' &&
                                              isFinite(data17)
                                            )
                                          ) {
                                            validate23.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/lineHeight',
                                                schemaPath:
                                                  '#/allOf/0/properties/lineHeight/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid1 = _errs38 === errors;
                                        } else {
                                          var valid1 = true;
                                        }
                                        if (valid1) {
                                          if (data.value !== undefined) {
                                            let data18 = data.value;
                                            const _errs40 = errors;
                                            if (
                                              typeof data18 !== 'string' &&
                                              data18 !== null
                                            ) {
                                              validate23.errors = [
                                                {
                                                  instancePath:
                                                    instancePath + '/value',
                                                  schemaPath:
                                                    '#/allOf/0/properties/value/type',
                                                  keyword: 'type',
                                                  params: {
                                                    type: schema29.allOf[0]
                                                      .properties.value.type,
                                                  },
                                                  message:
                                                    'must be string,null',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid1 = _errs40 === errors;
                                          } else {
                                            var valid1 = true;
                                          }
                                          if (valid1) {
                                            if (
                                              data.placeholder !== undefined
                                            ) {
                                              const _errs42 = errors;
                                              if (
                                                typeof data.placeholder !==
                                                'string'
                                              ) {
                                                validate23.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/placeholder',
                                                    schemaPath:
                                                      '#/allOf/0/properties/placeholder/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid1 = _errs42 === errors;
                                            } else {
                                              var valid1 = true;
                                            }
                                            if (valid1) {
                                              if (data.type !== undefined) {
                                                const _errs44 = errors;
                                                if (!func0(data.type, 'date')) {
                                                  validate23.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath + '/type',
                                                      schemaPath:
                                                        '#/allOf/0/properties/type/const',
                                                      keyword: 'const',
                                                      params: {
                                                        allowedValue: 'date',
                                                      },
                                                      message:
                                                        'must be equal to constant',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid1 = _errs44 === errors;
                                              } else {
                                                var valid1 = true;
                                              }
                                              if (valid1) {
                                                if (
                                                  data.dateFormat !== undefined
                                                ) {
                                                  let data21 = data.dateFormat;
                                                  const _errs45 = errors;
                                                  if (
                                                    typeof data21 !== 'string'
                                                  ) {
                                                    validate23.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath +
                                                          '/dateFormat',
                                                        schemaPath:
                                                          '#/definitions/JSDateFormat/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'string',
                                                        },
                                                        message:
                                                          'must be string',
                                                      },
                                                    ];
                                                    return false;
                                                  }
                                                  if (
                                                    !(
                                                      data21 === 'default' ||
                                                      data21 ===
                                                        'MM / DD / YYYY' ||
                                                      data21 ===
                                                        'MM - DD - YYYY' ||
                                                      data21 ===
                                                        'DD / MM / YYYY' ||
                                                      data21 ===
                                                        'DD - MM - YYYY' ||
                                                      data21 ===
                                                        'YYYY / MM / DD' ||
                                                      data21 ===
                                                        'YYYY - MM - DD'
                                                    )
                                                  ) {
                                                    validate23.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath +
                                                          '/dateFormat',
                                                        schemaPath:
                                                          '#/definitions/JSDateFormat/enum',
                                                        keyword: 'enum',
                                                        params: {
                                                          allowedValues:
                                                            schema33.enum,
                                                        },
                                                        message:
                                                          'must be equal to one of the allowed values',
                                                      },
                                                    ];
                                                    return false;
                                                  }
                                                  var valid1 =
                                                    _errs45 === errors;
                                                } else {
                                                  var valid1 = true;
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  validate23.errors = vErrors;
  return errors === 0;
}
const schema36 = {
  title: 'DropdownField',
  allOf: [
    {
      properties: {
        pageIndex: { type: 'number' },
        id: { type: 'string' },
        apiId: { type: 'string' },
        documentId: { type: 'string' },
        x: { type: 'number' },
        y: { type: 'number' },
        width: { type: 'number' },
        height: { type: 'number' },
        signer: { type: 'string' },
        required: { type: 'boolean' },
        readOnly: { type: 'boolean' },
        name: { type: 'string' },
        isDisabled: { type: 'boolean' },
        type: { const: 'dropdown', default: 'dropdown' },
        value: { type: ['string', 'null'] },
        options: { type: 'array', items: { type: 'string' } },
        fontSize: { $ref: '#/definitions/FontSize' },
        fontFamily: { $ref: '#/definitions/FontFamily' },
        lineHeight: { type: 'number' },
      },
      required: [
        'pageIndex',
        'signer',
        'documentId',
        'fontSize',
        'fontFamily',
        'type',
        'id',
        'name',
        'required',
        'readOnly',
        'x',
        'y',
        'width',
        'height',
        'options',
      ],
    },
  ],
};
function validate25(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    let missing0;
    if (
      (data.pageIndex === undefined && (missing0 = 'pageIndex')) ||
      (data.signer === undefined && (missing0 = 'signer')) ||
      (data.documentId === undefined && (missing0 = 'documentId')) ||
      (data.fontSize === undefined && (missing0 = 'fontSize')) ||
      (data.fontFamily === undefined && (missing0 = 'fontFamily')) ||
      (data.type === undefined && (missing0 = 'type')) ||
      (data.id === undefined && (missing0 = 'id')) ||
      (data.name === undefined && (missing0 = 'name')) ||
      (data.required === undefined && (missing0 = 'required')) ||
      (data.readOnly === undefined && (missing0 = 'readOnly')) ||
      (data.x === undefined && (missing0 = 'x')) ||
      (data.y === undefined && (missing0 = 'y')) ||
      (data.width === undefined && (missing0 = 'width')) ||
      (data.height === undefined && (missing0 = 'height')) ||
      (data.options === undefined && (missing0 = 'options'))
    ) {
      validate25.errors = [
        {
          instancePath,
          schemaPath: '#/allOf/0/required',
          keyword: 'required',
          params: { missingProperty: missing0 },
          message: "must have required property '" + missing0 + "'",
        },
      ];
      return false;
    } else {
      if (data.pageIndex !== undefined) {
        let data0 = data.pageIndex;
        const _errs1 = errors;
        if (!(typeof data0 == 'number' && isFinite(data0))) {
          validate25.errors = [
            {
              instancePath: instancePath + '/pageIndex',
              schemaPath: '#/allOf/0/properties/pageIndex/type',
              keyword: 'type',
              params: { type: 'number' },
              message: 'must be number',
            },
          ];
          return false;
        }
        var valid1 = _errs1 === errors;
      } else {
        var valid1 = true;
      }
      if (valid1) {
        if (data.id !== undefined) {
          const _errs3 = errors;
          if (typeof data.id !== 'string') {
            validate25.errors = [
              {
                instancePath: instancePath + '/id',
                schemaPath: '#/allOf/0/properties/id/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid1 = _errs3 === errors;
        } else {
          var valid1 = true;
        }
        if (valid1) {
          if (data.apiId !== undefined) {
            const _errs5 = errors;
            if (typeof data.apiId !== 'string') {
              validate25.errors = [
                {
                  instancePath: instancePath + '/apiId',
                  schemaPath: '#/allOf/0/properties/apiId/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid1 = _errs5 === errors;
          } else {
            var valid1 = true;
          }
          if (valid1) {
            if (data.documentId !== undefined) {
              const _errs7 = errors;
              if (typeof data.documentId !== 'string') {
                validate25.errors = [
                  {
                    instancePath: instancePath + '/documentId',
                    schemaPath: '#/allOf/0/properties/documentId/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid1 = _errs7 === errors;
            } else {
              var valid1 = true;
            }
            if (valid1) {
              if (data.x !== undefined) {
                let data4 = data.x;
                const _errs9 = errors;
                if (!(typeof data4 == 'number' && isFinite(data4))) {
                  validate25.errors = [
                    {
                      instancePath: instancePath + '/x',
                      schemaPath: '#/allOf/0/properties/x/type',
                      keyword: 'type',
                      params: { type: 'number' },
                      message: 'must be number',
                    },
                  ];
                  return false;
                }
                var valid1 = _errs9 === errors;
              } else {
                var valid1 = true;
              }
              if (valid1) {
                if (data.y !== undefined) {
                  let data5 = data.y;
                  const _errs11 = errors;
                  if (!(typeof data5 == 'number' && isFinite(data5))) {
                    validate25.errors = [
                      {
                        instancePath: instancePath + '/y',
                        schemaPath: '#/allOf/0/properties/y/type',
                        keyword: 'type',
                        params: { type: 'number' },
                        message: 'must be number',
                      },
                    ];
                    return false;
                  }
                  var valid1 = _errs11 === errors;
                } else {
                  var valid1 = true;
                }
                if (valid1) {
                  if (data.width !== undefined) {
                    let data6 = data.width;
                    const _errs13 = errors;
                    if (!(typeof data6 == 'number' && isFinite(data6))) {
                      validate25.errors = [
                        {
                          instancePath: instancePath + '/width',
                          schemaPath: '#/allOf/0/properties/width/type',
                          keyword: 'type',
                          params: { type: 'number' },
                          message: 'must be number',
                        },
                      ];
                      return false;
                    }
                    var valid1 = _errs13 === errors;
                  } else {
                    var valid1 = true;
                  }
                  if (valid1) {
                    if (data.height !== undefined) {
                      let data7 = data.height;
                      const _errs15 = errors;
                      if (!(typeof data7 == 'number' && isFinite(data7))) {
                        validate25.errors = [
                          {
                            instancePath: instancePath + '/height',
                            schemaPath: '#/allOf/0/properties/height/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          },
                        ];
                        return false;
                      }
                      var valid1 = _errs15 === errors;
                    } else {
                      var valid1 = true;
                    }
                    if (valid1) {
                      if (data.signer !== undefined) {
                        const _errs17 = errors;
                        if (typeof data.signer !== 'string') {
                          validate25.errors = [
                            {
                              instancePath: instancePath + '/signer',
                              schemaPath: '#/allOf/0/properties/signer/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid1 = _errs17 === errors;
                      } else {
                        var valid1 = true;
                      }
                      if (valid1) {
                        if (data.required !== undefined) {
                          const _errs19 = errors;
                          if (typeof data.required !== 'boolean') {
                            validate25.errors = [
                              {
                                instancePath: instancePath + '/required',
                                schemaPath:
                                  '#/allOf/0/properties/required/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid1 = _errs19 === errors;
                        } else {
                          var valid1 = true;
                        }
                        if (valid1) {
                          if (data.readOnly !== undefined) {
                            const _errs21 = errors;
                            if (typeof data.readOnly !== 'boolean') {
                              validate25.errors = [
                                {
                                  instancePath: instancePath + '/readOnly',
                                  schemaPath:
                                    '#/allOf/0/properties/readOnly/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid1 = _errs21 === errors;
                          } else {
                            var valid1 = true;
                          }
                          if (valid1) {
                            if (data.name !== undefined) {
                              const _errs23 = errors;
                              if (typeof data.name !== 'string') {
                                validate25.errors = [
                                  {
                                    instancePath: instancePath + '/name',
                                    schemaPath:
                                      '#/allOf/0/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid1 = _errs23 === errors;
                            } else {
                              var valid1 = true;
                            }
                            if (valid1) {
                              if (data.isDisabled !== undefined) {
                                const _errs25 = errors;
                                if (typeof data.isDisabled !== 'boolean') {
                                  validate25.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/isDisabled',
                                      schemaPath:
                                        '#/allOf/0/properties/isDisabled/type',
                                      keyword: 'type',
                                      params: { type: 'boolean' },
                                      message: 'must be boolean',
                                    },
                                  ];
                                  return false;
                                }
                                var valid1 = _errs25 === errors;
                              } else {
                                var valid1 = true;
                              }
                              if (valid1) {
                                if (data.type !== undefined) {
                                  const _errs27 = errors;
                                  if (!func0(data.type, 'dropdown')) {
                                    validate25.errors = [
                                      {
                                        instancePath: instancePath + '/type',
                                        schemaPath:
                                          '#/allOf/0/properties/type/const',
                                        keyword: 'const',
                                        params: { allowedValue: 'dropdown' },
                                        message: 'must be equal to constant',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid1 = _errs27 === errors;
                                } else {
                                  var valid1 = true;
                                }
                                if (valid1) {
                                  if (data.value !== undefined) {
                                    let data14 = data.value;
                                    const _errs28 = errors;
                                    if (
                                      typeof data14 !== 'string' &&
                                      data14 !== null
                                    ) {
                                      validate25.errors = [
                                        {
                                          instancePath: instancePath + '/value',
                                          schemaPath:
                                            '#/allOf/0/properties/value/type',
                                          keyword: 'type',
                                          params: {
                                            type: schema36.allOf[0].properties
                                              .value.type,
                                          },
                                          message: 'must be string,null',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid1 = _errs28 === errors;
                                  } else {
                                    var valid1 = true;
                                  }
                                  if (valid1) {
                                    if (data.options !== undefined) {
                                      let data15 = data.options;
                                      const _errs30 = errors;
                                      if (errors === _errs30) {
                                        if (Array.isArray(data15)) {
                                          var valid2 = true;
                                          const len0 = data15.length;
                                          for (let i0 = 0; i0 < len0; i0++) {
                                            const _errs32 = errors;
                                            if (
                                              typeof data15[i0] !== 'string'
                                            ) {
                                              validate25.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/options/' +
                                                    i0,
                                                  schemaPath:
                                                    '#/allOf/0/properties/options/items/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid2 = _errs32 === errors;
                                            if (!valid2) {
                                              break;
                                            }
                                          }
                                        } else {
                                          validate25.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/options',
                                              schemaPath:
                                                '#/allOf/0/properties/options/type',
                                              keyword: 'type',
                                              params: { type: 'array' },
                                              message: 'must be array',
                                            },
                                          ];
                                          return false;
                                        }
                                      }
                                      var valid1 = _errs30 === errors;
                                    } else {
                                      var valid1 = true;
                                    }
                                    if (valid1) {
                                      if (data.fontSize !== undefined) {
                                        let data17 = data.fontSize;
                                        const _errs34 = errors;
                                        if (
                                          !(
                                            typeof data17 == 'number' &&
                                            isFinite(data17)
                                          )
                                        ) {
                                          validate25.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/fontSize',
                                              schemaPath:
                                                '#/definitions/FontSize/type',
                                              keyword: 'type',
                                              params: { type: 'number' },
                                              message: 'must be number',
                                            },
                                          ];
                                          return false;
                                        }
                                        if (
                                          !(
                                            data17 === 7 ||
                                            data17 === 8 ||
                                            data17 === 9 ||
                                            data17 === 10 ||
                                            data17 === 12 ||
                                            data17 === 14 ||
                                            data17 === 16 ||
                                            data17 === 18 ||
                                            data17 === 20 ||
                                            data17 === 22 ||
                                            data17 === 24 ||
                                            data17 === 26 ||
                                            data17 === 28 ||
                                            data17 === 36 ||
                                            data17 === 42 ||
                                            data17 === 48
                                          )
                                        ) {
                                          validate25.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/fontSize',
                                              schemaPath:
                                                '#/definitions/FontSize/enum',
                                              keyword: 'enum',
                                              params: {
                                                allowedValues: schema18.enum,
                                              },
                                              message:
                                                'must be equal to one of the allowed values',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid1 = _errs34 === errors;
                                      } else {
                                        var valid1 = true;
                                      }
                                      if (valid1) {
                                        if (data.fontFamily !== undefined) {
                                          let data18 = data.fontFamily;
                                          const _errs37 = errors;
                                          if (typeof data18 !== 'string') {
                                            validate25.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/fontFamily',
                                                schemaPath:
                                                  '#/definitions/FontFamily/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          if (
                                            !(
                                              data18 === 'helvetica' ||
                                              data18 === 'arial' ||
                                              data18 === 'calibri' ||
                                              data18 === 'cambria' ||
                                              data18 === 'courier' ||
                                              data18 === 'georgia' ||
                                              data18 === 'times' ||
                                              data18 === 'trebuchet' ||
                                              data18 === 'verdana' ||
                                              data18 === 'notoSerif' ||
                                              data18 === 'notoSans' ||
                                              data18 === 'roboto' ||
                                              data18 === 'robotoMono'
                                            )
                                          ) {
                                            validate25.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/fontFamily',
                                                schemaPath:
                                                  '#/definitions/FontFamily/enum',
                                                keyword: 'enum',
                                                params: {
                                                  allowedValues: schema20.enum,
                                                },
                                                message:
                                                  'must be equal to one of the allowed values',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid1 = _errs37 === errors;
                                        } else {
                                          var valid1 = true;
                                        }
                                        if (valid1) {
                                          if (data.lineHeight !== undefined) {
                                            let data19 = data.lineHeight;
                                            const _errs40 = errors;
                                            if (
                                              !(
                                                typeof data19 == 'number' &&
                                                isFinite(data19)
                                              )
                                            ) {
                                              validate25.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/lineHeight',
                                                  schemaPath:
                                                    '#/allOf/0/properties/lineHeight/type',
                                                  keyword: 'type',
                                                  params: { type: 'number' },
                                                  message: 'must be number',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid1 = _errs40 === errors;
                                          } else {
                                            var valid1 = true;
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  validate25.errors = vErrors;
  return errors === 0;
}
const schema39 = {
  title: 'HyperlinkField',
  allOf: [
    {
      properties: {
        type: { const: 'hyperlink', default: 'hyperlink' },
        pageIndex: { type: 'number' },
        id: { type: 'string' },
        apiId: { type: 'string' },
        documentId: { type: 'string' },
        x: { type: 'number' },
        y: { type: 'number' },
        width: { type: 'number' },
        height: { type: 'number' },
        signer: { type: 'string' },
        required: { type: 'boolean' },
        readOnly: { type: 'boolean' },
        name: { type: 'string' },
        autoFillType: { $ref: '#/definitions/AutoFillType' },
        linkId: { type: 'string' },
        isDisabled: { type: 'boolean' },
        lineHeight: { type: 'number' },
        fontFamily: { $ref: '#/definitions/FontFamily' },
        fontSize: { $ref: '#/definitions/FontSize' },
        value: { oneOf: [{ type: 'string' }, { type: 'null' }] },
        url: { type: 'string' },
      },
      required: [
        'pageIndex',
        'signer',
        'documentId',
        'fontSize',
        'fontFamily',
        'value',
        'url',
        'type',
        'id',
        'name',
        'required',
        'readOnly',
        'x',
        'y',
        'width',
        'height',
      ],
    },
  ],
};
function validate27(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    let missing0;
    if (
      (data.pageIndex === undefined && (missing0 = 'pageIndex')) ||
      (data.signer === undefined && (missing0 = 'signer')) ||
      (data.documentId === undefined && (missing0 = 'documentId')) ||
      (data.fontSize === undefined && (missing0 = 'fontSize')) ||
      (data.fontFamily === undefined && (missing0 = 'fontFamily')) ||
      (data.value === undefined && (missing0 = 'value')) ||
      (data.url === undefined && (missing0 = 'url')) ||
      (data.type === undefined && (missing0 = 'type')) ||
      (data.id === undefined && (missing0 = 'id')) ||
      (data.name === undefined && (missing0 = 'name')) ||
      (data.required === undefined && (missing0 = 'required')) ||
      (data.readOnly === undefined && (missing0 = 'readOnly')) ||
      (data.x === undefined && (missing0 = 'x')) ||
      (data.y === undefined && (missing0 = 'y')) ||
      (data.width === undefined && (missing0 = 'width')) ||
      (data.height === undefined && (missing0 = 'height'))
    ) {
      validate27.errors = [
        {
          instancePath,
          schemaPath: '#/allOf/0/required',
          keyword: 'required',
          params: { missingProperty: missing0 },
          message: "must have required property '" + missing0 + "'",
        },
      ];
      return false;
    } else {
      if (data.type !== undefined) {
        const _errs1 = errors;
        if (!func0(data.type, 'hyperlink')) {
          validate27.errors = [
            {
              instancePath: instancePath + '/type',
              schemaPath: '#/allOf/0/properties/type/const',
              keyword: 'const',
              params: { allowedValue: 'hyperlink' },
              message: 'must be equal to constant',
            },
          ];
          return false;
        }
        var valid1 = _errs1 === errors;
      } else {
        var valid1 = true;
      }
      if (valid1) {
        if (data.pageIndex !== undefined) {
          let data1 = data.pageIndex;
          const _errs2 = errors;
          if (!(typeof data1 == 'number' && isFinite(data1))) {
            validate27.errors = [
              {
                instancePath: instancePath + '/pageIndex',
                schemaPath: '#/allOf/0/properties/pageIndex/type',
                keyword: 'type',
                params: { type: 'number' },
                message: 'must be number',
              },
            ];
            return false;
          }
          var valid1 = _errs2 === errors;
        } else {
          var valid1 = true;
        }
        if (valid1) {
          if (data.id !== undefined) {
            const _errs4 = errors;
            if (typeof data.id !== 'string') {
              validate27.errors = [
                {
                  instancePath: instancePath + '/id',
                  schemaPath: '#/allOf/0/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid1 = _errs4 === errors;
          } else {
            var valid1 = true;
          }
          if (valid1) {
            if (data.apiId !== undefined) {
              const _errs6 = errors;
              if (typeof data.apiId !== 'string') {
                validate27.errors = [
                  {
                    instancePath: instancePath + '/apiId',
                    schemaPath: '#/allOf/0/properties/apiId/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid1 = _errs6 === errors;
            } else {
              var valid1 = true;
            }
            if (valid1) {
              if (data.documentId !== undefined) {
                const _errs8 = errors;
                if (typeof data.documentId !== 'string') {
                  validate27.errors = [
                    {
                      instancePath: instancePath + '/documentId',
                      schemaPath: '#/allOf/0/properties/documentId/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid1 = _errs8 === errors;
              } else {
                var valid1 = true;
              }
              if (valid1) {
                if (data.x !== undefined) {
                  let data5 = data.x;
                  const _errs10 = errors;
                  if (!(typeof data5 == 'number' && isFinite(data5))) {
                    validate27.errors = [
                      {
                        instancePath: instancePath + '/x',
                        schemaPath: '#/allOf/0/properties/x/type',
                        keyword: 'type',
                        params: { type: 'number' },
                        message: 'must be number',
                      },
                    ];
                    return false;
                  }
                  var valid1 = _errs10 === errors;
                } else {
                  var valid1 = true;
                }
                if (valid1) {
                  if (data.y !== undefined) {
                    let data6 = data.y;
                    const _errs12 = errors;
                    if (!(typeof data6 == 'number' && isFinite(data6))) {
                      validate27.errors = [
                        {
                          instancePath: instancePath + '/y',
                          schemaPath: '#/allOf/0/properties/y/type',
                          keyword: 'type',
                          params: { type: 'number' },
                          message: 'must be number',
                        },
                      ];
                      return false;
                    }
                    var valid1 = _errs12 === errors;
                  } else {
                    var valid1 = true;
                  }
                  if (valid1) {
                    if (data.width !== undefined) {
                      let data7 = data.width;
                      const _errs14 = errors;
                      if (!(typeof data7 == 'number' && isFinite(data7))) {
                        validate27.errors = [
                          {
                            instancePath: instancePath + '/width',
                            schemaPath: '#/allOf/0/properties/width/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          },
                        ];
                        return false;
                      }
                      var valid1 = _errs14 === errors;
                    } else {
                      var valid1 = true;
                    }
                    if (valid1) {
                      if (data.height !== undefined) {
                        let data8 = data.height;
                        const _errs16 = errors;
                        if (!(typeof data8 == 'number' && isFinite(data8))) {
                          validate27.errors = [
                            {
                              instancePath: instancePath + '/height',
                              schemaPath: '#/allOf/0/properties/height/type',
                              keyword: 'type',
                              params: { type: 'number' },
                              message: 'must be number',
                            },
                          ];
                          return false;
                        }
                        var valid1 = _errs16 === errors;
                      } else {
                        var valid1 = true;
                      }
                      if (valid1) {
                        if (data.signer !== undefined) {
                          const _errs18 = errors;
                          if (typeof data.signer !== 'string') {
                            validate27.errors = [
                              {
                                instancePath: instancePath + '/signer',
                                schemaPath: '#/allOf/0/properties/signer/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid1 = _errs18 === errors;
                        } else {
                          var valid1 = true;
                        }
                        if (valid1) {
                          if (data.required !== undefined) {
                            const _errs20 = errors;
                            if (typeof data.required !== 'boolean') {
                              validate27.errors = [
                                {
                                  instancePath: instancePath + '/required',
                                  schemaPath:
                                    '#/allOf/0/properties/required/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid1 = _errs20 === errors;
                          } else {
                            var valid1 = true;
                          }
                          if (valid1) {
                            if (data.readOnly !== undefined) {
                              const _errs22 = errors;
                              if (typeof data.readOnly !== 'boolean') {
                                validate27.errors = [
                                  {
                                    instancePath: instancePath + '/readOnly',
                                    schemaPath:
                                      '#/allOf/0/properties/readOnly/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  },
                                ];
                                return false;
                              }
                              var valid1 = _errs22 === errors;
                            } else {
                              var valid1 = true;
                            }
                            if (valid1) {
                              if (data.name !== undefined) {
                                const _errs24 = errors;
                                if (typeof data.name !== 'string') {
                                  validate27.errors = [
                                    {
                                      instancePath: instancePath + '/name',
                                      schemaPath:
                                        '#/allOf/0/properties/name/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid1 = _errs24 === errors;
                              } else {
                                var valid1 = true;
                              }
                              if (valid1) {
                                if (data.autoFillType !== undefined) {
                                  let data13 = data.autoFillType;
                                  const _errs26 = errors;
                                  if (typeof data13 !== 'string') {
                                    validate27.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/autoFillType',
                                        schemaPath:
                                          '#/definitions/AutoFillType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  if (
                                    !(
                                      data13 === 'name' ||
                                      data13 === 'lastName' ||
                                      data13 === 'firstName' ||
                                      data13 === 'company' ||
                                      data13 === 'email' ||
                                      data13 === 'title' ||
                                      data13 === 'none'
                                    )
                                  ) {
                                    validate27.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/autoFillType',
                                        schemaPath:
                                          '#/definitions/AutoFillType/enum',
                                        keyword: 'enum',
                                        params: {
                                          allowedValues: schema17.enum,
                                        },
                                        message:
                                          'must be equal to one of the allowed values',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid1 = _errs26 === errors;
                                } else {
                                  var valid1 = true;
                                }
                                if (valid1) {
                                  if (data.linkId !== undefined) {
                                    const _errs29 = errors;
                                    if (typeof data.linkId !== 'string') {
                                      validate27.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/linkId',
                                          schemaPath:
                                            '#/allOf/0/properties/linkId/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid1 = _errs29 === errors;
                                  } else {
                                    var valid1 = true;
                                  }
                                  if (valid1) {
                                    if (data.isDisabled !== undefined) {
                                      const _errs31 = errors;
                                      if (
                                        typeof data.isDisabled !== 'boolean'
                                      ) {
                                        validate27.errors = [
                                          {
                                            instancePath:
                                              instancePath + '/isDisabled',
                                            schemaPath:
                                              '#/allOf/0/properties/isDisabled/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid1 = _errs31 === errors;
                                    } else {
                                      var valid1 = true;
                                    }
                                    if (valid1) {
                                      if (data.lineHeight !== undefined) {
                                        let data16 = data.lineHeight;
                                        const _errs33 = errors;
                                        if (
                                          !(
                                            typeof data16 == 'number' &&
                                            isFinite(data16)
                                          )
                                        ) {
                                          validate27.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/lineHeight',
                                              schemaPath:
                                                '#/allOf/0/properties/lineHeight/type',
                                              keyword: 'type',
                                              params: { type: 'number' },
                                              message: 'must be number',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid1 = _errs33 === errors;
                                      } else {
                                        var valid1 = true;
                                      }
                                      if (valid1) {
                                        if (data.fontFamily !== undefined) {
                                          let data17 = data.fontFamily;
                                          const _errs35 = errors;
                                          if (typeof data17 !== 'string') {
                                            validate27.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/fontFamily',
                                                schemaPath:
                                                  '#/definitions/FontFamily/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          if (
                                            !(
                                              data17 === 'helvetica' ||
                                              data17 === 'arial' ||
                                              data17 === 'calibri' ||
                                              data17 === 'cambria' ||
                                              data17 === 'courier' ||
                                              data17 === 'georgia' ||
                                              data17 === 'times' ||
                                              data17 === 'trebuchet' ||
                                              data17 === 'verdana' ||
                                              data17 === 'notoSerif' ||
                                              data17 === 'notoSans' ||
                                              data17 === 'roboto' ||
                                              data17 === 'robotoMono'
                                            )
                                          ) {
                                            validate27.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/fontFamily',
                                                schemaPath:
                                                  '#/definitions/FontFamily/enum',
                                                keyword: 'enum',
                                                params: {
                                                  allowedValues: schema20.enum,
                                                },
                                                message:
                                                  'must be equal to one of the allowed values',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid1 = _errs35 === errors;
                                        } else {
                                          var valid1 = true;
                                        }
                                        if (valid1) {
                                          if (data.fontSize !== undefined) {
                                            let data18 = data.fontSize;
                                            const _errs38 = errors;
                                            if (
                                              !(
                                                typeof data18 == 'number' &&
                                                isFinite(data18)
                                              )
                                            ) {
                                              validate27.errors = [
                                                {
                                                  instancePath:
                                                    instancePath + '/fontSize',
                                                  schemaPath:
                                                    '#/definitions/FontSize/type',
                                                  keyword: 'type',
                                                  params: { type: 'number' },
                                                  message: 'must be number',
                                                },
                                              ];
                                              return false;
                                            }
                                            if (
                                              !(
                                                data18 === 7 ||
                                                data18 === 8 ||
                                                data18 === 9 ||
                                                data18 === 10 ||
                                                data18 === 12 ||
                                                data18 === 14 ||
                                                data18 === 16 ||
                                                data18 === 18 ||
                                                data18 === 20 ||
                                                data18 === 22 ||
                                                data18 === 24 ||
                                                data18 === 26 ||
                                                data18 === 28 ||
                                                data18 === 36 ||
                                                data18 === 42 ||
                                                data18 === 48
                                              )
                                            ) {
                                              validate27.errors = [
                                                {
                                                  instancePath:
                                                    instancePath + '/fontSize',
                                                  schemaPath:
                                                    '#/definitions/FontSize/enum',
                                                  keyword: 'enum',
                                                  params: {
                                                    allowedValues:
                                                      schema18.enum,
                                                  },
                                                  message:
                                                    'must be equal to one of the allowed values',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid1 = _errs38 === errors;
                                          } else {
                                            var valid1 = true;
                                          }
                                          if (valid1) {
                                            if (data.value !== undefined) {
                                              let data19 = data.value;
                                              const _errs41 = errors;
                                              const _errs42 = errors;
                                              let valid5 = false;
                                              let passing0 = null;
                                              const _errs43 = errors;
                                              if (typeof data19 !== 'string') {
                                                const err0 = {
                                                  instancePath:
                                                    instancePath + '/value',
                                                  schemaPath:
                                                    '#/allOf/0/properties/value/oneOf/0/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err0];
                                                } else {
                                                  vErrors.push(err0);
                                                }
                                                errors++;
                                              }
                                              var _valid0 = _errs43 === errors;
                                              if (_valid0) {
                                                valid5 = true;
                                                passing0 = 0;
                                              }
                                              const _errs45 = errors;
                                              if (data19 !== null) {
                                                const err1 = {
                                                  instancePath:
                                                    instancePath + '/value',
                                                  schemaPath:
                                                    '#/allOf/0/properties/value/oneOf/1/type',
                                                  keyword: 'type',
                                                  params: { type: 'null' },
                                                  message: 'must be null',
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err1];
                                                } else {
                                                  vErrors.push(err1);
                                                }
                                                errors++;
                                              }
                                              var _valid0 = _errs45 === errors;
                                              if (_valid0 && valid5) {
                                                valid5 = false;
                                                passing0 = [passing0, 1];
                                              } else {
                                                if (_valid0) {
                                                  valid5 = true;
                                                  passing0 = 1;
                                                }
                                              }
                                              if (!valid5) {
                                                const err2 = {
                                                  instancePath:
                                                    instancePath + '/value',
                                                  schemaPath:
                                                    '#/allOf/0/properties/value/oneOf',
                                                  keyword: 'oneOf',
                                                  params: {
                                                    passingSchemas: passing0,
                                                  },
                                                  message:
                                                    'must match exactly one schema in oneOf',
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err2];
                                                } else {
                                                  vErrors.push(err2);
                                                }
                                                errors++;
                                                validate27.errors = vErrors;
                                                return false;
                                              } else {
                                                errors = _errs42;
                                                if (vErrors !== null) {
                                                  if (_errs42) {
                                                    vErrors.length = _errs42;
                                                  } else {
                                                    vErrors = null;
                                                  }
                                                }
                                              }
                                              var valid1 = _errs41 === errors;
                                            } else {
                                              var valid1 = true;
                                            }
                                            if (valid1) {
                                              if (data.url !== undefined) {
                                                const _errs47 = errors;
                                                if (
                                                  typeof data.url !== 'string'
                                                ) {
                                                  validate27.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath + '/url',
                                                      schemaPath:
                                                        '#/allOf/0/properties/url/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'string',
                                                      },
                                                      message: 'must be string',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid1 = _errs47 === errors;
                                              } else {
                                                var valid1 = true;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  validate27.errors = vErrors;
  return errors === 0;
}
function validate13(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="Field.json" */ let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == 'object' && !Array.isArray(data))) {
    validate13.errors = [
      {
        instancePath,
        schemaPath: '#/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      },
    ];
    return false;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (
    !validate14(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
    })
  ) {
    vErrors =
      vErrors === null ? validate14.errors : vErrors.concat(validate14.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs3 = errors;
  if (
    !validate16(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
    })
  ) {
    vErrors =
      vErrors === null ? validate16.errors : vErrors.concat(validate16.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs3 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs4 = errors;
    if (
      !validate20(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
      })
    ) {
      vErrors =
        vErrors === null
          ? validate20.errors
          : vErrors.concat(validate20.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs4 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
      const _errs5 = errors;
      if (
        !validate23(data, {
          instancePath,
          parentData,
          parentDataProperty,
          rootData,
        })
      ) {
        vErrors =
          vErrors === null
            ? validate23.errors
            : vErrors.concat(validate23.errors);
        errors = vErrors.length;
      }
      var _valid0 = _errs5 === errors;
      if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [passing0, 3];
      } else {
        if (_valid0) {
          valid0 = true;
          passing0 = 3;
        }
        const _errs6 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
          let missing0;
          if (
            (data.pageIndex === undefined && (missing0 = 'pageIndex')) ||
            (data.signer === undefined && (missing0 = 'signer')) ||
            (data.documentId === undefined && (missing0 = 'documentId')) ||
            (data.id === undefined && (missing0 = 'id')) ||
            (data.name === undefined && (missing0 = 'name')) ||
            (data.required === undefined && (missing0 = 'required')) ||
            (data.readOnly === undefined && (missing0 = 'readOnly')) ||
            (data.x === undefined && (missing0 = 'x')) ||
            (data.y === undefined && (missing0 = 'y')) ||
            (data.width === undefined && (missing0 = 'width')) ||
            (data.height === undefined && (missing0 = 'height')) ||
            (data.type === undefined && (missing0 = 'type'))
          ) {
            const err0 = {
              instancePath,
              schemaPath: '#/definitions/CheckboxField/allOf/0/required',
              keyword: 'required',
              params: { missingProperty: missing0 },
              message: "must have required property '" + missing0 + "'",
            };
            if (vErrors === null) {
              vErrors = [err0];
            } else {
              vErrors.push(err0);
            }
            errors++;
          } else {
            if (data.pageIndex !== undefined) {
              let data0 = data.pageIndex;
              const _errs9 = errors;
              if (!(typeof data0 == 'number' && isFinite(data0))) {
                const err1 = {
                  instancePath: instancePath + '/pageIndex',
                  schemaPath:
                    '#/definitions/CheckboxField/allOf/0/properties/pageIndex/type',
                  keyword: 'type',
                  params: { type: 'number' },
                  message: 'must be number',
                };
                if (vErrors === null) {
                  vErrors = [err1];
                } else {
                  vErrors.push(err1);
                }
                errors++;
              }
              var valid3 = _errs9 === errors;
            } else {
              var valid3 = true;
            }
            if (valid3) {
              if (data.id !== undefined) {
                const _errs11 = errors;
                if (typeof data.id !== 'string') {
                  const err2 = {
                    instancePath: instancePath + '/id',
                    schemaPath:
                      '#/definitions/CheckboxField/allOf/0/properties/id/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  };
                  if (vErrors === null) {
                    vErrors = [err2];
                  } else {
                    vErrors.push(err2);
                  }
                  errors++;
                }
                var valid3 = _errs11 === errors;
              } else {
                var valid3 = true;
              }
              if (valid3) {
                if (data.apiId !== undefined) {
                  const _errs13 = errors;
                  if (typeof data.apiId !== 'string') {
                    const err3 = {
                      instancePath: instancePath + '/apiId',
                      schemaPath:
                        '#/definitions/CheckboxField/allOf/0/properties/apiId/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    };
                    if (vErrors === null) {
                      vErrors = [err3];
                    } else {
                      vErrors.push(err3);
                    }
                    errors++;
                  }
                  var valid3 = _errs13 === errors;
                } else {
                  var valid3 = true;
                }
                if (valid3) {
                  if (data.documentId !== undefined) {
                    const _errs15 = errors;
                    if (typeof data.documentId !== 'string') {
                      const err4 = {
                        instancePath: instancePath + '/documentId',
                        schemaPath:
                          '#/definitions/CheckboxField/allOf/0/properties/documentId/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      };
                      if (vErrors === null) {
                        vErrors = [err4];
                      } else {
                        vErrors.push(err4);
                      }
                      errors++;
                    }
                    var valid3 = _errs15 === errors;
                  } else {
                    var valid3 = true;
                  }
                  if (valid3) {
                    if (data.x !== undefined) {
                      let data4 = data.x;
                      const _errs17 = errors;
                      if (!(typeof data4 == 'number' && isFinite(data4))) {
                        const err5 = {
                          instancePath: instancePath + '/x',
                          schemaPath:
                            '#/definitions/CheckboxField/allOf/0/properties/x/type',
                          keyword: 'type',
                          params: { type: 'number' },
                          message: 'must be number',
                        };
                        if (vErrors === null) {
                          vErrors = [err5];
                        } else {
                          vErrors.push(err5);
                        }
                        errors++;
                      }
                      var valid3 = _errs17 === errors;
                    } else {
                      var valid3 = true;
                    }
                    if (valid3) {
                      if (data.y !== undefined) {
                        let data5 = data.y;
                        const _errs19 = errors;
                        if (!(typeof data5 == 'number' && isFinite(data5))) {
                          const err6 = {
                            instancePath: instancePath + '/y',
                            schemaPath:
                              '#/definitions/CheckboxField/allOf/0/properties/y/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          };
                          if (vErrors === null) {
                            vErrors = [err6];
                          } else {
                            vErrors.push(err6);
                          }
                          errors++;
                        }
                        var valid3 = _errs19 === errors;
                      } else {
                        var valid3 = true;
                      }
                      if (valid3) {
                        if (data.width !== undefined) {
                          let data6 = data.width;
                          const _errs21 = errors;
                          if (!(typeof data6 == 'number' && isFinite(data6))) {
                            const err7 = {
                              instancePath: instancePath + '/width',
                              schemaPath:
                                '#/definitions/CheckboxField/allOf/0/properties/width/type',
                              keyword: 'type',
                              params: { type: 'number' },
                              message: 'must be number',
                            };
                            if (vErrors === null) {
                              vErrors = [err7];
                            } else {
                              vErrors.push(err7);
                            }
                            errors++;
                          }
                          var valid3 = _errs21 === errors;
                        } else {
                          var valid3 = true;
                        }
                        if (valid3) {
                          if (data.height !== undefined) {
                            let data7 = data.height;
                            const _errs23 = errors;
                            if (
                              !(typeof data7 == 'number' && isFinite(data7))
                            ) {
                              const err8 = {
                                instancePath: instancePath + '/height',
                                schemaPath:
                                  '#/definitions/CheckboxField/allOf/0/properties/height/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number',
                              };
                              if (vErrors === null) {
                                vErrors = [err8];
                              } else {
                                vErrors.push(err8);
                              }
                              errors++;
                            }
                            var valid3 = _errs23 === errors;
                          } else {
                            var valid3 = true;
                          }
                          if (valid3) {
                            if (data.signer !== undefined) {
                              const _errs25 = errors;
                              if (typeof data.signer !== 'string') {
                                const err9 = {
                                  instancePath: instancePath + '/signer',
                                  schemaPath:
                                    '#/definitions/CheckboxField/allOf/0/properties/signer/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                };
                                if (vErrors === null) {
                                  vErrors = [err9];
                                } else {
                                  vErrors.push(err9);
                                }
                                errors++;
                              }
                              var valid3 = _errs25 === errors;
                            } else {
                              var valid3 = true;
                            }
                            if (valid3) {
                              if (data.required !== undefined) {
                                const _errs27 = errors;
                                if (typeof data.required !== 'boolean') {
                                  const err10 = {
                                    instancePath: instancePath + '/required',
                                    schemaPath:
                                      '#/definitions/CheckboxField/allOf/0/properties/required/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err10];
                                  } else {
                                    vErrors.push(err10);
                                  }
                                  errors++;
                                }
                                var valid3 = _errs27 === errors;
                              } else {
                                var valid3 = true;
                              }
                              if (valid3) {
                                if (data.readOnly !== undefined) {
                                  const _errs29 = errors;
                                  if (typeof data.readOnly !== 'boolean') {
                                    const err11 = {
                                      instancePath: instancePath + '/readOnly',
                                      schemaPath:
                                        '#/definitions/CheckboxField/allOf/0/properties/readOnly/type',
                                      keyword: 'type',
                                      params: { type: 'boolean' },
                                      message: 'must be boolean',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err11];
                                    } else {
                                      vErrors.push(err11);
                                    }
                                    errors++;
                                  }
                                  var valid3 = _errs29 === errors;
                                } else {
                                  var valid3 = true;
                                }
                                if (valid3) {
                                  if (data.name !== undefined) {
                                    const _errs31 = errors;
                                    if (typeof data.name !== 'string') {
                                      const err12 = {
                                        instancePath: instancePath + '/name',
                                        schemaPath:
                                          '#/definitions/CheckboxField/allOf/0/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err12];
                                      } else {
                                        vErrors.push(err12);
                                      }
                                      errors++;
                                    }
                                    var valid3 = _errs31 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                  if (valid3) {
                                    if (data.isDisabled !== undefined) {
                                      const _errs33 = errors;
                                      if (
                                        typeof data.isDisabled !== 'boolean'
                                      ) {
                                        const err13 = {
                                          instancePath:
                                            instancePath + '/isDisabled',
                                          schemaPath:
                                            '#/definitions/CheckboxField/allOf/0/properties/isDisabled/type',
                                          keyword: 'type',
                                          params: { type: 'boolean' },
                                          message: 'must be boolean',
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err13];
                                        } else {
                                          vErrors.push(err13);
                                        }
                                        errors++;
                                      }
                                      var valid3 = _errs33 === errors;
                                    } else {
                                      var valid3 = true;
                                    }
                                    if (valid3) {
                                      if (data.type !== undefined) {
                                        const _errs35 = errors;
                                        if (!func0(data.type, 'checkbox')) {
                                          const err14 = {
                                            instancePath:
                                              instancePath + '/type',
                                            schemaPath:
                                              '#/definitions/CheckboxField/allOf/0/properties/type/const',
                                            keyword: 'const',
                                            params: {
                                              allowedValue: 'checkbox',
                                            },
                                            message:
                                              'must be equal to constant',
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err14];
                                          } else {
                                            vErrors.push(err14);
                                          }
                                          errors++;
                                        }
                                        var valid3 = _errs35 === errors;
                                      } else {
                                        var valid3 = true;
                                      }
                                      if (valid3) {
                                        if (data.checked !== undefined) {
                                          const _errs36 = errors;
                                          if (
                                            typeof data.checked !== 'boolean'
                                          ) {
                                            const err15 = {
                                              instancePath:
                                                instancePath + '/checked',
                                              schemaPath:
                                                '#/definitions/CheckboxField/allOf/0/properties/checked/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err15];
                                            } else {
                                              vErrors.push(err15);
                                            }
                                            errors++;
                                          }
                                          var valid3 = _errs36 === errors;
                                        } else {
                                          var valid3 = true;
                                        }
                                        if (valid3) {
                                          if (data.requirement !== undefined) {
                                            const _errs38 = errors;
                                            if (
                                              typeof data.requirement !==
                                              'string'
                                            ) {
                                              const err16 = {
                                                instancePath:
                                                  instancePath + '/requirement',
                                                schemaPath:
                                                  '#/definitions/CheckboxField/allOf/0/properties/requirement/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err16];
                                              } else {
                                                vErrors.push(err16);
                                              }
                                              errors++;
                                            }
                                            var valid3 = _errs38 === errors;
                                          } else {
                                            var valid3 = true;
                                          }
                                          if (valid3) {
                                            if (data.groupLabel !== undefined) {
                                              const _errs40 = errors;
                                              if (
                                                typeof data.groupLabel !==
                                                'string'
                                              ) {
                                                const err17 = {
                                                  instancePath:
                                                    instancePath +
                                                    '/groupLabel',
                                                  schemaPath:
                                                    '#/definitions/CheckboxField/allOf/0/properties/groupLabel/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err17];
                                                } else {
                                                  vErrors.push(err17);
                                                }
                                                errors++;
                                              }
                                              var valid3 = _errs40 === errors;
                                            } else {
                                              var valid3 = true;
                                            }
                                            if (valid3) {
                                              if (data.group !== undefined) {
                                                const _errs42 = errors;
                                                if (
                                                  typeof data.group !== 'string'
                                                ) {
                                                  const err18 = {
                                                    instancePath:
                                                      instancePath + '/group',
                                                    schemaPath:
                                                      '#/definitions/CheckboxField/allOf/0/properties/group/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err18];
                                                  } else {
                                                    vErrors.push(err18);
                                                  }
                                                  errors++;
                                                }
                                                var valid3 = _errs42 === errors;
                                              } else {
                                                var valid3 = true;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        var _valid0 = _errs6 === errors;
        if (_valid0 && valid0) {
          valid0 = false;
          passing0 = [passing0, 4];
        } else {
          if (_valid0) {
            valid0 = true;
            passing0 = 4;
          }
          const _errs44 = errors;
          if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (
              (data.checked === undefined && (missing1 = 'checked')) ||
              (data.requirement === undefined && (missing1 = 'requirement')) ||
              (data.group === undefined && (missing1 = 'group')) ||
              (data.pageIndex === undefined && (missing1 = 'pageIndex')) ||
              (data.signer === undefined && (missing1 = 'signer')) ||
              (data.documentId === undefined && (missing1 = 'documentId')) ||
              (data.id === undefined && (missing1 = 'id')) ||
              (data.name === undefined && (missing1 = 'name')) ||
              (data.required === undefined && (missing1 = 'required')) ||
              (data.readOnly === undefined && (missing1 = 'readOnly')) ||
              (data.x === undefined && (missing1 = 'x')) ||
              (data.y === undefined && (missing1 = 'y')) ||
              (data.width === undefined && (missing1 = 'width')) ||
              (data.height === undefined && (missing1 = 'height')) ||
              (data.type === undefined && (missing1 = 'type'))
            ) {
              const err19 = {
                instancePath,
                schemaPath: '#/definitions/RadioField/allOf/0/required',
                keyword: 'required',
                params: { missingProperty: missing1 },
                message: "must have required property '" + missing1 + "'",
              };
              if (vErrors === null) {
                vErrors = [err19];
              } else {
                vErrors.push(err19);
              }
              errors++;
            } else {
              if (data.pageIndex !== undefined) {
                let data18 = data.pageIndex;
                const _errs47 = errors;
                if (!(typeof data18 == 'number' && isFinite(data18))) {
                  const err20 = {
                    instancePath: instancePath + '/pageIndex',
                    schemaPath:
                      '#/definitions/RadioField/allOf/0/properties/pageIndex/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                  };
                  if (vErrors === null) {
                    vErrors = [err20];
                  } else {
                    vErrors.push(err20);
                  }
                  errors++;
                }
                var valid6 = _errs47 === errors;
              } else {
                var valid6 = true;
              }
              if (valid6) {
                if (data.id !== undefined) {
                  const _errs49 = errors;
                  if (typeof data.id !== 'string') {
                    const err21 = {
                      instancePath: instancePath + '/id',
                      schemaPath:
                        '#/definitions/RadioField/allOf/0/properties/id/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    };
                    if (vErrors === null) {
                      vErrors = [err21];
                    } else {
                      vErrors.push(err21);
                    }
                    errors++;
                  }
                  var valid6 = _errs49 === errors;
                } else {
                  var valid6 = true;
                }
                if (valid6) {
                  if (data.apiId !== undefined) {
                    const _errs51 = errors;
                    if (typeof data.apiId !== 'string') {
                      const err22 = {
                        instancePath: instancePath + '/apiId',
                        schemaPath:
                          '#/definitions/RadioField/allOf/0/properties/apiId/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      };
                      if (vErrors === null) {
                        vErrors = [err22];
                      } else {
                        vErrors.push(err22);
                      }
                      errors++;
                    }
                    var valid6 = _errs51 === errors;
                  } else {
                    var valid6 = true;
                  }
                  if (valid6) {
                    if (data.documentId !== undefined) {
                      const _errs53 = errors;
                      if (typeof data.documentId !== 'string') {
                        const err23 = {
                          instancePath: instancePath + '/documentId',
                          schemaPath:
                            '#/definitions/RadioField/allOf/0/properties/documentId/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        };
                        if (vErrors === null) {
                          vErrors = [err23];
                        } else {
                          vErrors.push(err23);
                        }
                        errors++;
                      }
                      var valid6 = _errs53 === errors;
                    } else {
                      var valid6 = true;
                    }
                    if (valid6) {
                      if (data.x !== undefined) {
                        let data22 = data.x;
                        const _errs55 = errors;
                        if (!(typeof data22 == 'number' && isFinite(data22))) {
                          const err24 = {
                            instancePath: instancePath + '/x',
                            schemaPath:
                              '#/definitions/RadioField/allOf/0/properties/x/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          };
                          if (vErrors === null) {
                            vErrors = [err24];
                          } else {
                            vErrors.push(err24);
                          }
                          errors++;
                        }
                        var valid6 = _errs55 === errors;
                      } else {
                        var valid6 = true;
                      }
                      if (valid6) {
                        if (data.y !== undefined) {
                          let data23 = data.y;
                          const _errs57 = errors;
                          if (
                            !(typeof data23 == 'number' && isFinite(data23))
                          ) {
                            const err25 = {
                              instancePath: instancePath + '/y',
                              schemaPath:
                                '#/definitions/RadioField/allOf/0/properties/y/type',
                              keyword: 'type',
                              params: { type: 'number' },
                              message: 'must be number',
                            };
                            if (vErrors === null) {
                              vErrors = [err25];
                            } else {
                              vErrors.push(err25);
                            }
                            errors++;
                          }
                          var valid6 = _errs57 === errors;
                        } else {
                          var valid6 = true;
                        }
                        if (valid6) {
                          if (data.width !== undefined) {
                            let data24 = data.width;
                            const _errs59 = errors;
                            if (
                              !(typeof data24 == 'number' && isFinite(data24))
                            ) {
                              const err26 = {
                                instancePath: instancePath + '/width',
                                schemaPath:
                                  '#/definitions/RadioField/allOf/0/properties/width/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number',
                              };
                              if (vErrors === null) {
                                vErrors = [err26];
                              } else {
                                vErrors.push(err26);
                              }
                              errors++;
                            }
                            var valid6 = _errs59 === errors;
                          } else {
                            var valid6 = true;
                          }
                          if (valid6) {
                            if (data.height !== undefined) {
                              let data25 = data.height;
                              const _errs61 = errors;
                              if (
                                !(typeof data25 == 'number' && isFinite(data25))
                              ) {
                                const err27 = {
                                  instancePath: instancePath + '/height',
                                  schemaPath:
                                    '#/definitions/RadioField/allOf/0/properties/height/type',
                                  keyword: 'type',
                                  params: { type: 'number' },
                                  message: 'must be number',
                                };
                                if (vErrors === null) {
                                  vErrors = [err27];
                                } else {
                                  vErrors.push(err27);
                                }
                                errors++;
                              }
                              var valid6 = _errs61 === errors;
                            } else {
                              var valid6 = true;
                            }
                            if (valid6) {
                              if (data.signer !== undefined) {
                                const _errs63 = errors;
                                if (typeof data.signer !== 'string') {
                                  const err28 = {
                                    instancePath: instancePath + '/signer',
                                    schemaPath:
                                      '#/definitions/RadioField/allOf/0/properties/signer/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err28];
                                  } else {
                                    vErrors.push(err28);
                                  }
                                  errors++;
                                }
                                var valid6 = _errs63 === errors;
                              } else {
                                var valid6 = true;
                              }
                              if (valid6) {
                                if (data.required !== undefined) {
                                  const _errs65 = errors;
                                  if (typeof data.required !== 'boolean') {
                                    const err29 = {
                                      instancePath: instancePath + '/required',
                                      schemaPath:
                                        '#/definitions/RadioField/allOf/0/properties/required/type',
                                      keyword: 'type',
                                      params: { type: 'boolean' },
                                      message: 'must be boolean',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err29];
                                    } else {
                                      vErrors.push(err29);
                                    }
                                    errors++;
                                  }
                                  var valid6 = _errs65 === errors;
                                } else {
                                  var valid6 = true;
                                }
                                if (valid6) {
                                  if (data.readOnly !== undefined) {
                                    const _errs67 = errors;
                                    if (typeof data.readOnly !== 'boolean') {
                                      const err30 = {
                                        instancePath:
                                          instancePath + '/readOnly',
                                        schemaPath:
                                          '#/definitions/RadioField/allOf/0/properties/readOnly/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean',
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err30];
                                      } else {
                                        vErrors.push(err30);
                                      }
                                      errors++;
                                    }
                                    var valid6 = _errs67 === errors;
                                  } else {
                                    var valid6 = true;
                                  }
                                  if (valid6) {
                                    if (data.name !== undefined) {
                                      const _errs69 = errors;
                                      if (typeof data.name !== 'string') {
                                        const err31 = {
                                          instancePath: instancePath + '/name',
                                          schemaPath:
                                            '#/definitions/RadioField/allOf/0/properties/name/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err31];
                                        } else {
                                          vErrors.push(err31);
                                        }
                                        errors++;
                                      }
                                      var valid6 = _errs69 === errors;
                                    } else {
                                      var valid6 = true;
                                    }
                                    if (valid6) {
                                      if (data.linkId !== undefined) {
                                        const _errs71 = errors;
                                        if (typeof data.linkId !== 'string') {
                                          const err32 = {
                                            instancePath:
                                              instancePath + '/linkId',
                                            schemaPath:
                                              '#/definitions/RadioField/allOf/0/properties/linkId/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err32];
                                          } else {
                                            vErrors.push(err32);
                                          }
                                          errors++;
                                        }
                                        var valid6 = _errs71 === errors;
                                      } else {
                                        var valid6 = true;
                                      }
                                      if (valid6) {
                                        if (data.isDisabled !== undefined) {
                                          const _errs73 = errors;
                                          if (
                                            typeof data.isDisabled !== 'boolean'
                                          ) {
                                            const err33 = {
                                              instancePath:
                                                instancePath + '/isDisabled',
                                              schemaPath:
                                                '#/definitions/RadioField/allOf/0/properties/isDisabled/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err33];
                                            } else {
                                              vErrors.push(err33);
                                            }
                                            errors++;
                                          }
                                          var valid6 = _errs73 === errors;
                                        } else {
                                          var valid6 = true;
                                        }
                                        if (valid6) {
                                          if (data.type !== undefined) {
                                            const _errs75 = errors;
                                            if (
                                              !func0(data.type, 'radiobutton')
                                            ) {
                                              const err34 = {
                                                instancePath:
                                                  instancePath + '/type',
                                                schemaPath:
                                                  '#/definitions/RadioField/allOf/0/properties/type/const',
                                                keyword: 'const',
                                                params: {
                                                  allowedValue: 'radiobutton',
                                                },
                                                message:
                                                  'must be equal to constant',
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err34];
                                              } else {
                                                vErrors.push(err34);
                                              }
                                              errors++;
                                            }
                                            var valid6 = _errs75 === errors;
                                          } else {
                                            var valid6 = true;
                                          }
                                          if (valid6) {
                                            if (data.checked !== undefined) {
                                              const _errs76 = errors;
                                              if (
                                                typeof data.checked !==
                                                'boolean'
                                              ) {
                                                const err35 = {
                                                  instancePath:
                                                    instancePath + '/checked',
                                                  schemaPath:
                                                    '#/definitions/RadioField/allOf/0/properties/checked/type',
                                                  keyword: 'type',
                                                  params: { type: 'boolean' },
                                                  message: 'must be boolean',
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err35];
                                                } else {
                                                  vErrors.push(err35);
                                                }
                                                errors++;
                                              }
                                              var valid6 = _errs76 === errors;
                                            } else {
                                              var valid6 = true;
                                            }
                                            if (valid6) {
                                              if (
                                                data.requirement !== undefined
                                              ) {
                                                const _errs78 = errors;
                                                if (
                                                  typeof data.requirement !==
                                                  'string'
                                                ) {
                                                  const err36 = {
                                                    instancePath:
                                                      instancePath +
                                                      '/requirement',
                                                    schemaPath:
                                                      '#/definitions/RadioField/allOf/0/properties/requirement/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err36];
                                                  } else {
                                                    vErrors.push(err36);
                                                  }
                                                  errors++;
                                                }
                                                var valid6 = _errs78 === errors;
                                              } else {
                                                var valid6 = true;
                                              }
                                              if (valid6) {
                                                if (
                                                  data.groupLabel !== undefined
                                                ) {
                                                  const _errs80 = errors;
                                                  if (
                                                    typeof data.groupLabel !==
                                                    'string'
                                                  ) {
                                                    const err37 = {
                                                      instancePath:
                                                        instancePath +
                                                        '/groupLabel',
                                                      schemaPath:
                                                        '#/definitions/RadioField/allOf/0/properties/groupLabel/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'string',
                                                      },
                                                      message: 'must be string',
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err37];
                                                    } else {
                                                      vErrors.push(err37);
                                                    }
                                                    errors++;
                                                  }
                                                  var valid6 =
                                                    _errs80 === errors;
                                                } else {
                                                  var valid6 = true;
                                                }
                                                if (valid6) {
                                                  if (
                                                    data.group !== undefined
                                                  ) {
                                                    const _errs82 = errors;
                                                    if (
                                                      typeof data.group !==
                                                      'string'
                                                    ) {
                                                      const err38 = {
                                                        instancePath:
                                                          instancePath +
                                                          '/group',
                                                        schemaPath:
                                                          '#/definitions/RadioField/allOf/0/properties/group/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'string',
                                                        },
                                                        message:
                                                          'must be string',
                                                      };
                                                      if (vErrors === null) {
                                                        vErrors = [err38];
                                                      } else {
                                                        vErrors.push(err38);
                                                      }
                                                      errors++;
                                                    }
                                                    var valid6 =
                                                      _errs82 === errors;
                                                  } else {
                                                    var valid6 = true;
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          var _valid0 = _errs44 === errors;
          if (_valid0 && valid0) {
            valid0 = false;
            passing0 = [passing0, 5];
          } else {
            if (_valid0) {
              valid0 = true;
              passing0 = 5;
            }
            const _errs84 = errors;
            if (
              !validate25(data, {
                instancePath,
                parentData,
                parentDataProperty,
                rootData,
              })
            ) {
              vErrors =
                vErrors === null
                  ? validate25.errors
                  : vErrors.concat(validate25.errors);
              errors = vErrors.length;
            }
            var _valid0 = _errs84 === errors;
            if (_valid0 && valid0) {
              valid0 = false;
              passing0 = [passing0, 6];
            } else {
              if (_valid0) {
                valid0 = true;
                passing0 = 6;
              }
              const _errs85 = errors;
              if (
                !validate27(data, {
                  instancePath,
                  parentData,
                  parentDataProperty,
                  rootData,
                })
              ) {
                vErrors =
                  vErrors === null
                    ? validate27.errors
                    : vErrors.concat(validate27.errors);
                errors = vErrors.length;
              }
              var _valid0 = _errs85 === errors;
              if (_valid0 && valid0) {
                valid0 = false;
                passing0 = [passing0, 7];
              } else {
                if (_valid0) {
                  valid0 = true;
                  passing0 = 7;
                }
              }
            }
          }
        }
      }
    }
  }
  if (!valid0) {
    const err39 = {
      instancePath,
      schemaPath: '#/oneOf',
      keyword: 'oneOf',
      params: { passingSchemas: passing0 },
      message: 'must match exactly one schema in oneOf',
    };
    if (vErrors === null) {
      vErrors = [err39];
    } else {
      vErrors.push(err39);
    }
    errors++;
    validate13.errors = vErrors;
    return false;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate13.errors = vErrors;
  return errors === 0;
}
function validate45(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="File.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.name === undefined && (missing0 = 'name')) ||
        (data.type === undefined && (missing0 = 'type')) ||
        (data.guid === undefined && (missing0 = 'guid')) ||
        (data.fields === undefined && (missing0 = 'fields')) ||
        (data.pwRequired === undefined && (missing0 = 'pwRequired')) ||
        (data.rootSnapshotGuid === undefined && (missing0 = 'rootSnapshotGuid'))
      ) {
        validate45.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func4.call(schema61.properties, key0)) {
            validate45.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.status !== undefined) {
            let data0 = data.status;
            const _errs2 = errors;
            if (typeof data0 !== 'string') {
              validate45.errors = [
                {
                  instancePath: instancePath + '/status',
                  schemaPath: '#/properties/status/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            if (
              !(
                data0 === 'converting' ||
                data0 === 'ok' ||
                data0 === 'file downloaded' ||
                data0 === 'downloading' ||
                data0 === 'download queued' ||
                data0 === 'deleted' ||
                data0 === 'error' ||
                data0 === '404 Error' ||
                data0 === 'password required' ||
                data0 === 'too many pages' ||
                data0 === 'file too large' ||
                data0 === 'retrieve error' ||
                data0 === 'bad request' ||
                data0 === 'bad auth'
              )
            ) {
              validate45.errors = [
                {
                  instancePath: instancePath + '/status',
                  schemaPath: '#/properties/status/enum',
                  keyword: 'enum',
                  params: { allowedValues: schema61.properties.status.enum },
                  message: 'must be equal to one of the allowed values',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.name !== undefined) {
              const _errs4 = errors;
              if (typeof data.name !== 'string') {
                validate45.errors = [
                  {
                    instancePath: instancePath + '/name',
                    schemaPath: '#/properties/name/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.type !== undefined) {
                let data2 = data.type;
                const _errs6 = errors;
                if (typeof data2 !== 'string') {
                  validate45.errors = [
                    {
                      instancePath: instancePath + '/type',
                      schemaPath: '#/properties/type/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                if (
                  !(
                    data2 === 'Upload' ||
                    data2 === 'Template' ||
                    data2 === 'External' ||
                    data2 === 'Signer'
                  )
                ) {
                  validate45.errors = [
                    {
                      instancePath: instancePath + '/type',
                      schemaPath: '#/properties/type/enum',
                      keyword: 'enum',
                      params: { allowedValues: schema61.properties.type.enum },
                      message: 'must be equal to one of the allowed values',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs6 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.guid !== undefined) {
                  const _errs8 = errors;
                  if (typeof data.guid !== 'string') {
                    validate45.errors = [
                      {
                        instancePath: instancePath + '/guid',
                        schemaPath: '#/properties/guid/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs8 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.documentGuid !== undefined) {
                    const _errs10 = errors;
                    if (typeof data.documentGuid !== 'string') {
                      validate45.errors = [
                        {
                          instancePath: instancePath + '/documentGuid',
                          schemaPath: '#/properties/documentGuid/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs10 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.draftSnapshotGuid !== undefined) {
                      const _errs12 = errors;
                      if (typeof data.draftSnapshotGuid !== 'string') {
                        validate45.errors = [
                          {
                            instancePath: instancePath + '/draftSnapshotGuid',
                            schemaPath: '#/properties/draftSnapshotGuid/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs12 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.tsmGroupGuid !== undefined) {
                        const _errs14 = errors;
                        if (typeof data.tsmGroupGuid !== 'string') {
                          validate45.errors = [
                            {
                              instancePath: instancePath + '/tsmGroupGuid',
                              schemaPath: '#/properties/tsmGroupGuid/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs14 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.templateGuid !== undefined) {
                          const _errs16 = errors;
                          if (typeof data.templateGuid !== 'string') {
                            validate45.errors = [
                              {
                                instancePath: instancePath + '/templateGuid',
                                schemaPath: '#/properties/templateGuid/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs16 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.rootSnapshotGuid !== undefined) {
                            const _errs18 = errors;
                            if (typeof data.rootSnapshotGuid !== 'string') {
                              validate45.errors = [
                                {
                                  instancePath:
                                    instancePath + '/rootSnapshotGuid',
                                  schemaPath:
                                    '#/properties/rootSnapshotGuid/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs18 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.order !== undefined) {
                              let data9 = data.order;
                              const _errs20 = errors;
                              if (
                                !(typeof data9 == 'number' && isFinite(data9))
                              ) {
                                validate45.errors = [
                                  {
                                    instancePath: instancePath + '/order',
                                    schemaPath: '#/properties/order/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs20 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.fields !== undefined) {
                                let data10 = data.fields;
                                const _errs22 = errors;
                                if (errors === _errs22) {
                                  if (Array.isArray(data10)) {
                                    var valid1 = true;
                                    const len0 = data10.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                      const _errs24 = errors;
                                      if (
                                        !validate13(data10[i0], {
                                          instancePath:
                                            instancePath + '/fields/' + i0,
                                          parentData: data10,
                                          parentDataProperty: i0,
                                          rootData,
                                        })
                                      ) {
                                        vErrors =
                                          vErrors === null
                                            ? validate13.errors
                                            : vErrors.concat(validate13.errors);
                                        errors = vErrors.length;
                                      }
                                      var valid1 = _errs24 === errors;
                                      if (!valid1) {
                                        break;
                                      }
                                    }
                                  } else {
                                    validate45.errors = [
                                      {
                                        instancePath: instancePath + '/fields',
                                        schemaPath: '#/properties/fields/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array',
                                      },
                                    ];
                                    return false;
                                  }
                                }
                                var valid0 = _errs22 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.pwRequired !== undefined) {
                                  const _errs25 = errors;
                                  if (typeof data.pwRequired !== 'boolean') {
                                    validate45.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/pwRequired',
                                        schemaPath:
                                          '#/properties/pwRequired/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs25 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.pageCount !== undefined) {
                                    let data13 = data.pageCount;
                                    const _errs27 = errors;
                                    if (
                                      !(
                                        typeof data13 == 'number' &&
                                        isFinite(data13)
                                      )
                                    ) {
                                      validate45.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/pageCount',
                                          schemaPath:
                                            '#/properties/pageCount/type',
                                          keyword: 'type',
                                          params: { type: 'number' },
                                          message: 'must be number',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid0 = _errs27 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (
                                      data.externalFileCacheKey !== undefined
                                    ) {
                                      const _errs29 = errors;
                                      if (
                                        typeof data.externalFileCacheKey !==
                                        'string'
                                      ) {
                                        validate45.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/externalFileCacheKey',
                                            schemaPath:
                                              '#/properties/externalFileCacheKey/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid0 = _errs29 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (
                                        data.externalServiceReference !==
                                        undefined
                                      ) {
                                        const _errs31 = errors;
                                        if (
                                          typeof data.externalServiceReference !==
                                          'string'
                                        ) {
                                          validate45.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/externalServiceReference',
                                              schemaPath:
                                                '#/properties/externalServiceReference/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid0 = _errs31 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (
                                          data.externalServiceType !== undefined
                                        ) {
                                          const _errs33 = errors;
                                          if (
                                            typeof data.externalServiceType !==
                                            'string'
                                          ) {
                                            validate45.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/externalServiceType',
                                                schemaPath:
                                                  '#/properties/externalServiceType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid0 = _errs33 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate45.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate45.errors = vErrors;
  return errors === 0;
}
const schema62 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'EditorData.json',
  title: 'EditorData',
  type: 'object',
  additionalProperties: false,
  properties: {
    pages: { type: 'array', items: { $ref: 'Page.json' } },
    fields: { type: 'array', items: { $ref: 'Field.json' } },
    mergeFields: { type: 'array', items: { $ref: 'Field.json' } },
    pdfFields: { type: 'array', items: { $ref: 'Field.json' } },
    editorFeatures: { type: 'array', items: { type: 'string' } },
    rules: { type: 'array', items: { $ref: 'Rule.json' } },
    transform: {
      type: 'object',
      title: 'Transform',
      additionalProperties: false,
      properties: { rotate: { type: 'integer' } },
      required: ['rotate'],
    },
    documents: { type: 'array', items: { $ref: '#/definitions/Document' } },
    signers: { type: 'array', items: { $ref: 'Recipient.json' } },
    signerOptions: { $ref: '#/definitions/SignerOptions' },
    editorOptions: { $ref: '#/definitions/EditorOptions' },
  },
  required: [
    'pages',
    'fields',
    'mergeFields',
    'pdfFields',
    'editorOptions',
    'rules',
    'transform',
    'signers',
    'documents',
    'signerOptions',
  ],
  definitions: {
    EditorOptions: {
      type: 'object',
      title: 'EditorOptions',
      properties: {
        allowEditSigners: { type: 'boolean' },
        allowEditDocuments: { type: 'boolean' },
        canUseCustomRegexDataValidation: { type: 'boolean' },
        canUseDataValidation: { type: 'boolean' },
      },
      required: [
        'allowEditSigners',
        'allowEditDocuments',
        'canUseCustomRegexDataValidation',
        'canUseDataValidation',
      ],
    },
    FieldOptions: {
      type: 'object',
      title: 'FieldOptions',
      properties: {
        dateFormat: { $ref: 'Field.json#/definitions/JSDateFormat' },
      },
    },
    SignatureTypes: {
      type: 'string',
      title: 'SignatureTypes',
      enum: ['draw', 'type', 'upload', 'phone'],
    },
    SignatureType: {
      type: 'object',
      title: 'SignatureType',
      properties: {
        default: { $ref: '#/definitions/SignatureTypes' },
        allowed: {
          type: 'array',
          items: { $ref: '#/definitions/SignatureTypes' },
        },
      },
    },
    SignerOptions: {
      type: 'object',
      title: 'SignerOptions',
      properties: {
        fieldOptions: { $ref: '#/definitions/FieldOptions' },
        signatureType: { $ref: '#/definitions/SignatureType' },
      },
    },
    Document: {
      type: 'object',
      title: 'Document',
      description:
        'Holds information about documents uploaded as part of the request. This is separate from files uploaded on the Prep and Send documents page because the ability to upload documents is available in the Editor as well.',
      additionalProperties: false,
      properties: {
        id: { type: 'string' },
        name: { type: 'string' },
        editable: { type: 'boolean' },
        snapshotGuid: { type: 'string' },
      },
      required: ['id', 'name', 'editable', 'snapshotGuid'],
    },
  },
};
const schema63 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'Page.json',
  title: 'Page',
  type: 'object',
  additionalProperties: false,
  properties: {
    src: { type: 'string' },
    width: { type: 'number' },
    height: { type: 'number' },
    documentId: { type: 'string' },
    orientation: { type: 'integer' },
    snapshotGuid: { type: 'string' },
    cdnSrc: { type: ['string', 'null'] },
  },
  required: [
    'src',
    'width',
    'height',
    'documentId',
    'orientation',
    'snapshotGuid',
  ],
};
const schema77 = {
  type: 'object',
  title: 'Document',
  description:
    'Holds information about documents uploaded as part of the request. This is separate from files uploaded on the Prep and Send documents page because the ability to upload documents is available in the Editor as well.',
  additionalProperties: false,
  properties: {
    id: { type: 'string' },
    name: { type: 'string' },
    editable: { type: 'boolean' },
    snapshotGuid: { type: 'string' },
  },
  required: ['id', 'name', 'editable', 'snapshotGuid'],
};
const schema91 = {
  type: 'object',
  title: 'EditorOptions',
  properties: {
    allowEditSigners: { type: 'boolean' },
    allowEditDocuments: { type: 'boolean' },
    canUseCustomRegexDataValidation: { type: 'boolean' },
    canUseDataValidation: { type: 'boolean' },
  },
  required: [
    'allowEditSigners',
    'allowEditDocuments',
    'canUseCustomRegexDataValidation',
    'canUseDataValidation',
  ],
};
const schema64 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'Rule.json',
  title: 'Rule',
  type: 'object',
  additionalProperties: false,
  properties: {
    id: { type: 'string' },
    triggerOperator: { $ref: '#/definitions/TriggerOperator' },
    triggers: {
      type: 'array',
      items: {
        oneOf: [
          { $ref: '#/definitions/StringArrayTrigger' },
          { $ref: '#/definitions/StringTrigger' },
          { $ref: '#/definitions/NonNumericTrigger' },
          { $ref: '#/definitions/NumericTrigger' },
        ],
      },
    },
    actions: { type: 'array', items: { $ref: '#/definitions/Action' } },
  },
  required: ['id', 'triggerOperator', 'triggers', 'actions'],
  definitions: {
    StringArrayOperator: {
      type: 'string',
      title: 'StringArrayOperator',
      enum: ['any', 'none'],
      tsEnumNames: ['Any', 'None'],
    },
    StringOperator: {
      type: 'string',
      title: 'StringOperator',
      enum: ['has', 'hasNot', 'match'],
      tsEnumNames: ['Has', 'HasNot', 'Match'],
    },
    NonNumericOperator: {
      type: 'string',
      title: 'NonNumericOperator',
      enum: ['is', 'not'],
      tsEnumNames: ['Is', 'Not'],
    },
    NumericOperator: {
      type: 'string',
      title: 'NumericOperator',
      enum: ['gt', 'lt'],
      tsEnumNames: ['Lt', 'Gt'],
    },
    TriggerOperator: {
      type: 'string',
      title: 'TriggerOperator',
      enum: ['AND', 'OR'],
      tsEnumNames: ['AND', 'OR'],
    },
    ActionType: {
      type: 'string',
      title: 'ActionType',
      enum: ['change-field-visibility', 'change-group-visibility'],
      tsEnumNames: ['ChangeFieldVisibility', 'ChangeGroupVisibility'],
    },
    StringArrayTrigger: {
      type: 'object',
      title: 'StringArrayTrigger',
      additionalProperties: false,
      properties: {
        id: { type: 'string' },
        operator: { $ref: '#/definitions/StringArrayOperator' },
        value: { type: 'array', items: { type: 'string' } },
      },
      required: ['id', 'operator', 'value'],
    },
    StringTrigger: {
      type: 'object',
      title: 'StringTrigger',
      additionalProperties: false,
      properties: {
        id: { type: 'string' },
        operator: { $ref: '#/definitions/StringOperator' },
        value: { type: ['string'] },
      },
      required: ['id', 'operator', 'value'],
    },
    NonNumericTrigger: {
      type: 'object',
      title: 'NonNumericTrigger',
      additionalProperties: false,
      properties: {
        id: { type: 'string' },
        operator: { $ref: '#/definitions/NonNumericOperator' },
        value: { type: ['string', 'boolean'] },
      },
      required: ['id', 'operator', 'value'],
    },
    NumericTrigger: {
      type: 'object',
      title: 'NumericTrigger',
      additionalProperties: false,
      properties: {
        id: { type: 'string' },
        operator: { $ref: '#/definitions/NumericOperator' },
        value: { type: 'number' },
      },
      required: ['id', 'operator', 'value'],
    },
    Action: {
      type: 'object',
      title: 'Action',
      oneOf: [
        { $ref: '#/definitions/FieldVisibilityAction' },
        { $ref: '#/definitions/GroupVisibilityAction' },
      ],
    },
    FieldVisibilityAction: {
      type: 'object',
      title: 'FieldVisibilityAction',
      additionalProperties: false,
      properties: {
        type: {
          const: 'change-field-visibility',
          default: 'change-field-visibility',
        },
        fieldId: { type: 'string' },
        hidden: { type: 'boolean' },
      },
      required: ['type', 'fieldId', 'hidden'],
    },
    GroupVisibilityAction: {
      type: 'object',
      title: 'GroupVisibilityAction',
      additionalProperties: false,
      properties: {
        type: {
          const: 'change-group-visibility',
          default: 'change-group-visibility',
        },
        groupId: { type: 'string' },
        hidden: { type: 'boolean' },
      },
      required: ['type', 'groupId', 'hidden'],
    },
  },
};
const schema65 = {
  type: 'string',
  title: 'TriggerOperator',
  enum: ['AND', 'OR'],
  tsEnumNames: ['AND', 'OR'],
};
const schema66 = {
  type: 'object',
  title: 'StringArrayTrigger',
  additionalProperties: false,
  properties: {
    id: { type: 'string' },
    operator: { $ref: '#/definitions/StringArrayOperator' },
    value: { type: 'array', items: { type: 'string' } },
  },
  required: ['id', 'operator', 'value'],
};
const schema67 = {
  type: 'string',
  title: 'StringArrayOperator',
  enum: ['any', 'none'],
  tsEnumNames: ['Any', 'None'],
};
function validate53(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.id === undefined && (missing0 = 'id')) ||
        (data.operator === undefined && (missing0 = 'operator')) ||
        (data.value === undefined && (missing0 = 'value'))
      ) {
        validate53.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'id' || key0 === 'operator' || key0 === 'value')) {
            validate53.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.id !== undefined) {
            const _errs2 = errors;
            if (typeof data.id !== 'string') {
              validate53.errors = [
                {
                  instancePath: instancePath + '/id',
                  schemaPath: '#/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.operator !== undefined) {
              let data1 = data.operator;
              const _errs4 = errors;
              if (typeof data1 !== 'string') {
                validate53.errors = [
                  {
                    instancePath: instancePath + '/operator',
                    schemaPath: '#/definitions/StringArrayOperator/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              if (!(data1 === 'any' || data1 === 'none')) {
                validate53.errors = [
                  {
                    instancePath: instancePath + '/operator',
                    schemaPath: '#/definitions/StringArrayOperator/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema67.enum },
                    message: 'must be equal to one of the allowed values',
                  },
                ];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.value !== undefined) {
                let data2 = data.value;
                const _errs7 = errors;
                if (errors === _errs7) {
                  if (Array.isArray(data2)) {
                    var valid2 = true;
                    const len0 = data2.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      const _errs9 = errors;
                      if (typeof data2[i0] !== 'string') {
                        validate53.errors = [
                          {
                            instancePath: instancePath + '/value/' + i0,
                            schemaPath: '#/properties/value/items/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs9 === errors;
                      if (!valid2) {
                        break;
                      }
                    }
                  } else {
                    validate53.errors = [
                      {
                        instancePath: instancePath + '/value',
                        schemaPath: '#/properties/value/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate53.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate53.errors = vErrors;
  return errors === 0;
}
const schema68 = {
  type: 'object',
  title: 'StringTrigger',
  additionalProperties: false,
  properties: {
    id: { type: 'string' },
    operator: { $ref: '#/definitions/StringOperator' },
    value: { type: ['string'] },
  },
  required: ['id', 'operator', 'value'],
};
const schema69 = {
  type: 'string',
  title: 'StringOperator',
  enum: ['has', 'hasNot', 'match'],
  tsEnumNames: ['Has', 'HasNot', 'Match'],
};
function validate55(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.id === undefined && (missing0 = 'id')) ||
        (data.operator === undefined && (missing0 = 'operator')) ||
        (data.value === undefined && (missing0 = 'value'))
      ) {
        validate55.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'id' || key0 === 'operator' || key0 === 'value')) {
            validate55.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.id !== undefined) {
            const _errs2 = errors;
            if (typeof data.id !== 'string') {
              validate55.errors = [
                {
                  instancePath: instancePath + '/id',
                  schemaPath: '#/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.operator !== undefined) {
              let data1 = data.operator;
              const _errs4 = errors;
              if (typeof data1 !== 'string') {
                validate55.errors = [
                  {
                    instancePath: instancePath + '/operator',
                    schemaPath: '#/definitions/StringOperator/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              if (
                !(data1 === 'has' || data1 === 'hasNot' || data1 === 'match')
              ) {
                validate55.errors = [
                  {
                    instancePath: instancePath + '/operator',
                    schemaPath: '#/definitions/StringOperator/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema69.enum },
                    message: 'must be equal to one of the allowed values',
                  },
                ];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.value !== undefined) {
                const _errs7 = errors;
                if (typeof data.value !== 'string') {
                  validate55.errors = [
                    {
                      instancePath: instancePath + '/value',
                      schemaPath: '#/properties/value/type',
                      keyword: 'type',
                      params: { type: schema68.properties.value.type },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate55.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate55.errors = vErrors;
  return errors === 0;
}
const schema70 = {
  type: 'object',
  title: 'NonNumericTrigger',
  additionalProperties: false,
  properties: {
    id: { type: 'string' },
    operator: { $ref: '#/definitions/NonNumericOperator' },
    value: { type: ['string', 'boolean'] },
  },
  required: ['id', 'operator', 'value'],
};
const schema71 = {
  type: 'string',
  title: 'NonNumericOperator',
  enum: ['is', 'not'],
  tsEnumNames: ['Is', 'Not'],
};
function validate57(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.id === undefined && (missing0 = 'id')) ||
        (data.operator === undefined && (missing0 = 'operator')) ||
        (data.value === undefined && (missing0 = 'value'))
      ) {
        validate57.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'id' || key0 === 'operator' || key0 === 'value')) {
            validate57.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.id !== undefined) {
            const _errs2 = errors;
            if (typeof data.id !== 'string') {
              validate57.errors = [
                {
                  instancePath: instancePath + '/id',
                  schemaPath: '#/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.operator !== undefined) {
              let data1 = data.operator;
              const _errs4 = errors;
              if (typeof data1 !== 'string') {
                validate57.errors = [
                  {
                    instancePath: instancePath + '/operator',
                    schemaPath: '#/definitions/NonNumericOperator/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              if (!(data1 === 'is' || data1 === 'not')) {
                validate57.errors = [
                  {
                    instancePath: instancePath + '/operator',
                    schemaPath: '#/definitions/NonNumericOperator/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema71.enum },
                    message: 'must be equal to one of the allowed values',
                  },
                ];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.value !== undefined) {
                let data2 = data.value;
                const _errs7 = errors;
                if (typeof data2 !== 'string' && typeof data2 !== 'boolean') {
                  validate57.errors = [
                    {
                      instancePath: instancePath + '/value',
                      schemaPath: '#/properties/value/type',
                      keyword: 'type',
                      params: { type: schema70.properties.value.type },
                      message: 'must be string,boolean',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate57.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate57.errors = vErrors;
  return errors === 0;
}
const schema72 = {
  type: 'object',
  title: 'NumericTrigger',
  additionalProperties: false,
  properties: {
    id: { type: 'string' },
    operator: { $ref: '#/definitions/NumericOperator' },
    value: { type: 'number' },
  },
  required: ['id', 'operator', 'value'],
};
const schema73 = {
  type: 'string',
  title: 'NumericOperator',
  enum: ['gt', 'lt'],
  tsEnumNames: ['Lt', 'Gt'],
};
function validate59(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.id === undefined && (missing0 = 'id')) ||
        (data.operator === undefined && (missing0 = 'operator')) ||
        (data.value === undefined && (missing0 = 'value'))
      ) {
        validate59.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'id' || key0 === 'operator' || key0 === 'value')) {
            validate59.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.id !== undefined) {
            const _errs2 = errors;
            if (typeof data.id !== 'string') {
              validate59.errors = [
                {
                  instancePath: instancePath + '/id',
                  schemaPath: '#/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.operator !== undefined) {
              let data1 = data.operator;
              const _errs4 = errors;
              if (typeof data1 !== 'string') {
                validate59.errors = [
                  {
                    instancePath: instancePath + '/operator',
                    schemaPath: '#/definitions/NumericOperator/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              if (!(data1 === 'gt' || data1 === 'lt')) {
                validate59.errors = [
                  {
                    instancePath: instancePath + '/operator',
                    schemaPath: '#/definitions/NumericOperator/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema73.enum },
                    message: 'must be equal to one of the allowed values',
                  },
                ];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.value !== undefined) {
                let data2 = data.value;
                const _errs7 = errors;
                if (!(typeof data2 == 'number' && isFinite(data2))) {
                  validate59.errors = [
                    {
                      instancePath: instancePath + '/value',
                      schemaPath: '#/properties/value/type',
                      keyword: 'type',
                      params: { type: 'number' },
                      message: 'must be number',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate59.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate59.errors = vErrors;
  return errors === 0;
}
const schema74 = {
  type: 'object',
  title: 'Action',
  oneOf: [
    { $ref: '#/definitions/FieldVisibilityAction' },
    { $ref: '#/definitions/GroupVisibilityAction' },
  ],
};
const schema75 = {
  type: 'object',
  title: 'FieldVisibilityAction',
  additionalProperties: false,
  properties: {
    type: {
      const: 'change-field-visibility',
      default: 'change-field-visibility',
    },
    fieldId: { type: 'string' },
    hidden: { type: 'boolean' },
  },
  required: ['type', 'fieldId', 'hidden'],
};
const schema76 = {
  type: 'object',
  title: 'GroupVisibilityAction',
  additionalProperties: false,
  properties: {
    type: {
      const: 'change-group-visibility',
      default: 'change-group-visibility',
    },
    groupId: { type: 'string' },
    hidden: { type: 'boolean' },
  },
  required: ['type', 'groupId', 'hidden'],
};
function validate61(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == 'object' && !Array.isArray(data))) {
    validate61.errors = [
      {
        instancePath,
        schemaPath: '#/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      },
    ];
    return false;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  const _errs3 = errors;
  if (errors === _errs3) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.type === undefined && (missing0 = 'type')) ||
        (data.fieldId === undefined && (missing0 = 'fieldId')) ||
        (data.hidden === undefined && (missing0 = 'hidden'))
      ) {
        const err0 = {
          instancePath,
          schemaPath: '#/definitions/FieldVisibilityAction/required',
          keyword: 'required',
          params: { missingProperty: missing0 },
          message: "must have required property '" + missing0 + "'",
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        const _errs5 = errors;
        for (const key0 in data) {
          if (!(key0 === 'type' || key0 === 'fieldId' || key0 === 'hidden')) {
            const err1 = {
              instancePath,
              schemaPath:
                '#/definitions/FieldVisibilityAction/additionalProperties',
              keyword: 'additionalProperties',
              params: { additionalProperty: key0 },
              message: 'must NOT have additional properties',
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
            break;
          }
        }
        if (_errs5 === errors) {
          if (data.type !== undefined) {
            const _errs6 = errors;
            if (!func0(data.type, 'change-field-visibility')) {
              const err2 = {
                instancePath: instancePath + '/type',
                schemaPath:
                  '#/definitions/FieldVisibilityAction/properties/type/const',
                keyword: 'const',
                params: { allowedValue: 'change-field-visibility' },
                message: 'must be equal to constant',
              };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            var valid2 = _errs6 === errors;
          } else {
            var valid2 = true;
          }
          if (valid2) {
            if (data.fieldId !== undefined) {
              const _errs7 = errors;
              if (typeof data.fieldId !== 'string') {
                const err3 = {
                  instancePath: instancePath + '/fieldId',
                  schemaPath:
                    '#/definitions/FieldVisibilityAction/properties/fieldId/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
              }
              var valid2 = _errs7 === errors;
            } else {
              var valid2 = true;
            }
            if (valid2) {
              if (data.hidden !== undefined) {
                const _errs9 = errors;
                if (typeof data.hidden !== 'boolean') {
                  const err4 = {
                    instancePath: instancePath + '/hidden',
                    schemaPath:
                      '#/definitions/FieldVisibilityAction/properties/hidden/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  };
                  if (vErrors === null) {
                    vErrors = [err4];
                  } else {
                    vErrors.push(err4);
                  }
                  errors++;
                }
                var valid2 = _errs9 === errors;
              } else {
                var valid2 = true;
              }
            }
          }
        }
      }
    } else {
      const err5 = {
        instancePath,
        schemaPath: '#/definitions/FieldVisibilityAction/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs11 = errors;
  const _errs12 = errors;
  if (errors === _errs12) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing1;
      if (
        (data.type === undefined && (missing1 = 'type')) ||
        (data.groupId === undefined && (missing1 = 'groupId')) ||
        (data.hidden === undefined && (missing1 = 'hidden'))
      ) {
        const err6 = {
          instancePath,
          schemaPath: '#/definitions/GroupVisibilityAction/required',
          keyword: 'required',
          params: { missingProperty: missing1 },
          message: "must have required property '" + missing1 + "'",
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      } else {
        const _errs14 = errors;
        for (const key1 in data) {
          if (!(key1 === 'type' || key1 === 'groupId' || key1 === 'hidden')) {
            const err7 = {
              instancePath,
              schemaPath:
                '#/definitions/GroupVisibilityAction/additionalProperties',
              keyword: 'additionalProperties',
              params: { additionalProperty: key1 },
              message: 'must NOT have additional properties',
            };
            if (vErrors === null) {
              vErrors = [err7];
            } else {
              vErrors.push(err7);
            }
            errors++;
            break;
          }
        }
        if (_errs14 === errors) {
          if (data.type !== undefined) {
            const _errs15 = errors;
            if (!func0(data.type, 'change-group-visibility')) {
              const err8 = {
                instancePath: instancePath + '/type',
                schemaPath:
                  '#/definitions/GroupVisibilityAction/properties/type/const',
                keyword: 'const',
                params: { allowedValue: 'change-group-visibility' },
                message: 'must be equal to constant',
              };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
            var valid4 = _errs15 === errors;
          } else {
            var valid4 = true;
          }
          if (valid4) {
            if (data.groupId !== undefined) {
              const _errs16 = errors;
              if (typeof data.groupId !== 'string') {
                const err9 = {
                  instancePath: instancePath + '/groupId',
                  schemaPath:
                    '#/definitions/GroupVisibilityAction/properties/groupId/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                };
                if (vErrors === null) {
                  vErrors = [err9];
                } else {
                  vErrors.push(err9);
                }
                errors++;
              }
              var valid4 = _errs16 === errors;
            } else {
              var valid4 = true;
            }
            if (valid4) {
              if (data.hidden !== undefined) {
                const _errs18 = errors;
                if (typeof data.hidden !== 'boolean') {
                  const err10 = {
                    instancePath: instancePath + '/hidden',
                    schemaPath:
                      '#/definitions/GroupVisibilityAction/properties/hidden/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  };
                  if (vErrors === null) {
                    vErrors = [err10];
                  } else {
                    vErrors.push(err10);
                  }
                  errors++;
                }
                var valid4 = _errs18 === errors;
              } else {
                var valid4 = true;
              }
            }
          }
        }
      }
    } else {
      const err11 = {
        instancePath,
        schemaPath: '#/definitions/GroupVisibilityAction/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      };
      if (vErrors === null) {
        vErrors = [err11];
      } else {
        vErrors.push(err11);
      }
      errors++;
    }
  }
  var _valid0 = _errs11 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
  }
  if (!valid0) {
    const err12 = {
      instancePath,
      schemaPath: '#/oneOf',
      keyword: 'oneOf',
      params: { passingSchemas: passing0 },
      message: 'must match exactly one schema in oneOf',
    };
    if (vErrors === null) {
      vErrors = [err12];
    } else {
      vErrors.push(err12);
    }
    errors++;
    validate61.errors = vErrors;
    return false;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate61.errors = vErrors;
  return errors === 0;
}
function validate52(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="Rule.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.id === undefined && (missing0 = 'id')) ||
        (data.triggerOperator === undefined &&
          (missing0 = 'triggerOperator')) ||
        (data.triggers === undefined && (missing0 = 'triggers')) ||
        (data.actions === undefined && (missing0 = 'actions'))
      ) {
        validate52.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (
            !(
              key0 === 'id' ||
              key0 === 'triggerOperator' ||
              key0 === 'triggers' ||
              key0 === 'actions'
            )
          ) {
            validate52.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.id !== undefined) {
            const _errs2 = errors;
            if (typeof data.id !== 'string') {
              validate52.errors = [
                {
                  instancePath: instancePath + '/id',
                  schemaPath: '#/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.triggerOperator !== undefined) {
              let data1 = data.triggerOperator;
              const _errs4 = errors;
              if (typeof data1 !== 'string') {
                validate52.errors = [
                  {
                    instancePath: instancePath + '/triggerOperator',
                    schemaPath: '#/definitions/TriggerOperator/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              if (!(data1 === 'AND' || data1 === 'OR')) {
                validate52.errors = [
                  {
                    instancePath: instancePath + '/triggerOperator',
                    schemaPath: '#/definitions/TriggerOperator/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema65.enum },
                    message: 'must be equal to one of the allowed values',
                  },
                ];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.triggers !== undefined) {
                let data2 = data.triggers;
                const _errs7 = errors;
                if (errors === _errs7) {
                  if (Array.isArray(data2)) {
                    var valid2 = true;
                    const len0 = data2.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      let data3 = data2[i0];
                      const _errs9 = errors;
                      const _errs10 = errors;
                      let valid3 = false;
                      let passing0 = null;
                      const _errs11 = errors;
                      if (
                        !validate53(data3, {
                          instancePath: instancePath + '/triggers/' + i0,
                          parentData: data2,
                          parentDataProperty: i0,
                          rootData,
                        })
                      ) {
                        vErrors =
                          vErrors === null
                            ? validate53.errors
                            : vErrors.concat(validate53.errors);
                        errors = vErrors.length;
                      }
                      var _valid0 = _errs11 === errors;
                      if (_valid0) {
                        valid3 = true;
                        passing0 = 0;
                      }
                      const _errs12 = errors;
                      if (
                        !validate55(data3, {
                          instancePath: instancePath + '/triggers/' + i0,
                          parentData: data2,
                          parentDataProperty: i0,
                          rootData,
                        })
                      ) {
                        vErrors =
                          vErrors === null
                            ? validate55.errors
                            : vErrors.concat(validate55.errors);
                        errors = vErrors.length;
                      }
                      var _valid0 = _errs12 === errors;
                      if (_valid0 && valid3) {
                        valid3 = false;
                        passing0 = [passing0, 1];
                      } else {
                        if (_valid0) {
                          valid3 = true;
                          passing0 = 1;
                        }
                        const _errs13 = errors;
                        if (
                          !validate57(data3, {
                            instancePath: instancePath + '/triggers/' + i0,
                            parentData: data2,
                            parentDataProperty: i0,
                            rootData,
                          })
                        ) {
                          vErrors =
                            vErrors === null
                              ? validate57.errors
                              : vErrors.concat(validate57.errors);
                          errors = vErrors.length;
                        }
                        var _valid0 = _errs13 === errors;
                        if (_valid0 && valid3) {
                          valid3 = false;
                          passing0 = [passing0, 2];
                        } else {
                          if (_valid0) {
                            valid3 = true;
                            passing0 = 2;
                          }
                          const _errs14 = errors;
                          if (
                            !validate59(data3, {
                              instancePath: instancePath + '/triggers/' + i0,
                              parentData: data2,
                              parentDataProperty: i0,
                              rootData,
                            })
                          ) {
                            vErrors =
                              vErrors === null
                                ? validate59.errors
                                : vErrors.concat(validate59.errors);
                            errors = vErrors.length;
                          }
                          var _valid0 = _errs14 === errors;
                          if (_valid0 && valid3) {
                            valid3 = false;
                            passing0 = [passing0, 3];
                          } else {
                            if (_valid0) {
                              valid3 = true;
                              passing0 = 3;
                            }
                          }
                        }
                      }
                      if (!valid3) {
                        const err0 = {
                          instancePath: instancePath + '/triggers/' + i0,
                          schemaPath: '#/properties/triggers/items/oneOf',
                          keyword: 'oneOf',
                          params: { passingSchemas: passing0 },
                          message: 'must match exactly one schema in oneOf',
                        };
                        if (vErrors === null) {
                          vErrors = [err0];
                        } else {
                          vErrors.push(err0);
                        }
                        errors++;
                        validate52.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs10;
                        if (vErrors !== null) {
                          if (_errs10) {
                            vErrors.length = _errs10;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid2 = _errs9 === errors;
                      if (!valid2) {
                        break;
                      }
                    }
                  } else {
                    validate52.errors = [
                      {
                        instancePath: instancePath + '/triggers',
                        schemaPath: '#/properties/triggers/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.actions !== undefined) {
                  let data4 = data.actions;
                  const _errs15 = errors;
                  if (errors === _errs15) {
                    if (Array.isArray(data4)) {
                      var valid4 = true;
                      const len1 = data4.length;
                      for (let i1 = 0; i1 < len1; i1++) {
                        const _errs17 = errors;
                        if (
                          !validate61(data4[i1], {
                            instancePath: instancePath + '/actions/' + i1,
                            parentData: data4,
                            parentDataProperty: i1,
                            rootData,
                          })
                        ) {
                          vErrors =
                            vErrors === null
                              ? validate61.errors
                              : vErrors.concat(validate61.errors);
                          errors = vErrors.length;
                        }
                        var valid4 = _errs17 === errors;
                        if (!valid4) {
                          break;
                        }
                      }
                    } else {
                      validate52.errors = [
                        {
                          instancePath: instancePath + '/actions',
                          schemaPath: '#/properties/actions/type',
                          keyword: 'type',
                          params: { type: 'array' },
                          message: 'must be array',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs15 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate52.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate52.errors = vErrors;
  return errors === 0;
}
const schema78 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'Recipient.json',
  title: 'Recipient',
  type: 'object',
  oneOf: [
    { $ref: '#/definitions/Role' },
    { $ref: '#/definitions/Signer' },
    { $ref: '#/definitions/FaxRecipient' },
  ],
  definitions: {
    DeliveryType: {
      type: 'string',
      title: 'DeliveryType',
      enum: ['EMAIL', 'EMAIL-SMS'],
      tsEnumNames: ['Email', 'EmailAndSMS'],
      'x-enum-names': ['Email', 'EmailAndSMS'],
    },
    Attachment: {
      type: 'object',
      title: 'Attachment',
      additionalProperties: false,
      properties: {
        id: { type: 'string' },
        name: { type: 'string' },
        instructions: { type: 'string' },
        required: { type: 'boolean' },
      },
      required: ['id', 'name', 'instructions', 'required'],
    },
    Role: {
      type: 'object',
      title: 'Role',
      additionalProperties: false,
      properties: {
        type: { const: 'role', default: 'role' },
        id: { type: 'string' },
        name: { type: 'string' },
        attachments: {
          type: 'array',
          items: { $ref: '#/definitions/Attachment' },
        },
        accessCode: { type: 'string' },
        smsAuthNumber: { type: 'string' },
        order: { type: 'integer' },
      },
      required: ['type', 'id', 'name', 'attachments'],
    },
    Signer: {
      type: 'object',
      title: 'Signer',
      additionalProperties: false,
      properties: {
        type: { const: 'signer', default: 'signer' },
        id: { type: 'string' },
        email: {
          oneOf: [{ type: 'string', format: 'email' }, { type: 'null' }],
        },
        name: { type: 'string' },
        role: { oneOf: [{ type: 'null' }, { $ref: '#/definitions/Role' }] },
        attachments: {
          type: 'array',
          items: { $ref: '#/definitions/Attachment' },
        },
        accessCode: { type: 'string' },
        smsAuthNumber: { type: 'string' },
        authType: { type: 'string' },
        smsDeliveryNumber: { type: 'string' },
        deliveryType: { $ref: '#/definitions/DeliveryType' },
        order: { type: 'integer' },
      },
      required: ['type', 'id', 'email', 'name', 'role', 'attachments'],
    },
    FaxRecipient: {
      type: 'object',
      title: 'FaxRecipient',
      additionalProperties: false,
      properties: {
        type: { const: 'fax', default: 'fax' },
        id: { type: 'string' },
        fax: { type: 'string' },
      },
      required: ['id', 'type', 'fax'],
    },
    CCRole: {
      type: 'object',
      title: 'CCRole',
      additionalProperties: false,
      properties: {
        type: { const: 'ccRole', default: 'ccRole' },
        id: { type: 'string' },
        name: { type: 'string' },
      },
      required: ['type', 'id', 'name'],
    },
    CCEmail: {
      type: 'object',
      title: 'CCEmail',
      additionalProperties: false,
      properties: {
        type: { const: 'ccEmail', default: 'ccEmail' },
        id: { type: 'string' },
        email: { type: 'string' },
        role: { $ref: '#/definitions/CCRole' },
      },
      required: ['type', 'id', 'email'],
    },
  },
};
const schema84 = {
  type: 'object',
  title: 'FaxRecipient',
  additionalProperties: false,
  properties: {
    type: { const: 'fax', default: 'fax' },
    id: { type: 'string' },
    fax: { type: 'string' },
  },
  required: ['id', 'type', 'fax'],
};
const schema79 = {
  type: 'object',
  title: 'Role',
  additionalProperties: false,
  properties: {
    type: { const: 'role', default: 'role' },
    id: { type: 'string' },
    name: { type: 'string' },
    attachments: { type: 'array', items: { $ref: '#/definitions/Attachment' } },
    accessCode: { type: 'string' },
    smsAuthNumber: { type: 'string' },
    order: { type: 'integer' },
  },
  required: ['type', 'id', 'name', 'attachments'],
};
const schema80 = {
  type: 'object',
  title: 'Attachment',
  additionalProperties: false,
  properties: {
    id: { type: 'string' },
    name: { type: 'string' },
    instructions: { type: 'string' },
    required: { type: 'boolean' },
  },
  required: ['id', 'name', 'instructions', 'required'],
};
function validate65(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.type === undefined && (missing0 = 'type')) ||
        (data.id === undefined && (missing0 = 'id')) ||
        (data.name === undefined && (missing0 = 'name')) ||
        (data.attachments === undefined && (missing0 = 'attachments'))
      ) {
        validate65.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (
            !(
              key0 === 'type' ||
              key0 === 'id' ||
              key0 === 'name' ||
              key0 === 'attachments' ||
              key0 === 'accessCode' ||
              key0 === 'smsAuthNumber' ||
              key0 === 'order'
            )
          ) {
            validate65.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.type !== undefined) {
            const _errs2 = errors;
            if (!func0(data.type, 'role')) {
              validate65.errors = [
                {
                  instancePath: instancePath + '/type',
                  schemaPath: '#/properties/type/const',
                  keyword: 'const',
                  params: { allowedValue: 'role' },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.id !== undefined) {
              const _errs3 = errors;
              if (typeof data.id !== 'string') {
                validate65.errors = [
                  {
                    instancePath: instancePath + '/id',
                    schemaPath: '#/properties/id/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.name !== undefined) {
                const _errs5 = errors;
                if (typeof data.name !== 'string') {
                  validate65.errors = [
                    {
                      instancePath: instancePath + '/name',
                      schemaPath: '#/properties/name/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.attachments !== undefined) {
                  let data3 = data.attachments;
                  const _errs7 = errors;
                  if (errors === _errs7) {
                    if (Array.isArray(data3)) {
                      var valid1 = true;
                      const len0 = data3.length;
                      for (let i0 = 0; i0 < len0; i0++) {
                        let data4 = data3[i0];
                        const _errs9 = errors;
                        const _errs10 = errors;
                        if (errors === _errs10) {
                          if (
                            data4 &&
                            typeof data4 == 'object' &&
                            !Array.isArray(data4)
                          ) {
                            let missing1;
                            if (
                              (data4.id === undefined && (missing1 = 'id')) ||
                              (data4.name === undefined &&
                                (missing1 = 'name')) ||
                              (data4.instructions === undefined &&
                                (missing1 = 'instructions')) ||
                              (data4.required === undefined &&
                                (missing1 = 'required'))
                            ) {
                              validate65.errors = [
                                {
                                  instancePath:
                                    instancePath + '/attachments/' + i0,
                                  schemaPath:
                                    '#/definitions/Attachment/required',
                                  keyword: 'required',
                                  params: { missingProperty: missing1 },
                                  message:
                                    "must have required property '" +
                                    missing1 +
                                    "'",
                                },
                              ];
                              return false;
                            } else {
                              const _errs12 = errors;
                              for (const key1 in data4) {
                                if (
                                  !(
                                    key1 === 'id' ||
                                    key1 === 'name' ||
                                    key1 === 'instructions' ||
                                    key1 === 'required'
                                  )
                                ) {
                                  validate65.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/attachments/' + i0,
                                      schemaPath:
                                        '#/definitions/Attachment/additionalProperties',
                                      keyword: 'additionalProperties',
                                      params: { additionalProperty: key1 },
                                      message:
                                        'must NOT have additional properties',
                                    },
                                  ];
                                  return false;
                                  break;
                                }
                              }
                              if (_errs12 === errors) {
                                if (data4.id !== undefined) {
                                  const _errs13 = errors;
                                  if (typeof data4.id !== 'string') {
                                    validate65.errors = [
                                      {
                                        instancePath:
                                          instancePath +
                                          '/attachments/' +
                                          i0 +
                                          '/id',
                                        schemaPath:
                                          '#/definitions/Attachment/properties/id/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid3 = _errs13 === errors;
                                } else {
                                  var valid3 = true;
                                }
                                if (valid3) {
                                  if (data4.name !== undefined) {
                                    const _errs15 = errors;
                                    if (typeof data4.name !== 'string') {
                                      validate65.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/attachments/' +
                                            i0 +
                                            '/name',
                                          schemaPath:
                                            '#/definitions/Attachment/properties/name/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid3 = _errs15 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                  if (valid3) {
                                    if (data4.instructions !== undefined) {
                                      const _errs17 = errors;
                                      if (
                                        typeof data4.instructions !== 'string'
                                      ) {
                                        validate65.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/attachments/' +
                                              i0 +
                                              '/instructions',
                                            schemaPath:
                                              '#/definitions/Attachment/properties/instructions/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid3 = _errs17 === errors;
                                    } else {
                                      var valid3 = true;
                                    }
                                    if (valid3) {
                                      if (data4.required !== undefined) {
                                        const _errs19 = errors;
                                        if (
                                          typeof data4.required !== 'boolean'
                                        ) {
                                          validate65.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/attachments/' +
                                                i0 +
                                                '/required',
                                              schemaPath:
                                                '#/definitions/Attachment/properties/required/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid3 = _errs19 === errors;
                                      } else {
                                        var valid3 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          } else {
                            validate65.errors = [
                              {
                                instancePath:
                                  instancePath + '/attachments/' + i0,
                                schemaPath: '#/definitions/Attachment/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object',
                              },
                            ];
                            return false;
                          }
                        }
                        var valid1 = _errs9 === errors;
                        if (!valid1) {
                          break;
                        }
                      }
                    } else {
                      validate65.errors = [
                        {
                          instancePath: instancePath + '/attachments',
                          schemaPath: '#/properties/attachments/type',
                          keyword: 'type',
                          params: { type: 'array' },
                          message: 'must be array',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs7 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.accessCode !== undefined) {
                    const _errs21 = errors;
                    if (typeof data.accessCode !== 'string') {
                      validate65.errors = [
                        {
                          instancePath: instancePath + '/accessCode',
                          schemaPath: '#/properties/accessCode/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs21 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.smsAuthNumber !== undefined) {
                      const _errs23 = errors;
                      if (typeof data.smsAuthNumber !== 'string') {
                        validate65.errors = [
                          {
                            instancePath: instancePath + '/smsAuthNumber',
                            schemaPath: '#/properties/smsAuthNumber/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs23 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.order !== undefined) {
                        let data11 = data.order;
                        const _errs25 = errors;
                        if (
                          !(
                            typeof data11 == 'number' &&
                            !(data11 % 1) &&
                            !isNaN(data11) &&
                            isFinite(data11)
                          )
                        ) {
                          validate65.errors = [
                            {
                              instancePath: instancePath + '/order',
                              schemaPath: '#/properties/order/type',
                              keyword: 'type',
                              params: { type: 'integer' },
                              message: 'must be integer',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs25 === errors;
                      } else {
                        var valid0 = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate65.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate65.errors = vErrors;
  return errors === 0;
}
const schema81 = {
  type: 'object',
  title: 'Signer',
  additionalProperties: false,
  properties: {
    type: { const: 'signer', default: 'signer' },
    id: { type: 'string' },
    email: { oneOf: [{ type: 'string', format: 'email' }, { type: 'null' }] },
    name: { type: 'string' },
    role: { oneOf: [{ type: 'null' }, { $ref: '#/definitions/Role' }] },
    attachments: { type: 'array', items: { $ref: '#/definitions/Attachment' } },
    accessCode: { type: 'string' },
    smsAuthNumber: { type: 'string' },
    authType: { type: 'string' },
    smsDeliveryNumber: { type: 'string' },
    deliveryType: { $ref: '#/definitions/DeliveryType' },
    order: { type: 'integer' },
  },
  required: ['type', 'id', 'email', 'name', 'role', 'attachments'],
};
const schema83 = {
  type: 'string',
  title: 'DeliveryType',
  enum: ['EMAIL', 'EMAIL-SMS'],
  tsEnumNames: ['Email', 'EmailAndSMS'],
  'x-enum-names': ['Email', 'EmailAndSMS'],
};
const formats4 =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
function validate67(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.type === undefined && (missing0 = 'type')) ||
        (data.id === undefined && (missing0 = 'id')) ||
        (data.email === undefined && (missing0 = 'email')) ||
        (data.name === undefined && (missing0 = 'name')) ||
        (data.role === undefined && (missing0 = 'role')) ||
        (data.attachments === undefined && (missing0 = 'attachments'))
      ) {
        validate67.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func4.call(schema81.properties, key0)) {
            validate67.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.type !== undefined) {
            const _errs2 = errors;
            if (!func0(data.type, 'signer')) {
              validate67.errors = [
                {
                  instancePath: instancePath + '/type',
                  schemaPath: '#/properties/type/const',
                  keyword: 'const',
                  params: { allowedValue: 'signer' },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.id !== undefined) {
              const _errs3 = errors;
              if (typeof data.id !== 'string') {
                validate67.errors = [
                  {
                    instancePath: instancePath + '/id',
                    schemaPath: '#/properties/id/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.email !== undefined) {
                let data2 = data.email;
                const _errs5 = errors;
                const _errs6 = errors;
                let valid1 = false;
                let passing0 = null;
                const _errs7 = errors;
                if (errors === _errs7) {
                  if (errors === _errs7) {
                    if (typeof data2 === 'string') {
                      if (!formats4.test(data2)) {
                        const err0 = {
                          instancePath: instancePath + '/email',
                          schemaPath: '#/properties/email/oneOf/0/format',
                          keyword: 'format',
                          params: { format: 'email' },
                          message: 'must match format "' + 'email' + '"',
                        };
                        if (vErrors === null) {
                          vErrors = [err0];
                        } else {
                          vErrors.push(err0);
                        }
                        errors++;
                      }
                    } else {
                      const err1 = {
                        instancePath: instancePath + '/email',
                        schemaPath: '#/properties/email/oneOf/0/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      };
                      if (vErrors === null) {
                        vErrors = [err1];
                      } else {
                        vErrors.push(err1);
                      }
                      errors++;
                    }
                  }
                }
                var _valid0 = _errs7 === errors;
                if (_valid0) {
                  valid1 = true;
                  passing0 = 0;
                }
                const _errs9 = errors;
                if (data2 !== null) {
                  const err2 = {
                    instancePath: instancePath + '/email',
                    schemaPath: '#/properties/email/oneOf/1/type',
                    keyword: 'type',
                    params: { type: 'null' },
                    message: 'must be null',
                  };
                  if (vErrors === null) {
                    vErrors = [err2];
                  } else {
                    vErrors.push(err2);
                  }
                  errors++;
                }
                var _valid0 = _errs9 === errors;
                if (_valid0 && valid1) {
                  valid1 = false;
                  passing0 = [passing0, 1];
                } else {
                  if (_valid0) {
                    valid1 = true;
                    passing0 = 1;
                  }
                }
                if (!valid1) {
                  const err3 = {
                    instancePath: instancePath + '/email',
                    schemaPath: '#/properties/email/oneOf',
                    keyword: 'oneOf',
                    params: { passingSchemas: passing0 },
                    message: 'must match exactly one schema in oneOf',
                  };
                  if (vErrors === null) {
                    vErrors = [err3];
                  } else {
                    vErrors.push(err3);
                  }
                  errors++;
                  validate67.errors = vErrors;
                  return false;
                } else {
                  errors = _errs6;
                  if (vErrors !== null) {
                    if (_errs6) {
                      vErrors.length = _errs6;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.name !== undefined) {
                  const _errs11 = errors;
                  if (typeof data.name !== 'string') {
                    validate67.errors = [
                      {
                        instancePath: instancePath + '/name',
                        schemaPath: '#/properties/name/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs11 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.role !== undefined) {
                    let data4 = data.role;
                    const _errs13 = errors;
                    const _errs14 = errors;
                    let valid2 = false;
                    let passing1 = null;
                    const _errs15 = errors;
                    if (data4 !== null) {
                      const err4 = {
                        instancePath: instancePath + '/role',
                        schemaPath: '#/properties/role/oneOf/0/type',
                        keyword: 'type',
                        params: { type: 'null' },
                        message: 'must be null',
                      };
                      if (vErrors === null) {
                        vErrors = [err4];
                      } else {
                        vErrors.push(err4);
                      }
                      errors++;
                    }
                    var _valid1 = _errs15 === errors;
                    if (_valid1) {
                      valid2 = true;
                      passing1 = 0;
                    }
                    const _errs17 = errors;
                    if (
                      !validate65(data4, {
                        instancePath: instancePath + '/role',
                        parentData: data,
                        parentDataProperty: 'role',
                        rootData,
                      })
                    ) {
                      vErrors =
                        vErrors === null
                          ? validate65.errors
                          : vErrors.concat(validate65.errors);
                      errors = vErrors.length;
                    }
                    var _valid1 = _errs17 === errors;
                    if (_valid1 && valid2) {
                      valid2 = false;
                      passing1 = [passing1, 1];
                    } else {
                      if (_valid1) {
                        valid2 = true;
                        passing1 = 1;
                      }
                    }
                    if (!valid2) {
                      const err5 = {
                        instancePath: instancePath + '/role',
                        schemaPath: '#/properties/role/oneOf',
                        keyword: 'oneOf',
                        params: { passingSchemas: passing1 },
                        message: 'must match exactly one schema in oneOf',
                      };
                      if (vErrors === null) {
                        vErrors = [err5];
                      } else {
                        vErrors.push(err5);
                      }
                      errors++;
                      validate67.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs14;
                      if (vErrors !== null) {
                        if (_errs14) {
                          vErrors.length = _errs14;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs13 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.attachments !== undefined) {
                      let data5 = data.attachments;
                      const _errs18 = errors;
                      if (errors === _errs18) {
                        if (Array.isArray(data5)) {
                          var valid3 = true;
                          const len0 = data5.length;
                          for (let i0 = 0; i0 < len0; i0++) {
                            let data6 = data5[i0];
                            const _errs20 = errors;
                            const _errs21 = errors;
                            if (errors === _errs21) {
                              if (
                                data6 &&
                                typeof data6 == 'object' &&
                                !Array.isArray(data6)
                              ) {
                                let missing1;
                                if (
                                  (data6.id === undefined &&
                                    (missing1 = 'id')) ||
                                  (data6.name === undefined &&
                                    (missing1 = 'name')) ||
                                  (data6.instructions === undefined &&
                                    (missing1 = 'instructions')) ||
                                  (data6.required === undefined &&
                                    (missing1 = 'required'))
                                ) {
                                  validate67.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/attachments/' + i0,
                                      schemaPath:
                                        '#/definitions/Attachment/required',
                                      keyword: 'required',
                                      params: { missingProperty: missing1 },
                                      message:
                                        "must have required property '" +
                                        missing1 +
                                        "'",
                                    },
                                  ];
                                  return false;
                                } else {
                                  const _errs23 = errors;
                                  for (const key1 in data6) {
                                    if (
                                      !(
                                        key1 === 'id' ||
                                        key1 === 'name' ||
                                        key1 === 'instructions' ||
                                        key1 === 'required'
                                      )
                                    ) {
                                      validate67.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/attachments/' + i0,
                                          schemaPath:
                                            '#/definitions/Attachment/additionalProperties',
                                          keyword: 'additionalProperties',
                                          params: { additionalProperty: key1 },
                                          message:
                                            'must NOT have additional properties',
                                        },
                                      ];
                                      return false;
                                      break;
                                    }
                                  }
                                  if (_errs23 === errors) {
                                    if (data6.id !== undefined) {
                                      const _errs24 = errors;
                                      if (typeof data6.id !== 'string') {
                                        validate67.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/attachments/' +
                                              i0 +
                                              '/id',
                                            schemaPath:
                                              '#/definitions/Attachment/properties/id/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid5 = _errs24 === errors;
                                    } else {
                                      var valid5 = true;
                                    }
                                    if (valid5) {
                                      if (data6.name !== undefined) {
                                        const _errs26 = errors;
                                        if (typeof data6.name !== 'string') {
                                          validate67.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/attachments/' +
                                                i0 +
                                                '/name',
                                              schemaPath:
                                                '#/definitions/Attachment/properties/name/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid5 = _errs26 === errors;
                                      } else {
                                        var valid5 = true;
                                      }
                                      if (valid5) {
                                        if (data6.instructions !== undefined) {
                                          const _errs28 = errors;
                                          if (
                                            typeof data6.instructions !==
                                            'string'
                                          ) {
                                            validate67.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/attachments/' +
                                                  i0 +
                                                  '/instructions',
                                                schemaPath:
                                                  '#/definitions/Attachment/properties/instructions/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid5 = _errs28 === errors;
                                        } else {
                                          var valid5 = true;
                                        }
                                        if (valid5) {
                                          if (data6.required !== undefined) {
                                            const _errs30 = errors;
                                            if (
                                              typeof data6.required !==
                                              'boolean'
                                            ) {
                                              validate67.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/attachments/' +
                                                    i0 +
                                                    '/required',
                                                  schemaPath:
                                                    '#/definitions/Attachment/properties/required/type',
                                                  keyword: 'type',
                                                  params: { type: 'boolean' },
                                                  message: 'must be boolean',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid5 = _errs30 === errors;
                                          } else {
                                            var valid5 = true;
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              } else {
                                validate67.errors = [
                                  {
                                    instancePath:
                                      instancePath + '/attachments/' + i0,
                                    schemaPath: '#/definitions/Attachment/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object',
                                  },
                                ];
                                return false;
                              }
                            }
                            var valid3 = _errs20 === errors;
                            if (!valid3) {
                              break;
                            }
                          }
                        } else {
                          validate67.errors = [
                            {
                              instancePath: instancePath + '/attachments',
                              schemaPath: '#/properties/attachments/type',
                              keyword: 'type',
                              params: { type: 'array' },
                              message: 'must be array',
                            },
                          ];
                          return false;
                        }
                      }
                      var valid0 = _errs18 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.accessCode !== undefined) {
                        const _errs32 = errors;
                        if (typeof data.accessCode !== 'string') {
                          validate67.errors = [
                            {
                              instancePath: instancePath + '/accessCode',
                              schemaPath: '#/properties/accessCode/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs32 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.smsAuthNumber !== undefined) {
                          const _errs34 = errors;
                          if (typeof data.smsAuthNumber !== 'string') {
                            validate67.errors = [
                              {
                                instancePath: instancePath + '/smsAuthNumber',
                                schemaPath: '#/properties/smsAuthNumber/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs34 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.authType !== undefined) {
                            const _errs36 = errors;
                            if (typeof data.authType !== 'string') {
                              validate67.errors = [
                                {
                                  instancePath: instancePath + '/authType',
                                  schemaPath: '#/properties/authType/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs36 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.smsDeliveryNumber !== undefined) {
                              const _errs38 = errors;
                              if (typeof data.smsDeliveryNumber !== 'string') {
                                validate67.errors = [
                                  {
                                    instancePath:
                                      instancePath + '/smsDeliveryNumber',
                                    schemaPath:
                                      '#/properties/smsDeliveryNumber/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs38 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.deliveryType !== undefined) {
                                let data15 = data.deliveryType;
                                const _errs40 = errors;
                                if (typeof data15 !== 'string') {
                                  validate67.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/deliveryType',
                                      schemaPath:
                                        '#/definitions/DeliveryType/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                if (
                                  !(
                                    data15 === 'EMAIL' || data15 === 'EMAIL-SMS'
                                  )
                                ) {
                                  validate67.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/deliveryType',
                                      schemaPath:
                                        '#/definitions/DeliveryType/enum',
                                      keyword: 'enum',
                                      params: { allowedValues: schema83.enum },
                                      message:
                                        'must be equal to one of the allowed values',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs40 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.order !== undefined) {
                                  let data16 = data.order;
                                  const _errs43 = errors;
                                  if (
                                    !(
                                      typeof data16 == 'number' &&
                                      !(data16 % 1) &&
                                      !isNaN(data16) &&
                                      isFinite(data16)
                                    )
                                  ) {
                                    validate67.errors = [
                                      {
                                        instancePath: instancePath + '/order',
                                        schemaPath: '#/properties/order/type',
                                        keyword: 'type',
                                        params: { type: 'integer' },
                                        message: 'must be integer',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs43 === errors;
                                } else {
                                  var valid0 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate67.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate67.errors = vErrors;
  return errors === 0;
}
function validate64(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="Recipient.json" */ let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == 'object' && !Array.isArray(data))) {
    validate64.errors = [
      {
        instancePath,
        schemaPath: '#/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      },
    ];
    return false;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (
    !validate65(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
    })
  ) {
    vErrors =
      vErrors === null ? validate65.errors : vErrors.concat(validate65.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs3 = errors;
  if (
    !validate67(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
    })
  ) {
    vErrors =
      vErrors === null ? validate67.errors : vErrors.concat(validate67.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs3 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs4 = errors;
    const _errs5 = errors;
    if (errors === _errs5) {
      if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (
          (data.id === undefined && (missing0 = 'id')) ||
          (data.type === undefined && (missing0 = 'type')) ||
          (data.fax === undefined && (missing0 = 'fax'))
        ) {
          const err0 = {
            instancePath,
            schemaPath: '#/definitions/FaxRecipient/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        } else {
          const _errs7 = errors;
          for (const key0 in data) {
            if (!(key0 === 'type' || key0 === 'id' || key0 === 'fax')) {
              const err1 = {
                instancePath,
                schemaPath: '#/definitions/FaxRecipient/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
              break;
            }
          }
          if (_errs7 === errors) {
            if (data.type !== undefined) {
              const _errs8 = errors;
              if (!func0(data.type, 'fax')) {
                const err2 = {
                  instancePath: instancePath + '/type',
                  schemaPath:
                    '#/definitions/FaxRecipient/properties/type/const',
                  keyword: 'const',
                  params: { allowedValue: 'fax' },
                  message: 'must be equal to constant',
                };
                if (vErrors === null) {
                  vErrors = [err2];
                } else {
                  vErrors.push(err2);
                }
                errors++;
              }
              var valid2 = _errs8 === errors;
            } else {
              var valid2 = true;
            }
            if (valid2) {
              if (data.id !== undefined) {
                const _errs9 = errors;
                if (typeof data.id !== 'string') {
                  const err3 = {
                    instancePath: instancePath + '/id',
                    schemaPath: '#/definitions/FaxRecipient/properties/id/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  };
                  if (vErrors === null) {
                    vErrors = [err3];
                  } else {
                    vErrors.push(err3);
                  }
                  errors++;
                }
                var valid2 = _errs9 === errors;
              } else {
                var valid2 = true;
              }
              if (valid2) {
                if (data.fax !== undefined) {
                  const _errs11 = errors;
                  if (typeof data.fax !== 'string') {
                    const err4 = {
                      instancePath: instancePath + '/fax',
                      schemaPath:
                        '#/definitions/FaxRecipient/properties/fax/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    };
                    if (vErrors === null) {
                      vErrors = [err4];
                    } else {
                      vErrors.push(err4);
                    }
                    errors++;
                  }
                  var valid2 = _errs11 === errors;
                } else {
                  var valid2 = true;
                }
              }
            }
          }
        }
      } else {
        const err5 = {
          instancePath,
          schemaPath: '#/definitions/FaxRecipient/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    var _valid0 = _errs4 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
    }
  }
  if (!valid0) {
    const err6 = {
      instancePath,
      schemaPath: '#/oneOf',
      keyword: 'oneOf',
      params: { passingSchemas: passing0 },
      message: 'must match exactly one schema in oneOf',
    };
    if (vErrors === null) {
      vErrors = [err6];
    } else {
      vErrors.push(err6);
    }
    errors++;
    validate64.errors = vErrors;
    return false;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate64.errors = vErrors;
  return errors === 0;
}
const schema85 = {
  type: 'object',
  title: 'SignerOptions',
  properties: {
    fieldOptions: { $ref: '#/definitions/FieldOptions' },
    signatureType: { $ref: '#/definitions/SignatureType' },
  },
};
const schema86 = {
  type: 'object',
  title: 'FieldOptions',
  properties: { dateFormat: { $ref: 'Field.json#/definitions/JSDateFormat' } },
};
function validate72(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.dateFormat !== undefined) {
        let data0 = data.dateFormat;
        if (typeof data0 !== 'string') {
          validate72.errors = [
            {
              instancePath: instancePath + '/dateFormat',
              schemaPath: 'Field.json#/definitions/JSDateFormat/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            },
          ];
          return false;
        }
        if (
          !(
            data0 === 'default' ||
            data0 === 'MM / DD / YYYY' ||
            data0 === 'MM - DD - YYYY' ||
            data0 === 'DD / MM / YYYY' ||
            data0 === 'DD - MM - YYYY' ||
            data0 === 'YYYY / MM / DD' ||
            data0 === 'YYYY - MM - DD'
          )
        ) {
          validate72.errors = [
            {
              instancePath: instancePath + '/dateFormat',
              schemaPath: 'Field.json#/definitions/JSDateFormat/enum',
              keyword: 'enum',
              params: { allowedValues: schema33.enum },
              message: 'must be equal to one of the allowed values',
            },
          ];
          return false;
        }
      }
    } else {
      validate72.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate72.errors = vErrors;
  return errors === 0;
}
const schema88 = {
  type: 'object',
  title: 'SignatureType',
  properties: {
    default: { $ref: '#/definitions/SignatureTypes' },
    allowed: { type: 'array', items: { $ref: '#/definitions/SignatureTypes' } },
  },
};
const schema89 = {
  type: 'string',
  title: 'SignatureTypes',
  enum: ['draw', 'type', 'upload', 'phone'],
};
function validate74(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.default !== undefined) {
        let data0 = data.default;
        const _errs1 = errors;
        if (typeof data0 !== 'string') {
          validate74.errors = [
            {
              instancePath: instancePath + '/default',
              schemaPath: '#/definitions/SignatureTypes/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            },
          ];
          return false;
        }
        if (
          !(
            data0 === 'draw' ||
            data0 === 'type' ||
            data0 === 'upload' ||
            data0 === 'phone'
          )
        ) {
          validate74.errors = [
            {
              instancePath: instancePath + '/default',
              schemaPath: '#/definitions/SignatureTypes/enum',
              keyword: 'enum',
              params: { allowedValues: schema89.enum },
              message: 'must be equal to one of the allowed values',
            },
          ];
          return false;
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.allowed !== undefined) {
          let data1 = data.allowed;
          const _errs4 = errors;
          if (errors === _errs4) {
            if (Array.isArray(data1)) {
              var valid2 = true;
              const len0 = data1.length;
              for (let i0 = 0; i0 < len0; i0++) {
                let data2 = data1[i0];
                const _errs6 = errors;
                if (typeof data2 !== 'string') {
                  validate74.errors = [
                    {
                      instancePath: instancePath + '/allowed/' + i0,
                      schemaPath: '#/definitions/SignatureTypes/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                if (
                  !(
                    data2 === 'draw' ||
                    data2 === 'type' ||
                    data2 === 'upload' ||
                    data2 === 'phone'
                  )
                ) {
                  validate74.errors = [
                    {
                      instancePath: instancePath + '/allowed/' + i0,
                      schemaPath: '#/definitions/SignatureTypes/enum',
                      keyword: 'enum',
                      params: { allowedValues: schema89.enum },
                      message: 'must be equal to one of the allowed values',
                    },
                  ];
                  return false;
                }
                var valid2 = _errs6 === errors;
                if (!valid2) {
                  break;
                }
              }
            } else {
              validate74.errors = [
                {
                  instancePath: instancePath + '/allowed',
                  schemaPath: '#/properties/allowed/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs4 === errors;
        } else {
          var valid0 = true;
        }
      }
    } else {
      validate74.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate74.errors = vErrors;
  return errors === 0;
}
function validate71(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.fieldOptions !== undefined) {
        const _errs1 = errors;
        if (
          !validate72(data.fieldOptions, {
            instancePath: instancePath + '/fieldOptions',
            parentData: data,
            parentDataProperty: 'fieldOptions',
            rootData,
          })
        ) {
          vErrors =
            vErrors === null
              ? validate72.errors
              : vErrors.concat(validate72.errors);
          errors = vErrors.length;
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.signatureType !== undefined) {
          const _errs2 = errors;
          if (
            !validate74(data.signatureType, {
              instancePath: instancePath + '/signatureType',
              parentData: data,
              parentDataProperty: 'signatureType',
              rootData,
            })
          ) {
            vErrors =
              vErrors === null
                ? validate74.errors
                : vErrors.concat(validate74.errors);
            errors = vErrors.length;
          }
          var valid0 = _errs2 === errors;
        } else {
          var valid0 = true;
        }
      }
    } else {
      validate71.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate71.errors = vErrors;
  return errors === 0;
}
function validate48(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="EditorData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.pages === undefined && (missing0 = 'pages')) ||
        (data.fields === undefined && (missing0 = 'fields')) ||
        (data.mergeFields === undefined && (missing0 = 'mergeFields')) ||
        (data.pdfFields === undefined && (missing0 = 'pdfFields')) ||
        (data.editorOptions === undefined && (missing0 = 'editorOptions')) ||
        (data.rules === undefined && (missing0 = 'rules')) ||
        (data.transform === undefined && (missing0 = 'transform')) ||
        (data.signers === undefined && (missing0 = 'signers')) ||
        (data.documents === undefined && (missing0 = 'documents')) ||
        (data.signerOptions === undefined && (missing0 = 'signerOptions'))
      ) {
        validate48.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func4.call(schema62.properties, key0)) {
            validate48.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.pages !== undefined) {
            let data0 = data.pages;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (Array.isArray(data0)) {
                var valid1 = true;
                const len0 = data0.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  let data1 = data0[i0];
                  const _errs4 = errors;
                  const _errs5 = errors;
                  if (errors === _errs5) {
                    if (
                      data1 &&
                      typeof data1 == 'object' &&
                      !Array.isArray(data1)
                    ) {
                      let missing1;
                      if (
                        (data1.src === undefined && (missing1 = 'src')) ||
                        (data1.width === undefined && (missing1 = 'width')) ||
                        (data1.height === undefined && (missing1 = 'height')) ||
                        (data1.documentId === undefined &&
                          (missing1 = 'documentId')) ||
                        (data1.orientation === undefined &&
                          (missing1 = 'orientation')) ||
                        (data1.snapshotGuid === undefined &&
                          (missing1 = 'snapshotGuid'))
                      ) {
                        validate48.errors = [
                          {
                            instancePath: instancePath + '/pages/' + i0,
                            schemaPath: 'Page.json/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message:
                              "must have required property '" + missing1 + "'",
                          },
                        ];
                        return false;
                      } else {
                        const _errs7 = errors;
                        for (const key1 in data1) {
                          if (
                            !(
                              key1 === 'src' ||
                              key1 === 'width' ||
                              key1 === 'height' ||
                              key1 === 'documentId' ||
                              key1 === 'orientation' ||
                              key1 === 'snapshotGuid' ||
                              key1 === 'cdnSrc'
                            )
                          ) {
                            validate48.errors = [
                              {
                                instancePath: instancePath + '/pages/' + i0,
                                schemaPath: 'Page.json/additionalProperties',
                                keyword: 'additionalProperties',
                                params: { additionalProperty: key1 },
                                message: 'must NOT have additional properties',
                              },
                            ];
                            return false;
                            break;
                          }
                        }
                        if (_errs7 === errors) {
                          if (data1.src !== undefined) {
                            const _errs8 = errors;
                            if (typeof data1.src !== 'string') {
                              validate48.errors = [
                                {
                                  instancePath:
                                    instancePath + '/pages/' + i0 + '/src',
                                  schemaPath: 'Page.json/properties/src/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid3 = _errs8 === errors;
                          } else {
                            var valid3 = true;
                          }
                          if (valid3) {
                            if (data1.width !== undefined) {
                              let data3 = data1.width;
                              const _errs10 = errors;
                              if (
                                !(typeof data3 == 'number' && isFinite(data3))
                              ) {
                                validate48.errors = [
                                  {
                                    instancePath:
                                      instancePath + '/pages/' + i0 + '/width',
                                    schemaPath:
                                      'Page.json/properties/width/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number',
                                  },
                                ];
                                return false;
                              }
                              var valid3 = _errs10 === errors;
                            } else {
                              var valid3 = true;
                            }
                            if (valid3) {
                              if (data1.height !== undefined) {
                                let data4 = data1.height;
                                const _errs12 = errors;
                                if (
                                  !(typeof data4 == 'number' && isFinite(data4))
                                ) {
                                  validate48.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/pages/' +
                                        i0 +
                                        '/height',
                                      schemaPath:
                                        'Page.json/properties/height/type',
                                      keyword: 'type',
                                      params: { type: 'number' },
                                      message: 'must be number',
                                    },
                                  ];
                                  return false;
                                }
                                var valid3 = _errs12 === errors;
                              } else {
                                var valid3 = true;
                              }
                              if (valid3) {
                                if (data1.documentId !== undefined) {
                                  const _errs14 = errors;
                                  if (typeof data1.documentId !== 'string') {
                                    validate48.errors = [
                                      {
                                        instancePath:
                                          instancePath +
                                          '/pages/' +
                                          i0 +
                                          '/documentId',
                                        schemaPath:
                                          'Page.json/properties/documentId/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid3 = _errs14 === errors;
                                } else {
                                  var valid3 = true;
                                }
                                if (valid3) {
                                  if (data1.orientation !== undefined) {
                                    let data6 = data1.orientation;
                                    const _errs16 = errors;
                                    if (
                                      !(
                                        typeof data6 == 'number' &&
                                        !(data6 % 1) &&
                                        !isNaN(data6) &&
                                        isFinite(data6)
                                      )
                                    ) {
                                      validate48.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/pages/' +
                                            i0 +
                                            '/orientation',
                                          schemaPath:
                                            'Page.json/properties/orientation/type',
                                          keyword: 'type',
                                          params: { type: 'integer' },
                                          message: 'must be integer',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid3 = _errs16 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                  if (valid3) {
                                    if (data1.snapshotGuid !== undefined) {
                                      const _errs18 = errors;
                                      if (
                                        typeof data1.snapshotGuid !== 'string'
                                      ) {
                                        validate48.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/pages/' +
                                              i0 +
                                              '/snapshotGuid',
                                            schemaPath:
                                              'Page.json/properties/snapshotGuid/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid3 = _errs18 === errors;
                                    } else {
                                      var valid3 = true;
                                    }
                                    if (valid3) {
                                      if (data1.cdnSrc !== undefined) {
                                        let data8 = data1.cdnSrc;
                                        const _errs20 = errors;
                                        if (
                                          typeof data8 !== 'string' &&
                                          data8 !== null
                                        ) {
                                          validate48.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/pages/' +
                                                i0 +
                                                '/cdnSrc',
                                              schemaPath:
                                                'Page.json/properties/cdnSrc/type',
                                              keyword: 'type',
                                              params: {
                                                type: schema63.properties.cdnSrc
                                                  .type,
                                              },
                                              message: 'must be string,null',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid3 = _errs20 === errors;
                                      } else {
                                        var valid3 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    } else {
                      validate48.errors = [
                        {
                          instancePath: instancePath + '/pages/' + i0,
                          schemaPath: 'Page.json/type',
                          keyword: 'type',
                          params: { type: 'object' },
                          message: 'must be object',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid1 = _errs4 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate48.errors = [
                  {
                    instancePath: instancePath + '/pages',
                    schemaPath: '#/properties/pages/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                  },
                ];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.fields !== undefined) {
              let data9 = data.fields;
              const _errs22 = errors;
              if (errors === _errs22) {
                if (Array.isArray(data9)) {
                  var valid4 = true;
                  const len1 = data9.length;
                  for (let i1 = 0; i1 < len1; i1++) {
                    const _errs24 = errors;
                    if (
                      !validate13(data9[i1], {
                        instancePath: instancePath + '/fields/' + i1,
                        parentData: data9,
                        parentDataProperty: i1,
                        rootData,
                      })
                    ) {
                      vErrors =
                        vErrors === null
                          ? validate13.errors
                          : vErrors.concat(validate13.errors);
                      errors = vErrors.length;
                    }
                    var valid4 = _errs24 === errors;
                    if (!valid4) {
                      break;
                    }
                  }
                } else {
                  validate48.errors = [
                    {
                      instancePath: instancePath + '/fields',
                      schemaPath: '#/properties/fields/type',
                      keyword: 'type',
                      params: { type: 'array' },
                      message: 'must be array',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs22 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.mergeFields !== undefined) {
                let data11 = data.mergeFields;
                const _errs25 = errors;
                if (errors === _errs25) {
                  if (Array.isArray(data11)) {
                    var valid5 = true;
                    const len2 = data11.length;
                    for (let i2 = 0; i2 < len2; i2++) {
                      const _errs27 = errors;
                      if (
                        !validate13(data11[i2], {
                          instancePath: instancePath + '/mergeFields/' + i2,
                          parentData: data11,
                          parentDataProperty: i2,
                          rootData,
                        })
                      ) {
                        vErrors =
                          vErrors === null
                            ? validate13.errors
                            : vErrors.concat(validate13.errors);
                        errors = vErrors.length;
                      }
                      var valid5 = _errs27 === errors;
                      if (!valid5) {
                        break;
                      }
                    }
                  } else {
                    validate48.errors = [
                      {
                        instancePath: instancePath + '/mergeFields',
                        schemaPath: '#/properties/mergeFields/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs25 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.pdfFields !== undefined) {
                  let data13 = data.pdfFields;
                  const _errs28 = errors;
                  if (errors === _errs28) {
                    if (Array.isArray(data13)) {
                      var valid6 = true;
                      const len3 = data13.length;
                      for (let i3 = 0; i3 < len3; i3++) {
                        const _errs30 = errors;
                        if (
                          !validate13(data13[i3], {
                            instancePath: instancePath + '/pdfFields/' + i3,
                            parentData: data13,
                            parentDataProperty: i3,
                            rootData,
                          })
                        ) {
                          vErrors =
                            vErrors === null
                              ? validate13.errors
                              : vErrors.concat(validate13.errors);
                          errors = vErrors.length;
                        }
                        var valid6 = _errs30 === errors;
                        if (!valid6) {
                          break;
                        }
                      }
                    } else {
                      validate48.errors = [
                        {
                          instancePath: instancePath + '/pdfFields',
                          schemaPath: '#/properties/pdfFields/type',
                          keyword: 'type',
                          params: { type: 'array' },
                          message: 'must be array',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs28 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.editorFeatures !== undefined) {
                    let data15 = data.editorFeatures;
                    const _errs31 = errors;
                    if (errors === _errs31) {
                      if (Array.isArray(data15)) {
                        var valid7 = true;
                        const len4 = data15.length;
                        for (let i4 = 0; i4 < len4; i4++) {
                          const _errs33 = errors;
                          if (typeof data15[i4] !== 'string') {
                            validate48.errors = [
                              {
                                instancePath:
                                  instancePath + '/editorFeatures/' + i4,
                                schemaPath:
                                  '#/properties/editorFeatures/items/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid7 = _errs33 === errors;
                          if (!valid7) {
                            break;
                          }
                        }
                      } else {
                        validate48.errors = [
                          {
                            instancePath: instancePath + '/editorFeatures',
                            schemaPath: '#/properties/editorFeatures/type',
                            keyword: 'type',
                            params: { type: 'array' },
                            message: 'must be array',
                          },
                        ];
                        return false;
                      }
                    }
                    var valid0 = _errs31 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.rules !== undefined) {
                      let data17 = data.rules;
                      const _errs35 = errors;
                      if (errors === _errs35) {
                        if (Array.isArray(data17)) {
                          var valid8 = true;
                          const len5 = data17.length;
                          for (let i5 = 0; i5 < len5; i5++) {
                            const _errs37 = errors;
                            if (
                              !validate52(data17[i5], {
                                instancePath: instancePath + '/rules/' + i5,
                                parentData: data17,
                                parentDataProperty: i5,
                                rootData,
                              })
                            ) {
                              vErrors =
                                vErrors === null
                                  ? validate52.errors
                                  : vErrors.concat(validate52.errors);
                              errors = vErrors.length;
                            }
                            var valid8 = _errs37 === errors;
                            if (!valid8) {
                              break;
                            }
                          }
                        } else {
                          validate48.errors = [
                            {
                              instancePath: instancePath + '/rules',
                              schemaPath: '#/properties/rules/type',
                              keyword: 'type',
                              params: { type: 'array' },
                              message: 'must be array',
                            },
                          ];
                          return false;
                        }
                      }
                      var valid0 = _errs35 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.transform !== undefined) {
                        let data19 = data.transform;
                        const _errs38 = errors;
                        if (errors === _errs38) {
                          if (
                            data19 &&
                            typeof data19 == 'object' &&
                            !Array.isArray(data19)
                          ) {
                            let missing2;
                            if (
                              data19.rotate === undefined &&
                              (missing2 = 'rotate')
                            ) {
                              validate48.errors = [
                                {
                                  instancePath: instancePath + '/transform',
                                  schemaPath: '#/properties/transform/required',
                                  keyword: 'required',
                                  params: { missingProperty: missing2 },
                                  message:
                                    "must have required property '" +
                                    missing2 +
                                    "'",
                                },
                              ];
                              return false;
                            } else {
                              const _errs40 = errors;
                              for (const key2 in data19) {
                                if (!(key2 === 'rotate')) {
                                  validate48.errors = [
                                    {
                                      instancePath: instancePath + '/transform',
                                      schemaPath:
                                        '#/properties/transform/additionalProperties',
                                      keyword: 'additionalProperties',
                                      params: { additionalProperty: key2 },
                                      message:
                                        'must NOT have additional properties',
                                    },
                                  ];
                                  return false;
                                  break;
                                }
                              }
                              if (_errs40 === errors) {
                                if (data19.rotate !== undefined) {
                                  let data20 = data19.rotate;
                                  if (
                                    !(
                                      typeof data20 == 'number' &&
                                      !(data20 % 1) &&
                                      !isNaN(data20) &&
                                      isFinite(data20)
                                    )
                                  ) {
                                    validate48.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/transform/rotate',
                                        schemaPath:
                                          '#/properties/transform/properties/rotate/type',
                                        keyword: 'type',
                                        params: { type: 'integer' },
                                        message: 'must be integer',
                                      },
                                    ];
                                    return false;
                                  }
                                }
                              }
                            }
                          } else {
                            validate48.errors = [
                              {
                                instancePath: instancePath + '/transform',
                                schemaPath: '#/properties/transform/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object',
                              },
                            ];
                            return false;
                          }
                        }
                        var valid0 = _errs38 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.documents !== undefined) {
                          let data21 = data.documents;
                          const _errs43 = errors;
                          if (errors === _errs43) {
                            if (Array.isArray(data21)) {
                              var valid10 = true;
                              const len6 = data21.length;
                              for (let i6 = 0; i6 < len6; i6++) {
                                let data22 = data21[i6];
                                const _errs45 = errors;
                                const _errs46 = errors;
                                if (errors === _errs46) {
                                  if (
                                    data22 &&
                                    typeof data22 == 'object' &&
                                    !Array.isArray(data22)
                                  ) {
                                    let missing3;
                                    if (
                                      (data22.id === undefined &&
                                        (missing3 = 'id')) ||
                                      (data22.name === undefined &&
                                        (missing3 = 'name')) ||
                                      (data22.editable === undefined &&
                                        (missing3 = 'editable')) ||
                                      (data22.snapshotGuid === undefined &&
                                        (missing3 = 'snapshotGuid'))
                                    ) {
                                      validate48.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/documents/' + i6,
                                          schemaPath:
                                            '#/definitions/Document/required',
                                          keyword: 'required',
                                          params: { missingProperty: missing3 },
                                          message:
                                            "must have required property '" +
                                            missing3 +
                                            "'",
                                        },
                                      ];
                                      return false;
                                    } else {
                                      const _errs48 = errors;
                                      for (const key3 in data22) {
                                        if (
                                          !(
                                            key3 === 'id' ||
                                            key3 === 'name' ||
                                            key3 === 'editable' ||
                                            key3 === 'snapshotGuid'
                                          )
                                        ) {
                                          validate48.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/documents/' +
                                                i6,
                                              schemaPath:
                                                '#/definitions/Document/additionalProperties',
                                              keyword: 'additionalProperties',
                                              params: {
                                                additionalProperty: key3,
                                              },
                                              message:
                                                'must NOT have additional properties',
                                            },
                                          ];
                                          return false;
                                          break;
                                        }
                                      }
                                      if (_errs48 === errors) {
                                        if (data22.id !== undefined) {
                                          const _errs49 = errors;
                                          if (typeof data22.id !== 'string') {
                                            validate48.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/documents/' +
                                                  i6 +
                                                  '/id',
                                                schemaPath:
                                                  '#/definitions/Document/properties/id/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid12 = _errs49 === errors;
                                        } else {
                                          var valid12 = true;
                                        }
                                        if (valid12) {
                                          if (data22.name !== undefined) {
                                            const _errs51 = errors;
                                            if (
                                              typeof data22.name !== 'string'
                                            ) {
                                              validate48.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/documents/' +
                                                    i6 +
                                                    '/name',
                                                  schemaPath:
                                                    '#/definitions/Document/properties/name/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid12 = _errs51 === errors;
                                          } else {
                                            var valid12 = true;
                                          }
                                          if (valid12) {
                                            if (data22.editable !== undefined) {
                                              const _errs53 = errors;
                                              if (
                                                typeof data22.editable !==
                                                'boolean'
                                              ) {
                                                validate48.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/documents/' +
                                                      i6 +
                                                      '/editable',
                                                    schemaPath:
                                                      '#/definitions/Document/properties/editable/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid12 = _errs53 === errors;
                                            } else {
                                              var valid12 = true;
                                            }
                                            if (valid12) {
                                              if (
                                                data22.snapshotGuid !==
                                                undefined
                                              ) {
                                                const _errs55 = errors;
                                                if (
                                                  typeof data22.snapshotGuid !==
                                                  'string'
                                                ) {
                                                  validate48.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/documents/' +
                                                        i6 +
                                                        '/snapshotGuid',
                                                      schemaPath:
                                                        '#/definitions/Document/properties/snapshotGuid/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'string',
                                                      },
                                                      message: 'must be string',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid12 =
                                                  _errs55 === errors;
                                              } else {
                                                var valid12 = true;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  } else {
                                    validate48.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/documents/' + i6,
                                        schemaPath:
                                          '#/definitions/Document/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object',
                                      },
                                    ];
                                    return false;
                                  }
                                }
                                var valid10 = _errs45 === errors;
                                if (!valid10) {
                                  break;
                                }
                              }
                            } else {
                              validate48.errors = [
                                {
                                  instancePath: instancePath + '/documents',
                                  schemaPath: '#/properties/documents/type',
                                  keyword: 'type',
                                  params: { type: 'array' },
                                  message: 'must be array',
                                },
                              ];
                              return false;
                            }
                          }
                          var valid0 = _errs43 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.signers !== undefined) {
                            let data27 = data.signers;
                            const _errs57 = errors;
                            if (errors === _errs57) {
                              if (Array.isArray(data27)) {
                                var valid13 = true;
                                const len7 = data27.length;
                                for (let i7 = 0; i7 < len7; i7++) {
                                  const _errs59 = errors;
                                  if (
                                    !validate64(data27[i7], {
                                      instancePath:
                                        instancePath + '/signers/' + i7,
                                      parentData: data27,
                                      parentDataProperty: i7,
                                      rootData,
                                    })
                                  ) {
                                    vErrors =
                                      vErrors === null
                                        ? validate64.errors
                                        : vErrors.concat(validate64.errors);
                                    errors = vErrors.length;
                                  }
                                  var valid13 = _errs59 === errors;
                                  if (!valid13) {
                                    break;
                                  }
                                }
                              } else {
                                validate48.errors = [
                                  {
                                    instancePath: instancePath + '/signers',
                                    schemaPath: '#/properties/signers/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array',
                                  },
                                ];
                                return false;
                              }
                            }
                            var valid0 = _errs57 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.signerOptions !== undefined) {
                              const _errs60 = errors;
                              if (
                                !validate71(data.signerOptions, {
                                  instancePath: instancePath + '/signerOptions',
                                  parentData: data,
                                  parentDataProperty: 'signerOptions',
                                  rootData,
                                })
                              ) {
                                vErrors =
                                  vErrors === null
                                    ? validate71.errors
                                    : vErrors.concat(validate71.errors);
                                errors = vErrors.length;
                              }
                              var valid0 = _errs60 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.editorOptions !== undefined) {
                                let data30 = data.editorOptions;
                                const _errs61 = errors;
                                const _errs62 = errors;
                                if (errors === _errs62) {
                                  if (
                                    data30 &&
                                    typeof data30 == 'object' &&
                                    !Array.isArray(data30)
                                  ) {
                                    let missing4;
                                    if (
                                      (data30.allowEditSigners === undefined &&
                                        (missing4 = 'allowEditSigners')) ||
                                      (data30.allowEditDocuments ===
                                        undefined &&
                                        (missing4 = 'allowEditDocuments')) ||
                                      (data30.canUseCustomRegexDataValidation ===
                                        undefined &&
                                        (missing4 =
                                          'canUseCustomRegexDataValidation')) ||
                                      (data30.canUseDataValidation ===
                                        undefined &&
                                        (missing4 = 'canUseDataValidation'))
                                    ) {
                                      validate48.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/editorOptions',
                                          schemaPath:
                                            '#/definitions/EditorOptions/required',
                                          keyword: 'required',
                                          params: { missingProperty: missing4 },
                                          message:
                                            "must have required property '" +
                                            missing4 +
                                            "'",
                                        },
                                      ];
                                      return false;
                                    } else {
                                      if (
                                        data30.allowEditSigners !== undefined
                                      ) {
                                        const _errs64 = errors;
                                        if (
                                          typeof data30.allowEditSigners !==
                                          'boolean'
                                        ) {
                                          validate48.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/editorOptions/allowEditSigners',
                                              schemaPath:
                                                '#/definitions/EditorOptions/properties/allowEditSigners/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid15 = _errs64 === errors;
                                      } else {
                                        var valid15 = true;
                                      }
                                      if (valid15) {
                                        if (
                                          data30.allowEditDocuments !==
                                          undefined
                                        ) {
                                          const _errs66 = errors;
                                          if (
                                            typeof data30.allowEditDocuments !==
                                            'boolean'
                                          ) {
                                            validate48.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/editorOptions/allowEditDocuments',
                                                schemaPath:
                                                  '#/definitions/EditorOptions/properties/allowEditDocuments/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid15 = _errs66 === errors;
                                        } else {
                                          var valid15 = true;
                                        }
                                        if (valid15) {
                                          if (
                                            data30.canUseCustomRegexDataValidation !==
                                            undefined
                                          ) {
                                            const _errs68 = errors;
                                            if (
                                              typeof data30.canUseCustomRegexDataValidation !==
                                              'boolean'
                                            ) {
                                              validate48.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/editorOptions/canUseCustomRegexDataValidation',
                                                  schemaPath:
                                                    '#/definitions/EditorOptions/properties/canUseCustomRegexDataValidation/type',
                                                  keyword: 'type',
                                                  params: { type: 'boolean' },
                                                  message: 'must be boolean',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid15 = _errs68 === errors;
                                          } else {
                                            var valid15 = true;
                                          }
                                          if (valid15) {
                                            if (
                                              data30.canUseDataValidation !==
                                              undefined
                                            ) {
                                              const _errs70 = errors;
                                              if (
                                                typeof data30.canUseDataValidation !==
                                                'boolean'
                                              ) {
                                                validate48.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/editorOptions/canUseDataValidation',
                                                    schemaPath:
                                                      '#/definitions/EditorOptions/properties/canUseDataValidation/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid15 = _errs70 === errors;
                                            } else {
                                              var valid15 = true;
                                            }
                                          }
                                        }
                                      }
                                    }
                                  } else {
                                    validate48.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/editorOptions',
                                        schemaPath:
                                          '#/definitions/EditorOptions/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object',
                                      },
                                    ];
                                    return false;
                                  }
                                }
                                var valid0 = _errs61 === errors;
                              } else {
                                var valid0 = true;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate48.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate48.errors = vErrors;
  return errors === 0;
}
const schema92 = {
  type: 'object',
  title: 'CCEmail',
  additionalProperties: false,
  properties: {
    type: { const: 'ccEmail', default: 'ccEmail' },
    id: { type: 'string' },
    email: { type: 'string' },
    role: { $ref: '#/definitions/CCRole' },
  },
  required: ['type', 'id', 'email'],
};
function validate79(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.type === undefined && (missing0 = 'type')) ||
        (data.id === undefined && (missing0 = 'id')) ||
        (data.email === undefined && (missing0 = 'email'))
      ) {
        validate79.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (
            !(
              key0 === 'type' ||
              key0 === 'id' ||
              key0 === 'email' ||
              key0 === 'role'
            )
          ) {
            validate79.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.type !== undefined) {
            const _errs2 = errors;
            if (!func0(data.type, 'ccEmail')) {
              validate79.errors = [
                {
                  instancePath: instancePath + '/type',
                  schemaPath: '#/properties/type/const',
                  keyword: 'const',
                  params: { allowedValue: 'ccEmail' },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.id !== undefined) {
              const _errs3 = errors;
              if (typeof data.id !== 'string') {
                validate79.errors = [
                  {
                    instancePath: instancePath + '/id',
                    schemaPath: '#/properties/id/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.email !== undefined) {
                const _errs5 = errors;
                if (typeof data.email !== 'string') {
                  validate79.errors = [
                    {
                      instancePath: instancePath + '/email',
                      schemaPath: '#/properties/email/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.role !== undefined) {
                  let data3 = data.role;
                  const _errs7 = errors;
                  const _errs8 = errors;
                  if (errors === _errs8) {
                    if (
                      data3 &&
                      typeof data3 == 'object' &&
                      !Array.isArray(data3)
                    ) {
                      let missing1;
                      if (
                        (data3.type === undefined && (missing1 = 'type')) ||
                        (data3.id === undefined && (missing1 = 'id')) ||
                        (data3.name === undefined && (missing1 = 'name'))
                      ) {
                        validate79.errors = [
                          {
                            instancePath: instancePath + '/role',
                            schemaPath: '#/definitions/CCRole/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message:
                              "must have required property '" + missing1 + "'",
                          },
                        ];
                        return false;
                      } else {
                        const _errs10 = errors;
                        for (const key1 in data3) {
                          if (
                            !(
                              key1 === 'type' ||
                              key1 === 'id' ||
                              key1 === 'name'
                            )
                          ) {
                            validate79.errors = [
                              {
                                instancePath: instancePath + '/role',
                                schemaPath:
                                  '#/definitions/CCRole/additionalProperties',
                                keyword: 'additionalProperties',
                                params: { additionalProperty: key1 },
                                message: 'must NOT have additional properties',
                              },
                            ];
                            return false;
                            break;
                          }
                        }
                        if (_errs10 === errors) {
                          if (data3.type !== undefined) {
                            const _errs11 = errors;
                            if (!func0(data3.type, 'ccRole')) {
                              validate79.errors = [
                                {
                                  instancePath: instancePath + '/role/type',
                                  schemaPath:
                                    '#/definitions/CCRole/properties/type/const',
                                  keyword: 'const',
                                  params: { allowedValue: 'ccRole' },
                                  message: 'must be equal to constant',
                                },
                              ];
                              return false;
                            }
                            var valid2 = _errs11 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data3.id !== undefined) {
                              const _errs12 = errors;
                              if (typeof data3.id !== 'string') {
                                validate79.errors = [
                                  {
                                    instancePath: instancePath + '/role/id',
                                    schemaPath:
                                      '#/definitions/CCRole/properties/id/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid2 = _errs12 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data3.name !== undefined) {
                                const _errs14 = errors;
                                if (typeof data3.name !== 'string') {
                                  validate79.errors = [
                                    {
                                      instancePath: instancePath + '/role/name',
                                      schemaPath:
                                        '#/definitions/CCRole/properties/name/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid2 = _errs14 === errors;
                              } else {
                                var valid2 = true;
                              }
                            }
                          }
                        }
                      }
                    } else {
                      validate79.errors = [
                        {
                          instancePath: instancePath + '/role',
                          schemaPath: '#/definitions/CCRole/type',
                          keyword: 'type',
                          params: { type: 'object' },
                          message: 'must be object',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs7 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate79.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate79.errors = vErrors;
  return errors === 0;
}
const schema95 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'Template.json',
  title: 'Template',
  type: 'object',
  additionalProperties: false,
  properties: {
    guid: {
      type: 'string',
      $comment: 'This is the unique identifier for the template',
    },
    requestType: { type: 'number' },
    recipientReassignment: { type: 'boolean' },
    starred: { type: 'boolean' },
    recipientOrder: { type: 'boolean' },
    updated: { type: 'string' },
    dateFormat: { $ref: 'Field.json#/definitions/PHPDateFormat' },
    jsDateFormat: { $ref: 'Field.json#/definitions/JSDateFormat' },
    files: { type: 'array', items: { $ref: 'File.json' } },
    editorData: { $ref: 'EditorData.json' },
    recipients: { type: 'array', items: { $ref: 'Recipient.json' } },
    ccs: {
      type: 'array',
      items: {
        anyOf: [
          { $ref: 'Recipient.json#/definitions/CCRole' },
          { $ref: 'Recipient.json#/definitions/CCEmail' },
        ],
      },
    },
    title: { type: 'string' },
    message: { type: 'string' },
    locked: { type: 'boolean' },
    shortGuid: { type: 'string' },
    isOwner: { type: 'boolean' },
    isEditable: { type: 'boolean' },
    isDeletable: { type: 'boolean' },
    isEmbedded: { type: 'boolean' },
    isSalesforceCreated: { type: 'boolean' },
    linkDetails: { $ref: '#/definitions/LinkDetails' },
    createdBy: { $ref: '#/definitions/CreatedBy' },
  },
  required: [
    'requestType',
    'recipientReassignment',
    'recipientOrder',
    'dateFormat',
    'guid',
    'recipients',
    'title',
    'createdBy',
    'isOwner',
    'message',
  ],
  definitions: {
    LinkDetails: {
      type: 'object',
      title: 'LinkDetails',
      additionalProperties: false,
      properties: {
        shareableLink: { type: 'string' },
        inPersonLink: { type: 'string' },
        receiveSignedCopies: { type: 'boolean' },
      },
      required: ['receiveSignedCopies'],
    },
    CreatedBy: {
      type: 'object',
      title: 'CreatedBy',
      additionalProperties: false,
      properties: {
        name: { type: 'string' },
        email: { type: 'string' },
        date: { type: 'string' },
      },
      required: ['name', 'email', 'date'],
    },
  },
};
const schema96 = {
  type: 'string',
  title: 'PHPDateFormat',
  enum: [
    'Default',
    'm / d / Y',
    'm - d - Y',
    'd / m / Y',
    'd - m - Y',
    'Y / m / d',
    'Y - m - d',
  ],
  tsEnumNames: [
    'Default',
    'MMDDYYYYSeparatedBySlash',
    'MMDDYYYYSeparatedByHyphen',
    'DDMMYYYYSeparatedBySlash',
    'DDMMYYYYSeparatedByHyphen',
    'YYYYMMDDSeparatedBySlash',
    'YYYYMMDDSeparatedByHyphen',
  ],
  'x-enum-names': [
    'Default',
    'MMDDYYYYSeparatedBySlash',
    'MMDDYYYYSeparatedByHyphen',
    'DDMMYYYYSeparatedBySlash',
    'DDMMYYYYSeparatedByHyphen',
    'YYYYMMDDSeparatedBySlash',
    'YYYYMMDDSeparatedByHyphen',
  ],
};
const schema101 = {
  type: 'object',
  title: 'LinkDetails',
  additionalProperties: false,
  properties: {
    shareableLink: { type: 'string' },
    inPersonLink: { type: 'string' },
    receiveSignedCopies: { type: 'boolean' },
  },
  required: ['receiveSignedCopies'],
};
const schema102 = {
  type: 'object',
  title: 'CreatedBy',
  additionalProperties: false,
  properties: {
    name: { type: 'string' },
    email: { type: 'string' },
    date: { type: 'string' },
  },
  required: ['name', 'email', 'date'],
};
function validate85(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.type === undefined && (missing0 = 'type')) ||
        (data.id === undefined && (missing0 = 'id')) ||
        (data.email === undefined && (missing0 = 'email'))
      ) {
        validate85.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (
            !(
              key0 === 'type' ||
              key0 === 'id' ||
              key0 === 'email' ||
              key0 === 'role'
            )
          ) {
            validate85.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.type !== undefined) {
            const _errs2 = errors;
            if (!func0(data.type, 'ccEmail')) {
              validate85.errors = [
                {
                  instancePath: instancePath + '/type',
                  schemaPath: '#/properties/type/const',
                  keyword: 'const',
                  params: { allowedValue: 'ccEmail' },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.id !== undefined) {
              const _errs3 = errors;
              if (typeof data.id !== 'string') {
                validate85.errors = [
                  {
                    instancePath: instancePath + '/id',
                    schemaPath: '#/properties/id/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.email !== undefined) {
                const _errs5 = errors;
                if (typeof data.email !== 'string') {
                  validate85.errors = [
                    {
                      instancePath: instancePath + '/email',
                      schemaPath: '#/properties/email/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.role !== undefined) {
                  let data3 = data.role;
                  const _errs7 = errors;
                  const _errs8 = errors;
                  if (errors === _errs8) {
                    if (
                      data3 &&
                      typeof data3 == 'object' &&
                      !Array.isArray(data3)
                    ) {
                      let missing1;
                      if (
                        (data3.type === undefined && (missing1 = 'type')) ||
                        (data3.id === undefined && (missing1 = 'id')) ||
                        (data3.name === undefined && (missing1 = 'name'))
                      ) {
                        validate85.errors = [
                          {
                            instancePath: instancePath + '/role',
                            schemaPath: '#/definitions/CCRole/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message:
                              "must have required property '" + missing1 + "'",
                          },
                        ];
                        return false;
                      } else {
                        const _errs10 = errors;
                        for (const key1 in data3) {
                          if (
                            !(
                              key1 === 'type' ||
                              key1 === 'id' ||
                              key1 === 'name'
                            )
                          ) {
                            validate85.errors = [
                              {
                                instancePath: instancePath + '/role',
                                schemaPath:
                                  '#/definitions/CCRole/additionalProperties',
                                keyword: 'additionalProperties',
                                params: { additionalProperty: key1 },
                                message: 'must NOT have additional properties',
                              },
                            ];
                            return false;
                            break;
                          }
                        }
                        if (_errs10 === errors) {
                          if (data3.type !== undefined) {
                            const _errs11 = errors;
                            if (!func0(data3.type, 'ccRole')) {
                              validate85.errors = [
                                {
                                  instancePath: instancePath + '/role/type',
                                  schemaPath:
                                    '#/definitions/CCRole/properties/type/const',
                                  keyword: 'const',
                                  params: { allowedValue: 'ccRole' },
                                  message: 'must be equal to constant',
                                },
                              ];
                              return false;
                            }
                            var valid2 = _errs11 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data3.id !== undefined) {
                              const _errs12 = errors;
                              if (typeof data3.id !== 'string') {
                                validate85.errors = [
                                  {
                                    instancePath: instancePath + '/role/id',
                                    schemaPath:
                                      '#/definitions/CCRole/properties/id/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid2 = _errs12 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data3.name !== undefined) {
                                const _errs14 = errors;
                                if (typeof data3.name !== 'string') {
                                  validate85.errors = [
                                    {
                                      instancePath: instancePath + '/role/name',
                                      schemaPath:
                                        '#/definitions/CCRole/properties/name/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid2 = _errs14 === errors;
                              } else {
                                var valid2 = true;
                              }
                            }
                          }
                        }
                      }
                    } else {
                      validate85.errors = [
                        {
                          instancePath: instancePath + '/role',
                          schemaPath: '#/definitions/CCRole/type',
                          keyword: 'type',
                          params: { type: 'object' },
                          message: 'must be object',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs7 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate85.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate85.errors = vErrors;
  return errors === 0;
}
function validate81(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="Template.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.requestType === undefined && (missing0 = 'requestType')) ||
        (data.recipientReassignment === undefined &&
          (missing0 = 'recipientReassignment')) ||
        (data.recipientOrder === undefined && (missing0 = 'recipientOrder')) ||
        (data.dateFormat === undefined && (missing0 = 'dateFormat')) ||
        (data.guid === undefined && (missing0 = 'guid')) ||
        (data.recipients === undefined && (missing0 = 'recipients')) ||
        (data.title === undefined && (missing0 = 'title')) ||
        (data.createdBy === undefined && (missing0 = 'createdBy')) ||
        (data.isOwner === undefined && (missing0 = 'isOwner')) ||
        (data.message === undefined && (missing0 = 'message'))
      ) {
        validate81.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func4.call(schema95.properties, key0)) {
            validate81.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.guid !== undefined) {
            const _errs2 = errors;
            if (typeof data.guid !== 'string') {
              validate81.errors = [
                {
                  instancePath: instancePath + '/guid',
                  schemaPath: '#/properties/guid/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.requestType !== undefined) {
              let data1 = data.requestType;
              const _errs5 = errors;
              if (!(typeof data1 == 'number' && isFinite(data1))) {
                validate81.errors = [
                  {
                    instancePath: instancePath + '/requestType',
                    schemaPath: '#/properties/requestType/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.recipientReassignment !== undefined) {
                const _errs7 = errors;
                if (typeof data.recipientReassignment !== 'boolean') {
                  validate81.errors = [
                    {
                      instancePath: instancePath + '/recipientReassignment',
                      schemaPath: '#/properties/recipientReassignment/type',
                      keyword: 'type',
                      params: { type: 'boolean' },
                      message: 'must be boolean',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.starred !== undefined) {
                  const _errs9 = errors;
                  if (typeof data.starred !== 'boolean') {
                    validate81.errors = [
                      {
                        instancePath: instancePath + '/starred',
                        schemaPath: '#/properties/starred/type',
                        keyword: 'type',
                        params: { type: 'boolean' },
                        message: 'must be boolean',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.recipientOrder !== undefined) {
                    const _errs11 = errors;
                    if (typeof data.recipientOrder !== 'boolean') {
                      validate81.errors = [
                        {
                          instancePath: instancePath + '/recipientOrder',
                          schemaPath: '#/properties/recipientOrder/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.updated !== undefined) {
                      const _errs13 = errors;
                      if (typeof data.updated !== 'string') {
                        validate81.errors = [
                          {
                            instancePath: instancePath + '/updated',
                            schemaPath: '#/properties/updated/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.dateFormat !== undefined) {
                        let data6 = data.dateFormat;
                        const _errs15 = errors;
                        if (typeof data6 !== 'string') {
                          validate81.errors = [
                            {
                              instancePath: instancePath + '/dateFormat',
                              schemaPath:
                                'Field.json#/definitions/PHPDateFormat/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        if (
                          !(
                            data6 === 'Default' ||
                            data6 === 'm / d / Y' ||
                            data6 === 'm - d - Y' ||
                            data6 === 'd / m / Y' ||
                            data6 === 'd - m - Y' ||
                            data6 === 'Y / m / d' ||
                            data6 === 'Y - m - d'
                          )
                        ) {
                          validate81.errors = [
                            {
                              instancePath: instancePath + '/dateFormat',
                              schemaPath:
                                'Field.json#/definitions/PHPDateFormat/enum',
                              keyword: 'enum',
                              params: { allowedValues: schema96.enum },
                              message:
                                'must be equal to one of the allowed values',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.jsDateFormat !== undefined) {
                          let data7 = data.jsDateFormat;
                          const _errs18 = errors;
                          if (typeof data7 !== 'string') {
                            validate81.errors = [
                              {
                                instancePath: instancePath + '/jsDateFormat',
                                schemaPath:
                                  'Field.json#/definitions/JSDateFormat/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          if (
                            !(
                              data7 === 'default' ||
                              data7 === 'MM / DD / YYYY' ||
                              data7 === 'MM - DD - YYYY' ||
                              data7 === 'DD / MM / YYYY' ||
                              data7 === 'DD - MM - YYYY' ||
                              data7 === 'YYYY / MM / DD' ||
                              data7 === 'YYYY - MM - DD'
                            )
                          ) {
                            validate81.errors = [
                              {
                                instancePath: instancePath + '/jsDateFormat',
                                schemaPath:
                                  'Field.json#/definitions/JSDateFormat/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema33.enum },
                                message:
                                  'must be equal to one of the allowed values',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs18 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.files !== undefined) {
                            let data8 = data.files;
                            const _errs21 = errors;
                            if (errors === _errs21) {
                              if (Array.isArray(data8)) {
                                var valid3 = true;
                                const len0 = data8.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                  const _errs23 = errors;
                                  if (
                                    !validate45(data8[i0], {
                                      instancePath:
                                        instancePath + '/files/' + i0,
                                      parentData: data8,
                                      parentDataProperty: i0,
                                      rootData,
                                    })
                                  ) {
                                    vErrors =
                                      vErrors === null
                                        ? validate45.errors
                                        : vErrors.concat(validate45.errors);
                                    errors = vErrors.length;
                                  }
                                  var valid3 = _errs23 === errors;
                                  if (!valid3) {
                                    break;
                                  }
                                }
                              } else {
                                validate81.errors = [
                                  {
                                    instancePath: instancePath + '/files',
                                    schemaPath: '#/properties/files/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array',
                                  },
                                ];
                                return false;
                              }
                            }
                            var valid0 = _errs21 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.editorData !== undefined) {
                              const _errs24 = errors;
                              if (
                                !validate48(data.editorData, {
                                  instancePath: instancePath + '/editorData',
                                  parentData: data,
                                  parentDataProperty: 'editorData',
                                  rootData,
                                })
                              ) {
                                vErrors =
                                  vErrors === null
                                    ? validate48.errors
                                    : vErrors.concat(validate48.errors);
                                errors = vErrors.length;
                              }
                              var valid0 = _errs24 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.recipients !== undefined) {
                                let data11 = data.recipients;
                                const _errs25 = errors;
                                if (errors === _errs25) {
                                  if (Array.isArray(data11)) {
                                    var valid4 = true;
                                    const len1 = data11.length;
                                    for (let i1 = 0; i1 < len1; i1++) {
                                      const _errs27 = errors;
                                      if (
                                        !validate64(data11[i1], {
                                          instancePath:
                                            instancePath + '/recipients/' + i1,
                                          parentData: data11,
                                          parentDataProperty: i1,
                                          rootData,
                                        })
                                      ) {
                                        vErrors =
                                          vErrors === null
                                            ? validate64.errors
                                            : vErrors.concat(validate64.errors);
                                        errors = vErrors.length;
                                      }
                                      var valid4 = _errs27 === errors;
                                      if (!valid4) {
                                        break;
                                      }
                                    }
                                  } else {
                                    validate81.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/recipients',
                                        schemaPath:
                                          '#/properties/recipients/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array',
                                      },
                                    ];
                                    return false;
                                  }
                                }
                                var valid0 = _errs25 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.ccs !== undefined) {
                                  let data13 = data.ccs;
                                  const _errs28 = errors;
                                  if (errors === _errs28) {
                                    if (Array.isArray(data13)) {
                                      var valid5 = true;
                                      const len2 = data13.length;
                                      for (let i2 = 0; i2 < len2; i2++) {
                                        let data14 = data13[i2];
                                        const _errs30 = errors;
                                        const _errs31 = errors;
                                        let valid6 = false;
                                        const _errs32 = errors;
                                        const _errs33 = errors;
                                        if (errors === _errs33) {
                                          if (
                                            data14 &&
                                            typeof data14 == 'object' &&
                                            !Array.isArray(data14)
                                          ) {
                                            let missing1;
                                            if (
                                              (data14.type === undefined &&
                                                (missing1 = 'type')) ||
                                              (data14.id === undefined &&
                                                (missing1 = 'id')) ||
                                              (data14.name === undefined &&
                                                (missing1 = 'name'))
                                            ) {
                                              const err0 = {
                                                instancePath:
                                                  instancePath + '/ccs/' + i2,
                                                schemaPath:
                                                  'Recipient.json#/definitions/CCRole/required',
                                                keyword: 'required',
                                                params: {
                                                  missingProperty: missing1,
                                                },
                                                message:
                                                  "must have required property '" +
                                                  missing1 +
                                                  "'",
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err0];
                                              } else {
                                                vErrors.push(err0);
                                              }
                                              errors++;
                                            } else {
                                              const _errs35 = errors;
                                              for (const key1 in data14) {
                                                if (
                                                  !(
                                                    key1 === 'type' ||
                                                    key1 === 'id' ||
                                                    key1 === 'name'
                                                  )
                                                ) {
                                                  const err1 = {
                                                    instancePath:
                                                      instancePath +
                                                      '/ccs/' +
                                                      i2,
                                                    schemaPath:
                                                      'Recipient.json#/definitions/CCRole/additionalProperties',
                                                    keyword:
                                                      'additionalProperties',
                                                    params: {
                                                      additionalProperty: key1,
                                                    },
                                                    message:
                                                      'must NOT have additional properties',
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err1];
                                                  } else {
                                                    vErrors.push(err1);
                                                  }
                                                  errors++;
                                                  break;
                                                }
                                              }
                                              if (_errs35 === errors) {
                                                if (data14.type !== undefined) {
                                                  const _errs36 = errors;
                                                  if (
                                                    !func0(
                                                      data14.type,
                                                      'ccRole'
                                                    )
                                                  ) {
                                                    const err2 = {
                                                      instancePath:
                                                        instancePath +
                                                        '/ccs/' +
                                                        i2 +
                                                        '/type',
                                                      schemaPath:
                                                        'Recipient.json#/definitions/CCRole/properties/type/const',
                                                      keyword: 'const',
                                                      params: {
                                                        allowedValue: 'ccRole',
                                                      },
                                                      message:
                                                        'must be equal to constant',
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err2];
                                                    } else {
                                                      vErrors.push(err2);
                                                    }
                                                    errors++;
                                                  }
                                                  var valid8 =
                                                    _errs36 === errors;
                                                } else {
                                                  var valid8 = true;
                                                }
                                                if (valid8) {
                                                  if (data14.id !== undefined) {
                                                    const _errs37 = errors;
                                                    if (
                                                      typeof data14.id !==
                                                      'string'
                                                    ) {
                                                      const err3 = {
                                                        instancePath:
                                                          instancePath +
                                                          '/ccs/' +
                                                          i2 +
                                                          '/id',
                                                        schemaPath:
                                                          'Recipient.json#/definitions/CCRole/properties/id/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'string',
                                                        },
                                                        message:
                                                          'must be string',
                                                      };
                                                      if (vErrors === null) {
                                                        vErrors = [err3];
                                                      } else {
                                                        vErrors.push(err3);
                                                      }
                                                      errors++;
                                                    }
                                                    var valid8 =
                                                      _errs37 === errors;
                                                  } else {
                                                    var valid8 = true;
                                                  }
                                                  if (valid8) {
                                                    if (
                                                      data14.name !== undefined
                                                    ) {
                                                      const _errs39 = errors;
                                                      if (
                                                        typeof data14.name !==
                                                        'string'
                                                      ) {
                                                        const err4 = {
                                                          instancePath:
                                                            instancePath +
                                                            '/ccs/' +
                                                            i2 +
                                                            '/name',
                                                          schemaPath:
                                                            'Recipient.json#/definitions/CCRole/properties/name/type',
                                                          keyword: 'type',
                                                          params: {
                                                            type: 'string',
                                                          },
                                                          message:
                                                            'must be string',
                                                        };
                                                        if (vErrors === null) {
                                                          vErrors = [err4];
                                                        } else {
                                                          vErrors.push(err4);
                                                        }
                                                        errors++;
                                                      }
                                                      var valid8 =
                                                        _errs39 === errors;
                                                    } else {
                                                      var valid8 = true;
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          } else {
                                            const err5 = {
                                              instancePath:
                                                instancePath + '/ccs/' + i2,
                                              schemaPath:
                                                'Recipient.json#/definitions/CCRole/type',
                                              keyword: 'type',
                                              params: { type: 'object' },
                                              message: 'must be object',
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err5];
                                            } else {
                                              vErrors.push(err5);
                                            }
                                            errors++;
                                          }
                                        }
                                        var _valid0 = _errs32 === errors;
                                        valid6 = valid6 || _valid0;
                                        if (!valid6) {
                                          const _errs41 = errors;
                                          if (
                                            !validate85(data14, {
                                              instancePath:
                                                instancePath + '/ccs/' + i2,
                                              parentData: data13,
                                              parentDataProperty: i2,
                                              rootData,
                                            })
                                          ) {
                                            vErrors =
                                              vErrors === null
                                                ? validate85.errors
                                                : vErrors.concat(
                                                    validate85.errors
                                                  );
                                            errors = vErrors.length;
                                          }
                                          var _valid0 = _errs41 === errors;
                                          valid6 = valid6 || _valid0;
                                        }
                                        if (!valid6) {
                                          const err6 = {
                                            instancePath:
                                              instancePath + '/ccs/' + i2,
                                            schemaPath:
                                              '#/properties/ccs/items/anyOf',
                                            keyword: 'anyOf',
                                            params: {},
                                            message:
                                              'must match a schema in anyOf',
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err6];
                                          } else {
                                            vErrors.push(err6);
                                          }
                                          errors++;
                                          validate81.errors = vErrors;
                                          return false;
                                        } else {
                                          errors = _errs31;
                                          if (vErrors !== null) {
                                            if (_errs31) {
                                              vErrors.length = _errs31;
                                            } else {
                                              vErrors = null;
                                            }
                                          }
                                        }
                                        var valid5 = _errs30 === errors;
                                        if (!valid5) {
                                          break;
                                        }
                                      }
                                    } else {
                                      validate81.errors = [
                                        {
                                          instancePath: instancePath + '/ccs',
                                          schemaPath: '#/properties/ccs/type',
                                          keyword: 'type',
                                          params: { type: 'array' },
                                          message: 'must be array',
                                        },
                                      ];
                                      return false;
                                    }
                                  }
                                  var valid0 = _errs28 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.title !== undefined) {
                                    const _errs42 = errors;
                                    if (typeof data.title !== 'string') {
                                      validate81.errors = [
                                        {
                                          instancePath: instancePath + '/title',
                                          schemaPath: '#/properties/title/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid0 = _errs42 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.message !== undefined) {
                                      const _errs44 = errors;
                                      if (typeof data.message !== 'string') {
                                        validate81.errors = [
                                          {
                                            instancePath:
                                              instancePath + '/message',
                                            schemaPath:
                                              '#/properties/message/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid0 = _errs44 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.locked !== undefined) {
                                        const _errs46 = errors;
                                        if (typeof data.locked !== 'boolean') {
                                          validate81.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/locked',
                                              schemaPath:
                                                '#/properties/locked/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid0 = _errs46 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (data.shortGuid !== undefined) {
                                          const _errs48 = errors;
                                          if (
                                            typeof data.shortGuid !== 'string'
                                          ) {
                                            validate81.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/shortGuid',
                                                schemaPath:
                                                  '#/properties/shortGuid/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid0 = _errs48 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                        if (valid0) {
                                          if (data.isOwner !== undefined) {
                                            const _errs50 = errors;
                                            if (
                                              typeof data.isOwner !== 'boolean'
                                            ) {
                                              validate81.errors = [
                                                {
                                                  instancePath:
                                                    instancePath + '/isOwner',
                                                  schemaPath:
                                                    '#/properties/isOwner/type',
                                                  keyword: 'type',
                                                  params: { type: 'boolean' },
                                                  message: 'must be boolean',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid0 = _errs50 === errors;
                                          } else {
                                            var valid0 = true;
                                          }
                                          if (valid0) {
                                            if (data.isEditable !== undefined) {
                                              const _errs52 = errors;
                                              if (
                                                typeof data.isEditable !==
                                                'boolean'
                                              ) {
                                                validate81.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/isEditable',
                                                    schemaPath:
                                                      '#/properties/isEditable/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid0 = _errs52 === errors;
                                            } else {
                                              var valid0 = true;
                                            }
                                            if (valid0) {
                                              if (
                                                data.isDeletable !== undefined
                                              ) {
                                                const _errs54 = errors;
                                                if (
                                                  typeof data.isDeletable !==
                                                  'boolean'
                                                ) {
                                                  validate81.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/isDeletable',
                                                      schemaPath:
                                                        '#/properties/isDeletable/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'boolean',
                                                      },
                                                      message:
                                                        'must be boolean',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid0 = _errs54 === errors;
                                              } else {
                                                var valid0 = true;
                                              }
                                              if (valid0) {
                                                if (
                                                  data.isEmbedded !== undefined
                                                ) {
                                                  const _errs56 = errors;
                                                  if (
                                                    typeof data.isEmbedded !==
                                                    'boolean'
                                                  ) {
                                                    validate81.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath +
                                                          '/isEmbedded',
                                                        schemaPath:
                                                          '#/properties/isEmbedded/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'boolean',
                                                        },
                                                        message:
                                                          'must be boolean',
                                                      },
                                                    ];
                                                    return false;
                                                  }
                                                  var valid0 =
                                                    _errs56 === errors;
                                                } else {
                                                  var valid0 = true;
                                                }
                                                if (valid0) {
                                                  if (
                                                    data.isSalesforceCreated !==
                                                    undefined
                                                  ) {
                                                    const _errs58 = errors;
                                                    if (
                                                      typeof data.isSalesforceCreated !==
                                                      'boolean'
                                                    ) {
                                                      validate81.errors = [
                                                        {
                                                          instancePath:
                                                            instancePath +
                                                            '/isSalesforceCreated',
                                                          schemaPath:
                                                            '#/properties/isSalesforceCreated/type',
                                                          keyword: 'type',
                                                          params: {
                                                            type: 'boolean',
                                                          },
                                                          message:
                                                            'must be boolean',
                                                        },
                                                      ];
                                                      return false;
                                                    }
                                                    var valid0 =
                                                      _errs58 === errors;
                                                  } else {
                                                    var valid0 = true;
                                                  }
                                                  if (valid0) {
                                                    if (
                                                      data.linkDetails !==
                                                      undefined
                                                    ) {
                                                      let data27 =
                                                        data.linkDetails;
                                                      const _errs60 = errors;
                                                      const _errs61 = errors;
                                                      if (errors === _errs61) {
                                                        if (
                                                          data27 &&
                                                          typeof data27 ==
                                                            'object' &&
                                                          !Array.isArray(data27)
                                                        ) {
                                                          let missing2;
                                                          if (
                                                            data27.receiveSignedCopies ===
                                                              undefined &&
                                                            (missing2 =
                                                              'receiveSignedCopies')
                                                          ) {
                                                            validate81.errors =
                                                              [
                                                                {
                                                                  instancePath:
                                                                    instancePath +
                                                                    '/linkDetails',
                                                                  schemaPath:
                                                                    '#/definitions/LinkDetails/required',
                                                                  keyword:
                                                                    'required',
                                                                  params: {
                                                                    missingProperty:
                                                                      missing2,
                                                                  },
                                                                  message:
                                                                    "must have required property '" +
                                                                    missing2 +
                                                                    "'",
                                                                },
                                                              ];
                                                            return false;
                                                          } else {
                                                            const _errs63 =
                                                              errors;
                                                            for (const key2 in data27) {
                                                              if (
                                                                !(
                                                                  key2 ===
                                                                    'shareableLink' ||
                                                                  key2 ===
                                                                    'inPersonLink' ||
                                                                  key2 ===
                                                                    'receiveSignedCopies'
                                                                )
                                                              ) {
                                                                validate81.errors =
                                                                  [
                                                                    {
                                                                      instancePath:
                                                                        instancePath +
                                                                        '/linkDetails',
                                                                      schemaPath:
                                                                        '#/definitions/LinkDetails/additionalProperties',
                                                                      keyword:
                                                                        'additionalProperties',
                                                                      params: {
                                                                        additionalProperty:
                                                                          key2,
                                                                      },
                                                                      message:
                                                                        'must NOT have additional properties',
                                                                    },
                                                                  ];
                                                                return false;
                                                                break;
                                                              }
                                                            }
                                                            if (
                                                              _errs63 === errors
                                                            ) {
                                                              if (
                                                                data27.shareableLink !==
                                                                undefined
                                                              ) {
                                                                const _errs64 =
                                                                  errors;
                                                                if (
                                                                  typeof data27.shareableLink !==
                                                                  'string'
                                                                ) {
                                                                  validate81.errors =
                                                                    [
                                                                      {
                                                                        instancePath:
                                                                          instancePath +
                                                                          '/linkDetails/shareableLink',
                                                                        schemaPath:
                                                                          '#/definitions/LinkDetails/properties/shareableLink/type',
                                                                        keyword:
                                                                          'type',
                                                                        params:
                                                                          {
                                                                            type: 'string',
                                                                          },
                                                                        message:
                                                                          'must be string',
                                                                      },
                                                                    ];
                                                                  return false;
                                                                }
                                                                var valid10 =
                                                                  _errs64 ===
                                                                  errors;
                                                              } else {
                                                                var valid10 = true;
                                                              }
                                                              if (valid10) {
                                                                if (
                                                                  data27.inPersonLink !==
                                                                  undefined
                                                                ) {
                                                                  const _errs66 =
                                                                    errors;
                                                                  if (
                                                                    typeof data27.inPersonLink !==
                                                                    'string'
                                                                  ) {
                                                                    validate81.errors =
                                                                      [
                                                                        {
                                                                          instancePath:
                                                                            instancePath +
                                                                            '/linkDetails/inPersonLink',
                                                                          schemaPath:
                                                                            '#/definitions/LinkDetails/properties/inPersonLink/type',
                                                                          keyword:
                                                                            'type',
                                                                          params:
                                                                            {
                                                                              type: 'string',
                                                                            },
                                                                          message:
                                                                            'must be string',
                                                                        },
                                                                      ];
                                                                    return false;
                                                                  }
                                                                  var valid10 =
                                                                    _errs66 ===
                                                                    errors;
                                                                } else {
                                                                  var valid10 = true;
                                                                }
                                                                if (valid10) {
                                                                  if (
                                                                    data27.receiveSignedCopies !==
                                                                    undefined
                                                                  ) {
                                                                    const _errs68 =
                                                                      errors;
                                                                    if (
                                                                      typeof data27.receiveSignedCopies !==
                                                                      'boolean'
                                                                    ) {
                                                                      validate81.errors =
                                                                        [
                                                                          {
                                                                            instancePath:
                                                                              instancePath +
                                                                              '/linkDetails/receiveSignedCopies',
                                                                            schemaPath:
                                                                              '#/definitions/LinkDetails/properties/receiveSignedCopies/type',
                                                                            keyword:
                                                                              'type',
                                                                            params:
                                                                              {
                                                                                type: 'boolean',
                                                                              },
                                                                            message:
                                                                              'must be boolean',
                                                                          },
                                                                        ];
                                                                      return false;
                                                                    }
                                                                    var valid10 =
                                                                      _errs68 ===
                                                                      errors;
                                                                  } else {
                                                                    var valid10 = true;
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        } else {
                                                          validate81.errors = [
                                                            {
                                                              instancePath:
                                                                instancePath +
                                                                '/linkDetails',
                                                              schemaPath:
                                                                '#/definitions/LinkDetails/type',
                                                              keyword: 'type',
                                                              params: {
                                                                type: 'object',
                                                              },
                                                              message:
                                                                'must be object',
                                                            },
                                                          ];
                                                          return false;
                                                        }
                                                      }
                                                      var valid0 =
                                                        _errs60 === errors;
                                                    } else {
                                                      var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                      if (
                                                        data.createdBy !==
                                                        undefined
                                                      ) {
                                                        let data31 =
                                                          data.createdBy;
                                                        const _errs70 = errors;
                                                        const _errs71 = errors;
                                                        if (
                                                          errors === _errs71
                                                        ) {
                                                          if (
                                                            data31 &&
                                                            typeof data31 ==
                                                              'object' &&
                                                            !Array.isArray(
                                                              data31
                                                            )
                                                          ) {
                                                            let missing3;
                                                            if (
                                                              (data31.name ===
                                                                undefined &&
                                                                (missing3 =
                                                                  'name')) ||
                                                              (data31.email ===
                                                                undefined &&
                                                                (missing3 =
                                                                  'email')) ||
                                                              (data31.date ===
                                                                undefined &&
                                                                (missing3 =
                                                                  'date'))
                                                            ) {
                                                              validate81.errors =
                                                                [
                                                                  {
                                                                    instancePath:
                                                                      instancePath +
                                                                      '/createdBy',
                                                                    schemaPath:
                                                                      '#/definitions/CreatedBy/required',
                                                                    keyword:
                                                                      'required',
                                                                    params: {
                                                                      missingProperty:
                                                                        missing3,
                                                                    },
                                                                    message:
                                                                      "must have required property '" +
                                                                      missing3 +
                                                                      "'",
                                                                  },
                                                                ];
                                                              return false;
                                                            } else {
                                                              const _errs73 =
                                                                errors;
                                                              for (const key3 in data31) {
                                                                if (
                                                                  !(
                                                                    key3 ===
                                                                      'name' ||
                                                                    key3 ===
                                                                      'email' ||
                                                                    key3 ===
                                                                      'date'
                                                                  )
                                                                ) {
                                                                  validate81.errors =
                                                                    [
                                                                      {
                                                                        instancePath:
                                                                          instancePath +
                                                                          '/createdBy',
                                                                        schemaPath:
                                                                          '#/definitions/CreatedBy/additionalProperties',
                                                                        keyword:
                                                                          'additionalProperties',
                                                                        params:
                                                                          {
                                                                            additionalProperty:
                                                                              key3,
                                                                          },
                                                                        message:
                                                                          'must NOT have additional properties',
                                                                      },
                                                                    ];
                                                                  return false;
                                                                  break;
                                                                }
                                                              }
                                                              if (
                                                                _errs73 ===
                                                                errors
                                                              ) {
                                                                if (
                                                                  data31.name !==
                                                                  undefined
                                                                ) {
                                                                  const _errs74 =
                                                                    errors;
                                                                  if (
                                                                    typeof data31.name !==
                                                                    'string'
                                                                  ) {
                                                                    validate81.errors =
                                                                      [
                                                                        {
                                                                          instancePath:
                                                                            instancePath +
                                                                            '/createdBy/name',
                                                                          schemaPath:
                                                                            '#/definitions/CreatedBy/properties/name/type',
                                                                          keyword:
                                                                            'type',
                                                                          params:
                                                                            {
                                                                              type: 'string',
                                                                            },
                                                                          message:
                                                                            'must be string',
                                                                        },
                                                                      ];
                                                                    return false;
                                                                  }
                                                                  var valid12 =
                                                                    _errs74 ===
                                                                    errors;
                                                                } else {
                                                                  var valid12 = true;
                                                                }
                                                                if (valid12) {
                                                                  if (
                                                                    data31.email !==
                                                                    undefined
                                                                  ) {
                                                                    const _errs76 =
                                                                      errors;
                                                                    if (
                                                                      typeof data31.email !==
                                                                      'string'
                                                                    ) {
                                                                      validate81.errors =
                                                                        [
                                                                          {
                                                                            instancePath:
                                                                              instancePath +
                                                                              '/createdBy/email',
                                                                            schemaPath:
                                                                              '#/definitions/CreatedBy/properties/email/type',
                                                                            keyword:
                                                                              'type',
                                                                            params:
                                                                              {
                                                                                type: 'string',
                                                                              },
                                                                            message:
                                                                              'must be string',
                                                                          },
                                                                        ];
                                                                      return false;
                                                                    }
                                                                    var valid12 =
                                                                      _errs76 ===
                                                                      errors;
                                                                  } else {
                                                                    var valid12 = true;
                                                                  }
                                                                  if (valid12) {
                                                                    if (
                                                                      data31.date !==
                                                                      undefined
                                                                    ) {
                                                                      const _errs78 =
                                                                        errors;
                                                                      if (
                                                                        typeof data31.date !==
                                                                        'string'
                                                                      ) {
                                                                        validate81.errors =
                                                                          [
                                                                            {
                                                                              instancePath:
                                                                                instancePath +
                                                                                '/createdBy/date',
                                                                              schemaPath:
                                                                                '#/definitions/CreatedBy/properties/date/type',
                                                                              keyword:
                                                                                'type',
                                                                              params:
                                                                                {
                                                                                  type: 'string',
                                                                                },
                                                                              message:
                                                                                'must be string',
                                                                            },
                                                                          ];
                                                                        return false;
                                                                      }
                                                                      var valid12 =
                                                                        _errs78 ===
                                                                        errors;
                                                                    } else {
                                                                      var valid12 = true;
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          } else {
                                                            validate81.errors =
                                                              [
                                                                {
                                                                  instancePath:
                                                                    instancePath +
                                                                    '/createdBy',
                                                                  schemaPath:
                                                                    '#/definitions/CreatedBy/type',
                                                                  keyword:
                                                                    'type',
                                                                  params: {
                                                                    type: 'object',
                                                                  },
                                                                  message:
                                                                    'must be object',
                                                                },
                                                              ];
                                                            return false;
                                                          }
                                                        }
                                                        var valid0 =
                                                          _errs70 === errors;
                                                      } else {
                                                        var valid0 = true;
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate81.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate81.errors = vErrors;
  return errors === 0;
}
const schema104 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'BulkSend.json',
  type: 'object',
  title: 'BulkSend',
  additionalProperties: false,
  properties: {
    exampleFields: { type: 'array', items: { type: 'string' } },
    signerFile: { oneOf: [{ $ref: 'File.json' }, { type: 'null' }] },
  },
  required: ['exampleFields', 'signerFile'],
};
function validate88(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="BulkSend.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.exampleFields === undefined && (missing0 = 'exampleFields')) ||
        (data.signerFile === undefined && (missing0 = 'signerFile'))
      ) {
        validate88.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'exampleFields' || key0 === 'signerFile')) {
            validate88.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.exampleFields !== undefined) {
            let data0 = data.exampleFields;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (Array.isArray(data0)) {
                var valid1 = true;
                const len0 = data0.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  const _errs4 = errors;
                  if (typeof data0[i0] !== 'string') {
                    validate88.errors = [
                      {
                        instancePath: instancePath + '/exampleFields/' + i0,
                        schemaPath: '#/properties/exampleFields/items/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid1 = _errs4 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate88.errors = [
                  {
                    instancePath: instancePath + '/exampleFields',
                    schemaPath: '#/properties/exampleFields/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                  },
                ];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.signerFile !== undefined) {
              let data2 = data.signerFile;
              const _errs6 = errors;
              const _errs7 = errors;
              let valid2 = false;
              let passing0 = null;
              const _errs8 = errors;
              if (
                !validate45(data2, {
                  instancePath: instancePath + '/signerFile',
                  parentData: data,
                  parentDataProperty: 'signerFile',
                  rootData,
                })
              ) {
                vErrors =
                  vErrors === null
                    ? validate45.errors
                    : vErrors.concat(validate45.errors);
                errors = vErrors.length;
              }
              var _valid0 = _errs8 === errors;
              if (_valid0) {
                valid2 = true;
                passing0 = 0;
              }
              const _errs9 = errors;
              if (data2 !== null) {
                const err0 = {
                  instancePath: instancePath + '/signerFile',
                  schemaPath: '#/properties/signerFile/oneOf/1/type',
                  keyword: 'type',
                  params: { type: 'null' },
                  message: 'must be null',
                };
                if (vErrors === null) {
                  vErrors = [err0];
                } else {
                  vErrors.push(err0);
                }
                errors++;
              }
              var _valid0 = _errs9 === errors;
              if (_valid0 && valid2) {
                valid2 = false;
                passing0 = [passing0, 1];
              } else {
                if (_valid0) {
                  valid2 = true;
                  passing0 = 1;
                }
              }
              if (!valid2) {
                const err1 = {
                  instancePath: instancePath + '/signerFile',
                  schemaPath: '#/properties/signerFile/oneOf',
                  keyword: 'oneOf',
                  params: { passingSchemas: passing0 },
                  message: 'must match exactly one schema in oneOf',
                };
                if (vErrors === null) {
                  vErrors = [err1];
                } else {
                  vErrors.push(err1);
                }
                errors++;
                validate88.errors = vErrors;
                return false;
              } else {
                errors = _errs7;
                if (vErrors !== null) {
                  if (_errs7) {
                    vErrors.length = _errs7;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate88.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate88.errors = vErrors;
  return errors === 0;
}
function validate44(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="RequestData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.files === undefined && (missing0 = 'files')) ||
        (data.editorData === undefined && (missing0 = 'editorData')) ||
        (data.recipients === undefined && (missing0 = 'recipients')) ||
        (data.ccs === undefined && (missing0 = 'ccs')) ||
        (data.templates === undefined && (missing0 = 'templates')) ||
        (data.bulkSend === undefined && (missing0 = 'bulkSend')) ||
        (data.title === undefined && (missing0 = 'title')) ||
        (data.message === undefined && (missing0 = 'message'))
      ) {
        validate44.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.files !== undefined) {
          let data0 = data.files;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                const _errs3 = errors;
                if (
                  !validate45(data0[i0], {
                    instancePath: instancePath + '/files/' + i0,
                    parentData: data0,
                    parentDataProperty: i0,
                    rootData,
                  })
                ) {
                  vErrors =
                    vErrors === null
                      ? validate45.errors
                      : vErrors.concat(validate45.errors);
                  errors = vErrors.length;
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate44.errors = [
                {
                  instancePath: instancePath + '/files',
                  schemaPath: '#/properties/files/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.editorData !== undefined) {
            const _errs4 = errors;
            if (
              !validate48(data.editorData, {
                instancePath: instancePath + '/editorData',
                parentData: data,
                parentDataProperty: 'editorData',
                rootData,
              })
            ) {
              vErrors =
                vErrors === null
                  ? validate48.errors
                  : vErrors.concat(validate48.errors);
              errors = vErrors.length;
            }
            var valid0 = _errs4 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.recipients !== undefined) {
              let data3 = data.recipients;
              const _errs5 = errors;
              if (errors === _errs5) {
                if (Array.isArray(data3)) {
                  var valid2 = true;
                  const len1 = data3.length;
                  for (let i1 = 0; i1 < len1; i1++) {
                    const _errs7 = errors;
                    if (
                      !validate64(data3[i1], {
                        instancePath: instancePath + '/recipients/' + i1,
                        parentData: data3,
                        parentDataProperty: i1,
                        rootData,
                      })
                    ) {
                      vErrors =
                        vErrors === null
                          ? validate64.errors
                          : vErrors.concat(validate64.errors);
                      errors = vErrors.length;
                    }
                    var valid2 = _errs7 === errors;
                    if (!valid2) {
                      break;
                    }
                  }
                } else {
                  validate44.errors = [
                    {
                      instancePath: instancePath + '/recipients',
                      schemaPath: '#/properties/recipients/type',
                      keyword: 'type',
                      params: { type: 'array' },
                      message: 'must be array',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.ccs !== undefined) {
                let data5 = data.ccs;
                const _errs8 = errors;
                if (errors === _errs8) {
                  if (Array.isArray(data5)) {
                    var valid3 = true;
                    const len2 = data5.length;
                    for (let i2 = 0; i2 < len2; i2++) {
                      let data6 = data5[i2];
                      const _errs10 = errors;
                      const _errs11 = errors;
                      let valid4 = false;
                      let passing0 = null;
                      const _errs12 = errors;
                      if (
                        !validate79(data6, {
                          instancePath: instancePath + '/ccs/' + i2,
                          parentData: data5,
                          parentDataProperty: i2,
                          rootData,
                        })
                      ) {
                        vErrors =
                          vErrors === null
                            ? validate79.errors
                            : vErrors.concat(validate79.errors);
                        errors = vErrors.length;
                      }
                      var _valid0 = _errs12 === errors;
                      if (_valid0) {
                        valid4 = true;
                        passing0 = 0;
                      }
                      const _errs13 = errors;
                      const _errs14 = errors;
                      if (errors === _errs14) {
                        if (
                          data6 &&
                          typeof data6 == 'object' &&
                          !Array.isArray(data6)
                        ) {
                          let missing1;
                          if (
                            (data6.type === undefined && (missing1 = 'type')) ||
                            (data6.id === undefined && (missing1 = 'id')) ||
                            (data6.name === undefined && (missing1 = 'name'))
                          ) {
                            const err0 = {
                              instancePath: instancePath + '/ccs/' + i2,
                              schemaPath:
                                'Recipient.json#/definitions/CCRole/required',
                              keyword: 'required',
                              params: { missingProperty: missing1 },
                              message:
                                "must have required property '" +
                                missing1 +
                                "'",
                            };
                            if (vErrors === null) {
                              vErrors = [err0];
                            } else {
                              vErrors.push(err0);
                            }
                            errors++;
                          } else {
                            const _errs16 = errors;
                            for (const key0 in data6) {
                              if (
                                !(
                                  key0 === 'type' ||
                                  key0 === 'id' ||
                                  key0 === 'name'
                                )
                              ) {
                                const err1 = {
                                  instancePath: instancePath + '/ccs/' + i2,
                                  schemaPath:
                                    'Recipient.json#/definitions/CCRole/additionalProperties',
                                  keyword: 'additionalProperties',
                                  params: { additionalProperty: key0 },
                                  message:
                                    'must NOT have additional properties',
                                };
                                if (vErrors === null) {
                                  vErrors = [err1];
                                } else {
                                  vErrors.push(err1);
                                }
                                errors++;
                                break;
                              }
                            }
                            if (_errs16 === errors) {
                              if (data6.type !== undefined) {
                                const _errs17 = errors;
                                if (!func0(data6.type, 'ccRole')) {
                                  const err2 = {
                                    instancePath:
                                      instancePath + '/ccs/' + i2 + '/type',
                                    schemaPath:
                                      'Recipient.json#/definitions/CCRole/properties/type/const',
                                    keyword: 'const',
                                    params: { allowedValue: 'ccRole' },
                                    message: 'must be equal to constant',
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err2];
                                  } else {
                                    vErrors.push(err2);
                                  }
                                  errors++;
                                }
                                var valid6 = _errs17 === errors;
                              } else {
                                var valid6 = true;
                              }
                              if (valid6) {
                                if (data6.id !== undefined) {
                                  const _errs18 = errors;
                                  if (typeof data6.id !== 'string') {
                                    const err3 = {
                                      instancePath:
                                        instancePath + '/ccs/' + i2 + '/id',
                                      schemaPath:
                                        'Recipient.json#/definitions/CCRole/properties/id/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err3];
                                    } else {
                                      vErrors.push(err3);
                                    }
                                    errors++;
                                  }
                                  var valid6 = _errs18 === errors;
                                } else {
                                  var valid6 = true;
                                }
                                if (valid6) {
                                  if (data6.name !== undefined) {
                                    const _errs20 = errors;
                                    if (typeof data6.name !== 'string') {
                                      const err4 = {
                                        instancePath:
                                          instancePath + '/ccs/' + i2 + '/name',
                                        schemaPath:
                                          'Recipient.json#/definitions/CCRole/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err4];
                                      } else {
                                        vErrors.push(err4);
                                      }
                                      errors++;
                                    }
                                    var valid6 = _errs20 === errors;
                                  } else {
                                    var valid6 = true;
                                  }
                                }
                              }
                            }
                          }
                        } else {
                          const err5 = {
                            instancePath: instancePath + '/ccs/' + i2,
                            schemaPath:
                              'Recipient.json#/definitions/CCRole/type',
                            keyword: 'type',
                            params: { type: 'object' },
                            message: 'must be object',
                          };
                          if (vErrors === null) {
                            vErrors = [err5];
                          } else {
                            vErrors.push(err5);
                          }
                          errors++;
                        }
                      }
                      var _valid0 = _errs13 === errors;
                      if (_valid0 && valid4) {
                        valid4 = false;
                        passing0 = [passing0, 1];
                      } else {
                        if (_valid0) {
                          valid4 = true;
                          passing0 = 1;
                        }
                      }
                      if (!valid4) {
                        const err6 = {
                          instancePath: instancePath + '/ccs/' + i2,
                          schemaPath: '#/properties/ccs/items/oneOf',
                          keyword: 'oneOf',
                          params: { passingSchemas: passing0 },
                          message: 'must match exactly one schema in oneOf',
                        };
                        if (vErrors === null) {
                          vErrors = [err6];
                        } else {
                          vErrors.push(err6);
                        }
                        errors++;
                        validate44.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs11;
                        if (vErrors !== null) {
                          if (_errs11) {
                            vErrors.length = _errs11;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid3 = _errs10 === errors;
                      if (!valid3) {
                        break;
                      }
                    }
                  } else {
                    validate44.errors = [
                      {
                        instancePath: instancePath + '/ccs',
                        schemaPath: '#/properties/ccs/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.title !== undefined) {
                  const _errs22 = errors;
                  if (typeof data.title !== 'string') {
                    validate44.errors = [
                      {
                        instancePath: instancePath + '/title',
                        schemaPath: '#/properties/title/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs22 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.message !== undefined) {
                    const _errs24 = errors;
                    if (typeof data.message !== 'string') {
                      validate44.errors = [
                        {
                          instancePath: instancePath + '/message',
                          schemaPath: '#/properties/message/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs24 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.templates !== undefined) {
                      let data12 = data.templates;
                      const _errs26 = errors;
                      if (errors === _errs26) {
                        if (Array.isArray(data12)) {
                          var valid7 = true;
                          const len3 = data12.length;
                          for (let i3 = 0; i3 < len3; i3++) {
                            const _errs28 = errors;
                            if (
                              !validate81(data12[i3], {
                                instancePath: instancePath + '/templates/' + i3,
                                parentData: data12,
                                parentDataProperty: i3,
                                rootData,
                              })
                            ) {
                              vErrors =
                                vErrors === null
                                  ? validate81.errors
                                  : vErrors.concat(validate81.errors);
                              errors = vErrors.length;
                            }
                            var valid7 = _errs28 === errors;
                            if (!valid7) {
                              break;
                            }
                          }
                        } else {
                          validate44.errors = [
                            {
                              instancePath: instancePath + '/templates',
                              schemaPath: '#/properties/templates/type',
                              keyword: 'type',
                              params: { type: 'array' },
                              message: 'must be array',
                            },
                          ];
                          return false;
                        }
                      }
                      var valid0 = _errs26 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.coverPage !== undefined) {
                        let data14 = data.coverPage;
                        const _errs29 = errors;
                        const _errs30 = errors;
                        if (errors === _errs30) {
                          if (
                            data14 &&
                            typeof data14 == 'object' &&
                            !Array.isArray(data14)
                          ) {
                            let missing2;
                            if (
                              (data14.to === undefined && (missing2 = 'to')) ||
                              (data14.from === undefined &&
                                (missing2 = 'from')) ||
                              (data14.message === undefined &&
                                (missing2 = 'message'))
                            ) {
                              validate44.errors = [
                                {
                                  instancePath: instancePath + '/coverPage',
                                  schemaPath: 'CoverPage.json/required',
                                  keyword: 'required',
                                  params: { missingProperty: missing2 },
                                  message:
                                    "must have required property '" +
                                    missing2 +
                                    "'",
                                },
                              ];
                              return false;
                            } else {
                              const _errs32 = errors;
                              for (const key1 in data14) {
                                if (
                                  !(
                                    key1 === 'to' ||
                                    key1 === 'from' ||
                                    key1 === 'message'
                                  )
                                ) {
                                  validate44.errors = [
                                    {
                                      instancePath: instancePath + '/coverPage',
                                      schemaPath:
                                        'CoverPage.json/additionalProperties',
                                      keyword: 'additionalProperties',
                                      params: { additionalProperty: key1 },
                                      message:
                                        'must NOT have additional properties',
                                    },
                                  ];
                                  return false;
                                  break;
                                }
                              }
                              if (_errs32 === errors) {
                                if (data14.to !== undefined) {
                                  const _errs33 = errors;
                                  if (typeof data14.to !== 'string') {
                                    validate44.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/coverPage/to',
                                        schemaPath:
                                          'CoverPage.json/properties/to/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid9 = _errs33 === errors;
                                } else {
                                  var valid9 = true;
                                }
                                if (valid9) {
                                  if (data14.from !== undefined) {
                                    const _errs35 = errors;
                                    if (typeof data14.from !== 'string') {
                                      validate44.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/coverPage/from',
                                          schemaPath:
                                            'CoverPage.json/properties/from/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid9 = _errs35 === errors;
                                  } else {
                                    var valid9 = true;
                                  }
                                  if (valid9) {
                                    if (data14.message !== undefined) {
                                      const _errs37 = errors;
                                      if (typeof data14.message !== 'string') {
                                        validate44.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/coverPage/message',
                                            schemaPath:
                                              'CoverPage.json/properties/message/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid9 = _errs37 === errors;
                                    } else {
                                      var valid9 = true;
                                    }
                                  }
                                }
                              }
                            }
                          } else {
                            validate44.errors = [
                              {
                                instancePath: instancePath + '/coverPage',
                                schemaPath: 'CoverPage.json/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object',
                              },
                            ];
                            return false;
                          }
                        }
                        var valid0 = _errs29 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.bulkSend !== undefined) {
                          const _errs39 = errors;
                          if (
                            !validate88(data.bulkSend, {
                              instancePath: instancePath + '/bulkSend',
                              parentData: data,
                              parentDataProperty: 'bulkSend',
                              rootData,
                            })
                          ) {
                            vErrors =
                              vErrors === null
                                ? validate88.errors
                                : vErrors.concat(validate88.errors);
                            errors = vErrors.length;
                          }
                          var valid0 = _errs39 === errors;
                        } else {
                          var valid0 = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate44.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate44.errors = vErrors;
  return errors === 0;
}
const schema107 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'User.json',
  type: 'object',
  title: 'User',
  properties: {
    name: { type: 'string' },
    firstName: { type: 'string' },
    lastName: { type: 'string' },
    email: { type: 'string' },
    isPaidAccount: { type: 'boolean' },
    isConfirmedAccount: { type: 'boolean' },
    title: { type: 'string' },
    company: { type: 'string' },
    apiIdsEnabled: { type: 'boolean' },
    accountDateFormat: { $ref: '#/definitions/AccountDateFormat' },
  },
  required: [
    'email',
    'isPaidAccount',
    'isConfirmedAccount',
    'apiIdsEnabled',
    'accountDateFormat',
  ],
  definitions: {
    AccountDateFormat: {
      type: 'string',
      title: 'AccountDateFormat',
      description: 'Preferred date format on account settings',
      enum: ['MM / DD / YYYY', 'DD / MM / YYYY', 'YYYY / MM / DD'],
      tsEnumNames: ['MMDDYYYY', 'DDMMYYYY', 'YYYYMMDD'],
      'x-enum-names': ['MMDDYYYY', 'DDMMYYYY', 'YYYYMMDD'],
    },
  },
};
const schema108 = {
  type: 'string',
  title: 'AccountDateFormat',
  description: 'Preferred date format on account settings',
  enum: ['MM / DD / YYYY', 'DD / MM / YYYY', 'YYYY / MM / DD'],
  tsEnumNames: ['MMDDYYYY', 'DDMMYYYY', 'YYYYMMDD'],
  'x-enum-names': ['MMDDYYYY', 'DDMMYYYY', 'YYYYMMDD'],
};
function validate92(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="User.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.email === undefined && (missing0 = 'email')) ||
        (data.isPaidAccount === undefined && (missing0 = 'isPaidAccount')) ||
        (data.isConfirmedAccount === undefined &&
          (missing0 = 'isConfirmedAccount')) ||
        (data.apiIdsEnabled === undefined && (missing0 = 'apiIdsEnabled')) ||
        (data.accountDateFormat === undefined &&
          (missing0 = 'accountDateFormat'))
      ) {
        validate92.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.name !== undefined) {
          const _errs1 = errors;
          if (typeof data.name !== 'string') {
            validate92.errors = [
              {
                instancePath: instancePath + '/name',
                schemaPath: '#/properties/name/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.firstName !== undefined) {
            const _errs3 = errors;
            if (typeof data.firstName !== 'string') {
              validate92.errors = [
                {
                  instancePath: instancePath + '/firstName',
                  schemaPath: '#/properties/firstName/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.lastName !== undefined) {
              const _errs5 = errors;
              if (typeof data.lastName !== 'string') {
                validate92.errors = [
                  {
                    instancePath: instancePath + '/lastName',
                    schemaPath: '#/properties/lastName/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.email !== undefined) {
                const _errs7 = errors;
                if (typeof data.email !== 'string') {
                  validate92.errors = [
                    {
                      instancePath: instancePath + '/email',
                      schemaPath: '#/properties/email/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.isPaidAccount !== undefined) {
                  const _errs9 = errors;
                  if (typeof data.isPaidAccount !== 'boolean') {
                    validate92.errors = [
                      {
                        instancePath: instancePath + '/isPaidAccount',
                        schemaPath: '#/properties/isPaidAccount/type',
                        keyword: 'type',
                        params: { type: 'boolean' },
                        message: 'must be boolean',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.isConfirmedAccount !== undefined) {
                    const _errs11 = errors;
                    if (typeof data.isConfirmedAccount !== 'boolean') {
                      validate92.errors = [
                        {
                          instancePath: instancePath + '/isConfirmedAccount',
                          schemaPath: '#/properties/isConfirmedAccount/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.title !== undefined) {
                      const _errs13 = errors;
                      if (typeof data.title !== 'string') {
                        validate92.errors = [
                          {
                            instancePath: instancePath + '/title',
                            schemaPath: '#/properties/title/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.company !== undefined) {
                        const _errs15 = errors;
                        if (typeof data.company !== 'string') {
                          validate92.errors = [
                            {
                              instancePath: instancePath + '/company',
                              schemaPath: '#/properties/company/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.apiIdsEnabled !== undefined) {
                          const _errs17 = errors;
                          if (typeof data.apiIdsEnabled !== 'boolean') {
                            validate92.errors = [
                              {
                                instancePath: instancePath + '/apiIdsEnabled',
                                schemaPath: '#/properties/apiIdsEnabled/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs17 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.accountDateFormat !== undefined) {
                            let data9 = data.accountDateFormat;
                            const _errs19 = errors;
                            if (typeof data9 !== 'string') {
                              validate92.errors = [
                                {
                                  instancePath:
                                    instancePath + '/accountDateFormat',
                                  schemaPath:
                                    '#/definitions/AccountDateFormat/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            if (
                              !(
                                data9 === 'MM / DD / YYYY' ||
                                data9 === 'DD / MM / YYYY' ||
                                data9 === 'YYYY / MM / DD'
                              )
                            ) {
                              validate92.errors = [
                                {
                                  instancePath:
                                    instancePath + '/accountDateFormat',
                                  schemaPath:
                                    '#/definitions/AccountDateFormat/enum',
                                  keyword: 'enum',
                                  params: { allowedValues: schema108.enum },
                                  message:
                                    'must be equal to one of the allowed values',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs19 === errors;
                          } else {
                            var valid0 = true;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate92.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate92.errors = vErrors;
  return errors === 0;
}
function validate11(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="PrepAndSendRequest.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.guid === undefined && (missing0 = 'guid')) ||
        (data.settings === undefined && (missing0 = 'settings')) ||
        (data.flags === undefined && (missing0 = 'flags')) ||
        (data.accountSettings === undefined &&
          (missing0 = 'accountSettings')) ||
        (data.user === undefined && (missing0 = 'user')) ||
        (data.options === undefined && (missing0 = 'options')) ||
        (data.requestData === undefined && (missing0 = 'requestData'))
      ) {
        validate11.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func4.call(schema12.properties, key0)) {
            validate11.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.guid !== undefined) {
            const _errs2 = errors;
            if (typeof data.guid !== 'string') {
              validate11.errors = [
                {
                  instancePath: instancePath + '/guid',
                  schemaPath: '#/properties/guid/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.settings !== undefined) {
              let data1 = data.settings;
              const _errs4 = errors;
              const _errs5 = errors;
              if (errors === _errs5) {
                if (
                  data1 &&
                  typeof data1 == 'object' &&
                  !Array.isArray(data1)
                ) {
                  const _errs7 = errors;
                  for (const key1 in data1) {
                    if (
                      !(
                        key1 === 'addCoverPage' ||
                        key1 === 'recipientOrder' ||
                        key1 === 'qes' ||
                        key1 === 'recipientReassignment' ||
                        key1 === 'requireSignerInfo' ||
                        key1 === 'sendHighResFax' ||
                        key1 === 'needsCharge'
                      )
                    ) {
                      validate11.errors = [
                        {
                          instancePath: instancePath + '/settings',
                          schemaPath: 'Settings.json/additionalProperties',
                          keyword: 'additionalProperties',
                          params: { additionalProperty: key1 },
                          message: 'must NOT have additional properties',
                        },
                      ];
                      return false;
                      break;
                    }
                  }
                  if (_errs7 === errors) {
                    if (data1.addCoverPage !== undefined) {
                      const _errs8 = errors;
                      if (typeof data1.addCoverPage !== 'boolean') {
                        validate11.errors = [
                          {
                            instancePath:
                              instancePath + '/settings/addCoverPage',
                            schemaPath:
                              'Settings.json/properties/addCoverPage/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs8 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data1.recipientOrder !== undefined) {
                        const _errs10 = errors;
                        if (typeof data1.recipientOrder !== 'boolean') {
                          validate11.errors = [
                            {
                              instancePath:
                                instancePath + '/settings/recipientOrder',
                              schemaPath:
                                'Settings.json/properties/recipientOrder/type',
                              keyword: 'type',
                              params: { type: 'boolean' },
                              message: 'must be boolean',
                            },
                          ];
                          return false;
                        }
                        var valid2 = _errs10 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data1.qes !== undefined) {
                          const _errs12 = errors;
                          if (typeof data1.qes !== 'boolean') {
                            validate11.errors = [
                              {
                                instancePath: instancePath + '/settings/qes',
                                schemaPath: 'Settings.json/properties/qes/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid2 = _errs12 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data1.recipientReassignment !== undefined) {
                            const _errs14 = errors;
                            if (
                              typeof data1.recipientReassignment !== 'boolean'
                            ) {
                              validate11.errors = [
                                {
                                  instancePath:
                                    instancePath +
                                    '/settings/recipientReassignment',
                                  schemaPath:
                                    'Settings.json/properties/recipientReassignment/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid2 = _errs14 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data1.requireSignerInfo !== undefined) {
                              const _errs16 = errors;
                              if (
                                typeof data1.requireSignerInfo !== 'boolean'
                              ) {
                                validate11.errors = [
                                  {
                                    instancePath:
                                      instancePath +
                                      '/settings/requireSignerInfo',
                                    schemaPath:
                                      'Settings.json/properties/requireSignerInfo/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  },
                                ];
                                return false;
                              }
                              var valid2 = _errs16 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data1.sendHighResFax !== undefined) {
                                const _errs18 = errors;
                                if (typeof data1.sendHighResFax !== 'boolean') {
                                  validate11.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/settings/sendHighResFax',
                                      schemaPath:
                                        'Settings.json/properties/sendHighResFax/type',
                                      keyword: 'type',
                                      params: { type: 'boolean' },
                                      message: 'must be boolean',
                                    },
                                  ];
                                  return false;
                                }
                                var valid2 = _errs18 === errors;
                              } else {
                                var valid2 = true;
                              }
                              if (valid2) {
                                if (data1.needsCharge !== undefined) {
                                  const _errs20 = errors;
                                  if (typeof data1.needsCharge !== 'boolean') {
                                    validate11.errors = [
                                      {
                                        instancePath:
                                          instancePath +
                                          '/settings/needsCharge',
                                        schemaPath:
                                          'Settings.json/properties/needsCharge/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid2 = _errs20 === errors;
                                } else {
                                  var valid2 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                } else {
                  validate11.errors = [
                    {
                      instancePath: instancePath + '/settings',
                      schemaPath: 'Settings.json/type',
                      keyword: 'type',
                      params: { type: 'object' },
                      message: 'must be object',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.options !== undefined) {
                const _errs22 = errors;
                if (
                  !validate12(data.options, {
                    instancePath: instancePath + '/options',
                    parentData: data,
                    parentDataProperty: 'options',
                    rootData,
                  })
                ) {
                  vErrors =
                    vErrors === null
                      ? validate12.errors
                      : vErrors.concat(validate12.errors);
                  errors = vErrors.length;
                }
                var valid0 = _errs22 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.flags !== undefined) {
                  const _errs23 = errors;
                  if (
                    !validate30(data.flags, {
                      instancePath: instancePath + '/flags',
                      parentData: data,
                      parentDataProperty: 'flags',
                      rootData,
                    })
                  ) {
                    vErrors =
                      vErrors === null
                        ? validate30.errors
                        : vErrors.concat(validate30.errors);
                    errors = vErrors.length;
                  }
                  var valid0 = _errs23 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.accountSettings !== undefined) {
                    const _errs24 = errors;
                    if (
                      !validate40(data.accountSettings, {
                        instancePath: instancePath + '/accountSettings',
                        parentData: data,
                        parentDataProperty: 'accountSettings',
                        rootData,
                      })
                    ) {
                      vErrors =
                        vErrors === null
                          ? validate40.errors
                          : vErrors.concat(validate40.errors);
                      errors = vErrors.length;
                    }
                    var valid0 = _errs24 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.requestData !== undefined) {
                      const _errs25 = errors;
                      if (
                        !validate44(data.requestData, {
                          instancePath: instancePath + '/requestData',
                          parentData: data,
                          parentDataProperty: 'requestData',
                          rootData,
                        })
                      ) {
                        vErrors =
                          vErrors === null
                            ? validate44.errors
                            : vErrors.concat(validate44.errors);
                        errors = vErrors.length;
                      }
                      var valid0 = _errs25 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.embeddedData !== undefined) {
                        let data13 = data.embeddedData;
                        const _errs26 = errors;
                        const _errs27 = errors;
                        if (errors === _errs27) {
                          if (
                            data13 &&
                            typeof data13 == 'object' &&
                            !Array.isArray(data13)
                          ) {
                            let missing1;
                            if (
                              (data13.docGuids === undefined &&
                                (missing1 = 'docGuids')) ||
                              (data13.parentUrl === undefined &&
                                (missing1 = 'parentUrl')) ||
                              (data13.usingTemplate === undefined &&
                                (missing1 = 'usingTemplate')) ||
                              (data13.redirectUrl === undefined &&
                                (missing1 = 'redirectUrl')) ||
                              (data13.isSelfSign === undefined &&
                                (missing1 = 'isSelfSign')) ||
                              (data13.locale === undefined &&
                                (missing1 = 'locale'))
                            ) {
                              validate11.errors = [
                                {
                                  instancePath: instancePath + '/embeddedData',
                                  schemaPath: 'EmbeddedData.json/required',
                                  keyword: 'required',
                                  params: { missingProperty: missing1 },
                                  message:
                                    "must have required property '" +
                                    missing1 +
                                    "'",
                                },
                              ];
                              return false;
                            } else {
                              if (data13.docGuids !== undefined) {
                                let data14 = data13.docGuids;
                                const _errs29 = errors;
                                if (errors === _errs29) {
                                  if (Array.isArray(data14)) {
                                    var valid5 = true;
                                    const len0 = data14.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                      const _errs31 = errors;
                                      if (typeof data14[i0] !== 'string') {
                                        validate11.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/embeddedData/docGuids/' +
                                              i0,
                                            schemaPath:
                                              'EmbeddedData.json/properties/docGuids/items/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid5 = _errs31 === errors;
                                      if (!valid5) {
                                        break;
                                      }
                                    }
                                  } else {
                                    validate11.errors = [
                                      {
                                        instancePath:
                                          instancePath +
                                          '/embeddedData/docGuids',
                                        schemaPath:
                                          'EmbeddedData.json/properties/docGuids/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array',
                                      },
                                    ];
                                    return false;
                                  }
                                }
                                var valid4 = _errs29 === errors;
                              } else {
                                var valid4 = true;
                              }
                              if (valid4) {
                                if (data13.isEmbeddedRequest !== undefined) {
                                  const _errs33 = errors;
                                  if (
                                    typeof data13.isEmbeddedRequest !==
                                    'boolean'
                                  ) {
                                    validate11.errors = [
                                      {
                                        instancePath:
                                          instancePath +
                                          '/embeddedData/isEmbeddedRequest',
                                        schemaPath:
                                          'EmbeddedData.json/properties/isEmbeddedRequest/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid4 = _errs33 === errors;
                                } else {
                                  var valid4 = true;
                                }
                                if (valid4) {
                                  if (data13.isEmbeddedTemplate !== undefined) {
                                    const _errs35 = errors;
                                    if (
                                      typeof data13.isEmbeddedTemplate !==
                                      'boolean'
                                    ) {
                                      validate11.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/embeddedData/isEmbeddedTemplate',
                                          schemaPath:
                                            'EmbeddedData.json/properties/isEmbeddedTemplate/type',
                                          keyword: 'type',
                                          params: { type: 'boolean' },
                                          message: 'must be boolean',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid4 = _errs35 === errors;
                                  } else {
                                    var valid4 = true;
                                  }
                                  if (valid4) {
                                    if (data13.isGmail !== undefined) {
                                      const _errs37 = errors;
                                      if (typeof data13.isGmail !== 'boolean') {
                                        validate11.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/embeddedData/isGmail',
                                            schemaPath:
                                              'EmbeddedData.json/properties/isGmail/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid4 = _errs37 === errors;
                                    } else {
                                      var valid4 = true;
                                    }
                                    if (valid4) {
                                      if (data13.skipMeNow !== undefined) {
                                        const _errs39 = errors;
                                        if (
                                          typeof data13.skipMeNow !== 'boolean'
                                        ) {
                                          validate11.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/embeddedData/skipMeNow',
                                              schemaPath:
                                                'EmbeddedData.json/properties/skipMeNow/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid4 = _errs39 === errors;
                                      } else {
                                        var valid4 = true;
                                      }
                                      if (valid4) {
                                        if (
                                          data13.usingTemplate !== undefined
                                        ) {
                                          const _errs41 = errors;
                                          if (
                                            typeof data13.usingTemplate !==
                                            'boolean'
                                          ) {
                                            validate11.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/embeddedData/usingTemplate',
                                                schemaPath:
                                                  'EmbeddedData.json/properties/usingTemplate/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid4 = _errs41 === errors;
                                        } else {
                                          var valid4 = true;
                                        }
                                        if (valid4) {
                                          if (
                                            data13.isCreatedFromTemplate !==
                                            undefined
                                          ) {
                                            const _errs43 = errors;
                                            if (
                                              typeof data13.isCreatedFromTemplate !==
                                              'boolean'
                                            ) {
                                              validate11.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/embeddedData/isCreatedFromTemplate',
                                                  schemaPath:
                                                    'EmbeddedData.json/properties/isCreatedFromTemplate/type',
                                                  keyword: 'type',
                                                  params: { type: 'boolean' },
                                                  message: 'must be boolean',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid4 = _errs43 === errors;
                                          } else {
                                            var valid4 = true;
                                          }
                                          if (valid4) {
                                            if (
                                              data13.parentUrl !== undefined
                                            ) {
                                              const _errs45 = errors;
                                              if (
                                                typeof data13.parentUrl !==
                                                'string'
                                              ) {
                                                validate11.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/embeddedData/parentUrl',
                                                    schemaPath:
                                                      'EmbeddedData.json/properties/parentUrl/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid4 = _errs45 === errors;
                                            } else {
                                              var valid4 = true;
                                            }
                                            if (valid4) {
                                              if (
                                                data13.redirectUrl !== undefined
                                              ) {
                                                const _errs47 = errors;
                                                if (
                                                  typeof data13.redirectUrl !==
                                                  'string'
                                                ) {
                                                  validate11.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/embeddedData/redirectUrl',
                                                      schemaPath:
                                                        'EmbeddedData.json/properties/redirectUrl/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'string',
                                                      },
                                                      message: 'must be string',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid4 = _errs47 === errors;
                                              } else {
                                                var valid4 = true;
                                              }
                                              if (valid4) {
                                                if (
                                                  data13.editedTemplateGuid !==
                                                  undefined
                                                ) {
                                                  let data24 =
                                                    data13.editedTemplateGuid;
                                                  const _errs49 = errors;
                                                  if (
                                                    typeof data24 !==
                                                      'string' &&
                                                    data24 !== null
                                                  ) {
                                                    validate11.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath +
                                                          '/embeddedData/editedTemplateGuid',
                                                        schemaPath:
                                                          'EmbeddedData.json/properties/editedTemplateGuid/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: schema105
                                                            .properties
                                                            .editedTemplateGuid
                                                            .type,
                                                        },
                                                        message:
                                                          'must be string,null',
                                                      },
                                                    ];
                                                    return false;
                                                  }
                                                  var valid4 =
                                                    _errs49 === errors;
                                                } else {
                                                  var valid4 = true;
                                                }
                                                if (valid4) {
                                                  if (
                                                    data13.isSelfSign !==
                                                    undefined
                                                  ) {
                                                    let data25 =
                                                      data13.isSelfSign;
                                                    const _errs51 = errors;
                                                    if (
                                                      typeof data25 !==
                                                        'boolean' &&
                                                      data25 !== null
                                                    ) {
                                                      validate11.errors = [
                                                        {
                                                          instancePath:
                                                            instancePath +
                                                            '/embeddedData/isSelfSign',
                                                          schemaPath:
                                                            'EmbeddedData.json/properties/isSelfSign/type',
                                                          keyword: 'type',
                                                          params: {
                                                            type: schema105
                                                              .properties
                                                              .isSelfSign.type,
                                                          },
                                                          message:
                                                            'must be boolean,null',
                                                        },
                                                      ];
                                                      return false;
                                                    }
                                                    var valid4 =
                                                      _errs51 === errors;
                                                  } else {
                                                    var valid4 = true;
                                                  }
                                                  if (valid4) {
                                                    if (
                                                      data13.locale !==
                                                      undefined
                                                    ) {
                                                      let data26 =
                                                        data13.locale;
                                                      const _errs53 = errors;
                                                      if (
                                                        typeof data26 !==
                                                          'string' &&
                                                        data26 !== null
                                                      ) {
                                                        validate11.errors = [
                                                          {
                                                            instancePath:
                                                              instancePath +
                                                              '/embeddedData/locale',
                                                            schemaPath:
                                                              'EmbeddedData.json/properties/locale/type',
                                                            keyword: 'type',
                                                            params: {
                                                              type: schema105
                                                                .properties
                                                                .locale.type,
                                                            },
                                                            message:
                                                              'must be string,null',
                                                          },
                                                        ];
                                                        return false;
                                                      }
                                                      var valid4 =
                                                        _errs53 === errors;
                                                    } else {
                                                      var valid4 = true;
                                                    }
                                                    if (valid4) {
                                                      if (
                                                        data13.appName !==
                                                        undefined
                                                      ) {
                                                        const _errs55 = errors;
                                                        if (
                                                          typeof data13.appName !==
                                                          'string'
                                                        ) {
                                                          validate11.errors = [
                                                            {
                                                              instancePath:
                                                                instancePath +
                                                                '/embeddedData/appName',
                                                              schemaPath:
                                                                'EmbeddedData.json/properties/appName/type',
                                                              keyword: 'type',
                                                              params: {
                                                                type: 'string',
                                                              },
                                                              message:
                                                                'must be string',
                                                            },
                                                          ];
                                                          return false;
                                                        }
                                                        var valid4 =
                                                          _errs55 === errors;
                                                      } else {
                                                        var valid4 = true;
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          } else {
                            validate11.errors = [
                              {
                                instancePath: instancePath + '/embeddedData',
                                schemaPath: 'EmbeddedData.json/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object',
                              },
                            ];
                            return false;
                          }
                        }
                        var valid0 = _errs26 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.apiApp !== undefined) {
                          let data28 = data.apiApp;
                          const _errs57 = errors;
                          const _errs58 = errors;
                          if (errors === _errs58) {
                            if (
                              data28 &&
                              typeof data28 == 'object' &&
                              !Array.isArray(data28)
                            ) {
                              let missing2;
                              if (
                                (data28.clientId === undefined &&
                                  (missing2 = 'clientId')) ||
                                (data28.parentUrl === undefined &&
                                  (missing2 = 'parentUrl'))
                              ) {
                                validate11.errors = [
                                  {
                                    instancePath: instancePath + '/apiApp',
                                    schemaPath: 'ApiApp.json/required',
                                    keyword: 'required',
                                    params: { missingProperty: missing2 },
                                    message:
                                      "must have required property '" +
                                      missing2 +
                                      "'",
                                  },
                                ];
                                return false;
                              } else {
                                if (data28.clientId !== undefined) {
                                  const _errs60 = errors;
                                  if (typeof data28.clientId !== 'string') {
                                    validate11.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/apiApp/clientId',
                                        schemaPath:
                                          'ApiApp.json/properties/clientId/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid7 = _errs60 === errors;
                                } else {
                                  var valid7 = true;
                                }
                                if (valid7) {
                                  if (data28.parentUrl !== undefined) {
                                    const _errs62 = errors;
                                    if (typeof data28.parentUrl !== 'string') {
                                      validate11.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/apiApp/parentUrl',
                                          schemaPath:
                                            'ApiApp.json/properties/parentUrl/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid7 = _errs62 === errors;
                                  } else {
                                    var valid7 = true;
                                  }
                                }
                              }
                            } else {
                              validate11.errors = [
                                {
                                  instancePath: instancePath + '/apiApp',
                                  schemaPath: 'ApiApp.json/type',
                                  keyword: 'type',
                                  params: { type: 'object' },
                                  message: 'must be object',
                                },
                              ];
                              return false;
                            }
                          }
                          var valid0 = _errs57 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.user !== undefined) {
                            const _errs64 = errors;
                            if (
                              !validate92(data.user, {
                                instancePath: instancePath + '/user',
                                parentData: data,
                                parentDataProperty: 'user',
                                rootData,
                              })
                            ) {
                              vErrors =
                                vErrors === null
                                  ? validate92.errors
                                  : vErrors.concat(validate92.errors);
                              errors = vErrors.length;
                            }
                            var valid0 = _errs64 === errors;
                          } else {
                            var valid0 = true;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate11.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate11.errors = vErrors;
  return errors === 0;
}
const schema109 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'SignerAppRequest.json',
  title: 'SignerAppRequest',
  type: 'object',
  additionalProperties: false,
  properties: {
    pages: { type: 'array', items: { $ref: 'Page.json' } },
    fields: { type: 'array', items: { $ref: 'Field.json' } },
    rules: { type: 'array', items: { $ref: 'Rule.json' } },
  },
  required: ['pages', 'fields', 'rules'],
};
function validate95(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="SignerAppRequest.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.pages === undefined && (missing0 = 'pages')) ||
        (data.fields === undefined && (missing0 = 'fields')) ||
        (data.rules === undefined && (missing0 = 'rules'))
      ) {
        validate95.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'pages' || key0 === 'fields' || key0 === 'rules')) {
            validate95.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.pages !== undefined) {
            let data0 = data.pages;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (Array.isArray(data0)) {
                var valid1 = true;
                const len0 = data0.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  let data1 = data0[i0];
                  const _errs4 = errors;
                  const _errs5 = errors;
                  if (errors === _errs5) {
                    if (
                      data1 &&
                      typeof data1 == 'object' &&
                      !Array.isArray(data1)
                    ) {
                      let missing1;
                      if (
                        (data1.src === undefined && (missing1 = 'src')) ||
                        (data1.width === undefined && (missing1 = 'width')) ||
                        (data1.height === undefined && (missing1 = 'height')) ||
                        (data1.documentId === undefined &&
                          (missing1 = 'documentId')) ||
                        (data1.orientation === undefined &&
                          (missing1 = 'orientation')) ||
                        (data1.snapshotGuid === undefined &&
                          (missing1 = 'snapshotGuid'))
                      ) {
                        validate95.errors = [
                          {
                            instancePath: instancePath + '/pages/' + i0,
                            schemaPath: 'Page.json/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message:
                              "must have required property '" + missing1 + "'",
                          },
                        ];
                        return false;
                      } else {
                        const _errs7 = errors;
                        for (const key1 in data1) {
                          if (
                            !(
                              key1 === 'src' ||
                              key1 === 'width' ||
                              key1 === 'height' ||
                              key1 === 'documentId' ||
                              key1 === 'orientation' ||
                              key1 === 'snapshotGuid' ||
                              key1 === 'cdnSrc'
                            )
                          ) {
                            validate95.errors = [
                              {
                                instancePath: instancePath + '/pages/' + i0,
                                schemaPath: 'Page.json/additionalProperties',
                                keyword: 'additionalProperties',
                                params: { additionalProperty: key1 },
                                message: 'must NOT have additional properties',
                              },
                            ];
                            return false;
                            break;
                          }
                        }
                        if (_errs7 === errors) {
                          if (data1.src !== undefined) {
                            const _errs8 = errors;
                            if (typeof data1.src !== 'string') {
                              validate95.errors = [
                                {
                                  instancePath:
                                    instancePath + '/pages/' + i0 + '/src',
                                  schemaPath: 'Page.json/properties/src/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid3 = _errs8 === errors;
                          } else {
                            var valid3 = true;
                          }
                          if (valid3) {
                            if (data1.width !== undefined) {
                              let data3 = data1.width;
                              const _errs10 = errors;
                              if (
                                !(typeof data3 == 'number' && isFinite(data3))
                              ) {
                                validate95.errors = [
                                  {
                                    instancePath:
                                      instancePath + '/pages/' + i0 + '/width',
                                    schemaPath:
                                      'Page.json/properties/width/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number',
                                  },
                                ];
                                return false;
                              }
                              var valid3 = _errs10 === errors;
                            } else {
                              var valid3 = true;
                            }
                            if (valid3) {
                              if (data1.height !== undefined) {
                                let data4 = data1.height;
                                const _errs12 = errors;
                                if (
                                  !(typeof data4 == 'number' && isFinite(data4))
                                ) {
                                  validate95.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/pages/' +
                                        i0 +
                                        '/height',
                                      schemaPath:
                                        'Page.json/properties/height/type',
                                      keyword: 'type',
                                      params: { type: 'number' },
                                      message: 'must be number',
                                    },
                                  ];
                                  return false;
                                }
                                var valid3 = _errs12 === errors;
                              } else {
                                var valid3 = true;
                              }
                              if (valid3) {
                                if (data1.documentId !== undefined) {
                                  const _errs14 = errors;
                                  if (typeof data1.documentId !== 'string') {
                                    validate95.errors = [
                                      {
                                        instancePath:
                                          instancePath +
                                          '/pages/' +
                                          i0 +
                                          '/documentId',
                                        schemaPath:
                                          'Page.json/properties/documentId/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid3 = _errs14 === errors;
                                } else {
                                  var valid3 = true;
                                }
                                if (valid3) {
                                  if (data1.orientation !== undefined) {
                                    let data6 = data1.orientation;
                                    const _errs16 = errors;
                                    if (
                                      !(
                                        typeof data6 == 'number' &&
                                        !(data6 % 1) &&
                                        !isNaN(data6) &&
                                        isFinite(data6)
                                      )
                                    ) {
                                      validate95.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/pages/' +
                                            i0 +
                                            '/orientation',
                                          schemaPath:
                                            'Page.json/properties/orientation/type',
                                          keyword: 'type',
                                          params: { type: 'integer' },
                                          message: 'must be integer',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid3 = _errs16 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                  if (valid3) {
                                    if (data1.snapshotGuid !== undefined) {
                                      const _errs18 = errors;
                                      if (
                                        typeof data1.snapshotGuid !== 'string'
                                      ) {
                                        validate95.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/pages/' +
                                              i0 +
                                              '/snapshotGuid',
                                            schemaPath:
                                              'Page.json/properties/snapshotGuid/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid3 = _errs18 === errors;
                                    } else {
                                      var valid3 = true;
                                    }
                                    if (valid3) {
                                      if (data1.cdnSrc !== undefined) {
                                        let data8 = data1.cdnSrc;
                                        const _errs20 = errors;
                                        if (
                                          typeof data8 !== 'string' &&
                                          data8 !== null
                                        ) {
                                          validate95.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/pages/' +
                                                i0 +
                                                '/cdnSrc',
                                              schemaPath:
                                                'Page.json/properties/cdnSrc/type',
                                              keyword: 'type',
                                              params: {
                                                type: schema63.properties.cdnSrc
                                                  .type,
                                              },
                                              message: 'must be string,null',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid3 = _errs20 === errors;
                                      } else {
                                        var valid3 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    } else {
                      validate95.errors = [
                        {
                          instancePath: instancePath + '/pages/' + i0,
                          schemaPath: 'Page.json/type',
                          keyword: 'type',
                          params: { type: 'object' },
                          message: 'must be object',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid1 = _errs4 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate95.errors = [
                  {
                    instancePath: instancePath + '/pages',
                    schemaPath: '#/properties/pages/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                  },
                ];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.fields !== undefined) {
              let data9 = data.fields;
              const _errs22 = errors;
              if (errors === _errs22) {
                if (Array.isArray(data9)) {
                  var valid4 = true;
                  const len1 = data9.length;
                  for (let i1 = 0; i1 < len1; i1++) {
                    const _errs24 = errors;
                    if (
                      !validate13(data9[i1], {
                        instancePath: instancePath + '/fields/' + i1,
                        parentData: data9,
                        parentDataProperty: i1,
                        rootData,
                      })
                    ) {
                      vErrors =
                        vErrors === null
                          ? validate13.errors
                          : vErrors.concat(validate13.errors);
                      errors = vErrors.length;
                    }
                    var valid4 = _errs24 === errors;
                    if (!valid4) {
                      break;
                    }
                  }
                } else {
                  validate95.errors = [
                    {
                      instancePath: instancePath + '/fields',
                      schemaPath: '#/properties/fields/type',
                      keyword: 'type',
                      params: { type: 'array' },
                      message: 'must be array',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs22 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.rules !== undefined) {
                let data11 = data.rules;
                const _errs25 = errors;
                if (errors === _errs25) {
                  if (Array.isArray(data11)) {
                    var valid5 = true;
                    const len2 = data11.length;
                    for (let i2 = 0; i2 < len2; i2++) {
                      const _errs27 = errors;
                      if (
                        !validate52(data11[i2], {
                          instancePath: instancePath + '/rules/' + i2,
                          parentData: data11,
                          parentDataProperty: i2,
                          rootData,
                        })
                      ) {
                        vErrors =
                          vErrors === null
                            ? validate52.errors
                            : vErrors.concat(validate52.errors);
                        errors = vErrors.length;
                      }
                      var valid5 = _errs27 === errors;
                      if (!valid5) {
                        break;
                      }
                    }
                  } else {
                    validate95.errors = [
                      {
                        instancePath: instancePath + '/rules',
                        schemaPath: '#/properties/rules/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs25 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate95.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate95.errors = vErrors;
  return errors === 0;
}
const schema112 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'AccountFeatureSettings.json',
  type: 'object',
  title: 'AccountFeatureSettings',
  $comment: 'The title will become a TypeScript class',
  properties: {
    hasCustomLogo: { type: 'boolean' },
    customLogoUrl: { type: 'string' },
    isAccountLogoTeamLogo: { type: 'boolean' },
    companyTagline: { type: 'string' },
    emailFrom: { type: 'string' },
    emailSignature: { type: 'string' },
    isCustomSigningRedirectEnabled: { type: 'boolean' },
    customSigningRedirectUrl: { type: 'string' },
    areDrawnSignaturesAccepted: { type: 'boolean' },
    areTypedSignaturesAccepted: { type: 'boolean' },
    areUploadedSignaturesAccepted: { type: 'boolean' },
    areSmartphoneSignaturesAccepted: { type: 'boolean' },
    shouldIncludeDistinctPdfs: { type: 'boolean' },
    shouldRemoveDocumentId: { type: 'boolean' },
    hasSubscriptionAccess: { type: 'boolean' },
    shouldEnableInPersonSigning: { type: 'boolean' },
    enabledFeatures: { $ref: '#/definitions/AccountFeaturePermissions' },
    esignDisclosureSettings: { $ref: '#/definitions/EsignDisclosureSettings' },
    dataResidencySettings: { $ref: '#/definitions/DataResidencySettings' },
  },
  required: [
    'hasCustomLogo',
    'customLogoUrl',
    'isAccountLogoTeamLogo',
    'companyTagline',
    'emailFrom',
    'emailSignature',
    'isCustomSigningRedirectEnabled',
    'customSigningRedirectUrl',
    'areDrawnSignaturesAccepted',
    'areTypedSignaturesAccepted',
    'areUploadedSignaturesAccepted',
    'areSmartphoneSignaturesAccepted',
    'shouldIncludeDistinctPdfs',
    'shouldRemoveDocumentId',
    'hasSubscriptionAccess',
    'shouldEnableInPersonSigning',
    'enabledFeatures',
  ],
  definitions: {
    AccountFeaturePermissions: {
      type: 'object',
      title: 'AccountFeaturePermissions',
      properties: {
        isBrandingEnabled: { type: 'boolean' },
        hasDataResidency: { type: 'boolean' },
      },
      required: [],
    },
    EsignDisclosureSettings: {
      type: 'object',
      title: 'ESignDisclosureSettings',
      properties: {
        esignDisclosureEnable: { type: 'boolean' },
        esignDisclosureAdditionalTextEnable: { type: 'boolean' },
        esignDisclosureBusinessName: { type: 'string' },
        esignDisclosureAdditionalText: { type: 'string' },
      },
      required: [],
    },
    DataResidencySettings: {
      type: 'object',
      title: 'DataResidencySettings',
      properties: {
        dataResidencyEnabled: { type: 'boolean' },
        selectedDataResidency: { type: 'string' },
        dataResidencyOptions: { type: 'array', items: { type: 'string' } },
      },
      required: [
        'dataResidencyEnabled',
        'selectedDataResidency',
        'dataResidencyOptions',
      ],
    },
  },
};
const schema113 = {
  type: 'object',
  title: 'AccountFeaturePermissions',
  properties: {
    isBrandingEnabled: { type: 'boolean' },
    hasDataResidency: { type: 'boolean' },
  },
  required: [],
};
const schema114 = {
  type: 'object',
  title: 'ESignDisclosureSettings',
  properties: {
    esignDisclosureEnable: { type: 'boolean' },
    esignDisclosureAdditionalTextEnable: { type: 'boolean' },
    esignDisclosureBusinessName: { type: 'string' },
    esignDisclosureAdditionalText: { type: 'string' },
  },
  required: [],
};
const schema115 = {
  type: 'object',
  title: 'DataResidencySettings',
  properties: {
    dataResidencyEnabled: { type: 'boolean' },
    selectedDataResidency: { type: 'string' },
    dataResidencyOptions: { type: 'array', items: { type: 'string' } },
  },
  required: [
    'dataResidencyEnabled',
    'selectedDataResidency',
    'dataResidencyOptions',
  ],
};
function validate99(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="AccountFeatureSettings.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.hasCustomLogo === undefined && (missing0 = 'hasCustomLogo')) ||
        (data.customLogoUrl === undefined && (missing0 = 'customLogoUrl')) ||
        (data.isAccountLogoTeamLogo === undefined &&
          (missing0 = 'isAccountLogoTeamLogo')) ||
        (data.companyTagline === undefined && (missing0 = 'companyTagline')) ||
        (data.emailFrom === undefined && (missing0 = 'emailFrom')) ||
        (data.emailSignature === undefined && (missing0 = 'emailSignature')) ||
        (data.isCustomSigningRedirectEnabled === undefined &&
          (missing0 = 'isCustomSigningRedirectEnabled')) ||
        (data.customSigningRedirectUrl === undefined &&
          (missing0 = 'customSigningRedirectUrl')) ||
        (data.areDrawnSignaturesAccepted === undefined &&
          (missing0 = 'areDrawnSignaturesAccepted')) ||
        (data.areTypedSignaturesAccepted === undefined &&
          (missing0 = 'areTypedSignaturesAccepted')) ||
        (data.areUploadedSignaturesAccepted === undefined &&
          (missing0 = 'areUploadedSignaturesAccepted')) ||
        (data.areSmartphoneSignaturesAccepted === undefined &&
          (missing0 = 'areSmartphoneSignaturesAccepted')) ||
        (data.shouldIncludeDistinctPdfs === undefined &&
          (missing0 = 'shouldIncludeDistinctPdfs')) ||
        (data.shouldRemoveDocumentId === undefined &&
          (missing0 = 'shouldRemoveDocumentId')) ||
        (data.hasSubscriptionAccess === undefined &&
          (missing0 = 'hasSubscriptionAccess')) ||
        (data.shouldEnableInPersonSigning === undefined &&
          (missing0 = 'shouldEnableInPersonSigning')) ||
        (data.enabledFeatures === undefined && (missing0 = 'enabledFeatures'))
      ) {
        validate99.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.hasCustomLogo !== undefined) {
          const _errs2 = errors;
          if (typeof data.hasCustomLogo !== 'boolean') {
            validate99.errors = [
              {
                instancePath: instancePath + '/hasCustomLogo',
                schemaPath: '#/properties/hasCustomLogo/type',
                keyword: 'type',
                params: { type: 'boolean' },
                message: 'must be boolean',
              },
            ];
            return false;
          }
          var valid0 = _errs2 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.customLogoUrl !== undefined) {
            const _errs4 = errors;
            if (typeof data.customLogoUrl !== 'string') {
              validate99.errors = [
                {
                  instancePath: instancePath + '/customLogoUrl',
                  schemaPath: '#/properties/customLogoUrl/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs4 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.isAccountLogoTeamLogo !== undefined) {
              const _errs6 = errors;
              if (typeof data.isAccountLogoTeamLogo !== 'boolean') {
                validate99.errors = [
                  {
                    instancePath: instancePath + '/isAccountLogoTeamLogo',
                    schemaPath: '#/properties/isAccountLogoTeamLogo/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  },
                ];
                return false;
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.companyTagline !== undefined) {
                const _errs8 = errors;
                if (typeof data.companyTagline !== 'string') {
                  validate99.errors = [
                    {
                      instancePath: instancePath + '/companyTagline',
                      schemaPath: '#/properties/companyTagline/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.emailFrom !== undefined) {
                  const _errs10 = errors;
                  if (typeof data.emailFrom !== 'string') {
                    validate99.errors = [
                      {
                        instancePath: instancePath + '/emailFrom',
                        schemaPath: '#/properties/emailFrom/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.emailSignature !== undefined) {
                    const _errs12 = errors;
                    if (typeof data.emailSignature !== 'string') {
                      validate99.errors = [
                        {
                          instancePath: instancePath + '/emailSignature',
                          schemaPath: '#/properties/emailSignature/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.isCustomSigningRedirectEnabled !== undefined) {
                      const _errs14 = errors;
                      if (
                        typeof data.isCustomSigningRedirectEnabled !== 'boolean'
                      ) {
                        validate99.errors = [
                          {
                            instancePath:
                              instancePath + '/isCustomSigningRedirectEnabled',
                            schemaPath:
                              '#/properties/isCustomSigningRedirectEnabled/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs14 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.customSigningRedirectUrl !== undefined) {
                        const _errs16 = errors;
                        if (typeof data.customSigningRedirectUrl !== 'string') {
                          validate99.errors = [
                            {
                              instancePath:
                                instancePath + '/customSigningRedirectUrl',
                              schemaPath:
                                '#/properties/customSigningRedirectUrl/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs16 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.areDrawnSignaturesAccepted !== undefined) {
                          const _errs18 = errors;
                          if (
                            typeof data.areDrawnSignaturesAccepted !== 'boolean'
                          ) {
                            validate99.errors = [
                              {
                                instancePath:
                                  instancePath + '/areDrawnSignaturesAccepted',
                                schemaPath:
                                  '#/properties/areDrawnSignaturesAccepted/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs18 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.areTypedSignaturesAccepted !== undefined) {
                            const _errs20 = errors;
                            if (
                              typeof data.areTypedSignaturesAccepted !==
                              'boolean'
                            ) {
                              validate99.errors = [
                                {
                                  instancePath:
                                    instancePath +
                                    '/areTypedSignaturesAccepted',
                                  schemaPath:
                                    '#/properties/areTypedSignaturesAccepted/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs20 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (
                              data.areUploadedSignaturesAccepted !== undefined
                            ) {
                              const _errs22 = errors;
                              if (
                                typeof data.areUploadedSignaturesAccepted !==
                                'boolean'
                              ) {
                                validate99.errors = [
                                  {
                                    instancePath:
                                      instancePath +
                                      '/areUploadedSignaturesAccepted',
                                    schemaPath:
                                      '#/properties/areUploadedSignaturesAccepted/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs22 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (
                                data.areSmartphoneSignaturesAccepted !==
                                undefined
                              ) {
                                const _errs24 = errors;
                                if (
                                  typeof data.areSmartphoneSignaturesAccepted !==
                                  'boolean'
                                ) {
                                  validate99.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/areSmartphoneSignaturesAccepted',
                                      schemaPath:
                                        '#/properties/areSmartphoneSignaturesAccepted/type',
                                      keyword: 'type',
                                      params: { type: 'boolean' },
                                      message: 'must be boolean',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs24 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (
                                  data.shouldIncludeDistinctPdfs !== undefined
                                ) {
                                  const _errs26 = errors;
                                  if (
                                    typeof data.shouldIncludeDistinctPdfs !==
                                    'boolean'
                                  ) {
                                    validate99.errors = [
                                      {
                                        instancePath:
                                          instancePath +
                                          '/shouldIncludeDistinctPdfs',
                                        schemaPath:
                                          '#/properties/shouldIncludeDistinctPdfs/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs26 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (
                                    data.shouldRemoveDocumentId !== undefined
                                  ) {
                                    const _errs28 = errors;
                                    if (
                                      typeof data.shouldRemoveDocumentId !==
                                      'boolean'
                                    ) {
                                      validate99.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/shouldRemoveDocumentId',
                                          schemaPath:
                                            '#/properties/shouldRemoveDocumentId/type',
                                          keyword: 'type',
                                          params: { type: 'boolean' },
                                          message: 'must be boolean',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid0 = _errs28 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (
                                      data.hasSubscriptionAccess !== undefined
                                    ) {
                                      const _errs30 = errors;
                                      if (
                                        typeof data.hasSubscriptionAccess !==
                                        'boolean'
                                      ) {
                                        validate99.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/hasSubscriptionAccess',
                                            schemaPath:
                                              '#/properties/hasSubscriptionAccess/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid0 = _errs30 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (
                                        data.shouldEnableInPersonSigning !==
                                        undefined
                                      ) {
                                        const _errs32 = errors;
                                        if (
                                          typeof data.shouldEnableInPersonSigning !==
                                          'boolean'
                                        ) {
                                          validate99.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/shouldEnableInPersonSigning',
                                              schemaPath:
                                                '#/properties/shouldEnableInPersonSigning/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid0 = _errs32 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (
                                          data.enabledFeatures !== undefined
                                        ) {
                                          let data16 = data.enabledFeatures;
                                          const _errs34 = errors;
                                          const _errs35 = errors;
                                          if (errors === _errs35) {
                                            if (
                                              data16 &&
                                              typeof data16 == 'object' &&
                                              !Array.isArray(data16)
                                            ) {
                                              if (
                                                data16.isBrandingEnabled !==
                                                undefined
                                              ) {
                                                const _errs37 = errors;
                                                if (
                                                  typeof data16.isBrandingEnabled !==
                                                  'boolean'
                                                ) {
                                                  validate99.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/enabledFeatures/isBrandingEnabled',
                                                      schemaPath:
                                                        '#/definitions/AccountFeaturePermissions/properties/isBrandingEnabled/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'boolean',
                                                      },
                                                      message:
                                                        'must be boolean',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid2 = _errs37 === errors;
                                              } else {
                                                var valid2 = true;
                                              }
                                              if (valid2) {
                                                if (
                                                  data16.hasDataResidency !==
                                                  undefined
                                                ) {
                                                  const _errs39 = errors;
                                                  if (
                                                    typeof data16.hasDataResidency !==
                                                    'boolean'
                                                  ) {
                                                    validate99.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath +
                                                          '/enabledFeatures/hasDataResidency',
                                                        schemaPath:
                                                          '#/definitions/AccountFeaturePermissions/properties/hasDataResidency/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'boolean',
                                                        },
                                                        message:
                                                          'must be boolean',
                                                      },
                                                    ];
                                                    return false;
                                                  }
                                                  var valid2 =
                                                    _errs39 === errors;
                                                } else {
                                                  var valid2 = true;
                                                }
                                              }
                                            } else {
                                              validate99.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/enabledFeatures',
                                                  schemaPath:
                                                    '#/definitions/AccountFeaturePermissions/type',
                                                  keyword: 'type',
                                                  params: { type: 'object' },
                                                  message: 'must be object',
                                                },
                                              ];
                                              return false;
                                            }
                                          }
                                          var valid0 = _errs34 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                        if (valid0) {
                                          if (
                                            data.esignDisclosureSettings !==
                                            undefined
                                          ) {
                                            let data19 =
                                              data.esignDisclosureSettings;
                                            const _errs41 = errors;
                                            const _errs42 = errors;
                                            if (errors === _errs42) {
                                              if (
                                                data19 &&
                                                typeof data19 == 'object' &&
                                                !Array.isArray(data19)
                                              ) {
                                                if (
                                                  data19.esignDisclosureEnable !==
                                                  undefined
                                                ) {
                                                  const _errs44 = errors;
                                                  if (
                                                    typeof data19.esignDisclosureEnable !==
                                                    'boolean'
                                                  ) {
                                                    validate99.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath +
                                                          '/esignDisclosureSettings/esignDisclosureEnable',
                                                        schemaPath:
                                                          '#/definitions/EsignDisclosureSettings/properties/esignDisclosureEnable/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'boolean',
                                                        },
                                                        message:
                                                          'must be boolean',
                                                      },
                                                    ];
                                                    return false;
                                                  }
                                                  var valid4 =
                                                    _errs44 === errors;
                                                } else {
                                                  var valid4 = true;
                                                }
                                                if (valid4) {
                                                  if (
                                                    data19.esignDisclosureAdditionalTextEnable !==
                                                    undefined
                                                  ) {
                                                    const _errs46 = errors;
                                                    if (
                                                      typeof data19.esignDisclosureAdditionalTextEnable !==
                                                      'boolean'
                                                    ) {
                                                      validate99.errors = [
                                                        {
                                                          instancePath:
                                                            instancePath +
                                                            '/esignDisclosureSettings/esignDisclosureAdditionalTextEnable',
                                                          schemaPath:
                                                            '#/definitions/EsignDisclosureSettings/properties/esignDisclosureAdditionalTextEnable/type',
                                                          keyword: 'type',
                                                          params: {
                                                            type: 'boolean',
                                                          },
                                                          message:
                                                            'must be boolean',
                                                        },
                                                      ];
                                                      return false;
                                                    }
                                                    var valid4 =
                                                      _errs46 === errors;
                                                  } else {
                                                    var valid4 = true;
                                                  }
                                                  if (valid4) {
                                                    if (
                                                      data19.esignDisclosureBusinessName !==
                                                      undefined
                                                    ) {
                                                      const _errs48 = errors;
                                                      if (
                                                        typeof data19.esignDisclosureBusinessName !==
                                                        'string'
                                                      ) {
                                                        validate99.errors = [
                                                          {
                                                            instancePath:
                                                              instancePath +
                                                              '/esignDisclosureSettings/esignDisclosureBusinessName',
                                                            schemaPath:
                                                              '#/definitions/EsignDisclosureSettings/properties/esignDisclosureBusinessName/type',
                                                            keyword: 'type',
                                                            params: {
                                                              type: 'string',
                                                            },
                                                            message:
                                                              'must be string',
                                                          },
                                                        ];
                                                        return false;
                                                      }
                                                      var valid4 =
                                                        _errs48 === errors;
                                                    } else {
                                                      var valid4 = true;
                                                    }
                                                    if (valid4) {
                                                      if (
                                                        data19.esignDisclosureAdditionalText !==
                                                        undefined
                                                      ) {
                                                        const _errs50 = errors;
                                                        if (
                                                          typeof data19.esignDisclosureAdditionalText !==
                                                          'string'
                                                        ) {
                                                          validate99.errors = [
                                                            {
                                                              instancePath:
                                                                instancePath +
                                                                '/esignDisclosureSettings/esignDisclosureAdditionalText',
                                                              schemaPath:
                                                                '#/definitions/EsignDisclosureSettings/properties/esignDisclosureAdditionalText/type',
                                                              keyword: 'type',
                                                              params: {
                                                                type: 'string',
                                                              },
                                                              message:
                                                                'must be string',
                                                            },
                                                          ];
                                                          return false;
                                                        }
                                                        var valid4 =
                                                          _errs50 === errors;
                                                      } else {
                                                        var valid4 = true;
                                                      }
                                                    }
                                                  }
                                                }
                                              } else {
                                                validate99.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/esignDisclosureSettings',
                                                    schemaPath:
                                                      '#/definitions/EsignDisclosureSettings/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object',
                                                  },
                                                ];
                                                return false;
                                              }
                                            }
                                            var valid0 = _errs41 === errors;
                                          } else {
                                            var valid0 = true;
                                          }
                                          if (valid0) {
                                            if (
                                              data.dataResidencySettings !==
                                              undefined
                                            ) {
                                              let data24 =
                                                data.dataResidencySettings;
                                              const _errs52 = errors;
                                              const _errs53 = errors;
                                              if (errors === _errs53) {
                                                if (
                                                  data24 &&
                                                  typeof data24 == 'object' &&
                                                  !Array.isArray(data24)
                                                ) {
                                                  let missing1;
                                                  if (
                                                    (data24.dataResidencyEnabled ===
                                                      undefined &&
                                                      (missing1 =
                                                        'dataResidencyEnabled')) ||
                                                    (data24.selectedDataResidency ===
                                                      undefined &&
                                                      (missing1 =
                                                        'selectedDataResidency')) ||
                                                    (data24.dataResidencyOptions ===
                                                      undefined &&
                                                      (missing1 =
                                                        'dataResidencyOptions'))
                                                  ) {
                                                    validate99.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath +
                                                          '/dataResidencySettings',
                                                        schemaPath:
                                                          '#/definitions/DataResidencySettings/required',
                                                        keyword: 'required',
                                                        params: {
                                                          missingProperty:
                                                            missing1,
                                                        },
                                                        message:
                                                          "must have required property '" +
                                                          missing1 +
                                                          "'",
                                                      },
                                                    ];
                                                    return false;
                                                  } else {
                                                    if (
                                                      data24.dataResidencyEnabled !==
                                                      undefined
                                                    ) {
                                                      const _errs55 = errors;
                                                      if (
                                                        typeof data24.dataResidencyEnabled !==
                                                        'boolean'
                                                      ) {
                                                        validate99.errors = [
                                                          {
                                                            instancePath:
                                                              instancePath +
                                                              '/dataResidencySettings/dataResidencyEnabled',
                                                            schemaPath:
                                                              '#/definitions/DataResidencySettings/properties/dataResidencyEnabled/type',
                                                            keyword: 'type',
                                                            params: {
                                                              type: 'boolean',
                                                            },
                                                            message:
                                                              'must be boolean',
                                                          },
                                                        ];
                                                        return false;
                                                      }
                                                      var valid6 =
                                                        _errs55 === errors;
                                                    } else {
                                                      var valid6 = true;
                                                    }
                                                    if (valid6) {
                                                      if (
                                                        data24.selectedDataResidency !==
                                                        undefined
                                                      ) {
                                                        const _errs57 = errors;
                                                        if (
                                                          typeof data24.selectedDataResidency !==
                                                          'string'
                                                        ) {
                                                          validate99.errors = [
                                                            {
                                                              instancePath:
                                                                instancePath +
                                                                '/dataResidencySettings/selectedDataResidency',
                                                              schemaPath:
                                                                '#/definitions/DataResidencySettings/properties/selectedDataResidency/type',
                                                              keyword: 'type',
                                                              params: {
                                                                type: 'string',
                                                              },
                                                              message:
                                                                'must be string',
                                                            },
                                                          ];
                                                          return false;
                                                        }
                                                        var valid6 =
                                                          _errs57 === errors;
                                                      } else {
                                                        var valid6 = true;
                                                      }
                                                      if (valid6) {
                                                        if (
                                                          data24.dataResidencyOptions !==
                                                          undefined
                                                        ) {
                                                          let data27 =
                                                            data24.dataResidencyOptions;
                                                          const _errs59 =
                                                            errors;
                                                          if (
                                                            errors === _errs59
                                                          ) {
                                                            if (
                                                              Array.isArray(
                                                                data27
                                                              )
                                                            ) {
                                                              var valid7 = true;
                                                              const len0 =
                                                                data27.length;
                                                              for (
                                                                let i0 = 0;
                                                                i0 < len0;
                                                                i0++
                                                              ) {
                                                                const _errs61 =
                                                                  errors;
                                                                if (
                                                                  typeof data27[
                                                                    i0
                                                                  ] !== 'string'
                                                                ) {
                                                                  validate99.errors =
                                                                    [
                                                                      {
                                                                        instancePath:
                                                                          instancePath +
                                                                          '/dataResidencySettings/dataResidencyOptions/' +
                                                                          i0,
                                                                        schemaPath:
                                                                          '#/definitions/DataResidencySettings/properties/dataResidencyOptions/items/type',
                                                                        keyword:
                                                                          'type',
                                                                        params:
                                                                          {
                                                                            type: 'string',
                                                                          },
                                                                        message:
                                                                          'must be string',
                                                                      },
                                                                    ];
                                                                  return false;
                                                                }
                                                                var valid7 =
                                                                  _errs61 ===
                                                                  errors;
                                                                if (!valid7) {
                                                                  break;
                                                                }
                                                              }
                                                            } else {
                                                              validate99.errors =
                                                                [
                                                                  {
                                                                    instancePath:
                                                                      instancePath +
                                                                      '/dataResidencySettings/dataResidencyOptions',
                                                                    schemaPath:
                                                                      '#/definitions/DataResidencySettings/properties/dataResidencyOptions/type',
                                                                    keyword:
                                                                      'type',
                                                                    params: {
                                                                      type: 'array',
                                                                    },
                                                                    message:
                                                                      'must be array',
                                                                  },
                                                                ];
                                                              return false;
                                                            }
                                                          }
                                                          var valid6 =
                                                            _errs59 === errors;
                                                        } else {
                                                          var valid6 = true;
                                                        }
                                                      }
                                                    }
                                                  }
                                                } else {
                                                  validate99.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/dataResidencySettings',
                                                      schemaPath:
                                                        '#/definitions/DataResidencySettings/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'object',
                                                      },
                                                      message: 'must be object',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                              }
                                              var valid0 = _errs52 === errors;
                                            } else {
                                              var valid0 = true;
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate99.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate99.errors = vErrors;
  return errors === 0;
}
const schema116 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'AccountIntegrationSettings.json',
  type: 'object',
  title: 'AccountIntegrationSettings',
  properties: {
    authUrl: {
      type: 'string',
      $comment:
        'AccountIntegrationSettings is also used as the response when updating an integration, so it MAY include a redirect URL',
    },
    integrationSettings: {
      type: 'array',
      items: {
        oneOf: [
          { $ref: '#/definitions/EditableIntegration' },
          { $ref: '#/definitions/LinkedIntegration' },
        ],
      },
    },
  },
  required: ['integrationSettings'],
  definitions: {
    EditableIntegration: {
      type: 'object',
      title: 'EditableIntegration',
      properties: {
        name: { type: 'string' },
        serviceTypeCode: { type: 'string' },
        isEnabled: { type: 'boolean' },
        isActive: { type: 'boolean' },
      },
      required: ['name', 'serviceTypeCode', 'isEnabled', 'isActive'],
    },
    LinkedIntegration: {
      type: 'object',
      title: 'LinkedIntegration',
      properties: {
        name: { type: 'string' },
        isEnabled: { type: 'boolean' },
        buttonLink: { type: 'string' },
      },
      required: ['name', 'buttonLink', 'isEnabled'],
    },
  },
};
const schema117 = {
  type: 'object',
  title: 'EditableIntegration',
  properties: {
    name: { type: 'string' },
    serviceTypeCode: { type: 'string' },
    isEnabled: { type: 'boolean' },
    isActive: { type: 'boolean' },
  },
  required: ['name', 'serviceTypeCode', 'isEnabled', 'isActive'],
};
const schema118 = {
  type: 'object',
  title: 'LinkedIntegration',
  properties: {
    name: { type: 'string' },
    isEnabled: { type: 'boolean' },
    buttonLink: { type: 'string' },
  },
  required: ['name', 'buttonLink', 'isEnabled'],
};
function validate101(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="AccountIntegrationSettings.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        data.integrationSettings === undefined &&
        (missing0 = 'integrationSettings')
      ) {
        validate101.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.authUrl !== undefined) {
          const _errs1 = errors;
          if (typeof data.authUrl !== 'string') {
            validate101.errors = [
              {
                instancePath: instancePath + '/authUrl',
                schemaPath: '#/properties/authUrl/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.integrationSettings !== undefined) {
            let data1 = data.integrationSettings;
            const _errs4 = errors;
            if (errors === _errs4) {
              if (Array.isArray(data1)) {
                var valid1 = true;
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  let data2 = data1[i0];
                  const _errs6 = errors;
                  const _errs7 = errors;
                  let valid2 = false;
                  let passing0 = null;
                  const _errs8 = errors;
                  const _errs9 = errors;
                  if (errors === _errs9) {
                    if (
                      data2 &&
                      typeof data2 == 'object' &&
                      !Array.isArray(data2)
                    ) {
                      let missing1;
                      if (
                        (data2.name === undefined && (missing1 = 'name')) ||
                        (data2.serviceTypeCode === undefined &&
                          (missing1 = 'serviceTypeCode')) ||
                        (data2.isEnabled === undefined &&
                          (missing1 = 'isEnabled')) ||
                        (data2.isActive === undefined &&
                          (missing1 = 'isActive'))
                      ) {
                        const err0 = {
                          instancePath:
                            instancePath + '/integrationSettings/' + i0,
                          schemaPath:
                            '#/definitions/EditableIntegration/required',
                          keyword: 'required',
                          params: { missingProperty: missing1 },
                          message:
                            "must have required property '" + missing1 + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err0];
                        } else {
                          vErrors.push(err0);
                        }
                        errors++;
                      } else {
                        if (data2.name !== undefined) {
                          const _errs11 = errors;
                          if (typeof data2.name !== 'string') {
                            const err1 = {
                              instancePath:
                                instancePath +
                                '/integrationSettings/' +
                                i0 +
                                '/name',
                              schemaPath:
                                '#/definitions/EditableIntegration/properties/name/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            };
                            if (vErrors === null) {
                              vErrors = [err1];
                            } else {
                              vErrors.push(err1);
                            }
                            errors++;
                          }
                          var valid4 = _errs11 === errors;
                        } else {
                          var valid4 = true;
                        }
                        if (valid4) {
                          if (data2.serviceTypeCode !== undefined) {
                            const _errs13 = errors;
                            if (typeof data2.serviceTypeCode !== 'string') {
                              const err2 = {
                                instancePath:
                                  instancePath +
                                  '/integrationSettings/' +
                                  i0 +
                                  '/serviceTypeCode',
                                schemaPath:
                                  '#/definitions/EditableIntegration/properties/serviceTypeCode/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              };
                              if (vErrors === null) {
                                vErrors = [err2];
                              } else {
                                vErrors.push(err2);
                              }
                              errors++;
                            }
                            var valid4 = _errs13 === errors;
                          } else {
                            var valid4 = true;
                          }
                          if (valid4) {
                            if (data2.isEnabled !== undefined) {
                              const _errs15 = errors;
                              if (typeof data2.isEnabled !== 'boolean') {
                                const err3 = {
                                  instancePath:
                                    instancePath +
                                    '/integrationSettings/' +
                                    i0 +
                                    '/isEnabled',
                                  schemaPath:
                                    '#/definitions/EditableIntegration/properties/isEnabled/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                };
                                if (vErrors === null) {
                                  vErrors = [err3];
                                } else {
                                  vErrors.push(err3);
                                }
                                errors++;
                              }
                              var valid4 = _errs15 === errors;
                            } else {
                              var valid4 = true;
                            }
                            if (valid4) {
                              if (data2.isActive !== undefined) {
                                const _errs17 = errors;
                                if (typeof data2.isActive !== 'boolean') {
                                  const err4 = {
                                    instancePath:
                                      instancePath +
                                      '/integrationSettings/' +
                                      i0 +
                                      '/isActive',
                                    schemaPath:
                                      '#/definitions/EditableIntegration/properties/isActive/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err4];
                                  } else {
                                    vErrors.push(err4);
                                  }
                                  errors++;
                                }
                                var valid4 = _errs17 === errors;
                              } else {
                                var valid4 = true;
                              }
                            }
                          }
                        }
                      }
                    } else {
                      const err5 = {
                        instancePath:
                          instancePath + '/integrationSettings/' + i0,
                        schemaPath: '#/definitions/EditableIntegration/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                      };
                      if (vErrors === null) {
                        vErrors = [err5];
                      } else {
                        vErrors.push(err5);
                      }
                      errors++;
                    }
                  }
                  var _valid0 = _errs8 === errors;
                  if (_valid0) {
                    valid2 = true;
                    passing0 = 0;
                  }
                  const _errs19 = errors;
                  const _errs20 = errors;
                  if (errors === _errs20) {
                    if (
                      data2 &&
                      typeof data2 == 'object' &&
                      !Array.isArray(data2)
                    ) {
                      let missing2;
                      if (
                        (data2.name === undefined && (missing2 = 'name')) ||
                        (data2.buttonLink === undefined &&
                          (missing2 = 'buttonLink')) ||
                        (data2.isEnabled === undefined &&
                          (missing2 = 'isEnabled'))
                      ) {
                        const err6 = {
                          instancePath:
                            instancePath + '/integrationSettings/' + i0,
                          schemaPath:
                            '#/definitions/LinkedIntegration/required',
                          keyword: 'required',
                          params: { missingProperty: missing2 },
                          message:
                            "must have required property '" + missing2 + "'",
                        };
                        if (vErrors === null) {
                          vErrors = [err6];
                        } else {
                          vErrors.push(err6);
                        }
                        errors++;
                      } else {
                        if (data2.name !== undefined) {
                          const _errs22 = errors;
                          if (typeof data2.name !== 'string') {
                            const err7 = {
                              instancePath:
                                instancePath +
                                '/integrationSettings/' +
                                i0 +
                                '/name',
                              schemaPath:
                                '#/definitions/LinkedIntegration/properties/name/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            };
                            if (vErrors === null) {
                              vErrors = [err7];
                            } else {
                              vErrors.push(err7);
                            }
                            errors++;
                          }
                          var valid6 = _errs22 === errors;
                        } else {
                          var valid6 = true;
                        }
                        if (valid6) {
                          if (data2.isEnabled !== undefined) {
                            const _errs24 = errors;
                            if (typeof data2.isEnabled !== 'boolean') {
                              const err8 = {
                                instancePath:
                                  instancePath +
                                  '/integrationSettings/' +
                                  i0 +
                                  '/isEnabled',
                                schemaPath:
                                  '#/definitions/LinkedIntegration/properties/isEnabled/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              };
                              if (vErrors === null) {
                                vErrors = [err8];
                              } else {
                                vErrors.push(err8);
                              }
                              errors++;
                            }
                            var valid6 = _errs24 === errors;
                          } else {
                            var valid6 = true;
                          }
                          if (valid6) {
                            if (data2.buttonLink !== undefined) {
                              const _errs26 = errors;
                              if (typeof data2.buttonLink !== 'string') {
                                const err9 = {
                                  instancePath:
                                    instancePath +
                                    '/integrationSettings/' +
                                    i0 +
                                    '/buttonLink',
                                  schemaPath:
                                    '#/definitions/LinkedIntegration/properties/buttonLink/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                };
                                if (vErrors === null) {
                                  vErrors = [err9];
                                } else {
                                  vErrors.push(err9);
                                }
                                errors++;
                              }
                              var valid6 = _errs26 === errors;
                            } else {
                              var valid6 = true;
                            }
                          }
                        }
                      }
                    } else {
                      const err10 = {
                        instancePath:
                          instancePath + '/integrationSettings/' + i0,
                        schemaPath: '#/definitions/LinkedIntegration/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                      };
                      if (vErrors === null) {
                        vErrors = [err10];
                      } else {
                        vErrors.push(err10);
                      }
                      errors++;
                    }
                  }
                  var _valid0 = _errs19 === errors;
                  if (_valid0 && valid2) {
                    valid2 = false;
                    passing0 = [passing0, 1];
                  } else {
                    if (_valid0) {
                      valid2 = true;
                      passing0 = 1;
                    }
                  }
                  if (!valid2) {
                    const err11 = {
                      instancePath: instancePath + '/integrationSettings/' + i0,
                      schemaPath:
                        '#/properties/integrationSettings/items/oneOf',
                      keyword: 'oneOf',
                      params: { passingSchemas: passing0 },
                      message: 'must match exactly one schema in oneOf',
                    };
                    if (vErrors === null) {
                      vErrors = [err11];
                    } else {
                      vErrors.push(err11);
                    }
                    errors++;
                    validate101.errors = vErrors;
                    return false;
                  } else {
                    errors = _errs7;
                    if (vErrors !== null) {
                      if (_errs7) {
                        vErrors.length = _errs7;
                      } else {
                        vErrors = null;
                      }
                    }
                  }
                  var valid1 = _errs6 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate101.errors = [
                  {
                    instancePath: instancePath + '/integrationSettings',
                    schemaPath: '#/properties/integrationSettings/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                  },
                ];
                return false;
              }
            }
            var valid0 = _errs4 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate101.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate101.errors = vErrors;
  return errors === 0;
}
const schema119 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'AccountProfileSettings.json',
  type: 'object',
  title: 'AccountProfileSettings',
  properties: {
    isHf: { type: 'boolean' },
    supportEmailAddress: { type: 'string' },
    canChangeEmailAddress: { type: 'boolean' },
    email: { type: 'string' },
    numContacts: { type: 'number' },
    faxNumbers: { type: 'array', items: { type: 'string' } },
    hasDKIMAuthentication: { type: 'boolean' },
    hasSPFAuthentication: { type: 'boolean' },
    isEmailAuthenticationEnabled: { type: 'boolean' },
    hasPendingSignatures: { type: 'boolean' },
    hasPaidSubscription: { type: 'boolean' },
    canChangePassword: { type: 'boolean' },
    hasTempPassword: { type: 'boolean' },
    isAccountConfirmed: { type: 'boolean' },
    showEsignDisclosure: { type: 'boolean' },
    firstName: { type: 'string' },
    lastName: { type: 'string' },
    accountLocale: { type: 'string' },
    company: { type: 'string' },
    industry: { type: 'string' },
    jobTitle: { type: 'string' },
    department: { type: 'string' },
    dateFormat: { type: 'string' },
    isTimezoneLocked: { type: 'boolean' },
    timezone: { type: 'string' },
    shouldAutocomplete: { type: 'boolean' },
    shouldEnableTamperProof: { type: 'boolean' },
    hasTeam: { type: 'boolean' },
    isTeamAdmin: { type: 'boolean' },
    numTeamMembers: { type: 'number' },
    canDeleteAccount: { type: 'boolean' },
    hasSubscription: { $comment: 'is_paid_sub_on_this_site', type: 'boolean' },
    hasSubscriptionFrom: {
      $comment:
        'other_site_name https://github.com/HelloFax/HelloFax/blob/bf0714ab2f859153758f87d1717ee2c7bdf2c5a8/apps/webapp/modules/home/templates/myAccount/_profile.php#L513',
      type: 'string',
    },
    cancelUrl: { type: 'string' },
    hasBillingRestriction: { type: 'boolean' },
    notifications: { $ref: '#/definitions/AccountProfileNotifications' },
    multiFactorPhoneNumber: { type: 'string' },
    hasMultiFactorSMSVerification: { type: 'boolean' },
    hasMultiFactorGoogleAuthenticator: { type: 'boolean' },
    hasGoogleAuthenticatorAccess: { type: 'boolean' },
    hasSMSVerficationAccess: { type: 'boolean' },
    businessName: { type: 'string' },
    additionalDisclosureText: { type: 'string' },
    hasEsignDisclosureAccess: { type: 'boolean' },
    timezoneOptions: { type: 'array', items: { $ref: 'Timezone.json' } },
    hipaaLock: { $ref: '#/definitions/HipaaLock' },
    cancelSubscriptionLink: { type: 'string' },
  },
  definitions: {
    HipaaLock: {
      type: 'object',
      title: 'HipaaLock',
      properties: {
        shouldIncludeReceivedFaxPDFs: { type: 'boolean' },
        shouldIncludeReceivedFaxPDFsForOthers: { type: 'boolean' },
        shouldIncludeSentFaxPDFs: { type: 'boolean' },
        shouldIncludeRequestedPDFs: { type: 'boolean' },
        shouldIncludeRequestedPDFsForOthers: { type: 'boolean' },
        shouldIncludeSentDocPDFs: { type: 'boolean' },
        shouldIncludeSentDocPDFsForOthers: { type: 'boolean' },
      },
      required: [
        'shouldIncludeReceivedFaxPDFs',
        'shouldIncludeReceivedFaxPDFsForOthers',
        'shouldIncludeSentFaxPDFs',
        'shouldIncludeRequestedPDFs',
        'shouldIncludeRequestedPDFsForOthers',
        'shouldIncludeSentDocPDFs',
        'shouldIncludeSentDocPDFsForOthers',
      ],
    },
    AccountProfileNotifications: {
      type: 'object',
      title: 'AccountProfileNotifications',
      properties: {
        shouldIncludeReceivedFaxPDFs: { type: 'boolean' },
        shouldIncludeReceivedFaxPDFsForOthers: { type: 'boolean' },
        shouldIncludeSentFaxPDFs: { type: 'boolean' },
        isOptedInMarketingEmails: { type: 'boolean' },
        isSignatureRemindersEnabled: { type: 'boolean' },
        shouldSendOutboundConfEmails: { type: 'boolean' },
        isNotifyOnSignEnabled: { type: 'boolean' },
        isNotifyOnViewEnabled: { type: 'boolean' },
        shouldSendEmbeddedSignatureConfEmails: { type: 'boolean' },
        shouldSendDailySummary: { type: 'boolean' },
        shouldSendOrderedSREmail: { type: 'boolean' },
        shouldIncludeRequestedPDFs: { type: 'boolean' },
        shouldIncludeRequestedPDFsForOthers: { type: 'boolean' },
        shouldIncludeSentDocPDFs: { type: 'boolean' },
        shouldIncludeSentDocPDFsForOthers: { type: 'boolean' },
        isEmailAuthenticationEnabled: { type: 'boolean' },
        notifyCCOnDocumentSend: { type: 'boolean' },
        notifyCCOnDocumentCompleted: { type: 'boolean' },
        notifyCCOnDocumentDeclined: { type: 'boolean' },
        notifyCCOnDocumentView: { type: 'boolean' },
        notifyCCOnDocumentDelegate: { type: 'boolean' },
        hasSMSSignatureDelivery: { type: 'boolean' },
      },
      required: [
        'shouldIncludeReceivedFaxPDFs',
        'shouldIncludeReceivedFaxPDFsForOthers',
        'shouldIncludeSentFaxPDFs',
        'isOptedInMarketingEmails',
        'isSignatureRemindersEnabled',
        'shouldSendOutboundConfEmails',
        'isNotifyOnSignEnabled',
        'isNotifyOnViewEnabled',
        'shouldSendEmbeddedSignatureConfEmails',
        'shouldSendDailySummary',
        'shouldSendOrderedSREmail',
        'shouldIncludeRequestedPDFs',
        'shouldIncludeRequestedPDFsForOthers',
        'shouldIncludeSentDocPDFs',
        'shouldIncludeSentDocPDFsForOthers',
        'isEmailAuthenticationEnabled',
        'notifyCCOnDocumentSend',
        'notifyCCOnDocumentCompleted',
        'notifyCCOnDocumentDeclined',
        'notifyCCOnDocumentView',
        'notifyCCOnDocumentDelegate',
        'hasSMSSignatureDelivery',
      ],
    },
  },
  required: [
    'isHf',
    'supportEmailAddress',
    'canChangeEmailAddress',
    'email',
    'numContacts',
    'faxNumbers',
    'hasDKIMAuthentication',
    'hasSPFAuthentication',
    'isEmailAuthenticationEnabled',
    'hasPendingSignatures',
    'hasPaidSubscription',
    'canChangePassword',
    'hasTempPassword',
    'isAccountConfirmed',
    'showEsignDisclosure',
    'firstName',
    'lastName',
    'accountLocale',
    'company',
    'industry',
    'jobTitle',
    'department',
    'dateFormat',
    'isTimezoneLocked',
    'timezone',
    'shouldAutocomplete',
    'shouldEnableTamperProof',
    'numTeamMembers',
    'canDeleteAccount',
    'hasSubscription',
    'hasSubscriptionFrom',
    'cancelUrl',
    'hasBillingRestriction',
    'notifications',
    'multiFactorPhoneNumber',
    'hasMultiFactorSMSVerification',
    'hasMultiFactorGoogleAuthenticator',
    'hasGoogleAuthenticatorAccess',
    'hasSMSVerficationAccess',
    'businessName',
    'additionalDisclosureText',
    'hasEsignDisclosureAccess',
    'timezoneOptions',
    'hipaaLock',
    'cancelSubscriptionLink',
  ],
};
const schema120 = {
  type: 'object',
  title: 'AccountProfileNotifications',
  properties: {
    shouldIncludeReceivedFaxPDFs: { type: 'boolean' },
    shouldIncludeReceivedFaxPDFsForOthers: { type: 'boolean' },
    shouldIncludeSentFaxPDFs: { type: 'boolean' },
    isOptedInMarketingEmails: { type: 'boolean' },
    isSignatureRemindersEnabled: { type: 'boolean' },
    shouldSendOutboundConfEmails: { type: 'boolean' },
    isNotifyOnSignEnabled: { type: 'boolean' },
    isNotifyOnViewEnabled: { type: 'boolean' },
    shouldSendEmbeddedSignatureConfEmails: { type: 'boolean' },
    shouldSendDailySummary: { type: 'boolean' },
    shouldSendOrderedSREmail: { type: 'boolean' },
    shouldIncludeRequestedPDFs: { type: 'boolean' },
    shouldIncludeRequestedPDFsForOthers: { type: 'boolean' },
    shouldIncludeSentDocPDFs: { type: 'boolean' },
    shouldIncludeSentDocPDFsForOthers: { type: 'boolean' },
    isEmailAuthenticationEnabled: { type: 'boolean' },
    notifyCCOnDocumentSend: { type: 'boolean' },
    notifyCCOnDocumentCompleted: { type: 'boolean' },
    notifyCCOnDocumentDeclined: { type: 'boolean' },
    notifyCCOnDocumentView: { type: 'boolean' },
    notifyCCOnDocumentDelegate: { type: 'boolean' },
    hasSMSSignatureDelivery: { type: 'boolean' },
  },
  required: [
    'shouldIncludeReceivedFaxPDFs',
    'shouldIncludeReceivedFaxPDFsForOthers',
    'shouldIncludeSentFaxPDFs',
    'isOptedInMarketingEmails',
    'isSignatureRemindersEnabled',
    'shouldSendOutboundConfEmails',
    'isNotifyOnSignEnabled',
    'isNotifyOnViewEnabled',
    'shouldSendEmbeddedSignatureConfEmails',
    'shouldSendDailySummary',
    'shouldSendOrderedSREmail',
    'shouldIncludeRequestedPDFs',
    'shouldIncludeRequestedPDFsForOthers',
    'shouldIncludeSentDocPDFs',
    'shouldIncludeSentDocPDFsForOthers',
    'isEmailAuthenticationEnabled',
    'notifyCCOnDocumentSend',
    'notifyCCOnDocumentCompleted',
    'notifyCCOnDocumentDeclined',
    'notifyCCOnDocumentView',
    'notifyCCOnDocumentDelegate',
    'hasSMSSignatureDelivery',
  ],
};
const schema121 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'Timezone.json',
  type: 'object',
  title: 'Timezone',
  properties: {
    offset: { type: 'number' },
    hasDST: { type: 'boolean' },
    displayName: { type: 'string' },
  },
  required: ['offset', 'hasDST', 'displayName'],
};
const schema122 = {
  type: 'object',
  title: 'HipaaLock',
  properties: {
    shouldIncludeReceivedFaxPDFs: { type: 'boolean' },
    shouldIncludeReceivedFaxPDFsForOthers: { type: 'boolean' },
    shouldIncludeSentFaxPDFs: { type: 'boolean' },
    shouldIncludeRequestedPDFs: { type: 'boolean' },
    shouldIncludeRequestedPDFsForOthers: { type: 'boolean' },
    shouldIncludeSentDocPDFs: { type: 'boolean' },
    shouldIncludeSentDocPDFsForOthers: { type: 'boolean' },
  },
  required: [
    'shouldIncludeReceivedFaxPDFs',
    'shouldIncludeReceivedFaxPDFsForOthers',
    'shouldIncludeSentFaxPDFs',
    'shouldIncludeRequestedPDFs',
    'shouldIncludeRequestedPDFsForOthers',
    'shouldIncludeSentDocPDFs',
    'shouldIncludeSentDocPDFsForOthers',
  ],
};
function validate103(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="AccountProfileSettings.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.isHf === undefined && (missing0 = 'isHf')) ||
        (data.supportEmailAddress === undefined &&
          (missing0 = 'supportEmailAddress')) ||
        (data.canChangeEmailAddress === undefined &&
          (missing0 = 'canChangeEmailAddress')) ||
        (data.email === undefined && (missing0 = 'email')) ||
        (data.numContacts === undefined && (missing0 = 'numContacts')) ||
        (data.faxNumbers === undefined && (missing0 = 'faxNumbers')) ||
        (data.hasDKIMAuthentication === undefined &&
          (missing0 = 'hasDKIMAuthentication')) ||
        (data.hasSPFAuthentication === undefined &&
          (missing0 = 'hasSPFAuthentication')) ||
        (data.isEmailAuthenticationEnabled === undefined &&
          (missing0 = 'isEmailAuthenticationEnabled')) ||
        (data.hasPendingSignatures === undefined &&
          (missing0 = 'hasPendingSignatures')) ||
        (data.hasPaidSubscription === undefined &&
          (missing0 = 'hasPaidSubscription')) ||
        (data.canChangePassword === undefined &&
          (missing0 = 'canChangePassword')) ||
        (data.hasTempPassword === undefined &&
          (missing0 = 'hasTempPassword')) ||
        (data.isAccountConfirmed === undefined &&
          (missing0 = 'isAccountConfirmed')) ||
        (data.showEsignDisclosure === undefined &&
          (missing0 = 'showEsignDisclosure')) ||
        (data.firstName === undefined && (missing0 = 'firstName')) ||
        (data.lastName === undefined && (missing0 = 'lastName')) ||
        (data.accountLocale === undefined && (missing0 = 'accountLocale')) ||
        (data.company === undefined && (missing0 = 'company')) ||
        (data.industry === undefined && (missing0 = 'industry')) ||
        (data.jobTitle === undefined && (missing0 = 'jobTitle')) ||
        (data.department === undefined && (missing0 = 'department')) ||
        (data.dateFormat === undefined && (missing0 = 'dateFormat')) ||
        (data.isTimezoneLocked === undefined &&
          (missing0 = 'isTimezoneLocked')) ||
        (data.timezone === undefined && (missing0 = 'timezone')) ||
        (data.shouldAutocomplete === undefined &&
          (missing0 = 'shouldAutocomplete')) ||
        (data.shouldEnableTamperProof === undefined &&
          (missing0 = 'shouldEnableTamperProof')) ||
        (data.numTeamMembers === undefined && (missing0 = 'numTeamMembers')) ||
        (data.canDeleteAccount === undefined &&
          (missing0 = 'canDeleteAccount')) ||
        (data.hasSubscription === undefined &&
          (missing0 = 'hasSubscription')) ||
        (data.hasSubscriptionFrom === undefined &&
          (missing0 = 'hasSubscriptionFrom')) ||
        (data.cancelUrl === undefined && (missing0 = 'cancelUrl')) ||
        (data.hasBillingRestriction === undefined &&
          (missing0 = 'hasBillingRestriction')) ||
        (data.notifications === undefined && (missing0 = 'notifications')) ||
        (data.multiFactorPhoneNumber === undefined &&
          (missing0 = 'multiFactorPhoneNumber')) ||
        (data.hasMultiFactorSMSVerification === undefined &&
          (missing0 = 'hasMultiFactorSMSVerification')) ||
        (data.hasMultiFactorGoogleAuthenticator === undefined &&
          (missing0 = 'hasMultiFactorGoogleAuthenticator')) ||
        (data.hasGoogleAuthenticatorAccess === undefined &&
          (missing0 = 'hasGoogleAuthenticatorAccess')) ||
        (data.hasSMSVerficationAccess === undefined &&
          (missing0 = 'hasSMSVerficationAccess')) ||
        (data.businessName === undefined && (missing0 = 'businessName')) ||
        (data.additionalDisclosureText === undefined &&
          (missing0 = 'additionalDisclosureText')) ||
        (data.hasEsignDisclosureAccess === undefined &&
          (missing0 = 'hasEsignDisclosureAccess')) ||
        (data.timezoneOptions === undefined &&
          (missing0 = 'timezoneOptions')) ||
        (data.hipaaLock === undefined && (missing0 = 'hipaaLock')) ||
        (data.cancelSubscriptionLink === undefined &&
          (missing0 = 'cancelSubscriptionLink'))
      ) {
        validate103.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.isHf !== undefined) {
          const _errs1 = errors;
          if (typeof data.isHf !== 'boolean') {
            validate103.errors = [
              {
                instancePath: instancePath + '/isHf',
                schemaPath: '#/properties/isHf/type',
                keyword: 'type',
                params: { type: 'boolean' },
                message: 'must be boolean',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.supportEmailAddress !== undefined) {
            const _errs3 = errors;
            if (typeof data.supportEmailAddress !== 'string') {
              validate103.errors = [
                {
                  instancePath: instancePath + '/supportEmailAddress',
                  schemaPath: '#/properties/supportEmailAddress/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.canChangeEmailAddress !== undefined) {
              const _errs5 = errors;
              if (typeof data.canChangeEmailAddress !== 'boolean') {
                validate103.errors = [
                  {
                    instancePath: instancePath + '/canChangeEmailAddress',
                    schemaPath: '#/properties/canChangeEmailAddress/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.email !== undefined) {
                const _errs7 = errors;
                if (typeof data.email !== 'string') {
                  validate103.errors = [
                    {
                      instancePath: instancePath + '/email',
                      schemaPath: '#/properties/email/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.numContacts !== undefined) {
                  let data4 = data.numContacts;
                  const _errs9 = errors;
                  if (!(typeof data4 == 'number' && isFinite(data4))) {
                    validate103.errors = [
                      {
                        instancePath: instancePath + '/numContacts',
                        schemaPath: '#/properties/numContacts/type',
                        keyword: 'type',
                        params: { type: 'number' },
                        message: 'must be number',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.faxNumbers !== undefined) {
                    let data5 = data.faxNumbers;
                    const _errs11 = errors;
                    if (errors === _errs11) {
                      if (Array.isArray(data5)) {
                        var valid1 = true;
                        const len0 = data5.length;
                        for (let i0 = 0; i0 < len0; i0++) {
                          const _errs13 = errors;
                          if (typeof data5[i0] !== 'string') {
                            validate103.errors = [
                              {
                                instancePath:
                                  instancePath + '/faxNumbers/' + i0,
                                schemaPath:
                                  '#/properties/faxNumbers/items/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid1 = _errs13 === errors;
                          if (!valid1) {
                            break;
                          }
                        }
                      } else {
                        validate103.errors = [
                          {
                            instancePath: instancePath + '/faxNumbers',
                            schemaPath: '#/properties/faxNumbers/type',
                            keyword: 'type',
                            params: { type: 'array' },
                            message: 'must be array',
                          },
                        ];
                        return false;
                      }
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.hasDKIMAuthentication !== undefined) {
                      const _errs15 = errors;
                      if (typeof data.hasDKIMAuthentication !== 'boolean') {
                        validate103.errors = [
                          {
                            instancePath:
                              instancePath + '/hasDKIMAuthentication',
                            schemaPath:
                              '#/properties/hasDKIMAuthentication/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs15 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.hasSPFAuthentication !== undefined) {
                        const _errs17 = errors;
                        if (typeof data.hasSPFAuthentication !== 'boolean') {
                          validate103.errors = [
                            {
                              instancePath:
                                instancePath + '/hasSPFAuthentication',
                              schemaPath:
                                '#/properties/hasSPFAuthentication/type',
                              keyword: 'type',
                              params: { type: 'boolean' },
                              message: 'must be boolean',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs17 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.isEmailAuthenticationEnabled !== undefined) {
                          const _errs19 = errors;
                          if (
                            typeof data.isEmailAuthenticationEnabled !==
                            'boolean'
                          ) {
                            validate103.errors = [
                              {
                                instancePath:
                                  instancePath +
                                  '/isEmailAuthenticationEnabled',
                                schemaPath:
                                  '#/properties/isEmailAuthenticationEnabled/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs19 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.hasPendingSignatures !== undefined) {
                            const _errs21 = errors;
                            if (
                              typeof data.hasPendingSignatures !== 'boolean'
                            ) {
                              validate103.errors = [
                                {
                                  instancePath:
                                    instancePath + '/hasPendingSignatures',
                                  schemaPath:
                                    '#/properties/hasPendingSignatures/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs21 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.hasPaidSubscription !== undefined) {
                              const _errs23 = errors;
                              if (
                                typeof data.hasPaidSubscription !== 'boolean'
                              ) {
                                validate103.errors = [
                                  {
                                    instancePath:
                                      instancePath + '/hasPaidSubscription',
                                    schemaPath:
                                      '#/properties/hasPaidSubscription/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs23 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.canChangePassword !== undefined) {
                                const _errs25 = errors;
                                if (
                                  typeof data.canChangePassword !== 'boolean'
                                ) {
                                  validate103.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/canChangePassword',
                                      schemaPath:
                                        '#/properties/canChangePassword/type',
                                      keyword: 'type',
                                      params: { type: 'boolean' },
                                      message: 'must be boolean',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs25 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.hasTempPassword !== undefined) {
                                  const _errs27 = errors;
                                  if (
                                    typeof data.hasTempPassword !== 'boolean'
                                  ) {
                                    validate103.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/hasTempPassword',
                                        schemaPath:
                                          '#/properties/hasTempPassword/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs27 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.isAccountConfirmed !== undefined) {
                                    const _errs29 = errors;
                                    if (
                                      typeof data.isAccountConfirmed !==
                                      'boolean'
                                    ) {
                                      validate103.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/isAccountConfirmed',
                                          schemaPath:
                                            '#/properties/isAccountConfirmed/type',
                                          keyword: 'type',
                                          params: { type: 'boolean' },
                                          message: 'must be boolean',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid0 = _errs29 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (
                                      data.showEsignDisclosure !== undefined
                                    ) {
                                      const _errs31 = errors;
                                      if (
                                        typeof data.showEsignDisclosure !==
                                        'boolean'
                                      ) {
                                        validate103.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/showEsignDisclosure',
                                            schemaPath:
                                              '#/properties/showEsignDisclosure/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid0 = _errs31 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.firstName !== undefined) {
                                        const _errs33 = errors;
                                        if (
                                          typeof data.firstName !== 'string'
                                        ) {
                                          validate103.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/firstName',
                                              schemaPath:
                                                '#/properties/firstName/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid0 = _errs33 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (data.lastName !== undefined) {
                                          const _errs35 = errors;
                                          if (
                                            typeof data.lastName !== 'string'
                                          ) {
                                            validate103.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/lastName',
                                                schemaPath:
                                                  '#/properties/lastName/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid0 = _errs35 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                        if (valid0) {
                                          if (
                                            data.accountLocale !== undefined
                                          ) {
                                            const _errs37 = errors;
                                            if (
                                              typeof data.accountLocale !==
                                              'string'
                                            ) {
                                              validate103.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/accountLocale',
                                                  schemaPath:
                                                    '#/properties/accountLocale/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid0 = _errs37 === errors;
                                          } else {
                                            var valid0 = true;
                                          }
                                          if (valid0) {
                                            if (data.company !== undefined) {
                                              const _errs39 = errors;
                                              if (
                                                typeof data.company !== 'string'
                                              ) {
                                                validate103.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath + '/company',
                                                    schemaPath:
                                                      '#/properties/company/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid0 = _errs39 === errors;
                                            } else {
                                              var valid0 = true;
                                            }
                                            if (valid0) {
                                              if (data.industry !== undefined) {
                                                const _errs41 = errors;
                                                if (
                                                  typeof data.industry !==
                                                  'string'
                                                ) {
                                                  validate103.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/industry',
                                                      schemaPath:
                                                        '#/properties/industry/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'string',
                                                      },
                                                      message: 'must be string',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid0 = _errs41 === errors;
                                              } else {
                                                var valid0 = true;
                                              }
                                              if (valid0) {
                                                if (
                                                  data.jobTitle !== undefined
                                                ) {
                                                  const _errs43 = errors;
                                                  if (
                                                    typeof data.jobTitle !==
                                                    'string'
                                                  ) {
                                                    validate103.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath +
                                                          '/jobTitle',
                                                        schemaPath:
                                                          '#/properties/jobTitle/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'string',
                                                        },
                                                        message:
                                                          'must be string',
                                                      },
                                                    ];
                                                    return false;
                                                  }
                                                  var valid0 =
                                                    _errs43 === errors;
                                                } else {
                                                  var valid0 = true;
                                                }
                                                if (valid0) {
                                                  if (
                                                    data.department !==
                                                    undefined
                                                  ) {
                                                    const _errs45 = errors;
                                                    if (
                                                      typeof data.department !==
                                                      'string'
                                                    ) {
                                                      validate103.errors = [
                                                        {
                                                          instancePath:
                                                            instancePath +
                                                            '/department',
                                                          schemaPath:
                                                            '#/properties/department/type',
                                                          keyword: 'type',
                                                          params: {
                                                            type: 'string',
                                                          },
                                                          message:
                                                            'must be string',
                                                        },
                                                      ];
                                                      return false;
                                                    }
                                                    var valid0 =
                                                      _errs45 === errors;
                                                  } else {
                                                    var valid0 = true;
                                                  }
                                                  if (valid0) {
                                                    if (
                                                      data.dateFormat !==
                                                      undefined
                                                    ) {
                                                      const _errs47 = errors;
                                                      if (
                                                        typeof data.dateFormat !==
                                                        'string'
                                                      ) {
                                                        validate103.errors = [
                                                          {
                                                            instancePath:
                                                              instancePath +
                                                              '/dateFormat',
                                                            schemaPath:
                                                              '#/properties/dateFormat/type',
                                                            keyword: 'type',
                                                            params: {
                                                              type: 'string',
                                                            },
                                                            message:
                                                              'must be string',
                                                          },
                                                        ];
                                                        return false;
                                                      }
                                                      var valid0 =
                                                        _errs47 === errors;
                                                    } else {
                                                      var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                      if (
                                                        data.isTimezoneLocked !==
                                                        undefined
                                                      ) {
                                                        const _errs49 = errors;
                                                        if (
                                                          typeof data.isTimezoneLocked !==
                                                          'boolean'
                                                        ) {
                                                          validate103.errors = [
                                                            {
                                                              instancePath:
                                                                instancePath +
                                                                '/isTimezoneLocked',
                                                              schemaPath:
                                                                '#/properties/isTimezoneLocked/type',
                                                              keyword: 'type',
                                                              params: {
                                                                type: 'boolean',
                                                              },
                                                              message:
                                                                'must be boolean',
                                                            },
                                                          ];
                                                          return false;
                                                        }
                                                        var valid0 =
                                                          _errs49 === errors;
                                                      } else {
                                                        var valid0 = true;
                                                      }
                                                      if (valid0) {
                                                        if (
                                                          data.timezone !==
                                                          undefined
                                                        ) {
                                                          const _errs51 =
                                                            errors;
                                                          if (
                                                            typeof data.timezone !==
                                                            'string'
                                                          ) {
                                                            validate103.errors =
                                                              [
                                                                {
                                                                  instancePath:
                                                                    instancePath +
                                                                    '/timezone',
                                                                  schemaPath:
                                                                    '#/properties/timezone/type',
                                                                  keyword:
                                                                    'type',
                                                                  params: {
                                                                    type: 'string',
                                                                  },
                                                                  message:
                                                                    'must be string',
                                                                },
                                                              ];
                                                            return false;
                                                          }
                                                          var valid0 =
                                                            _errs51 === errors;
                                                        } else {
                                                          var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                          if (
                                                            data.shouldAutocomplete !==
                                                            undefined
                                                          ) {
                                                            const _errs53 =
                                                              errors;
                                                            if (
                                                              typeof data.shouldAutocomplete !==
                                                              'boolean'
                                                            ) {
                                                              validate103.errors =
                                                                [
                                                                  {
                                                                    instancePath:
                                                                      instancePath +
                                                                      '/shouldAutocomplete',
                                                                    schemaPath:
                                                                      '#/properties/shouldAutocomplete/type',
                                                                    keyword:
                                                                      'type',
                                                                    params: {
                                                                      type: 'boolean',
                                                                    },
                                                                    message:
                                                                      'must be boolean',
                                                                  },
                                                                ];
                                                              return false;
                                                            }
                                                            var valid0 =
                                                              _errs53 ===
                                                              errors;
                                                          } else {
                                                            var valid0 = true;
                                                          }
                                                          if (valid0) {
                                                            if (
                                                              data.shouldEnableTamperProof !==
                                                              undefined
                                                            ) {
                                                              const _errs55 =
                                                                errors;
                                                              if (
                                                                typeof data.shouldEnableTamperProof !==
                                                                'boolean'
                                                              ) {
                                                                validate103.errors =
                                                                  [
                                                                    {
                                                                      instancePath:
                                                                        instancePath +
                                                                        '/shouldEnableTamperProof',
                                                                      schemaPath:
                                                                        '#/properties/shouldEnableTamperProof/type',
                                                                      keyword:
                                                                        'type',
                                                                      params: {
                                                                        type: 'boolean',
                                                                      },
                                                                      message:
                                                                        'must be boolean',
                                                                    },
                                                                  ];
                                                                return false;
                                                              }
                                                              var valid0 =
                                                                _errs55 ===
                                                                errors;
                                                            } else {
                                                              var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                              if (
                                                                data.hasTeam !==
                                                                undefined
                                                              ) {
                                                                const _errs57 =
                                                                  errors;
                                                                if (
                                                                  typeof data.hasTeam !==
                                                                  'boolean'
                                                                ) {
                                                                  validate103.errors =
                                                                    [
                                                                      {
                                                                        instancePath:
                                                                          instancePath +
                                                                          '/hasTeam',
                                                                        schemaPath:
                                                                          '#/properties/hasTeam/type',
                                                                        keyword:
                                                                          'type',
                                                                        params:
                                                                          {
                                                                            type: 'boolean',
                                                                          },
                                                                        message:
                                                                          'must be boolean',
                                                                      },
                                                                    ];
                                                                  return false;
                                                                }
                                                                var valid0 =
                                                                  _errs57 ===
                                                                  errors;
                                                              } else {
                                                                var valid0 = true;
                                                              }
                                                              if (valid0) {
                                                                if (
                                                                  data.isTeamAdmin !==
                                                                  undefined
                                                                ) {
                                                                  const _errs59 =
                                                                    errors;
                                                                  if (
                                                                    typeof data.isTeamAdmin !==
                                                                    'boolean'
                                                                  ) {
                                                                    validate103.errors =
                                                                      [
                                                                        {
                                                                          instancePath:
                                                                            instancePath +
                                                                            '/isTeamAdmin',
                                                                          schemaPath:
                                                                            '#/properties/isTeamAdmin/type',
                                                                          keyword:
                                                                            'type',
                                                                          params:
                                                                            {
                                                                              type: 'boolean',
                                                                            },
                                                                          message:
                                                                            'must be boolean',
                                                                        },
                                                                      ];
                                                                    return false;
                                                                  }
                                                                  var valid0 =
                                                                    _errs59 ===
                                                                    errors;
                                                                } else {
                                                                  var valid0 = true;
                                                                }
                                                                if (valid0) {
                                                                  if (
                                                                    data.numTeamMembers !==
                                                                    undefined
                                                                  ) {
                                                                    let data30 =
                                                                      data.numTeamMembers;
                                                                    const _errs61 =
                                                                      errors;
                                                                    if (
                                                                      !(
                                                                        typeof data30 ==
                                                                          'number' &&
                                                                        isFinite(
                                                                          data30
                                                                        )
                                                                      )
                                                                    ) {
                                                                      validate103.errors =
                                                                        [
                                                                          {
                                                                            instancePath:
                                                                              instancePath +
                                                                              '/numTeamMembers',
                                                                            schemaPath:
                                                                              '#/properties/numTeamMembers/type',
                                                                            keyword:
                                                                              'type',
                                                                            params:
                                                                              {
                                                                                type: 'number',
                                                                              },
                                                                            message:
                                                                              'must be number',
                                                                          },
                                                                        ];
                                                                      return false;
                                                                    }
                                                                    var valid0 =
                                                                      _errs61 ===
                                                                      errors;
                                                                  } else {
                                                                    var valid0 = true;
                                                                  }
                                                                  if (valid0) {
                                                                    if (
                                                                      data.canDeleteAccount !==
                                                                      undefined
                                                                    ) {
                                                                      const _errs63 =
                                                                        errors;
                                                                      if (
                                                                        typeof data.canDeleteAccount !==
                                                                        'boolean'
                                                                      ) {
                                                                        validate103.errors =
                                                                          [
                                                                            {
                                                                              instancePath:
                                                                                instancePath +
                                                                                '/canDeleteAccount',
                                                                              schemaPath:
                                                                                '#/properties/canDeleteAccount/type',
                                                                              keyword:
                                                                                'type',
                                                                              params:
                                                                                {
                                                                                  type: 'boolean',
                                                                                },
                                                                              message:
                                                                                'must be boolean',
                                                                            },
                                                                          ];
                                                                        return false;
                                                                      }
                                                                      var valid0 =
                                                                        _errs63 ===
                                                                        errors;
                                                                    } else {
                                                                      var valid0 = true;
                                                                    }
                                                                    if (
                                                                      valid0
                                                                    ) {
                                                                      if (
                                                                        data.hasSubscription !==
                                                                        undefined
                                                                      ) {
                                                                        const _errs65 =
                                                                          errors;
                                                                        if (
                                                                          typeof data.hasSubscription !==
                                                                          'boolean'
                                                                        ) {
                                                                          validate103.errors =
                                                                            [
                                                                              {
                                                                                instancePath:
                                                                                  instancePath +
                                                                                  '/hasSubscription',
                                                                                schemaPath:
                                                                                  '#/properties/hasSubscription/type',
                                                                                keyword:
                                                                                  'type',
                                                                                params:
                                                                                  {
                                                                                    type: 'boolean',
                                                                                  },
                                                                                message:
                                                                                  'must be boolean',
                                                                              },
                                                                            ];
                                                                          return false;
                                                                        }
                                                                        var valid0 =
                                                                          _errs65 ===
                                                                          errors;
                                                                      } else {
                                                                        var valid0 = true;
                                                                      }
                                                                      if (
                                                                        valid0
                                                                      ) {
                                                                        if (
                                                                          data.hasSubscriptionFrom !==
                                                                          undefined
                                                                        ) {
                                                                          const _errs68 =
                                                                            errors;
                                                                          if (
                                                                            typeof data.hasSubscriptionFrom !==
                                                                            'string'
                                                                          ) {
                                                                            validate103.errors =
                                                                              [
                                                                                {
                                                                                  instancePath:
                                                                                    instancePath +
                                                                                    '/hasSubscriptionFrom',
                                                                                  schemaPath:
                                                                                    '#/properties/hasSubscriptionFrom/type',
                                                                                  keyword:
                                                                                    'type',
                                                                                  params:
                                                                                    {
                                                                                      type: 'string',
                                                                                    },
                                                                                  message:
                                                                                    'must be string',
                                                                                },
                                                                              ];
                                                                            return false;
                                                                          }
                                                                          var valid0 =
                                                                            _errs68 ===
                                                                            errors;
                                                                        } else {
                                                                          var valid0 = true;
                                                                        }
                                                                        if (
                                                                          valid0
                                                                        ) {
                                                                          if (
                                                                            data.cancelUrl !==
                                                                            undefined
                                                                          ) {
                                                                            const _errs71 =
                                                                              errors;
                                                                            if (
                                                                              typeof data.cancelUrl !==
                                                                              'string'
                                                                            ) {
                                                                              validate103.errors =
                                                                                [
                                                                                  {
                                                                                    instancePath:
                                                                                      instancePath +
                                                                                      '/cancelUrl',
                                                                                    schemaPath:
                                                                                      '#/properties/cancelUrl/type',
                                                                                    keyword:
                                                                                      'type',
                                                                                    params:
                                                                                      {
                                                                                        type: 'string',
                                                                                      },
                                                                                    message:
                                                                                      'must be string',
                                                                                  },
                                                                                ];
                                                                              return false;
                                                                            }
                                                                            var valid0 =
                                                                              _errs71 ===
                                                                              errors;
                                                                          } else {
                                                                            var valid0 = true;
                                                                          }
                                                                          if (
                                                                            valid0
                                                                          ) {
                                                                            if (
                                                                              data.hasBillingRestriction !==
                                                                              undefined
                                                                            ) {
                                                                              const _errs73 =
                                                                                errors;
                                                                              if (
                                                                                typeof data.hasBillingRestriction !==
                                                                                'boolean'
                                                                              ) {
                                                                                validate103.errors =
                                                                                  [
                                                                                    {
                                                                                      instancePath:
                                                                                        instancePath +
                                                                                        '/hasBillingRestriction',
                                                                                      schemaPath:
                                                                                        '#/properties/hasBillingRestriction/type',
                                                                                      keyword:
                                                                                        'type',
                                                                                      params:
                                                                                        {
                                                                                          type: 'boolean',
                                                                                        },
                                                                                      message:
                                                                                        'must be boolean',
                                                                                    },
                                                                                  ];
                                                                                return false;
                                                                              }
                                                                              var valid0 =
                                                                                _errs73 ===
                                                                                errors;
                                                                            } else {
                                                                              var valid0 = true;
                                                                            }
                                                                            if (
                                                                              valid0
                                                                            ) {
                                                                              if (
                                                                                data.notifications !==
                                                                                undefined
                                                                              ) {
                                                                                let data36 =
                                                                                  data.notifications;
                                                                                const _errs75 =
                                                                                  errors;
                                                                                const _errs76 =
                                                                                  errors;
                                                                                if (
                                                                                  errors ===
                                                                                  _errs76
                                                                                ) {
                                                                                  if (
                                                                                    data36 &&
                                                                                    typeof data36 ==
                                                                                      'object' &&
                                                                                    !Array.isArray(
                                                                                      data36
                                                                                    )
                                                                                  ) {
                                                                                    let missing1;
                                                                                    if (
                                                                                      (data36.shouldIncludeReceivedFaxPDFs ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'shouldIncludeReceivedFaxPDFs')) ||
                                                                                      (data36.shouldIncludeReceivedFaxPDFsForOthers ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'shouldIncludeReceivedFaxPDFsForOthers')) ||
                                                                                      (data36.shouldIncludeSentFaxPDFs ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'shouldIncludeSentFaxPDFs')) ||
                                                                                      (data36.isOptedInMarketingEmails ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'isOptedInMarketingEmails')) ||
                                                                                      (data36.isSignatureRemindersEnabled ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'isSignatureRemindersEnabled')) ||
                                                                                      (data36.shouldSendOutboundConfEmails ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'shouldSendOutboundConfEmails')) ||
                                                                                      (data36.isNotifyOnSignEnabled ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'isNotifyOnSignEnabled')) ||
                                                                                      (data36.isNotifyOnViewEnabled ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'isNotifyOnViewEnabled')) ||
                                                                                      (data36.shouldSendEmbeddedSignatureConfEmails ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'shouldSendEmbeddedSignatureConfEmails')) ||
                                                                                      (data36.shouldSendDailySummary ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'shouldSendDailySummary')) ||
                                                                                      (data36.shouldSendOrderedSREmail ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'shouldSendOrderedSREmail')) ||
                                                                                      (data36.shouldIncludeRequestedPDFs ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'shouldIncludeRequestedPDFs')) ||
                                                                                      (data36.shouldIncludeRequestedPDFsForOthers ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'shouldIncludeRequestedPDFsForOthers')) ||
                                                                                      (data36.shouldIncludeSentDocPDFs ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'shouldIncludeSentDocPDFs')) ||
                                                                                      (data36.shouldIncludeSentDocPDFsForOthers ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'shouldIncludeSentDocPDFsForOthers')) ||
                                                                                      (data36.isEmailAuthenticationEnabled ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'isEmailAuthenticationEnabled')) ||
                                                                                      (data36.notifyCCOnDocumentSend ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'notifyCCOnDocumentSend')) ||
                                                                                      (data36.notifyCCOnDocumentCompleted ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'notifyCCOnDocumentCompleted')) ||
                                                                                      (data36.notifyCCOnDocumentDeclined ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'notifyCCOnDocumentDeclined')) ||
                                                                                      (data36.notifyCCOnDocumentView ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'notifyCCOnDocumentView')) ||
                                                                                      (data36.notifyCCOnDocumentDelegate ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'notifyCCOnDocumentDelegate')) ||
                                                                                      (data36.hasSMSSignatureDelivery ===
                                                                                        undefined &&
                                                                                        (missing1 =
                                                                                          'hasSMSSignatureDelivery'))
                                                                                    ) {
                                                                                      validate103.errors =
                                                                                        [
                                                                                          {
                                                                                            instancePath:
                                                                                              instancePath +
                                                                                              '/notifications',
                                                                                            schemaPath:
                                                                                              '#/definitions/AccountProfileNotifications/required',
                                                                                            keyword:
                                                                                              'required',
                                                                                            params:
                                                                                              {
                                                                                                missingProperty:
                                                                                                  missing1,
                                                                                              },
                                                                                            message:
                                                                                              "must have required property '" +
                                                                                              missing1 +
                                                                                              "'",
                                                                                          },
                                                                                        ];
                                                                                      return false;
                                                                                    } else {
                                                                                      if (
                                                                                        data36.shouldIncludeReceivedFaxPDFs !==
                                                                                        undefined
                                                                                      ) {
                                                                                        const _errs78 =
                                                                                          errors;
                                                                                        if (
                                                                                          typeof data36.shouldIncludeReceivedFaxPDFs !==
                                                                                          'boolean'
                                                                                        ) {
                                                                                          validate103.errors =
                                                                                            [
                                                                                              {
                                                                                                instancePath:
                                                                                                  instancePath +
                                                                                                  '/notifications/shouldIncludeReceivedFaxPDFs',
                                                                                                schemaPath:
                                                                                                  '#/definitions/AccountProfileNotifications/properties/shouldIncludeReceivedFaxPDFs/type',
                                                                                                keyword:
                                                                                                  'type',
                                                                                                params:
                                                                                                  {
                                                                                                    type: 'boolean',
                                                                                                  },
                                                                                                message:
                                                                                                  'must be boolean',
                                                                                              },
                                                                                            ];
                                                                                          return false;
                                                                                        }
                                                                                        var valid3 =
                                                                                          _errs78 ===
                                                                                          errors;
                                                                                      } else {
                                                                                        var valid3 = true;
                                                                                      }
                                                                                      if (
                                                                                        valid3
                                                                                      ) {
                                                                                        if (
                                                                                          data36.shouldIncludeReceivedFaxPDFsForOthers !==
                                                                                          undefined
                                                                                        ) {
                                                                                          const _errs80 =
                                                                                            errors;
                                                                                          if (
                                                                                            typeof data36.shouldIncludeReceivedFaxPDFsForOthers !==
                                                                                            'boolean'
                                                                                          ) {
                                                                                            validate103.errors =
                                                                                              [
                                                                                                {
                                                                                                  instancePath:
                                                                                                    instancePath +
                                                                                                    '/notifications/shouldIncludeReceivedFaxPDFsForOthers',
                                                                                                  schemaPath:
                                                                                                    '#/definitions/AccountProfileNotifications/properties/shouldIncludeReceivedFaxPDFsForOthers/type',
                                                                                                  keyword:
                                                                                                    'type',
                                                                                                  params:
                                                                                                    {
                                                                                                      type: 'boolean',
                                                                                                    },
                                                                                                  message:
                                                                                                    'must be boolean',
                                                                                                },
                                                                                              ];
                                                                                            return false;
                                                                                          }
                                                                                          var valid3 =
                                                                                            _errs80 ===
                                                                                            errors;
                                                                                        } else {
                                                                                          var valid3 = true;
                                                                                        }
                                                                                        if (
                                                                                          valid3
                                                                                        ) {
                                                                                          if (
                                                                                            data36.shouldIncludeSentFaxPDFs !==
                                                                                            undefined
                                                                                          ) {
                                                                                            const _errs82 =
                                                                                              errors;
                                                                                            if (
                                                                                              typeof data36.shouldIncludeSentFaxPDFs !==
                                                                                              'boolean'
                                                                                            ) {
                                                                                              validate103.errors =
                                                                                                [
                                                                                                  {
                                                                                                    instancePath:
                                                                                                      instancePath +
                                                                                                      '/notifications/shouldIncludeSentFaxPDFs',
                                                                                                    schemaPath:
                                                                                                      '#/definitions/AccountProfileNotifications/properties/shouldIncludeSentFaxPDFs/type',
                                                                                                    keyword:
                                                                                                      'type',
                                                                                                    params:
                                                                                                      {
                                                                                                        type: 'boolean',
                                                                                                      },
                                                                                                    message:
                                                                                                      'must be boolean',
                                                                                                  },
                                                                                                ];
                                                                                              return false;
                                                                                            }
                                                                                            var valid3 =
                                                                                              _errs82 ===
                                                                                              errors;
                                                                                          } else {
                                                                                            var valid3 = true;
                                                                                          }
                                                                                          if (
                                                                                            valid3
                                                                                          ) {
                                                                                            if (
                                                                                              data36.isOptedInMarketingEmails !==
                                                                                              undefined
                                                                                            ) {
                                                                                              const _errs84 =
                                                                                                errors;
                                                                                              if (
                                                                                                typeof data36.isOptedInMarketingEmails !==
                                                                                                'boolean'
                                                                                              ) {
                                                                                                validate103.errors =
                                                                                                  [
                                                                                                    {
                                                                                                      instancePath:
                                                                                                        instancePath +
                                                                                                        '/notifications/isOptedInMarketingEmails',
                                                                                                      schemaPath:
                                                                                                        '#/definitions/AccountProfileNotifications/properties/isOptedInMarketingEmails/type',
                                                                                                      keyword:
                                                                                                        'type',
                                                                                                      params:
                                                                                                        {
                                                                                                          type: 'boolean',
                                                                                                        },
                                                                                                      message:
                                                                                                        'must be boolean',
                                                                                                    },
                                                                                                  ];
                                                                                                return false;
                                                                                              }
                                                                                              var valid3 =
                                                                                                _errs84 ===
                                                                                                errors;
                                                                                            } else {
                                                                                              var valid3 = true;
                                                                                            }
                                                                                            if (
                                                                                              valid3
                                                                                            ) {
                                                                                              if (
                                                                                                data36.isSignatureRemindersEnabled !==
                                                                                                undefined
                                                                                              ) {
                                                                                                const _errs86 =
                                                                                                  errors;
                                                                                                if (
                                                                                                  typeof data36.isSignatureRemindersEnabled !==
                                                                                                  'boolean'
                                                                                                ) {
                                                                                                  validate103.errors =
                                                                                                    [
                                                                                                      {
                                                                                                        instancePath:
                                                                                                          instancePath +
                                                                                                          '/notifications/isSignatureRemindersEnabled',
                                                                                                        schemaPath:
                                                                                                          '#/definitions/AccountProfileNotifications/properties/isSignatureRemindersEnabled/type',
                                                                                                        keyword:
                                                                                                          'type',
                                                                                                        params:
                                                                                                          {
                                                                                                            type: 'boolean',
                                                                                                          },
                                                                                                        message:
                                                                                                          'must be boolean',
                                                                                                      },
                                                                                                    ];
                                                                                                  return false;
                                                                                                }
                                                                                                var valid3 =
                                                                                                  _errs86 ===
                                                                                                  errors;
                                                                                              } else {
                                                                                                var valid3 = true;
                                                                                              }
                                                                                              if (
                                                                                                valid3
                                                                                              ) {
                                                                                                if (
                                                                                                  data36.shouldSendOutboundConfEmails !==
                                                                                                  undefined
                                                                                                ) {
                                                                                                  const _errs88 =
                                                                                                    errors;
                                                                                                  if (
                                                                                                    typeof data36.shouldSendOutboundConfEmails !==
                                                                                                    'boolean'
                                                                                                  ) {
                                                                                                    validate103.errors =
                                                                                                      [
                                                                                                        {
                                                                                                          instancePath:
                                                                                                            instancePath +
                                                                                                            '/notifications/shouldSendOutboundConfEmails',
                                                                                                          schemaPath:
                                                                                                            '#/definitions/AccountProfileNotifications/properties/shouldSendOutboundConfEmails/type',
                                                                                                          keyword:
                                                                                                            'type',
                                                                                                          params:
                                                                                                            {
                                                                                                              type: 'boolean',
                                                                                                            },
                                                                                                          message:
                                                                                                            'must be boolean',
                                                                                                        },
                                                                                                      ];
                                                                                                    return false;
                                                                                                  }
                                                                                                  var valid3 =
                                                                                                    _errs88 ===
                                                                                                    errors;
                                                                                                } else {
                                                                                                  var valid3 = true;
                                                                                                }
                                                                                                if (
                                                                                                  valid3
                                                                                                ) {
                                                                                                  if (
                                                                                                    data36.isNotifyOnSignEnabled !==
                                                                                                    undefined
                                                                                                  ) {
                                                                                                    const _errs90 =
                                                                                                      errors;
                                                                                                    if (
                                                                                                      typeof data36.isNotifyOnSignEnabled !==
                                                                                                      'boolean'
                                                                                                    ) {
                                                                                                      validate103.errors =
                                                                                                        [
                                                                                                          {
                                                                                                            instancePath:
                                                                                                              instancePath +
                                                                                                              '/notifications/isNotifyOnSignEnabled',
                                                                                                            schemaPath:
                                                                                                              '#/definitions/AccountProfileNotifications/properties/isNotifyOnSignEnabled/type',
                                                                                                            keyword:
                                                                                                              'type',
                                                                                                            params:
                                                                                                              {
                                                                                                                type: 'boolean',
                                                                                                              },
                                                                                                            message:
                                                                                                              'must be boolean',
                                                                                                          },
                                                                                                        ];
                                                                                                      return false;
                                                                                                    }
                                                                                                    var valid3 =
                                                                                                      _errs90 ===
                                                                                                      errors;
                                                                                                  } else {
                                                                                                    var valid3 = true;
                                                                                                  }
                                                                                                  if (
                                                                                                    valid3
                                                                                                  ) {
                                                                                                    if (
                                                                                                      data36.isNotifyOnViewEnabled !==
                                                                                                      undefined
                                                                                                    ) {
                                                                                                      const _errs92 =
                                                                                                        errors;
                                                                                                      if (
                                                                                                        typeof data36.isNotifyOnViewEnabled !==
                                                                                                        'boolean'
                                                                                                      ) {
                                                                                                        validate103.errors =
                                                                                                          [
                                                                                                            {
                                                                                                              instancePath:
                                                                                                                instancePath +
                                                                                                                '/notifications/isNotifyOnViewEnabled',
                                                                                                              schemaPath:
                                                                                                                '#/definitions/AccountProfileNotifications/properties/isNotifyOnViewEnabled/type',
                                                                                                              keyword:
                                                                                                                'type',
                                                                                                              params:
                                                                                                                {
                                                                                                                  type: 'boolean',
                                                                                                                },
                                                                                                              message:
                                                                                                                'must be boolean',
                                                                                                            },
                                                                                                          ];
                                                                                                        return false;
                                                                                                      }
                                                                                                      var valid3 =
                                                                                                        _errs92 ===
                                                                                                        errors;
                                                                                                    } else {
                                                                                                      var valid3 = true;
                                                                                                    }
                                                                                                    if (
                                                                                                      valid3
                                                                                                    ) {
                                                                                                      if (
                                                                                                        data36.shouldSendEmbeddedSignatureConfEmails !==
                                                                                                        undefined
                                                                                                      ) {
                                                                                                        const _errs94 =
                                                                                                          errors;
                                                                                                        if (
                                                                                                          typeof data36.shouldSendEmbeddedSignatureConfEmails !==
                                                                                                          'boolean'
                                                                                                        ) {
                                                                                                          validate103.errors =
                                                                                                            [
                                                                                                              {
                                                                                                                instancePath:
                                                                                                                  instancePath +
                                                                                                                  '/notifications/shouldSendEmbeddedSignatureConfEmails',
                                                                                                                schemaPath:
                                                                                                                  '#/definitions/AccountProfileNotifications/properties/shouldSendEmbeddedSignatureConfEmails/type',
                                                                                                                keyword:
                                                                                                                  'type',
                                                                                                                params:
                                                                                                                  {
                                                                                                                    type: 'boolean',
                                                                                                                  },
                                                                                                                message:
                                                                                                                  'must be boolean',
                                                                                                              },
                                                                                                            ];
                                                                                                          return false;
                                                                                                        }
                                                                                                        var valid3 =
                                                                                                          _errs94 ===
                                                                                                          errors;
                                                                                                      } else {
                                                                                                        var valid3 = true;
                                                                                                      }
                                                                                                      if (
                                                                                                        valid3
                                                                                                      ) {
                                                                                                        if (
                                                                                                          data36.shouldSendDailySummary !==
                                                                                                          undefined
                                                                                                        ) {
                                                                                                          const _errs96 =
                                                                                                            errors;
                                                                                                          if (
                                                                                                            typeof data36.shouldSendDailySummary !==
                                                                                                            'boolean'
                                                                                                          ) {
                                                                                                            validate103.errors =
                                                                                                              [
                                                                                                                {
                                                                                                                  instancePath:
                                                                                                                    instancePath +
                                                                                                                    '/notifications/shouldSendDailySummary',
                                                                                                                  schemaPath:
                                                                                                                    '#/definitions/AccountProfileNotifications/properties/shouldSendDailySummary/type',
                                                                                                                  keyword:
                                                                                                                    'type',
                                                                                                                  params:
                                                                                                                    {
                                                                                                                      type: 'boolean',
                                                                                                                    },
                                                                                                                  message:
                                                                                                                    'must be boolean',
                                                                                                                },
                                                                                                              ];
                                                                                                            return false;
                                                                                                          }
                                                                                                          var valid3 =
                                                                                                            _errs96 ===
                                                                                                            errors;
                                                                                                        } else {
                                                                                                          var valid3 = true;
                                                                                                        }
                                                                                                        if (
                                                                                                          valid3
                                                                                                        ) {
                                                                                                          if (
                                                                                                            data36.shouldSendOrderedSREmail !==
                                                                                                            undefined
                                                                                                          ) {
                                                                                                            const _errs98 =
                                                                                                              errors;
                                                                                                            if (
                                                                                                              typeof data36.shouldSendOrderedSREmail !==
                                                                                                              'boolean'
                                                                                                            ) {
                                                                                                              validate103.errors =
                                                                                                                [
                                                                                                                  {
                                                                                                                    instancePath:
                                                                                                                      instancePath +
                                                                                                                      '/notifications/shouldSendOrderedSREmail',
                                                                                                                    schemaPath:
                                                                                                                      '#/definitions/AccountProfileNotifications/properties/shouldSendOrderedSREmail/type',
                                                                                                                    keyword:
                                                                                                                      'type',
                                                                                                                    params:
                                                                                                                      {
                                                                                                                        type: 'boolean',
                                                                                                                      },
                                                                                                                    message:
                                                                                                                      'must be boolean',
                                                                                                                  },
                                                                                                                ];
                                                                                                              return false;
                                                                                                            }
                                                                                                            var valid3 =
                                                                                                              _errs98 ===
                                                                                                              errors;
                                                                                                          } else {
                                                                                                            var valid3 = true;
                                                                                                          }
                                                                                                          if (
                                                                                                            valid3
                                                                                                          ) {
                                                                                                            if (
                                                                                                              data36.shouldIncludeRequestedPDFs !==
                                                                                                              undefined
                                                                                                            ) {
                                                                                                              const _errs100 =
                                                                                                                errors;
                                                                                                              if (
                                                                                                                typeof data36.shouldIncludeRequestedPDFs !==
                                                                                                                'boolean'
                                                                                                              ) {
                                                                                                                validate103.errors =
                                                                                                                  [
                                                                                                                    {
                                                                                                                      instancePath:
                                                                                                                        instancePath +
                                                                                                                        '/notifications/shouldIncludeRequestedPDFs',
                                                                                                                      schemaPath:
                                                                                                                        '#/definitions/AccountProfileNotifications/properties/shouldIncludeRequestedPDFs/type',
                                                                                                                      keyword:
                                                                                                                        'type',
                                                                                                                      params:
                                                                                                                        {
                                                                                                                          type: 'boolean',
                                                                                                                        },
                                                                                                                      message:
                                                                                                                        'must be boolean',
                                                                                                                    },
                                                                                                                  ];
                                                                                                                return false;
                                                                                                              }
                                                                                                              var valid3 =
                                                                                                                _errs100 ===
                                                                                                                errors;
                                                                                                            } else {
                                                                                                              var valid3 = true;
                                                                                                            }
                                                                                                            if (
                                                                                                              valid3
                                                                                                            ) {
                                                                                                              if (
                                                                                                                data36.shouldIncludeRequestedPDFsForOthers !==
                                                                                                                undefined
                                                                                                              ) {
                                                                                                                const _errs102 =
                                                                                                                  errors;
                                                                                                                if (
                                                                                                                  typeof data36.shouldIncludeRequestedPDFsForOthers !==
                                                                                                                  'boolean'
                                                                                                                ) {
                                                                                                                  validate103.errors =
                                                                                                                    [
                                                                                                                      {
                                                                                                                        instancePath:
                                                                                                                          instancePath +
                                                                                                                          '/notifications/shouldIncludeRequestedPDFsForOthers',
                                                                                                                        schemaPath:
                                                                                                                          '#/definitions/AccountProfileNotifications/properties/shouldIncludeRequestedPDFsForOthers/type',
                                                                                                                        keyword:
                                                                                                                          'type',
                                                                                                                        params:
                                                                                                                          {
                                                                                                                            type: 'boolean',
                                                                                                                          },
                                                                                                                        message:
                                                                                                                          'must be boolean',
                                                                                                                      },
                                                                                                                    ];
                                                                                                                  return false;
                                                                                                                }
                                                                                                                var valid3 =
                                                                                                                  _errs102 ===
                                                                                                                  errors;
                                                                                                              } else {
                                                                                                                var valid3 = true;
                                                                                                              }
                                                                                                              if (
                                                                                                                valid3
                                                                                                              ) {
                                                                                                                if (
                                                                                                                  data36.shouldIncludeSentDocPDFs !==
                                                                                                                  undefined
                                                                                                                ) {
                                                                                                                  const _errs104 =
                                                                                                                    errors;
                                                                                                                  if (
                                                                                                                    typeof data36.shouldIncludeSentDocPDFs !==
                                                                                                                    'boolean'
                                                                                                                  ) {
                                                                                                                    validate103.errors =
                                                                                                                      [
                                                                                                                        {
                                                                                                                          instancePath:
                                                                                                                            instancePath +
                                                                                                                            '/notifications/shouldIncludeSentDocPDFs',
                                                                                                                          schemaPath:
                                                                                                                            '#/definitions/AccountProfileNotifications/properties/shouldIncludeSentDocPDFs/type',
                                                                                                                          keyword:
                                                                                                                            'type',
                                                                                                                          params:
                                                                                                                            {
                                                                                                                              type: 'boolean',
                                                                                                                            },
                                                                                                                          message:
                                                                                                                            'must be boolean',
                                                                                                                        },
                                                                                                                      ];
                                                                                                                    return false;
                                                                                                                  }
                                                                                                                  var valid3 =
                                                                                                                    _errs104 ===
                                                                                                                    errors;
                                                                                                                } else {
                                                                                                                  var valid3 = true;
                                                                                                                }
                                                                                                                if (
                                                                                                                  valid3
                                                                                                                ) {
                                                                                                                  if (
                                                                                                                    data36.shouldIncludeSentDocPDFsForOthers !==
                                                                                                                    undefined
                                                                                                                  ) {
                                                                                                                    const _errs106 =
                                                                                                                      errors;
                                                                                                                    if (
                                                                                                                      typeof data36.shouldIncludeSentDocPDFsForOthers !==
                                                                                                                      'boolean'
                                                                                                                    ) {
                                                                                                                      validate103.errors =
                                                                                                                        [
                                                                                                                          {
                                                                                                                            instancePath:
                                                                                                                              instancePath +
                                                                                                                              '/notifications/shouldIncludeSentDocPDFsForOthers',
                                                                                                                            schemaPath:
                                                                                                                              '#/definitions/AccountProfileNotifications/properties/shouldIncludeSentDocPDFsForOthers/type',
                                                                                                                            keyword:
                                                                                                                              'type',
                                                                                                                            params:
                                                                                                                              {
                                                                                                                                type: 'boolean',
                                                                                                                              },
                                                                                                                            message:
                                                                                                                              'must be boolean',
                                                                                                                          },
                                                                                                                        ];
                                                                                                                      return false;
                                                                                                                    }
                                                                                                                    var valid3 =
                                                                                                                      _errs106 ===
                                                                                                                      errors;
                                                                                                                  } else {
                                                                                                                    var valid3 = true;
                                                                                                                  }
                                                                                                                  if (
                                                                                                                    valid3
                                                                                                                  ) {
                                                                                                                    if (
                                                                                                                      data36.isEmailAuthenticationEnabled !==
                                                                                                                      undefined
                                                                                                                    ) {
                                                                                                                      const _errs108 =
                                                                                                                        errors;
                                                                                                                      if (
                                                                                                                        typeof data36.isEmailAuthenticationEnabled !==
                                                                                                                        'boolean'
                                                                                                                      ) {
                                                                                                                        validate103.errors =
                                                                                                                          [
                                                                                                                            {
                                                                                                                              instancePath:
                                                                                                                                instancePath +
                                                                                                                                '/notifications/isEmailAuthenticationEnabled',
                                                                                                                              schemaPath:
                                                                                                                                '#/definitions/AccountProfileNotifications/properties/isEmailAuthenticationEnabled/type',
                                                                                                                              keyword:
                                                                                                                                'type',
                                                                                                                              params:
                                                                                                                                {
                                                                                                                                  type: 'boolean',
                                                                                                                                },
                                                                                                                              message:
                                                                                                                                'must be boolean',
                                                                                                                            },
                                                                                                                          ];
                                                                                                                        return false;
                                                                                                                      }
                                                                                                                      var valid3 =
                                                                                                                        _errs108 ===
                                                                                                                        errors;
                                                                                                                    } else {
                                                                                                                      var valid3 = true;
                                                                                                                    }
                                                                                                                    if (
                                                                                                                      valid3
                                                                                                                    ) {
                                                                                                                      if (
                                                                                                                        data36.notifyCCOnDocumentSend !==
                                                                                                                        undefined
                                                                                                                      ) {
                                                                                                                        const _errs110 =
                                                                                                                          errors;
                                                                                                                        if (
                                                                                                                          typeof data36.notifyCCOnDocumentSend !==
                                                                                                                          'boolean'
                                                                                                                        ) {
                                                                                                                          validate103.errors =
                                                                                                                            [
                                                                                                                              {
                                                                                                                                instancePath:
                                                                                                                                  instancePath +
                                                                                                                                  '/notifications/notifyCCOnDocumentSend',
                                                                                                                                schemaPath:
                                                                                                                                  '#/definitions/AccountProfileNotifications/properties/notifyCCOnDocumentSend/type',
                                                                                                                                keyword:
                                                                                                                                  'type',
                                                                                                                                params:
                                                                                                                                  {
                                                                                                                                    type: 'boolean',
                                                                                                                                  },
                                                                                                                                message:
                                                                                                                                  'must be boolean',
                                                                                                                              },
                                                                                                                            ];
                                                                                                                          return false;
                                                                                                                        }
                                                                                                                        var valid3 =
                                                                                                                          _errs110 ===
                                                                                                                          errors;
                                                                                                                      } else {
                                                                                                                        var valid3 = true;
                                                                                                                      }
                                                                                                                      if (
                                                                                                                        valid3
                                                                                                                      ) {
                                                                                                                        if (
                                                                                                                          data36.notifyCCOnDocumentCompleted !==
                                                                                                                          undefined
                                                                                                                        ) {
                                                                                                                          const _errs112 =
                                                                                                                            errors;
                                                                                                                          if (
                                                                                                                            typeof data36.notifyCCOnDocumentCompleted !==
                                                                                                                            'boolean'
                                                                                                                          ) {
                                                                                                                            validate103.errors =
                                                                                                                              [
                                                                                                                                {
                                                                                                                                  instancePath:
                                                                                                                                    instancePath +
                                                                                                                                    '/notifications/notifyCCOnDocumentCompleted',
                                                                                                                                  schemaPath:
                                                                                                                                    '#/definitions/AccountProfileNotifications/properties/notifyCCOnDocumentCompleted/type',
                                                                                                                                  keyword:
                                                                                                                                    'type',
                                                                                                                                  params:
                                                                                                                                    {
                                                                                                                                      type: 'boolean',
                                                                                                                                    },
                                                                                                                                  message:
                                                                                                                                    'must be boolean',
                                                                                                                                },
                                                                                                                              ];
                                                                                                                            return false;
                                                                                                                          }
                                                                                                                          var valid3 =
                                                                                                                            _errs112 ===
                                                                                                                            errors;
                                                                                                                        } else {
                                                                                                                          var valid3 = true;
                                                                                                                        }
                                                                                                                        if (
                                                                                                                          valid3
                                                                                                                        ) {
                                                                                                                          if (
                                                                                                                            data36.notifyCCOnDocumentDeclined !==
                                                                                                                            undefined
                                                                                                                          ) {
                                                                                                                            const _errs114 =
                                                                                                                              errors;
                                                                                                                            if (
                                                                                                                              typeof data36.notifyCCOnDocumentDeclined !==
                                                                                                                              'boolean'
                                                                                                                            ) {
                                                                                                                              validate103.errors =
                                                                                                                                [
                                                                                                                                  {
                                                                                                                                    instancePath:
                                                                                                                                      instancePath +
                                                                                                                                      '/notifications/notifyCCOnDocumentDeclined',
                                                                                                                                    schemaPath:
                                                                                                                                      '#/definitions/AccountProfileNotifications/properties/notifyCCOnDocumentDeclined/type',
                                                                                                                                    keyword:
                                                                                                                                      'type',
                                                                                                                                    params:
                                                                                                                                      {
                                                                                                                                        type: 'boolean',
                                                                                                                                      },
                                                                                                                                    message:
                                                                                                                                      'must be boolean',
                                                                                                                                  },
                                                                                                                                ];
                                                                                                                              return false;
                                                                                                                            }
                                                                                                                            var valid3 =
                                                                                                                              _errs114 ===
                                                                                                                              errors;
                                                                                                                          } else {
                                                                                                                            var valid3 = true;
                                                                                                                          }
                                                                                                                          if (
                                                                                                                            valid3
                                                                                                                          ) {
                                                                                                                            if (
                                                                                                                              data36.notifyCCOnDocumentView !==
                                                                                                                              undefined
                                                                                                                            ) {
                                                                                                                              const _errs116 =
                                                                                                                                errors;
                                                                                                                              if (
                                                                                                                                typeof data36.notifyCCOnDocumentView !==
                                                                                                                                'boolean'
                                                                                                                              ) {
                                                                                                                                validate103.errors =
                                                                                                                                  [
                                                                                                                                    {
                                                                                                                                      instancePath:
                                                                                                                                        instancePath +
                                                                                                                                        '/notifications/notifyCCOnDocumentView',
                                                                                                                                      schemaPath:
                                                                                                                                        '#/definitions/AccountProfileNotifications/properties/notifyCCOnDocumentView/type',
                                                                                                                                      keyword:
                                                                                                                                        'type',
                                                                                                                                      params:
                                                                                                                                        {
                                                                                                                                          type: 'boolean',
                                                                                                                                        },
                                                                                                                                      message:
                                                                                                                                        'must be boolean',
                                                                                                                                    },
                                                                                                                                  ];
                                                                                                                                return false;
                                                                                                                              }
                                                                                                                              var valid3 =
                                                                                                                                _errs116 ===
                                                                                                                                errors;
                                                                                                                            } else {
                                                                                                                              var valid3 = true;
                                                                                                                            }
                                                                                                                            if (
                                                                                                                              valid3
                                                                                                                            ) {
                                                                                                                              if (
                                                                                                                                data36.notifyCCOnDocumentDelegate !==
                                                                                                                                undefined
                                                                                                                              ) {
                                                                                                                                const _errs118 =
                                                                                                                                  errors;
                                                                                                                                if (
                                                                                                                                  typeof data36.notifyCCOnDocumentDelegate !==
                                                                                                                                  'boolean'
                                                                                                                                ) {
                                                                                                                                  validate103.errors =
                                                                                                                                    [
                                                                                                                                      {
                                                                                                                                        instancePath:
                                                                                                                                          instancePath +
                                                                                                                                          '/notifications/notifyCCOnDocumentDelegate',
                                                                                                                                        schemaPath:
                                                                                                                                          '#/definitions/AccountProfileNotifications/properties/notifyCCOnDocumentDelegate/type',
                                                                                                                                        keyword:
                                                                                                                                          'type',
                                                                                                                                        params:
                                                                                                                                          {
                                                                                                                                            type: 'boolean',
                                                                                                                                          },
                                                                                                                                        message:
                                                                                                                                          'must be boolean',
                                                                                                                                      },
                                                                                                                                    ];
                                                                                                                                  return false;
                                                                                                                                }
                                                                                                                                var valid3 =
                                                                                                                                  _errs118 ===
                                                                                                                                  errors;
                                                                                                                              } else {
                                                                                                                                var valid3 = true;
                                                                                                                              }
                                                                                                                              if (
                                                                                                                                valid3
                                                                                                                              ) {
                                                                                                                                if (
                                                                                                                                  data36.hasSMSSignatureDelivery !==
                                                                                                                                  undefined
                                                                                                                                ) {
                                                                                                                                  const _errs120 =
                                                                                                                                    errors;
                                                                                                                                  if (
                                                                                                                                    typeof data36.hasSMSSignatureDelivery !==
                                                                                                                                    'boolean'
                                                                                                                                  ) {
                                                                                                                                    validate103.errors =
                                                                                                                                      [
                                                                                                                                        {
                                                                                                                                          instancePath:
                                                                                                                                            instancePath +
                                                                                                                                            '/notifications/hasSMSSignatureDelivery',
                                                                                                                                          schemaPath:
                                                                                                                                            '#/definitions/AccountProfileNotifications/properties/hasSMSSignatureDelivery/type',
                                                                                                                                          keyword:
                                                                                                                                            'type',
                                                                                                                                          params:
                                                                                                                                            {
                                                                                                                                              type: 'boolean',
                                                                                                                                            },
                                                                                                                                          message:
                                                                                                                                            'must be boolean',
                                                                                                                                        },
                                                                                                                                      ];
                                                                                                                                    return false;
                                                                                                                                  }
                                                                                                                                  var valid3 =
                                                                                                                                    _errs120 ===
                                                                                                                                    errors;
                                                                                                                                } else {
                                                                                                                                  var valid3 = true;
                                                                                                                                }
                                                                                                                              }
                                                                                                                            }
                                                                                                                          }
                                                                                                                        }
                                                                                                                      }
                                                                                                                    }
                                                                                                                  }
                                                                                                                }
                                                                                                              }
                                                                                                            }
                                                                                                          }
                                                                                                        }
                                                                                                      }
                                                                                                    }
                                                                                                  }
                                                                                                }
                                                                                              }
                                                                                            }
                                                                                          }
                                                                                        }
                                                                                      }
                                                                                    }
                                                                                  } else {
                                                                                    validate103.errors =
                                                                                      [
                                                                                        {
                                                                                          instancePath:
                                                                                            instancePath +
                                                                                            '/notifications',
                                                                                          schemaPath:
                                                                                            '#/definitions/AccountProfileNotifications/type',
                                                                                          keyword:
                                                                                            'type',
                                                                                          params:
                                                                                            {
                                                                                              type: 'object',
                                                                                            },
                                                                                          message:
                                                                                            'must be object',
                                                                                        },
                                                                                      ];
                                                                                    return false;
                                                                                  }
                                                                                }
                                                                                var valid0 =
                                                                                  _errs75 ===
                                                                                  errors;
                                                                              } else {
                                                                                var valid0 = true;
                                                                              }
                                                                              if (
                                                                                valid0
                                                                              ) {
                                                                                if (
                                                                                  data.multiFactorPhoneNumber !==
                                                                                  undefined
                                                                                ) {
                                                                                  const _errs122 =
                                                                                    errors;
                                                                                  if (
                                                                                    typeof data.multiFactorPhoneNumber !==
                                                                                    'string'
                                                                                  ) {
                                                                                    validate103.errors =
                                                                                      [
                                                                                        {
                                                                                          instancePath:
                                                                                            instancePath +
                                                                                            '/multiFactorPhoneNumber',
                                                                                          schemaPath:
                                                                                            '#/properties/multiFactorPhoneNumber/type',
                                                                                          keyword:
                                                                                            'type',
                                                                                          params:
                                                                                            {
                                                                                              type: 'string',
                                                                                            },
                                                                                          message:
                                                                                            'must be string',
                                                                                        },
                                                                                      ];
                                                                                    return false;
                                                                                  }
                                                                                  var valid0 =
                                                                                    _errs122 ===
                                                                                    errors;
                                                                                } else {
                                                                                  var valid0 = true;
                                                                                }
                                                                                if (
                                                                                  valid0
                                                                                ) {
                                                                                  if (
                                                                                    data.hasMultiFactorSMSVerification !==
                                                                                    undefined
                                                                                  ) {
                                                                                    const _errs124 =
                                                                                      errors;
                                                                                    if (
                                                                                      typeof data.hasMultiFactorSMSVerification !==
                                                                                      'boolean'
                                                                                    ) {
                                                                                      validate103.errors =
                                                                                        [
                                                                                          {
                                                                                            instancePath:
                                                                                              instancePath +
                                                                                              '/hasMultiFactorSMSVerification',
                                                                                            schemaPath:
                                                                                              '#/properties/hasMultiFactorSMSVerification/type',
                                                                                            keyword:
                                                                                              'type',
                                                                                            params:
                                                                                              {
                                                                                                type: 'boolean',
                                                                                              },
                                                                                            message:
                                                                                              'must be boolean',
                                                                                          },
                                                                                        ];
                                                                                      return false;
                                                                                    }
                                                                                    var valid0 =
                                                                                      _errs124 ===
                                                                                      errors;
                                                                                  } else {
                                                                                    var valid0 = true;
                                                                                  }
                                                                                  if (
                                                                                    valid0
                                                                                  ) {
                                                                                    if (
                                                                                      data.hasMultiFactorGoogleAuthenticator !==
                                                                                      undefined
                                                                                    ) {
                                                                                      const _errs126 =
                                                                                        errors;
                                                                                      if (
                                                                                        typeof data.hasMultiFactorGoogleAuthenticator !==
                                                                                        'boolean'
                                                                                      ) {
                                                                                        validate103.errors =
                                                                                          [
                                                                                            {
                                                                                              instancePath:
                                                                                                instancePath +
                                                                                                '/hasMultiFactorGoogleAuthenticator',
                                                                                              schemaPath:
                                                                                                '#/properties/hasMultiFactorGoogleAuthenticator/type',
                                                                                              keyword:
                                                                                                'type',
                                                                                              params:
                                                                                                {
                                                                                                  type: 'boolean',
                                                                                                },
                                                                                              message:
                                                                                                'must be boolean',
                                                                                            },
                                                                                          ];
                                                                                        return false;
                                                                                      }
                                                                                      var valid0 =
                                                                                        _errs126 ===
                                                                                        errors;
                                                                                    } else {
                                                                                      var valid0 = true;
                                                                                    }
                                                                                    if (
                                                                                      valid0
                                                                                    ) {
                                                                                      if (
                                                                                        data.hasGoogleAuthenticatorAccess !==
                                                                                        undefined
                                                                                      ) {
                                                                                        const _errs128 =
                                                                                          errors;
                                                                                        if (
                                                                                          typeof data.hasGoogleAuthenticatorAccess !==
                                                                                          'boolean'
                                                                                        ) {
                                                                                          validate103.errors =
                                                                                            [
                                                                                              {
                                                                                                instancePath:
                                                                                                  instancePath +
                                                                                                  '/hasGoogleAuthenticatorAccess',
                                                                                                schemaPath:
                                                                                                  '#/properties/hasGoogleAuthenticatorAccess/type',
                                                                                                keyword:
                                                                                                  'type',
                                                                                                params:
                                                                                                  {
                                                                                                    type: 'boolean',
                                                                                                  },
                                                                                                message:
                                                                                                  'must be boolean',
                                                                                              },
                                                                                            ];
                                                                                          return false;
                                                                                        }
                                                                                        var valid0 =
                                                                                          _errs128 ===
                                                                                          errors;
                                                                                      } else {
                                                                                        var valid0 = true;
                                                                                      }
                                                                                      if (
                                                                                        valid0
                                                                                      ) {
                                                                                        if (
                                                                                          data.hasSMSVerficationAccess !==
                                                                                          undefined
                                                                                        ) {
                                                                                          const _errs130 =
                                                                                            errors;
                                                                                          if (
                                                                                            typeof data.hasSMSVerficationAccess !==
                                                                                            'boolean'
                                                                                          ) {
                                                                                            validate103.errors =
                                                                                              [
                                                                                                {
                                                                                                  instancePath:
                                                                                                    instancePath +
                                                                                                    '/hasSMSVerficationAccess',
                                                                                                  schemaPath:
                                                                                                    '#/properties/hasSMSVerficationAccess/type',
                                                                                                  keyword:
                                                                                                    'type',
                                                                                                  params:
                                                                                                    {
                                                                                                      type: 'boolean',
                                                                                                    },
                                                                                                  message:
                                                                                                    'must be boolean',
                                                                                                },
                                                                                              ];
                                                                                            return false;
                                                                                          }
                                                                                          var valid0 =
                                                                                            _errs130 ===
                                                                                            errors;
                                                                                        } else {
                                                                                          var valid0 = true;
                                                                                        }
                                                                                        if (
                                                                                          valid0
                                                                                        ) {
                                                                                          if (
                                                                                            data.businessName !==
                                                                                            undefined
                                                                                          ) {
                                                                                            const _errs132 =
                                                                                              errors;
                                                                                            if (
                                                                                              typeof data.businessName !==
                                                                                              'string'
                                                                                            ) {
                                                                                              validate103.errors =
                                                                                                [
                                                                                                  {
                                                                                                    instancePath:
                                                                                                      instancePath +
                                                                                                      '/businessName',
                                                                                                    schemaPath:
                                                                                                      '#/properties/businessName/type',
                                                                                                    keyword:
                                                                                                      'type',
                                                                                                    params:
                                                                                                      {
                                                                                                        type: 'string',
                                                                                                      },
                                                                                                    message:
                                                                                                      'must be string',
                                                                                                  },
                                                                                                ];
                                                                                              return false;
                                                                                            }
                                                                                            var valid0 =
                                                                                              _errs132 ===
                                                                                              errors;
                                                                                          } else {
                                                                                            var valid0 = true;
                                                                                          }
                                                                                          if (
                                                                                            valid0
                                                                                          ) {
                                                                                            if (
                                                                                              data.additionalDisclosureText !==
                                                                                              undefined
                                                                                            ) {
                                                                                              const _errs134 =
                                                                                                errors;
                                                                                              if (
                                                                                                typeof data.additionalDisclosureText !==
                                                                                                'string'
                                                                                              ) {
                                                                                                validate103.errors =
                                                                                                  [
                                                                                                    {
                                                                                                      instancePath:
                                                                                                        instancePath +
                                                                                                        '/additionalDisclosureText',
                                                                                                      schemaPath:
                                                                                                        '#/properties/additionalDisclosureText/type',
                                                                                                      keyword:
                                                                                                        'type',
                                                                                                      params:
                                                                                                        {
                                                                                                          type: 'string',
                                                                                                        },
                                                                                                      message:
                                                                                                        'must be string',
                                                                                                    },
                                                                                                  ];
                                                                                                return false;
                                                                                              }
                                                                                              var valid0 =
                                                                                                _errs134 ===
                                                                                                errors;
                                                                                            } else {
                                                                                              var valid0 = true;
                                                                                            }
                                                                                            if (
                                                                                              valid0
                                                                                            ) {
                                                                                              if (
                                                                                                data.hasEsignDisclosureAccess !==
                                                                                                undefined
                                                                                              ) {
                                                                                                const _errs136 =
                                                                                                  errors;
                                                                                                if (
                                                                                                  typeof data.hasEsignDisclosureAccess !==
                                                                                                  'boolean'
                                                                                                ) {
                                                                                                  validate103.errors =
                                                                                                    [
                                                                                                      {
                                                                                                        instancePath:
                                                                                                          instancePath +
                                                                                                          '/hasEsignDisclosureAccess',
                                                                                                        schemaPath:
                                                                                                          '#/properties/hasEsignDisclosureAccess/type',
                                                                                                        keyword:
                                                                                                          'type',
                                                                                                        params:
                                                                                                          {
                                                                                                            type: 'boolean',
                                                                                                          },
                                                                                                        message:
                                                                                                          'must be boolean',
                                                                                                      },
                                                                                                    ];
                                                                                                  return false;
                                                                                                }
                                                                                                var valid0 =
                                                                                                  _errs136 ===
                                                                                                  errors;
                                                                                              } else {
                                                                                                var valid0 = true;
                                                                                              }
                                                                                              if (
                                                                                                valid0
                                                                                              ) {
                                                                                                if (
                                                                                                  data.timezoneOptions !==
                                                                                                  undefined
                                                                                                ) {
                                                                                                  let data67 =
                                                                                                    data.timezoneOptions;
                                                                                                  const _errs138 =
                                                                                                    errors;
                                                                                                  if (
                                                                                                    errors ===
                                                                                                    _errs138
                                                                                                  ) {
                                                                                                    if (
                                                                                                      Array.isArray(
                                                                                                        data67
                                                                                                      )
                                                                                                    ) {
                                                                                                      var valid4 = true;
                                                                                                      const len1 =
                                                                                                        data67.length;
                                                                                                      for (
                                                                                                        let i1 = 0;
                                                                                                        i1 <
                                                                                                        len1;
                                                                                                        i1++
                                                                                                      ) {
                                                                                                        let data68 =
                                                                                                          data67[
                                                                                                            i1
                                                                                                          ];
                                                                                                        const _errs140 =
                                                                                                          errors;
                                                                                                        const _errs141 =
                                                                                                          errors;
                                                                                                        if (
                                                                                                          errors ===
                                                                                                          _errs141
                                                                                                        ) {
                                                                                                          if (
                                                                                                            data68 &&
                                                                                                            typeof data68 ==
                                                                                                              'object' &&
                                                                                                            !Array.isArray(
                                                                                                              data68
                                                                                                            )
                                                                                                          ) {
                                                                                                            let missing2;
                                                                                                            if (
                                                                                                              (data68.offset ===
                                                                                                                undefined &&
                                                                                                                (missing2 =
                                                                                                                  'offset')) ||
                                                                                                              (data68.hasDST ===
                                                                                                                undefined &&
                                                                                                                (missing2 =
                                                                                                                  'hasDST')) ||
                                                                                                              (data68.displayName ===
                                                                                                                undefined &&
                                                                                                                (missing2 =
                                                                                                                  'displayName'))
                                                                                                            ) {
                                                                                                              validate103.errors =
                                                                                                                [
                                                                                                                  {
                                                                                                                    instancePath:
                                                                                                                      instancePath +
                                                                                                                      '/timezoneOptions/' +
                                                                                                                      i1,
                                                                                                                    schemaPath:
                                                                                                                      'Timezone.json/required',
                                                                                                                    keyword:
                                                                                                                      'required',
                                                                                                                    params:
                                                                                                                      {
                                                                                                                        missingProperty:
                                                                                                                          missing2,
                                                                                                                      },
                                                                                                                    message:
                                                                                                                      "must have required property '" +
                                                                                                                      missing2 +
                                                                                                                      "'",
                                                                                                                  },
                                                                                                                ];
                                                                                                              return false;
                                                                                                            } else {
                                                                                                              if (
                                                                                                                data68.offset !==
                                                                                                                undefined
                                                                                                              ) {
                                                                                                                let data69 =
                                                                                                                  data68.offset;
                                                                                                                const _errs143 =
                                                                                                                  errors;
                                                                                                                if (
                                                                                                                  !(
                                                                                                                    typeof data69 ==
                                                                                                                      'number' &&
                                                                                                                    isFinite(
                                                                                                                      data69
                                                                                                                    )
                                                                                                                  )
                                                                                                                ) {
                                                                                                                  validate103.errors =
                                                                                                                    [
                                                                                                                      {
                                                                                                                        instancePath:
                                                                                                                          instancePath +
                                                                                                                          '/timezoneOptions/' +
                                                                                                                          i1 +
                                                                                                                          '/offset',
                                                                                                                        schemaPath:
                                                                                                                          'Timezone.json/properties/offset/type',
                                                                                                                        keyword:
                                                                                                                          'type',
                                                                                                                        params:
                                                                                                                          {
                                                                                                                            type: 'number',
                                                                                                                          },
                                                                                                                        message:
                                                                                                                          'must be number',
                                                                                                                      },
                                                                                                                    ];
                                                                                                                  return false;
                                                                                                                }
                                                                                                                var valid6 =
                                                                                                                  _errs143 ===
                                                                                                                  errors;
                                                                                                              } else {
                                                                                                                var valid6 = true;
                                                                                                              }
                                                                                                              if (
                                                                                                                valid6
                                                                                                              ) {
                                                                                                                if (
                                                                                                                  data68.hasDST !==
                                                                                                                  undefined
                                                                                                                ) {
                                                                                                                  const _errs145 =
                                                                                                                    errors;
                                                                                                                  if (
                                                                                                                    typeof data68.hasDST !==
                                                                                                                    'boolean'
                                                                                                                  ) {
                                                                                                                    validate103.errors =
                                                                                                                      [
                                                                                                                        {
                                                                                                                          instancePath:
                                                                                                                            instancePath +
                                                                                                                            '/timezoneOptions/' +
                                                                                                                            i1 +
                                                                                                                            '/hasDST',
                                                                                                                          schemaPath:
                                                                                                                            'Timezone.json/properties/hasDST/type',
                                                                                                                          keyword:
                                                                                                                            'type',
                                                                                                                          params:
                                                                                                                            {
                                                                                                                              type: 'boolean',
                                                                                                                            },
                                                                                                                          message:
                                                                                                                            'must be boolean',
                                                                                                                        },
                                                                                                                      ];
                                                                                                                    return false;
                                                                                                                  }
                                                                                                                  var valid6 =
                                                                                                                    _errs145 ===
                                                                                                                    errors;
                                                                                                                } else {
                                                                                                                  var valid6 = true;
                                                                                                                }
                                                                                                                if (
                                                                                                                  valid6
                                                                                                                ) {
                                                                                                                  if (
                                                                                                                    data68.displayName !==
                                                                                                                    undefined
                                                                                                                  ) {
                                                                                                                    const _errs147 =
                                                                                                                      errors;
                                                                                                                    if (
                                                                                                                      typeof data68.displayName !==
                                                                                                                      'string'
                                                                                                                    ) {
                                                                                                                      validate103.errors =
                                                                                                                        [
                                                                                                                          {
                                                                                                                            instancePath:
                                                                                                                              instancePath +
                                                                                                                              '/timezoneOptions/' +
                                                                                                                              i1 +
                                                                                                                              '/displayName',
                                                                                                                            schemaPath:
                                                                                                                              'Timezone.json/properties/displayName/type',
                                                                                                                            keyword:
                                                                                                                              'type',
                                                                                                                            params:
                                                                                                                              {
                                                                                                                                type: 'string',
                                                                                                                              },
                                                                                                                            message:
                                                                                                                              'must be string',
                                                                                                                          },
                                                                                                                        ];
                                                                                                                      return false;
                                                                                                                    }
                                                                                                                    var valid6 =
                                                                                                                      _errs147 ===
                                                                                                                      errors;
                                                                                                                  } else {
                                                                                                                    var valid6 = true;
                                                                                                                  }
                                                                                                                }
                                                                                                              }
                                                                                                            }
                                                                                                          } else {
                                                                                                            validate103.errors =
                                                                                                              [
                                                                                                                {
                                                                                                                  instancePath:
                                                                                                                    instancePath +
                                                                                                                    '/timezoneOptions/' +
                                                                                                                    i1,
                                                                                                                  schemaPath:
                                                                                                                    'Timezone.json/type',
                                                                                                                  keyword:
                                                                                                                    'type',
                                                                                                                  params:
                                                                                                                    {
                                                                                                                      type: 'object',
                                                                                                                    },
                                                                                                                  message:
                                                                                                                    'must be object',
                                                                                                                },
                                                                                                              ];
                                                                                                            return false;
                                                                                                          }
                                                                                                        }
                                                                                                        var valid4 =
                                                                                                          _errs140 ===
                                                                                                          errors;
                                                                                                        if (
                                                                                                          !valid4
                                                                                                        ) {
                                                                                                          break;
                                                                                                        }
                                                                                                      }
                                                                                                    } else {
                                                                                                      validate103.errors =
                                                                                                        [
                                                                                                          {
                                                                                                            instancePath:
                                                                                                              instancePath +
                                                                                                              '/timezoneOptions',
                                                                                                            schemaPath:
                                                                                                              '#/properties/timezoneOptions/type',
                                                                                                            keyword:
                                                                                                              'type',
                                                                                                            params:
                                                                                                              {
                                                                                                                type: 'array',
                                                                                                              },
                                                                                                            message:
                                                                                                              'must be array',
                                                                                                          },
                                                                                                        ];
                                                                                                      return false;
                                                                                                    }
                                                                                                  }
                                                                                                  var valid0 =
                                                                                                    _errs138 ===
                                                                                                    errors;
                                                                                                } else {
                                                                                                  var valid0 = true;
                                                                                                }
                                                                                                if (
                                                                                                  valid0
                                                                                                ) {
                                                                                                  if (
                                                                                                    data.hipaaLock !==
                                                                                                    undefined
                                                                                                  ) {
                                                                                                    let data72 =
                                                                                                      data.hipaaLock;
                                                                                                    const _errs149 =
                                                                                                      errors;
                                                                                                    const _errs150 =
                                                                                                      errors;
                                                                                                    if (
                                                                                                      errors ===
                                                                                                      _errs150
                                                                                                    ) {
                                                                                                      if (
                                                                                                        data72 &&
                                                                                                        typeof data72 ==
                                                                                                          'object' &&
                                                                                                        !Array.isArray(
                                                                                                          data72
                                                                                                        )
                                                                                                      ) {
                                                                                                        let missing3;
                                                                                                        if (
                                                                                                          (data72.shouldIncludeReceivedFaxPDFs ===
                                                                                                            undefined &&
                                                                                                            (missing3 =
                                                                                                              'shouldIncludeReceivedFaxPDFs')) ||
                                                                                                          (data72.shouldIncludeReceivedFaxPDFsForOthers ===
                                                                                                            undefined &&
                                                                                                            (missing3 =
                                                                                                              'shouldIncludeReceivedFaxPDFsForOthers')) ||
                                                                                                          (data72.shouldIncludeSentFaxPDFs ===
                                                                                                            undefined &&
                                                                                                            (missing3 =
                                                                                                              'shouldIncludeSentFaxPDFs')) ||
                                                                                                          (data72.shouldIncludeRequestedPDFs ===
                                                                                                            undefined &&
                                                                                                            (missing3 =
                                                                                                              'shouldIncludeRequestedPDFs')) ||
                                                                                                          (data72.shouldIncludeRequestedPDFsForOthers ===
                                                                                                            undefined &&
                                                                                                            (missing3 =
                                                                                                              'shouldIncludeRequestedPDFsForOthers')) ||
                                                                                                          (data72.shouldIncludeSentDocPDFs ===
                                                                                                            undefined &&
                                                                                                            (missing3 =
                                                                                                              'shouldIncludeSentDocPDFs')) ||
                                                                                                          (data72.shouldIncludeSentDocPDFsForOthers ===
                                                                                                            undefined &&
                                                                                                            (missing3 =
                                                                                                              'shouldIncludeSentDocPDFsForOthers'))
                                                                                                        ) {
                                                                                                          validate103.errors =
                                                                                                            [
                                                                                                              {
                                                                                                                instancePath:
                                                                                                                  instancePath +
                                                                                                                  '/hipaaLock',
                                                                                                                schemaPath:
                                                                                                                  '#/definitions/HipaaLock/required',
                                                                                                                keyword:
                                                                                                                  'required',
                                                                                                                params:
                                                                                                                  {
                                                                                                                    missingProperty:
                                                                                                                      missing3,
                                                                                                                  },
                                                                                                                message:
                                                                                                                  "must have required property '" +
                                                                                                                  missing3 +
                                                                                                                  "'",
                                                                                                              },
                                                                                                            ];
                                                                                                          return false;
                                                                                                        } else {
                                                                                                          if (
                                                                                                            data72.shouldIncludeReceivedFaxPDFs !==
                                                                                                            undefined
                                                                                                          ) {
                                                                                                            const _errs152 =
                                                                                                              errors;
                                                                                                            if (
                                                                                                              typeof data72.shouldIncludeReceivedFaxPDFs !==
                                                                                                              'boolean'
                                                                                                            ) {
                                                                                                              validate103.errors =
                                                                                                                [
                                                                                                                  {
                                                                                                                    instancePath:
                                                                                                                      instancePath +
                                                                                                                      '/hipaaLock/shouldIncludeReceivedFaxPDFs',
                                                                                                                    schemaPath:
                                                                                                                      '#/definitions/HipaaLock/properties/shouldIncludeReceivedFaxPDFs/type',
                                                                                                                    keyword:
                                                                                                                      'type',
                                                                                                                    params:
                                                                                                                      {
                                                                                                                        type: 'boolean',
                                                                                                                      },
                                                                                                                    message:
                                                                                                                      'must be boolean',
                                                                                                                  },
                                                                                                                ];
                                                                                                              return false;
                                                                                                            }
                                                                                                            var valid8 =
                                                                                                              _errs152 ===
                                                                                                              errors;
                                                                                                          } else {
                                                                                                            var valid8 = true;
                                                                                                          }
                                                                                                          if (
                                                                                                            valid8
                                                                                                          ) {
                                                                                                            if (
                                                                                                              data72.shouldIncludeReceivedFaxPDFsForOthers !==
                                                                                                              undefined
                                                                                                            ) {
                                                                                                              const _errs154 =
                                                                                                                errors;
                                                                                                              if (
                                                                                                                typeof data72.shouldIncludeReceivedFaxPDFsForOthers !==
                                                                                                                'boolean'
                                                                                                              ) {
                                                                                                                validate103.errors =
                                                                                                                  [
                                                                                                                    {
                                                                                                                      instancePath:
                                                                                                                        instancePath +
                                                                                                                        '/hipaaLock/shouldIncludeReceivedFaxPDFsForOthers',
                                                                                                                      schemaPath:
                                                                                                                        '#/definitions/HipaaLock/properties/shouldIncludeReceivedFaxPDFsForOthers/type',
                                                                                                                      keyword:
                                                                                                                        'type',
                                                                                                                      params:
                                                                                                                        {
                                                                                                                          type: 'boolean',
                                                                                                                        },
                                                                                                                      message:
                                                                                                                        'must be boolean',
                                                                                                                    },
                                                                                                                  ];
                                                                                                                return false;
                                                                                                              }
                                                                                                              var valid8 =
                                                                                                                _errs154 ===
                                                                                                                errors;
                                                                                                            } else {
                                                                                                              var valid8 = true;
                                                                                                            }
                                                                                                            if (
                                                                                                              valid8
                                                                                                            ) {
                                                                                                              if (
                                                                                                                data72.shouldIncludeSentFaxPDFs !==
                                                                                                                undefined
                                                                                                              ) {
                                                                                                                const _errs156 =
                                                                                                                  errors;
                                                                                                                if (
                                                                                                                  typeof data72.shouldIncludeSentFaxPDFs !==
                                                                                                                  'boolean'
                                                                                                                ) {
                                                                                                                  validate103.errors =
                                                                                                                    [
                                                                                                                      {
                                                                                                                        instancePath:
                                                                                                                          instancePath +
                                                                                                                          '/hipaaLock/shouldIncludeSentFaxPDFs',
                                                                                                                        schemaPath:
                                                                                                                          '#/definitions/HipaaLock/properties/shouldIncludeSentFaxPDFs/type',
                                                                                                                        keyword:
                                                                                                                          'type',
                                                                                                                        params:
                                                                                                                          {
                                                                                                                            type: 'boolean',
                                                                                                                          },
                                                                                                                        message:
                                                                                                                          'must be boolean',
                                                                                                                      },
                                                                                                                    ];
                                                                                                                  return false;
                                                                                                                }
                                                                                                                var valid8 =
                                                                                                                  _errs156 ===
                                                                                                                  errors;
                                                                                                              } else {
                                                                                                                var valid8 = true;
                                                                                                              }
                                                                                                              if (
                                                                                                                valid8
                                                                                                              ) {
                                                                                                                if (
                                                                                                                  data72.shouldIncludeRequestedPDFs !==
                                                                                                                  undefined
                                                                                                                ) {
                                                                                                                  const _errs158 =
                                                                                                                    errors;
                                                                                                                  if (
                                                                                                                    typeof data72.shouldIncludeRequestedPDFs !==
                                                                                                                    'boolean'
                                                                                                                  ) {
                                                                                                                    validate103.errors =
                                                                                                                      [
                                                                                                                        {
                                                                                                                          instancePath:
                                                                                                                            instancePath +
                                                                                                                            '/hipaaLock/shouldIncludeRequestedPDFs',
                                                                                                                          schemaPath:
                                                                                                                            '#/definitions/HipaaLock/properties/shouldIncludeRequestedPDFs/type',
                                                                                                                          keyword:
                                                                                                                            'type',
                                                                                                                          params:
                                                                                                                            {
                                                                                                                              type: 'boolean',
                                                                                                                            },
                                                                                                                          message:
                                                                                                                            'must be boolean',
                                                                                                                        },
                                                                                                                      ];
                                                                                                                    return false;
                                                                                                                  }
                                                                                                                  var valid8 =
                                                                                                                    _errs158 ===
                                                                                                                    errors;
                                                                                                                } else {
                                                                                                                  var valid8 = true;
                                                                                                                }
                                                                                                                if (
                                                                                                                  valid8
                                                                                                                ) {
                                                                                                                  if (
                                                                                                                    data72.shouldIncludeRequestedPDFsForOthers !==
                                                                                                                    undefined
                                                                                                                  ) {
                                                                                                                    const _errs160 =
                                                                                                                      errors;
                                                                                                                    if (
                                                                                                                      typeof data72.shouldIncludeRequestedPDFsForOthers !==
                                                                                                                      'boolean'
                                                                                                                    ) {
                                                                                                                      validate103.errors =
                                                                                                                        [
                                                                                                                          {
                                                                                                                            instancePath:
                                                                                                                              instancePath +
                                                                                                                              '/hipaaLock/shouldIncludeRequestedPDFsForOthers',
                                                                                                                            schemaPath:
                                                                                                                              '#/definitions/HipaaLock/properties/shouldIncludeRequestedPDFsForOthers/type',
                                                                                                                            keyword:
                                                                                                                              'type',
                                                                                                                            params:
                                                                                                                              {
                                                                                                                                type: 'boolean',
                                                                                                                              },
                                                                                                                            message:
                                                                                                                              'must be boolean',
                                                                                                                          },
                                                                                                                        ];
                                                                                                                      return false;
                                                                                                                    }
                                                                                                                    var valid8 =
                                                                                                                      _errs160 ===
                                                                                                                      errors;
                                                                                                                  } else {
                                                                                                                    var valid8 = true;
                                                                                                                  }
                                                                                                                  if (
                                                                                                                    valid8
                                                                                                                  ) {
                                                                                                                    if (
                                                                                                                      data72.shouldIncludeSentDocPDFs !==
                                                                                                                      undefined
                                                                                                                    ) {
                                                                                                                      const _errs162 =
                                                                                                                        errors;
                                                                                                                      if (
                                                                                                                        typeof data72.shouldIncludeSentDocPDFs !==
                                                                                                                        'boolean'
                                                                                                                      ) {
                                                                                                                        validate103.errors =
                                                                                                                          [
                                                                                                                            {
                                                                                                                              instancePath:
                                                                                                                                instancePath +
                                                                                                                                '/hipaaLock/shouldIncludeSentDocPDFs',
                                                                                                                              schemaPath:
                                                                                                                                '#/definitions/HipaaLock/properties/shouldIncludeSentDocPDFs/type',
                                                                                                                              keyword:
                                                                                                                                'type',
                                                                                                                              params:
                                                                                                                                {
                                                                                                                                  type: 'boolean',
                                                                                                                                },
                                                                                                                              message:
                                                                                                                                'must be boolean',
                                                                                                                            },
                                                                                                                          ];
                                                                                                                        return false;
                                                                                                                      }
                                                                                                                      var valid8 =
                                                                                                                        _errs162 ===
                                                                                                                        errors;
                                                                                                                    } else {
                                                                                                                      var valid8 = true;
                                                                                                                    }
                                                                                                                    if (
                                                                                                                      valid8
                                                                                                                    ) {
                                                                                                                      if (
                                                                                                                        data72.shouldIncludeSentDocPDFsForOthers !==
                                                                                                                        undefined
                                                                                                                      ) {
                                                                                                                        const _errs164 =
                                                                                                                          errors;
                                                                                                                        if (
                                                                                                                          typeof data72.shouldIncludeSentDocPDFsForOthers !==
                                                                                                                          'boolean'
                                                                                                                        ) {
                                                                                                                          validate103.errors =
                                                                                                                            [
                                                                                                                              {
                                                                                                                                instancePath:
                                                                                                                                  instancePath +
                                                                                                                                  '/hipaaLock/shouldIncludeSentDocPDFsForOthers',
                                                                                                                                schemaPath:
                                                                                                                                  '#/definitions/HipaaLock/properties/shouldIncludeSentDocPDFsForOthers/type',
                                                                                                                                keyword:
                                                                                                                                  'type',
                                                                                                                                params:
                                                                                                                                  {
                                                                                                                                    type: 'boolean',
                                                                                                                                  },
                                                                                                                                message:
                                                                                                                                  'must be boolean',
                                                                                                                              },
                                                                                                                            ];
                                                                                                                          return false;
                                                                                                                        }
                                                                                                                        var valid8 =
                                                                                                                          _errs164 ===
                                                                                                                          errors;
                                                                                                                      } else {
                                                                                                                        var valid8 = true;
                                                                                                                      }
                                                                                                                    }
                                                                                                                  }
                                                                                                                }
                                                                                                              }
                                                                                                            }
                                                                                                          }
                                                                                                        }
                                                                                                      } else {
                                                                                                        validate103.errors =
                                                                                                          [
                                                                                                            {
                                                                                                              instancePath:
                                                                                                                instancePath +
                                                                                                                '/hipaaLock',
                                                                                                              schemaPath:
                                                                                                                '#/definitions/HipaaLock/type',
                                                                                                              keyword:
                                                                                                                'type',
                                                                                                              params:
                                                                                                                {
                                                                                                                  type: 'object',
                                                                                                                },
                                                                                                              message:
                                                                                                                'must be object',
                                                                                                            },
                                                                                                          ];
                                                                                                        return false;
                                                                                                      }
                                                                                                    }
                                                                                                    var valid0 =
                                                                                                      _errs149 ===
                                                                                                      errors;
                                                                                                  } else {
                                                                                                    var valid0 = true;
                                                                                                  }
                                                                                                  if (
                                                                                                    valid0
                                                                                                  ) {
                                                                                                    if (
                                                                                                      data.cancelSubscriptionLink !==
                                                                                                      undefined
                                                                                                    ) {
                                                                                                      const _errs166 =
                                                                                                        errors;
                                                                                                      if (
                                                                                                        typeof data.cancelSubscriptionLink !==
                                                                                                        'string'
                                                                                                      ) {
                                                                                                        validate103.errors =
                                                                                                          [
                                                                                                            {
                                                                                                              instancePath:
                                                                                                                instancePath +
                                                                                                                '/cancelSubscriptionLink',
                                                                                                              schemaPath:
                                                                                                                '#/properties/cancelSubscriptionLink/type',
                                                                                                              keyword:
                                                                                                                'type',
                                                                                                              params:
                                                                                                                {
                                                                                                                  type: 'string',
                                                                                                                },
                                                                                                              message:
                                                                                                                'must be string',
                                                                                                            },
                                                                                                          ];
                                                                                                        return false;
                                                                                                      }
                                                                                                      var valid0 =
                                                                                                        _errs166 ===
                                                                                                        errors;
                                                                                                    } else {
                                                                                                      var valid0 = true;
                                                                                                    }
                                                                                                  }
                                                                                                }
                                                                                              }
                                                                                            }
                                                                                          }
                                                                                        }
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                }
                                                                              }
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate103.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate103.errors = vErrors;
  return errors === 0;
}
function validate10(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="HelloRequest.json" */ let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == 'object' && !Array.isArray(data))) {
    validate10.errors = [
      {
        instancePath,
        schemaPath: '#/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      },
    ];
    return false;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (
    !validate11(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
    })
  ) {
    vErrors =
      vErrors === null ? validate11.errors : vErrors.concat(validate11.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs4 = errors;
  if (
    !validate95(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
    })
  ) {
    vErrors =
      vErrors === null ? validate95.errors : vErrors.concat(validate95.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs4 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs6 = errors;
    const _errs7 = errors;
    if (errors === _errs7) {
      if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (
          (data.id === undefined && (missing0 = 'id')) ||
          (data.guid === undefined && (missing0 = 'guid')) ||
          (data.emailAddress === undefined && (missing0 = 'emailAddress')) ||
          (data.name === undefined && (missing0 = 'name')) ||
          (data.settings === undefined && (missing0 = 'settings')) ||
          (data.isFree === undefined && (missing0 = 'isFree')) ||
          (data.hasTeam === undefined && (missing0 = 'hasTeam')) ||
          (data.plan === undefined && (missing0 = 'plan')) ||
          (data.numApiDocsLeft === undefined &&
            (missing0 = 'numApiDocsLeft')) ||
          (data.numDocsLeft === undefined && (missing0 = 'numDocsLeft')) ||
          (data.numTemplatesLeft === undefined &&
            (missing0 = 'numTemplatesLeft')) ||
          (data.numFaxPagesLeft === undefined &&
            (missing0 = 'numFaxPagesLeft')) ||
          (data.canAccessBulkSendUI === undefined &&
            (missing0 = 'canAccessBulkSendUI')) ||
          (data.canAccessAdminConsole === undefined &&
            (missing0 = 'canAccessAdminConsole')) ||
          (data.canAccessTemplateConverter === undefined &&
            (missing0 = 'canAccessTemplateConverter')) ||
          (data.noTimeout === undefined && (missing0 = 'noTimeout')) ||
          (data.isFromSelfServeApi === undefined &&
            (missing0 = 'isFromSelfServeApi')) ||
          (data.showApiCredits === undefined &&
            (missing0 = 'showApiCredits')) ||
          (data.canCreateEditTemplate === undefined &&
            (missing0 = 'canCreateEditTemplate')) ||
          (data.hasLegacyApiKeys === undefined &&
            (missing0 = 'hasLegacyApiKeys')) ||
          (data.referUrl === undefined && (missing0 = 'referUrl'))
        ) {
          const err0 = {
            instancePath,
            schemaPath: 'HSUser.json/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        } else {
          if (data.id !== undefined) {
            let data0 = data.id;
            const _errs9 = errors;
            if (!(typeof data0 == 'number' && isFinite(data0))) {
              const err1 = {
                instancePath: instancePath + '/id',
                schemaPath: 'HSUser.json/properties/id/type',
                keyword: 'type',
                params: { type: 'number' },
                message: 'must be number',
              };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
            var valid2 = _errs9 === errors;
          } else {
            var valid2 = true;
          }
          if (valid2) {
            if (data.guid !== undefined) {
              const _errs11 = errors;
              if (typeof data.guid !== 'string') {
                const err2 = {
                  instancePath: instancePath + '/guid',
                  schemaPath: 'HSUser.json/properties/guid/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                };
                if (vErrors === null) {
                  vErrors = [err2];
                } else {
                  vErrors.push(err2);
                }
                errors++;
              }
              var valid2 = _errs11 === errors;
            } else {
              var valid2 = true;
            }
            if (valid2) {
              if (data.emailAddress !== undefined) {
                const _errs13 = errors;
                if (typeof data.emailAddress !== 'string') {
                  const err3 = {
                    instancePath: instancePath + '/emailAddress',
                    schemaPath: 'HSUser.json/properties/emailAddress/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  };
                  if (vErrors === null) {
                    vErrors = [err3];
                  } else {
                    vErrors.push(err3);
                  }
                  errors++;
                }
                var valid2 = _errs13 === errors;
              } else {
                var valid2 = true;
              }
              if (valid2) {
                if (data.name !== undefined) {
                  const _errs15 = errors;
                  if (typeof data.name !== 'string') {
                    const err4 = {
                      instancePath: instancePath + '/name',
                      schemaPath: 'HSUser.json/properties/name/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    };
                    if (vErrors === null) {
                      vErrors = [err4];
                    } else {
                      vErrors.push(err4);
                    }
                    errors++;
                  }
                  var valid2 = _errs15 === errors;
                } else {
                  var valid2 = true;
                }
                if (valid2) {
                  if (data.settings !== undefined) {
                    let data4 = data.settings;
                    const _errs17 = errors;
                    if (errors === _errs17) {
                      if (
                        data4 &&
                        typeof data4 == 'object' &&
                        !Array.isArray(data4)
                      ) {
                        let missing1;
                        if (
                          (data4.firstName === undefined &&
                            (missing1 = 'firstName')) ||
                          (data4.lastName === undefined &&
                            (missing1 = 'lastName'))
                        ) {
                          const err5 = {
                            instancePath: instancePath + '/settings',
                            schemaPath:
                              'HSUser.json/properties/settings/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message:
                              "must have required property '" + missing1 + "'",
                          };
                          if (vErrors === null) {
                            vErrors = [err5];
                          } else {
                            vErrors.push(err5);
                          }
                          errors++;
                        } else {
                          if (data4.firstName !== undefined) {
                            const _errs19 = errors;
                            if (typeof data4.firstName !== 'string') {
                              const err6 = {
                                instancePath:
                                  instancePath + '/settings/firstName',
                                schemaPath:
                                  'HSUser.json/properties/settings/properties/firstName/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              };
                              if (vErrors === null) {
                                vErrors = [err6];
                              } else {
                                vErrors.push(err6);
                              }
                              errors++;
                            }
                            var valid3 = _errs19 === errors;
                          } else {
                            var valid3 = true;
                          }
                          if (valid3) {
                            if (data4.lastName !== undefined) {
                              const _errs21 = errors;
                              if (typeof data4.lastName !== 'string') {
                                const err7 = {
                                  instancePath:
                                    instancePath + '/settings/lastName',
                                  schemaPath:
                                    'HSUser.json/properties/settings/properties/lastName/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                };
                                if (vErrors === null) {
                                  vErrors = [err7];
                                } else {
                                  vErrors.push(err7);
                                }
                                errors++;
                              }
                              var valid3 = _errs21 === errors;
                            } else {
                              var valid3 = true;
                            }
                          }
                        }
                      } else {
                        const err8 = {
                          instancePath: instancePath + '/settings',
                          schemaPath: 'HSUser.json/properties/settings/type',
                          keyword: 'type',
                          params: { type: 'object' },
                          message: 'must be object',
                        };
                        if (vErrors === null) {
                          vErrors = [err8];
                        } else {
                          vErrors.push(err8);
                        }
                        errors++;
                      }
                    }
                    var valid2 = _errs17 === errors;
                  } else {
                    var valid2 = true;
                  }
                  if (valid2) {
                    if (data.isFree !== undefined) {
                      const _errs23 = errors;
                      if (typeof data.isFree !== 'boolean') {
                        const err9 = {
                          instancePath: instancePath + '/isFree',
                          schemaPath: 'HSUser.json/properties/isFree/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        };
                        if (vErrors === null) {
                          vErrors = [err9];
                        } else {
                          vErrors.push(err9);
                        }
                        errors++;
                      }
                      var valid2 = _errs23 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data.hasTeam !== undefined) {
                        const _errs25 = errors;
                        if (typeof data.hasTeam !== 'boolean') {
                          const err10 = {
                            instancePath: instancePath + '/hasTeam',
                            schemaPath: 'HSUser.json/properties/hasTeam/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          };
                          if (vErrors === null) {
                            vErrors = [err10];
                          } else {
                            vErrors.push(err10);
                          }
                          errors++;
                        }
                        var valid2 = _errs25 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data.plan !== undefined) {
                          let data9 = data.plan;
                          const _errs27 = errors;
                          if (typeof data9 !== 'string') {
                            const err11 = {
                              instancePath: instancePath + '/plan',
                              schemaPath: 'HSUser.json/properties/plan/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            };
                            if (vErrors === null) {
                              vErrors = [err11];
                            } else {
                              vErrors.push(err11);
                            }
                            errors++;
                          }
                          if (
                            !(
                              data9 === '(Grandfathered 2016)' ||
                              data9 === 'API Basic' ||
                              data9 === 'Business 10' ||
                              data9 === 'Business' ||
                              data9 === 'Enterprise' ||
                              data9 === 'Enterprise+' ||
                              data9 === 'Essentials' ||
                              data9 === 'Free Premium' ||
                              data9 === 'Free' ||
                              data9 === 'Grandfathered' ||
                              data9 === 'Premium' ||
                              data9 === 'Standard' ||
                              data9 === 'Test Mode' ||
                              data9 === 'Web 300k'
                            )
                          ) {
                            const err12 = {
                              instancePath: instancePath + '/plan',
                              schemaPath: 'HSUser.json/properties/plan/enum',
                              keyword: 'enum',
                              params: {
                                allowedValues: schema111.properties.plan.enum,
                              },
                              message:
                                'must be equal to one of the allowed values',
                            };
                            if (vErrors === null) {
                              vErrors = [err12];
                            } else {
                              vErrors.push(err12);
                            }
                            errors++;
                          }
                          var valid2 = _errs27 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data.numApiDocsLeft !== undefined) {
                            let data10 = data.numApiDocsLeft;
                            const _errs29 = errors;
                            if (
                              !(typeof data10 == 'number' && isFinite(data10))
                            ) {
                              const err13 = {
                                instancePath: instancePath + '/numApiDocsLeft',
                                schemaPath:
                                  'HSUser.json/properties/numApiDocsLeft/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number',
                              };
                              if (vErrors === null) {
                                vErrors = [err13];
                              } else {
                                vErrors.push(err13);
                              }
                              errors++;
                            }
                            var valid2 = _errs29 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data.numDocsLeft !== undefined) {
                              let data11 = data.numDocsLeft;
                              const _errs31 = errors;
                              if (
                                !(typeof data11 == 'number' && isFinite(data11))
                              ) {
                                const err14 = {
                                  instancePath: instancePath + '/numDocsLeft',
                                  schemaPath:
                                    'HSUser.json/properties/numDocsLeft/type',
                                  keyword: 'type',
                                  params: { type: 'number' },
                                  message: 'must be number',
                                };
                                if (vErrors === null) {
                                  vErrors = [err14];
                                } else {
                                  vErrors.push(err14);
                                }
                                errors++;
                              }
                              var valid2 = _errs31 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data.numTemplatesLeft !== undefined) {
                                let data12 = data.numTemplatesLeft;
                                const _errs33 = errors;
                                if (
                                  !(
                                    typeof data12 == 'number' &&
                                    isFinite(data12)
                                  )
                                ) {
                                  const err15 = {
                                    instancePath:
                                      instancePath + '/numTemplatesLeft',
                                    schemaPath:
                                      'HSUser.json/properties/numTemplatesLeft/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number',
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err15];
                                  } else {
                                    vErrors.push(err15);
                                  }
                                  errors++;
                                }
                                var valid2 = _errs33 === errors;
                              } else {
                                var valid2 = true;
                              }
                              if (valid2) {
                                if (data.numFaxPagesLeft !== undefined) {
                                  let data13 = data.numFaxPagesLeft;
                                  const _errs35 = errors;
                                  if (
                                    !(
                                      typeof data13 == 'number' &&
                                      isFinite(data13)
                                    )
                                  ) {
                                    const err16 = {
                                      instancePath:
                                        instancePath + '/numFaxPagesLeft',
                                      schemaPath:
                                        'HSUser.json/properties/numFaxPagesLeft/type',
                                      keyword: 'type',
                                      params: { type: 'number' },
                                      message: 'must be number',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err16];
                                    } else {
                                      vErrors.push(err16);
                                    }
                                    errors++;
                                  }
                                  var valid2 = _errs35 === errors;
                                } else {
                                  var valid2 = true;
                                }
                                if (valid2) {
                                  if (data.canAccessBulkSendUI !== undefined) {
                                    const _errs37 = errors;
                                    if (
                                      typeof data.canAccessBulkSendUI !==
                                      'boolean'
                                    ) {
                                      const err17 = {
                                        instancePath:
                                          instancePath + '/canAccessBulkSendUI',
                                        schemaPath:
                                          'HSUser.json/properties/canAccessBulkSendUI/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean',
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err17];
                                      } else {
                                        vErrors.push(err17);
                                      }
                                      errors++;
                                    }
                                    var valid2 = _errs37 === errors;
                                  } else {
                                    var valid2 = true;
                                  }
                                  if (valid2) {
                                    if (
                                      data.canAccessAdminConsole !== undefined
                                    ) {
                                      const _errs39 = errors;
                                      if (
                                        typeof data.canAccessAdminConsole !==
                                        'boolean'
                                      ) {
                                        const err18 = {
                                          instancePath:
                                            instancePath +
                                            '/canAccessAdminConsole',
                                          schemaPath:
                                            'HSUser.json/properties/canAccessAdminConsole/type',
                                          keyword: 'type',
                                          params: { type: 'boolean' },
                                          message: 'must be boolean',
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err18];
                                        } else {
                                          vErrors.push(err18);
                                        }
                                        errors++;
                                      }
                                      var valid2 = _errs39 === errors;
                                    } else {
                                      var valid2 = true;
                                    }
                                    if (valid2) {
                                      if (
                                        data.canAccessTemplateConverter !==
                                        undefined
                                      ) {
                                        const _errs41 = errors;
                                        if (
                                          typeof data.canAccessTemplateConverter !==
                                          'boolean'
                                        ) {
                                          const err19 = {
                                            instancePath:
                                              instancePath +
                                              '/canAccessTemplateConverter',
                                            schemaPath:
                                              'HSUser.json/properties/canAccessTemplateConverter/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean',
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err19];
                                          } else {
                                            vErrors.push(err19);
                                          }
                                          errors++;
                                        }
                                        var valid2 = _errs41 === errors;
                                      } else {
                                        var valid2 = true;
                                      }
                                      if (valid2) {
                                        if (data.noTimeout !== undefined) {
                                          const _errs43 = errors;
                                          if (
                                            typeof data.noTimeout !== 'boolean'
                                          ) {
                                            const err20 = {
                                              instancePath:
                                                instancePath + '/noTimeout',
                                              schemaPath:
                                                'HSUser.json/properties/noTimeout/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err20];
                                            } else {
                                              vErrors.push(err20);
                                            }
                                            errors++;
                                          }
                                          var valid2 = _errs43 === errors;
                                        } else {
                                          var valid2 = true;
                                        }
                                        if (valid2) {
                                          if (
                                            data.isFromSelfServeApi !==
                                            undefined
                                          ) {
                                            const _errs45 = errors;
                                            if (
                                              typeof data.isFromSelfServeApi !==
                                              'boolean'
                                            ) {
                                              const err21 = {
                                                instancePath:
                                                  instancePath +
                                                  '/isFromSelfServeApi',
                                                schemaPath:
                                                  'HSUser.json/properties/isFromSelfServeApi/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean',
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err21];
                                              } else {
                                                vErrors.push(err21);
                                              }
                                              errors++;
                                            }
                                            var valid2 = _errs45 === errors;
                                          } else {
                                            var valid2 = true;
                                          }
                                          if (valid2) {
                                            if (
                                              data.primarySignatureGuid !==
                                              undefined
                                            ) {
                                              const _errs47 = errors;
                                              if (
                                                typeof data.primarySignatureGuid !==
                                                'string'
                                              ) {
                                                const err22 = {
                                                  instancePath:
                                                    instancePath +
                                                    '/primarySignatureGuid',
                                                  schemaPath:
                                                    'HSUser.json/properties/primarySignatureGuid/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err22];
                                                } else {
                                                  vErrors.push(err22);
                                                }
                                                errors++;
                                              }
                                              var valid2 = _errs47 === errors;
                                            } else {
                                              var valid2 = true;
                                            }
                                            if (valid2) {
                                              if (
                                                data.showApiCredits !==
                                                undefined
                                              ) {
                                                const _errs49 = errors;
                                                if (
                                                  typeof data.showApiCredits !==
                                                  'boolean'
                                                ) {
                                                  const err23 = {
                                                    instancePath:
                                                      instancePath +
                                                      '/showApiCredits',
                                                    schemaPath:
                                                      'HSUser.json/properties/showApiCredits/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean',
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err23];
                                                  } else {
                                                    vErrors.push(err23);
                                                  }
                                                  errors++;
                                                }
                                                var valid2 = _errs49 === errors;
                                              } else {
                                                var valid2 = true;
                                              }
                                              if (valid2) {
                                                if (
                                                  data.canCreateEditTemplate !==
                                                  undefined
                                                ) {
                                                  const _errs51 = errors;
                                                  if (
                                                    typeof data.canCreateEditTemplate !==
                                                    'boolean'
                                                  ) {
                                                    const err24 = {
                                                      instancePath:
                                                        instancePath +
                                                        '/canCreateEditTemplate',
                                                      schemaPath:
                                                        'HSUser.json/properties/canCreateEditTemplate/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'boolean',
                                                      },
                                                      message:
                                                        'must be boolean',
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err24];
                                                    } else {
                                                      vErrors.push(err24);
                                                    }
                                                    errors++;
                                                  }
                                                  var valid2 =
                                                    _errs51 === errors;
                                                } else {
                                                  var valid2 = true;
                                                }
                                                if (valid2) {
                                                  if (
                                                    data.hasLegacyApiKeys !==
                                                    undefined
                                                  ) {
                                                    const _errs53 = errors;
                                                    if (
                                                      typeof data.hasLegacyApiKeys !==
                                                      'boolean'
                                                    ) {
                                                      const err25 = {
                                                        instancePath:
                                                          instancePath +
                                                          '/hasLegacyApiKeys',
                                                        schemaPath:
                                                          'HSUser.json/properties/hasLegacyApiKeys/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'boolean',
                                                        },
                                                        message:
                                                          'must be boolean',
                                                      };
                                                      if (vErrors === null) {
                                                        vErrors = [err25];
                                                      } else {
                                                        vErrors.push(err25);
                                                      }
                                                      errors++;
                                                    }
                                                    var valid2 =
                                                      _errs53 === errors;
                                                  } else {
                                                    var valid2 = true;
                                                  }
                                                  if (valid2) {
                                                    if (
                                                      data.referUrl !==
                                                      undefined
                                                    ) {
                                                      const _errs55 = errors;
                                                      if (
                                                        typeof data.referUrl !==
                                                        'string'
                                                      ) {
                                                        const err26 = {
                                                          instancePath:
                                                            instancePath +
                                                            '/referUrl',
                                                          schemaPath:
                                                            'HSUser.json/properties/referUrl/type',
                                                          keyword: 'type',
                                                          params: {
                                                            type: 'string',
                                                          },
                                                          message:
                                                            'must be string',
                                                        };
                                                        if (vErrors === null) {
                                                          vErrors = [err26];
                                                        } else {
                                                          vErrors.push(err26);
                                                        }
                                                        errors++;
                                                      }
                                                      var valid2 =
                                                        _errs55 === errors;
                                                    } else {
                                                      var valid2 = true;
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      } else {
        const err27 = {
          instancePath,
          schemaPath: 'HSUser.json/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        };
        if (vErrors === null) {
          vErrors = [err27];
        } else {
          vErrors.push(err27);
        }
        errors++;
      }
    }
    var _valid0 = _errs6 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
      const _errs57 = errors;
      if (
        !validate99(data, {
          instancePath,
          parentData,
          parentDataProperty,
          rootData,
        })
      ) {
        vErrors =
          vErrors === null
            ? validate99.errors
            : vErrors.concat(validate99.errors);
        errors = vErrors.length;
      }
      var _valid0 = _errs57 === errors;
      if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [passing0, 3];
      } else {
        if (_valid0) {
          valid0 = true;
          passing0 = 3;
        }
        const _errs58 = errors;
        if (
          !validate101(data, {
            instancePath,
            parentData,
            parentDataProperty,
            rootData,
          })
        ) {
          vErrors =
            vErrors === null
              ? validate101.errors
              : vErrors.concat(validate101.errors);
          errors = vErrors.length;
        }
        var _valid0 = _errs58 === errors;
        if (_valid0 && valid0) {
          valid0 = false;
          passing0 = [passing0, 4];
        } else {
          if (_valid0) {
            valid0 = true;
            passing0 = 4;
          }
          const _errs59 = errors;
          if (
            !validate103(data, {
              instancePath,
              parentData,
              parentDataProperty,
              rootData,
            })
          ) {
            vErrors =
              vErrors === null
                ? validate103.errors
                : vErrors.concat(validate103.errors);
            errors = vErrors.length;
          }
          var _valid0 = _errs59 === errors;
          if (_valid0 && valid0) {
            valid0 = false;
            passing0 = [passing0, 5];
          } else {
            if (_valid0) {
              valid0 = true;
              passing0 = 5;
            }
          }
        }
      }
    }
  }
  if (!valid0) {
    const err28 = {
      instancePath,
      schemaPath: '#/oneOf',
      keyword: 'oneOf',
      params: { passingSchemas: passing0 },
      message: 'must match exactly one schema in oneOf',
    };
    if (vErrors === null) {
      vErrors = [err28];
    } else {
      vErrors.push(err28);
    }
    errors++;
    validate10.errors = vErrors;
    return false;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate10.errors = vErrors;
  return errors === 0;
}
exports.validatePrepAndSendRequest = validate11;
exports.validateSettings = validate105;
function validate105(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="Settings.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      const _errs1 = errors;
      for (const key0 in data) {
        if (
          !(
            key0 === 'addCoverPage' ||
            key0 === 'recipientOrder' ||
            key0 === 'qes' ||
            key0 === 'recipientReassignment' ||
            key0 === 'requireSignerInfo' ||
            key0 === 'sendHighResFax' ||
            key0 === 'needsCharge'
          )
        ) {
          validate105.errors = [
            {
              instancePath,
              schemaPath: '#/additionalProperties',
              keyword: 'additionalProperties',
              params: { additionalProperty: key0 },
              message: 'must NOT have additional properties',
            },
          ];
          return false;
          break;
        }
      }
      if (_errs1 === errors) {
        if (data.addCoverPage !== undefined) {
          const _errs2 = errors;
          if (typeof data.addCoverPage !== 'boolean') {
            validate105.errors = [
              {
                instancePath: instancePath + '/addCoverPage',
                schemaPath: '#/properties/addCoverPage/type',
                keyword: 'type',
                params: { type: 'boolean' },
                message: 'must be boolean',
              },
            ];
            return false;
          }
          var valid0 = _errs2 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.recipientOrder !== undefined) {
            const _errs4 = errors;
            if (typeof data.recipientOrder !== 'boolean') {
              validate105.errors = [
                {
                  instancePath: instancePath + '/recipientOrder',
                  schemaPath: '#/properties/recipientOrder/type',
                  keyword: 'type',
                  params: { type: 'boolean' },
                  message: 'must be boolean',
                },
              ];
              return false;
            }
            var valid0 = _errs4 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.qes !== undefined) {
              const _errs6 = errors;
              if (typeof data.qes !== 'boolean') {
                validate105.errors = [
                  {
                    instancePath: instancePath + '/qes',
                    schemaPath: '#/properties/qes/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  },
                ];
                return false;
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.recipientReassignment !== undefined) {
                const _errs8 = errors;
                if (typeof data.recipientReassignment !== 'boolean') {
                  validate105.errors = [
                    {
                      instancePath: instancePath + '/recipientReassignment',
                      schemaPath: '#/properties/recipientReassignment/type',
                      keyword: 'type',
                      params: { type: 'boolean' },
                      message: 'must be boolean',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.requireSignerInfo !== undefined) {
                  const _errs10 = errors;
                  if (typeof data.requireSignerInfo !== 'boolean') {
                    validate105.errors = [
                      {
                        instancePath: instancePath + '/requireSignerInfo',
                        schemaPath: '#/properties/requireSignerInfo/type',
                        keyword: 'type',
                        params: { type: 'boolean' },
                        message: 'must be boolean',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.sendHighResFax !== undefined) {
                    const _errs12 = errors;
                    if (typeof data.sendHighResFax !== 'boolean') {
                      validate105.errors = [
                        {
                          instancePath: instancePath + '/sendHighResFax',
                          schemaPath: '#/properties/sendHighResFax/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.needsCharge !== undefined) {
                      const _errs14 = errors;
                      if (typeof data.needsCharge !== 'boolean') {
                        validate105.errors = [
                          {
                            instancePath: instancePath + '/needsCharge',
                            schemaPath: '#/properties/needsCharge/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs14 === errors;
                    } else {
                      var valid0 = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate105.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate105.errors = vErrors;
  return errors === 0;
}
exports.validateOptions = validate12;
exports.validateFlags = validate30;
exports.validateAccountSettings = validate40;
exports.validateRequestData = validate44;
exports.validateFile = validate45;
exports.validateField = validate13;
exports.validateEditorData = validate48;
exports.validatePage = validate106;
function validate106(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="Page.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.src === undefined && (missing0 = 'src')) ||
        (data.width === undefined && (missing0 = 'width')) ||
        (data.height === undefined && (missing0 = 'height')) ||
        (data.documentId === undefined && (missing0 = 'documentId')) ||
        (data.orientation === undefined && (missing0 = 'orientation')) ||
        (data.snapshotGuid === undefined && (missing0 = 'snapshotGuid'))
      ) {
        validate106.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (
            !(
              key0 === 'src' ||
              key0 === 'width' ||
              key0 === 'height' ||
              key0 === 'documentId' ||
              key0 === 'orientation' ||
              key0 === 'snapshotGuid' ||
              key0 === 'cdnSrc'
            )
          ) {
            validate106.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.src !== undefined) {
            const _errs2 = errors;
            if (typeof data.src !== 'string') {
              validate106.errors = [
                {
                  instancePath: instancePath + '/src',
                  schemaPath: '#/properties/src/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.width !== undefined) {
              let data1 = data.width;
              const _errs4 = errors;
              if (!(typeof data1 == 'number' && isFinite(data1))) {
                validate106.errors = [
                  {
                    instancePath: instancePath + '/width',
                    schemaPath: '#/properties/width/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                  },
                ];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.height !== undefined) {
                let data2 = data.height;
                const _errs6 = errors;
                if (!(typeof data2 == 'number' && isFinite(data2))) {
                  validate106.errors = [
                    {
                      instancePath: instancePath + '/height',
                      schemaPath: '#/properties/height/type',
                      keyword: 'type',
                      params: { type: 'number' },
                      message: 'must be number',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs6 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.documentId !== undefined) {
                  const _errs8 = errors;
                  if (typeof data.documentId !== 'string') {
                    validate106.errors = [
                      {
                        instancePath: instancePath + '/documentId',
                        schemaPath: '#/properties/documentId/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs8 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.orientation !== undefined) {
                    let data4 = data.orientation;
                    const _errs10 = errors;
                    if (
                      !(
                        typeof data4 == 'number' &&
                        !(data4 % 1) &&
                        !isNaN(data4) &&
                        isFinite(data4)
                      )
                    ) {
                      validate106.errors = [
                        {
                          instancePath: instancePath + '/orientation',
                          schemaPath: '#/properties/orientation/type',
                          keyword: 'type',
                          params: { type: 'integer' },
                          message: 'must be integer',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs10 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.snapshotGuid !== undefined) {
                      const _errs12 = errors;
                      if (typeof data.snapshotGuid !== 'string') {
                        validate106.errors = [
                          {
                            instancePath: instancePath + '/snapshotGuid',
                            schemaPath: '#/properties/snapshotGuid/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs12 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.cdnSrc !== undefined) {
                        let data6 = data.cdnSrc;
                        const _errs14 = errors;
                        if (typeof data6 !== 'string' && data6 !== null) {
                          validate106.errors = [
                            {
                              instancePath: instancePath + '/cdnSrc',
                              schemaPath: '#/properties/cdnSrc/type',
                              keyword: 'type',
                              params: { type: schema63.properties.cdnSrc.type },
                              message: 'must be string,null',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs14 === errors;
                      } else {
                        var valid0 = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate106.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate106.errors = vErrors;
  return errors === 0;
}
exports.validateRule = validate52;
exports.validateRecipient = validate64;
exports.validateTemplate = validate81;
exports.validateCoverPage = validate107;
function validate107(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="CoverPage.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.to === undefined && (missing0 = 'to')) ||
        (data.from === undefined && (missing0 = 'from')) ||
        (data.message === undefined && (missing0 = 'message'))
      ) {
        validate107.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'to' || key0 === 'from' || key0 === 'message')) {
            validate107.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.to !== undefined) {
            const _errs2 = errors;
            if (typeof data.to !== 'string') {
              validate107.errors = [
                {
                  instancePath: instancePath + '/to',
                  schemaPath: '#/properties/to/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.from !== undefined) {
              const _errs4 = errors;
              if (typeof data.from !== 'string') {
                validate107.errors = [
                  {
                    instancePath: instancePath + '/from',
                    schemaPath: '#/properties/from/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.message !== undefined) {
                const _errs6 = errors;
                if (typeof data.message !== 'string') {
                  validate107.errors = [
                    {
                      instancePath: instancePath + '/message',
                      schemaPath: '#/properties/message/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs6 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate107.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate107.errors = vErrors;
  return errors === 0;
}
exports.validateBulkSend = validate88;
exports.validateEmbeddedData = validate108;
function validate108(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="EmbeddedData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.docGuids === undefined && (missing0 = 'docGuids')) ||
        (data.parentUrl === undefined && (missing0 = 'parentUrl')) ||
        (data.usingTemplate === undefined && (missing0 = 'usingTemplate')) ||
        (data.redirectUrl === undefined && (missing0 = 'redirectUrl')) ||
        (data.isSelfSign === undefined && (missing0 = 'isSelfSign')) ||
        (data.locale === undefined && (missing0 = 'locale'))
      ) {
        validate108.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.docGuids !== undefined) {
          let data0 = data.docGuids;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                const _errs3 = errors;
                if (typeof data0[i0] !== 'string') {
                  validate108.errors = [
                    {
                      instancePath: instancePath + '/docGuids/' + i0,
                      schemaPath: '#/properties/docGuids/items/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate108.errors = [
                {
                  instancePath: instancePath + '/docGuids',
                  schemaPath: '#/properties/docGuids/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.isEmbeddedRequest !== undefined) {
            const _errs5 = errors;
            if (typeof data.isEmbeddedRequest !== 'boolean') {
              validate108.errors = [
                {
                  instancePath: instancePath + '/isEmbeddedRequest',
                  schemaPath: '#/properties/isEmbeddedRequest/type',
                  keyword: 'type',
                  params: { type: 'boolean' },
                  message: 'must be boolean',
                },
              ];
              return false;
            }
            var valid0 = _errs5 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.isEmbeddedTemplate !== undefined) {
              const _errs7 = errors;
              if (typeof data.isEmbeddedTemplate !== 'boolean') {
                validate108.errors = [
                  {
                    instancePath: instancePath + '/isEmbeddedTemplate',
                    schemaPath: '#/properties/isEmbeddedTemplate/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  },
                ];
                return false;
              }
              var valid0 = _errs7 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.isGmail !== undefined) {
                const _errs9 = errors;
                if (typeof data.isGmail !== 'boolean') {
                  validate108.errors = [
                    {
                      instancePath: instancePath + '/isGmail',
                      schemaPath: '#/properties/isGmail/type',
                      keyword: 'type',
                      params: { type: 'boolean' },
                      message: 'must be boolean',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs9 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.skipMeNow !== undefined) {
                  const _errs11 = errors;
                  if (typeof data.skipMeNow !== 'boolean') {
                    validate108.errors = [
                      {
                        instancePath: instancePath + '/skipMeNow',
                        schemaPath: '#/properties/skipMeNow/type',
                        keyword: 'type',
                        params: { type: 'boolean' },
                        message: 'must be boolean',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs11 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.usingTemplate !== undefined) {
                    const _errs13 = errors;
                    if (typeof data.usingTemplate !== 'boolean') {
                      validate108.errors = [
                        {
                          instancePath: instancePath + '/usingTemplate',
                          schemaPath: '#/properties/usingTemplate/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs13 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.isCreatedFromTemplate !== undefined) {
                      const _errs15 = errors;
                      if (typeof data.isCreatedFromTemplate !== 'boolean') {
                        validate108.errors = [
                          {
                            instancePath:
                              instancePath + '/isCreatedFromTemplate',
                            schemaPath:
                              '#/properties/isCreatedFromTemplate/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs15 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.parentUrl !== undefined) {
                        const _errs17 = errors;
                        if (typeof data.parentUrl !== 'string') {
                          validate108.errors = [
                            {
                              instancePath: instancePath + '/parentUrl',
                              schemaPath: '#/properties/parentUrl/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs17 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.redirectUrl !== undefined) {
                          const _errs19 = errors;
                          if (typeof data.redirectUrl !== 'string') {
                            validate108.errors = [
                              {
                                instancePath: instancePath + '/redirectUrl',
                                schemaPath: '#/properties/redirectUrl/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs19 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.editedTemplateGuid !== undefined) {
                            let data10 = data.editedTemplateGuid;
                            const _errs21 = errors;
                            if (typeof data10 !== 'string' && data10 !== null) {
                              validate108.errors = [
                                {
                                  instancePath:
                                    instancePath + '/editedTemplateGuid',
                                  schemaPath:
                                    '#/properties/editedTemplateGuid/type',
                                  keyword: 'type',
                                  params: {
                                    type: schema105.properties
                                      .editedTemplateGuid.type,
                                  },
                                  message: 'must be string,null',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs21 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.isSelfSign !== undefined) {
                              let data11 = data.isSelfSign;
                              const _errs23 = errors;
                              if (
                                typeof data11 !== 'boolean' &&
                                data11 !== null
                              ) {
                                validate108.errors = [
                                  {
                                    instancePath: instancePath + '/isSelfSign',
                                    schemaPath: '#/properties/isSelfSign/type',
                                    keyword: 'type',
                                    params: {
                                      type: schema105.properties.isSelfSign
                                        .type,
                                    },
                                    message: 'must be boolean,null',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs23 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.locale !== undefined) {
                                let data12 = data.locale;
                                const _errs25 = errors;
                                if (
                                  typeof data12 !== 'string' &&
                                  data12 !== null
                                ) {
                                  validate108.errors = [
                                    {
                                      instancePath: instancePath + '/locale',
                                      schemaPath: '#/properties/locale/type',
                                      keyword: 'type',
                                      params: {
                                        type: schema105.properties.locale.type,
                                      },
                                      message: 'must be string,null',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs25 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.appName !== undefined) {
                                  const _errs27 = errors;
                                  if (typeof data.appName !== 'string') {
                                    validate108.errors = [
                                      {
                                        instancePath: instancePath + '/appName',
                                        schemaPath: '#/properties/appName/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs27 === errors;
                                } else {
                                  var valid0 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate108.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate108.errors = vErrors;
  return errors === 0;
}
exports.validateApiApp = validate109;
function validate109(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="ApiApp.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.clientId === undefined && (missing0 = 'clientId')) ||
        (data.parentUrl === undefined && (missing0 = 'parentUrl'))
      ) {
        validate109.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.clientId !== undefined) {
          const _errs1 = errors;
          if (typeof data.clientId !== 'string') {
            validate109.errors = [
              {
                instancePath: instancePath + '/clientId',
                schemaPath: '#/properties/clientId/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.parentUrl !== undefined) {
            const _errs3 = errors;
            if (typeof data.parentUrl !== 'string') {
              validate109.errors = [
                {
                  instancePath: instancePath + '/parentUrl',
                  schemaPath: '#/properties/parentUrl/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate109.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate109.errors = vErrors;
  return errors === 0;
}
exports.validateUser = validate92;
exports.validateSignerAppRequest = validate95;
exports.validateHSUserSchema = validate110;
function validate110(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="HSUser.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.id === undefined && (missing0 = 'id')) ||
        (data.guid === undefined && (missing0 = 'guid')) ||
        (data.emailAddress === undefined && (missing0 = 'emailAddress')) ||
        (data.name === undefined && (missing0 = 'name')) ||
        (data.settings === undefined && (missing0 = 'settings')) ||
        (data.isFree === undefined && (missing0 = 'isFree')) ||
        (data.hasTeam === undefined && (missing0 = 'hasTeam')) ||
        (data.plan === undefined && (missing0 = 'plan')) ||
        (data.numApiDocsLeft === undefined && (missing0 = 'numApiDocsLeft')) ||
        (data.numDocsLeft === undefined && (missing0 = 'numDocsLeft')) ||
        (data.numTemplatesLeft === undefined &&
          (missing0 = 'numTemplatesLeft')) ||
        (data.numFaxPagesLeft === undefined &&
          (missing0 = 'numFaxPagesLeft')) ||
        (data.canAccessBulkSendUI === undefined &&
          (missing0 = 'canAccessBulkSendUI')) ||
        (data.canAccessAdminConsole === undefined &&
          (missing0 = 'canAccessAdminConsole')) ||
        (data.canAccessTemplateConverter === undefined &&
          (missing0 = 'canAccessTemplateConverter')) ||
        (data.noTimeout === undefined && (missing0 = 'noTimeout')) ||
        (data.isFromSelfServeApi === undefined &&
          (missing0 = 'isFromSelfServeApi')) ||
        (data.showApiCredits === undefined && (missing0 = 'showApiCredits')) ||
        (data.canCreateEditTemplate === undefined &&
          (missing0 = 'canCreateEditTemplate')) ||
        (data.hasLegacyApiKeys === undefined &&
          (missing0 = 'hasLegacyApiKeys')) ||
        (data.referUrl === undefined && (missing0 = 'referUrl'))
      ) {
        validate110.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.id !== undefined) {
          let data0 = data.id;
          const _errs1 = errors;
          if (!(typeof data0 == 'number' && isFinite(data0))) {
            validate110.errors = [
              {
                instancePath: instancePath + '/id',
                schemaPath: '#/properties/id/type',
                keyword: 'type',
                params: { type: 'number' },
                message: 'must be number',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.guid !== undefined) {
            const _errs3 = errors;
            if (typeof data.guid !== 'string') {
              validate110.errors = [
                {
                  instancePath: instancePath + '/guid',
                  schemaPath: '#/properties/guid/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.emailAddress !== undefined) {
              const _errs5 = errors;
              if (typeof data.emailAddress !== 'string') {
                validate110.errors = [
                  {
                    instancePath: instancePath + '/emailAddress',
                    schemaPath: '#/properties/emailAddress/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.name !== undefined) {
                const _errs7 = errors;
                if (typeof data.name !== 'string') {
                  validate110.errors = [
                    {
                      instancePath: instancePath + '/name',
                      schemaPath: '#/properties/name/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.settings !== undefined) {
                  let data4 = data.settings;
                  const _errs9 = errors;
                  if (errors === _errs9) {
                    if (
                      data4 &&
                      typeof data4 == 'object' &&
                      !Array.isArray(data4)
                    ) {
                      let missing1;
                      if (
                        (data4.firstName === undefined &&
                          (missing1 = 'firstName')) ||
                        (data4.lastName === undefined &&
                          (missing1 = 'lastName'))
                      ) {
                        validate110.errors = [
                          {
                            instancePath: instancePath + '/settings',
                            schemaPath: '#/properties/settings/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message:
                              "must have required property '" + missing1 + "'",
                          },
                        ];
                        return false;
                      } else {
                        if (data4.firstName !== undefined) {
                          const _errs11 = errors;
                          if (typeof data4.firstName !== 'string') {
                            validate110.errors = [
                              {
                                instancePath:
                                  instancePath + '/settings/firstName',
                                schemaPath:
                                  '#/properties/settings/properties/firstName/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid1 = _errs11 === errors;
                        } else {
                          var valid1 = true;
                        }
                        if (valid1) {
                          if (data4.lastName !== undefined) {
                            const _errs13 = errors;
                            if (typeof data4.lastName !== 'string') {
                              validate110.errors = [
                                {
                                  instancePath:
                                    instancePath + '/settings/lastName',
                                  schemaPath:
                                    '#/properties/settings/properties/lastName/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid1 = _errs13 === errors;
                          } else {
                            var valid1 = true;
                          }
                        }
                      }
                    } else {
                      validate110.errors = [
                        {
                          instancePath: instancePath + '/settings',
                          schemaPath: '#/properties/settings/type',
                          keyword: 'type',
                          params: { type: 'object' },
                          message: 'must be object',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.isFree !== undefined) {
                    const _errs15 = errors;
                    if (typeof data.isFree !== 'boolean') {
                      validate110.errors = [
                        {
                          instancePath: instancePath + '/isFree',
                          schemaPath: '#/properties/isFree/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs15 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.hasTeam !== undefined) {
                      const _errs17 = errors;
                      if (typeof data.hasTeam !== 'boolean') {
                        validate110.errors = [
                          {
                            instancePath: instancePath + '/hasTeam',
                            schemaPath: '#/properties/hasTeam/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs17 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.plan !== undefined) {
                        let data9 = data.plan;
                        const _errs19 = errors;
                        if (typeof data9 !== 'string') {
                          validate110.errors = [
                            {
                              instancePath: instancePath + '/plan',
                              schemaPath: '#/properties/plan/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        if (
                          !(
                            data9 === '(Grandfathered 2016)' ||
                            data9 === 'API Basic' ||
                            data9 === 'Business 10' ||
                            data9 === 'Business' ||
                            data9 === 'Enterprise' ||
                            data9 === 'Enterprise+' ||
                            data9 === 'Essentials' ||
                            data9 === 'Free Premium' ||
                            data9 === 'Free' ||
                            data9 === 'Grandfathered' ||
                            data9 === 'Premium' ||
                            data9 === 'Standard' ||
                            data9 === 'Test Mode' ||
                            data9 === 'Web 300k'
                          )
                        ) {
                          validate110.errors = [
                            {
                              instancePath: instancePath + '/plan',
                              schemaPath: '#/properties/plan/enum',
                              keyword: 'enum',
                              params: {
                                allowedValues: schema111.properties.plan.enum,
                              },
                              message:
                                'must be equal to one of the allowed values',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs19 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.numApiDocsLeft !== undefined) {
                          let data10 = data.numApiDocsLeft;
                          const _errs21 = errors;
                          if (
                            !(typeof data10 == 'number' && isFinite(data10))
                          ) {
                            validate110.errors = [
                              {
                                instancePath: instancePath + '/numApiDocsLeft',
                                schemaPath: '#/properties/numApiDocsLeft/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs21 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.numDocsLeft !== undefined) {
                            let data11 = data.numDocsLeft;
                            const _errs23 = errors;
                            if (
                              !(typeof data11 == 'number' && isFinite(data11))
                            ) {
                              validate110.errors = [
                                {
                                  instancePath: instancePath + '/numDocsLeft',
                                  schemaPath: '#/properties/numDocsLeft/type',
                                  keyword: 'type',
                                  params: { type: 'number' },
                                  message: 'must be number',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs23 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.numTemplatesLeft !== undefined) {
                              let data12 = data.numTemplatesLeft;
                              const _errs25 = errors;
                              if (
                                !(typeof data12 == 'number' && isFinite(data12))
                              ) {
                                validate110.errors = [
                                  {
                                    instancePath:
                                      instancePath + '/numTemplatesLeft',
                                    schemaPath:
                                      '#/properties/numTemplatesLeft/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs25 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.numFaxPagesLeft !== undefined) {
                                let data13 = data.numFaxPagesLeft;
                                const _errs27 = errors;
                                if (
                                  !(
                                    typeof data13 == 'number' &&
                                    isFinite(data13)
                                  )
                                ) {
                                  validate110.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/numFaxPagesLeft',
                                      schemaPath:
                                        '#/properties/numFaxPagesLeft/type',
                                      keyword: 'type',
                                      params: { type: 'number' },
                                      message: 'must be number',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs27 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.canAccessBulkSendUI !== undefined) {
                                  const _errs29 = errors;
                                  if (
                                    typeof data.canAccessBulkSendUI !==
                                    'boolean'
                                  ) {
                                    validate110.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/canAccessBulkSendUI',
                                        schemaPath:
                                          '#/properties/canAccessBulkSendUI/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs29 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (
                                    data.canAccessAdminConsole !== undefined
                                  ) {
                                    const _errs31 = errors;
                                    if (
                                      typeof data.canAccessAdminConsole !==
                                      'boolean'
                                    ) {
                                      validate110.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/canAccessAdminConsole',
                                          schemaPath:
                                            '#/properties/canAccessAdminConsole/type',
                                          keyword: 'type',
                                          params: { type: 'boolean' },
                                          message: 'must be boolean',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid0 = _errs31 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (
                                      data.canAccessTemplateConverter !==
                                      undefined
                                    ) {
                                      const _errs33 = errors;
                                      if (
                                        typeof data.canAccessTemplateConverter !==
                                        'boolean'
                                      ) {
                                        validate110.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/canAccessTemplateConverter',
                                            schemaPath:
                                              '#/properties/canAccessTemplateConverter/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid0 = _errs33 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.noTimeout !== undefined) {
                                        const _errs35 = errors;
                                        if (
                                          typeof data.noTimeout !== 'boolean'
                                        ) {
                                          validate110.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/noTimeout',
                                              schemaPath:
                                                '#/properties/noTimeout/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid0 = _errs35 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (
                                          data.isFromSelfServeApi !== undefined
                                        ) {
                                          const _errs37 = errors;
                                          if (
                                            typeof data.isFromSelfServeApi !==
                                            'boolean'
                                          ) {
                                            validate110.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/isFromSelfServeApi',
                                                schemaPath:
                                                  '#/properties/isFromSelfServeApi/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid0 = _errs37 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                        if (valid0) {
                                          if (
                                            data.primarySignatureGuid !==
                                            undefined
                                          ) {
                                            const _errs39 = errors;
                                            if (
                                              typeof data.primarySignatureGuid !==
                                              'string'
                                            ) {
                                              validate110.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/primarySignatureGuid',
                                                  schemaPath:
                                                    '#/properties/primarySignatureGuid/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid0 = _errs39 === errors;
                                          } else {
                                            var valid0 = true;
                                          }
                                          if (valid0) {
                                            if (
                                              data.showApiCredits !== undefined
                                            ) {
                                              const _errs41 = errors;
                                              if (
                                                typeof data.showApiCredits !==
                                                'boolean'
                                              ) {
                                                validate110.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/showApiCredits',
                                                    schemaPath:
                                                      '#/properties/showApiCredits/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid0 = _errs41 === errors;
                                            } else {
                                              var valid0 = true;
                                            }
                                            if (valid0) {
                                              if (
                                                data.canCreateEditTemplate !==
                                                undefined
                                              ) {
                                                const _errs43 = errors;
                                                if (
                                                  typeof data.canCreateEditTemplate !==
                                                  'boolean'
                                                ) {
                                                  validate110.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/canCreateEditTemplate',
                                                      schemaPath:
                                                        '#/properties/canCreateEditTemplate/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'boolean',
                                                      },
                                                      message:
                                                        'must be boolean',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid0 = _errs43 === errors;
                                              } else {
                                                var valid0 = true;
                                              }
                                              if (valid0) {
                                                if (
                                                  data.hasLegacyApiKeys !==
                                                  undefined
                                                ) {
                                                  const _errs45 = errors;
                                                  if (
                                                    typeof data.hasLegacyApiKeys !==
                                                    'boolean'
                                                  ) {
                                                    validate110.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath +
                                                          '/hasLegacyApiKeys',
                                                        schemaPath:
                                                          '#/properties/hasLegacyApiKeys/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'boolean',
                                                        },
                                                        message:
                                                          'must be boolean',
                                                      },
                                                    ];
                                                    return false;
                                                  }
                                                  var valid0 =
                                                    _errs45 === errors;
                                                } else {
                                                  var valid0 = true;
                                                }
                                                if (valid0) {
                                                  if (
                                                    data.referUrl !== undefined
                                                  ) {
                                                    const _errs47 = errors;
                                                    if (
                                                      typeof data.referUrl !==
                                                      'string'
                                                    ) {
                                                      validate110.errors = [
                                                        {
                                                          instancePath:
                                                            instancePath +
                                                            '/referUrl',
                                                          schemaPath:
                                                            '#/properties/referUrl/type',
                                                          keyword: 'type',
                                                          params: {
                                                            type: 'string',
                                                          },
                                                          message:
                                                            'must be string',
                                                        },
                                                      ];
                                                      return false;
                                                    }
                                                    var valid0 =
                                                      _errs47 === errors;
                                                  } else {
                                                    var valid0 = true;
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate110.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate110.errors = vErrors;
  return errors === 0;
}
exports.validateAccountFeatureSettings = validate99;
exports.validateAccountIntegrationSettings = validate101;
exports.validateAccountProfileSettings = validate103;
exports.validateTimezone = validate111;
function validate111(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  /*# sourceURL="Timezone.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.offset === undefined && (missing0 = 'offset')) ||
        (data.hasDST === undefined && (missing0 = 'hasDST')) ||
        (data.displayName === undefined && (missing0 = 'displayName'))
      ) {
        validate111.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.offset !== undefined) {
          let data0 = data.offset;
          const _errs1 = errors;
          if (!(typeof data0 == 'number' && isFinite(data0))) {
            validate111.errors = [
              {
                instancePath: instancePath + '/offset',
                schemaPath: '#/properties/offset/type',
                keyword: 'type',
                params: { type: 'number' },
                message: 'must be number',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.hasDST !== undefined) {
            const _errs3 = errors;
            if (typeof data.hasDST !== 'boolean') {
              validate111.errors = [
                {
                  instancePath: instancePath + '/hasDST',
                  schemaPath: '#/properties/hasDST/type',
                  keyword: 'type',
                  params: { type: 'boolean' },
                  message: 'must be boolean',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.displayName !== undefined) {
              const _errs5 = errors;
              if (typeof data.displayName !== 'string') {
                validate111.errors = [
                  {
                    instancePath: instancePath + '/displayName',
                    schemaPath: '#/properties/displayName/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate111.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate111.errors = vErrors;
  return errors === 0;
}
